export default {
  "12313": "",
  "123123": "",
  "77777777": "",
  "language.name": "Italiano",
  "system.dataScreen": "Schermo dati",
  "product.PleaseEnter": "Si prega di inserire il nome del prodotto",
  "product.PleaseEnterTheProductSerialNumber": "Si prega di inserire il numero di serie del prodotto",
  "product.PleaseEnterSubmodelNumber": "Si prega di inserire il numero del sottomodello",
  "product.PleaseenterTheSubmodelSerialNumber": "Si prega di inserire il numero di serie del sottomodello",
  "product.PleaseSelectTheDeviceType": "Si prega di selezionare il tipo di dispositivo",
  "product.PleaseSelectDevelopmentType": "Si prega di selezionare il tipo di sviluppo",
  "product.management": "Prodotto",
  "product.name": "Serie di prodotti",
  "product.reset": "reimposta",
  "product.search": "ricerca",
  "product.ApplicationList": "elenco applicazioni",
  "product.newProduct": "nuovo prodotto",
  "product.editName": "modifica prodotto",
  "product.DetailSetting": "impostazioni dettaglio",
  "product.delete": "elimina",
  "product.serialNumber": "numero di serie",
  "product.deviceType": "tipo di dispositivo",
  "product.RandDtype": "tipo di R&S (Ricerche e Sviluppo)",
  "product.subType": "sottotipo",
  "product.updateTime": "tempo di aggiornamento",
  "product.operation": "operazione",
  "product.shippingMarket": "Mercato di spedizione",
  "product.deviceList": "Elenco dispositivi (Registro di spedizione)",
  "product.parameterManagement": "Gestione dei parametri",
  "product.updataManagement": "Gestione degli aggiornamenti",
  "product.ParentDevice": "Dispositivo Padre",
  "product.AssociatedPowerStationState": "Stato Stazione Elettrica Associata",
  "product.ImportDeviceList": "Importa Elenco Dispositivi",
  "product.PlantDetails": "Dettagli della centrale elettrica",
  "product.parameterName": "Nome Parametro",
  "product.OwningPowerStation": "Stazione Elettrica Proprietaria",
  "product.ParameterClass": "Categoria Parametro",
  "product.ParameterSettingType": "Tipo di Impostazione del Parametro",
  "product.ParameterOperationType": "Tipo di Operazione del Parametro",
  "product.ImportParameter": "Importa Parametro",
  "product.OwningUpperLevelParameterCategory": "Categoria Superiore del Parametro Proprietario",
  "product.WhetherYoSupportBatchRead": "Se Supporta la Lettura di Gruppo",
  "product.value": "valore",
  "product.scope": "ambito",
  "product.unit": "unità",
  "product.explain": "spiegazione",
  "product.remark": "osservazione",
  "product.fileName": "Nome del File",
  "product.fileAddress": "Indirizzo del File",
  "product.versionNumber": "numero di versione",
  "product.ProductOfOwnership": "prodotto di appartenenza",
  "product.ProductDetailsSettings": "Balcone 1.0 - Impostazioni Dettagli Prodotto",
  "product.QueryResultList": "Elenco Risultati Ricerca",
  "product.AddFirmware": "Aggiungi Firmware",
  "product.NewParameter": "Nuovo Parametro",
  "product.datalog": "Registratore dati",
  "product.Inverter": "Inverter",
  "product.storage": "Memorizzazione",
  "product.battery": "Batteria",
  "product.socket": "Presa",
  "product.DownloadTemplate": "Scarica modello",
  "product.nation": "paese",
  "product.agent": "agente",
  "product.expirationDate": "periodo di garanzia della qualità",
  "product.UpdateTime": "Tempo di aggiornamento",
  "product.LastWeek": "La scorsa settimana",
  "product.LastMonth": "Il mese scorso",
  "product.LastThreeMonths": "Negli ultimi tre mesi",
  "product.parameterType": "Tipo di parametro",
  "product.ProtocolAddress": "Indirizzo nel protocollo parametro",
  "product.stepSize": "passo",
  "product.PleaseEnterAParameterName": "Inserisci il nome del parametro",
  "product.parameterCoding": "Codifica dei parametri",
  "product.PleaseEnterTheParameterCode": "Inserisci il codice del parametro",
  "product.ParameterDataType": "Tipo di dati dei parametri",
  "product.PleaseEnterTheAddressInTheParameterProtocol": "Inserisci l'indirizzo nel protocollo parametro",
  "product.blockEncoding": "Codifica di gruppo",
  "product.PleaseEnterABlockCode": "Inserisci il codice del gruppo",
  "product.GroupName": "Nome del gruppo",
  "product.PleaseEnterAGroupName": "Inserisci il nome del gruppo",
  "product.PleaseEnterTheUnit": "Inserisci il valore minimo",
  "product.decimalPoint": "punto decimale",
  "product.PleaseEnterTheDecimalPoint": "Inserire il punto decimale",
  "product.leastValue": "valore minimo",
  "product.maximumValue": "Valore massimo",
  "product.PleaseEnterTheMaximumValue": "Inserisci il valore massimo",
  "product.PleaseEnterTheStepSize": "Inserisci la dimensione del passo",
  "product.addEquipment": "Aggiungere nuove attrezzature",
  "product.equipment": "apparecchiature",
  "product.remove": "rimuovere",
  "product.sort": "ordinamento",
  "product.PleaseEnterTheOrder": "Inserisci ordinamento",
  "product.PleaseEnterTheParameterSettingType": "Inserisci il tipo di impostazione dei parametri",
  "product.PleaseSelectAFolderPath": "Seleziona il percorso della cartella",
  "product.ReturnToSuperior": "Ritorna al superiore",
  "product.PleaseEnterTheVersionNumber": "Inserisci il numero di versione",
  "product.firmwareSpecification": "Descrizione del firmware",
  "product.PleaseEnterFirmwareDescription": "si prega di inserire la descrizione del firmware",
  "product.FileName": "nome file",
  "product.DeviceType": "tipo di dispositivo",
  "product.FileAddress": "Indirizzo file",
  "product.time": "tempo di servizio",
  "sidebar.default": "Pagina di navigazione",
  "sidebar.home": "Panoramica dei dati",
  "sidebar.endbenutzer": "Utente",
  "sidebar.plant": "Gestione della scena",
  "sidebar.plant_plant": "Centrale Elettrica",
  "sidebar.device": "Dispositivo",
  "sidebar.datalog": "Elenco raccoglitori",
  "sidebar.inverter": "Elenco invertitore",
  "sidebar.sotrage": "Elenco di stoccaggio dell'energia",
  "sidebar.socket": "Elenco delle prese",
  "sidebar.battery": "Elenco batterie",
  "sidebar.agent": "Gestione agenti",
  "sidebar.systematicSupply": "Diario delle spedizioni",
  "sidebar.firmware": "Elenco firmware",
  "sidebar.firmware_up": "Caricamento firmware",
  "sidebar.firmware_log": "Aggiornamento record",
  "sidebar.system": "Registro",
  "sidebar.system_datalog_log": "Registro raccoglitore",
  "sidebar.system_log": "Registro delle operazioni",
  "sidebar.system_tongxun": "Registro delle comunicazioni",
  "sidebar.system_app": "Versione dell'app",
  "sidebar.personal": "Informazioni utente",
  "sidebar.logout": "Esci dal conto",
  "sidebar.organizationalManagement": "Organizzazione",
  "sidebar.auth_manage": "Autorizzazione",
  "sidebar.workorder": "Ordine di lavoro",
  "shipment.shippingManagement": "Spedizione",
  "shipment.shippingManagementTemplage": "Modello di importazione gestione spedizioni",
  "login.email": "cassetta postale",
  "login.password": "password",
  "login.remember": "Ricorda email e password",
  "login.rememberAccount": "ricorda account e password",
  "login.enteremail": "Inserisci il tuo indirizzo email",
  "login.enterpassword": "Inserisci una password",
  "login.enterAccount": "inserisci email o numero di telefono",
  "login.correctAccount": "inserisci un'email o numero di telefono valido",
  "login.accountPlaceholder": "inserisci email o numero di telefono",
  "login.accountNumber": "numero di conto",
  "login.system": "Haier Smart Energy Management System",
  "login.read": "Leggi e accetta",
  "login.userAgreement": "Accordo utente",
  "login.privacyPolicy": "Informativa sulla privacy",
  "login.temporarilyDisagree": "Non accetto temporaneamente",
  "login.agreeAndAccept": "Accetto e acconsento",
  "login.retrievePassword": "Recupera password",
  "login.verCode": "Codice di verifica",
  "login.newPassword": "Nuova password",
  "login.sendverCode": "Invia codice di verifica",
  "login.greenLife": "Innovazione energia pulita per una vita più verde",
  "login.welcome": "Benvenuti alla nuvola energetica di haier",
  "login.downloadApp": "Scarica l'app",
  "login.sure": "Confermare",
  "home.echarts1.title": "Utente registrato",
  "home.echarts1.subhead": "Numero totale di nuovi utenti aggiunti oggi",
  "home.echarts2.title": "login utente",
  "home.echarts2.subhead": "Accesso di oggi/numero totale di utenti",
  "home.echarts3.title": "Aggiungi agente",
  "home.echarts3.subhead": "Accesso di oggi/numero totale di agenti",
  "home.echarts4.title": "Aggiungi scena",
  "home.echarts4.subhead": "Nuove scene/numero totale di scene aggiunte",
  "home.echarts4.title_plant": "Aggiungere centrale elettrica",
  "home.echarts4.subhead_plant": "Centrali nuove aggiunte/numero totale di centrali elettriche",
  "home.echarts5.title": "Aggiungi raccoglitore",
  "home.echarts5.subhead": "Nuovi collezionisti/numero totale di collezionisti aggiunti",
  "home.echarts6.title": "Aggiungi dispositivo",
  "home.echarts6.subhead": "Dispositivi aggiunti di recente/numero totale di dispositivi",
  "End_user.input_email": "Inserisci l'indirizzo email dell'utente",
  "End_user.btn_search": "ricerca",
  "End_user.btn_add": "Aggiungi a",
  "End_user.btn_delete": "elimina",
  "End_user.btn_binding": "vincolante",
  "End_user.add_station": "Aggiungi scena",
  "End_user.lable_StationName": "Nome scena",
  "End_user.lable_StationType": "Tipo di scena",
  "End_user.lable_PVCapacity": "Capacità delle celle solari",
  "End_user.lable_InstalltionDate": "data di installazione",
  "End_user.lable_Country": "paese",
  "End_user.lable_City": "città",
  "End_user.lable_Address": "indirizzo",
  "End_user.lable_TimeZone": "fuso orario",
  "End_user.lable_Energyprice": "Prezzo unitario dell'energia",
  "End_user.lable_IncomeUnit": "Unità di reddito",
  "End_user.input_StationName": "Inserisci il nome della scena",
  "End_user.input_StationType": "Seleziona il tipo",
  "End_user.input_PVCapacity": "Inserire la capacità della batteria",
  "End_user.input_InstalltionDate": "Seleziona la data di installazione",
  "End_user.input_Country": "Seleziona un paese",
  "End_user.input_City": "Seleziona una città",
  "End_user.input_Address": "Inserisci l'indirizzo",
  "End_user.input_TimeZone": "Scegli un fuso orario",
  "End_user.input_Energyprice": "Inserisci il prezzo unitario",
  "End_user.input_IncomeUnit": "Seleziona unità di reddito",
  "End_user.max_20": "Il numero massimo di caratteri non può superare i 20",
  "End_user.max_5": "Il numero massimo di caratteri non può superare 5",
  "End_user.max_8": "Il numero massimo di caratteri non può superare 8",
  "End_user.format": "Inserisci il formato corretto",
  "End_user.close": "chiudi",
  "End_user.submit": "Invia",
  "End_user.title_delete": "Cancellare?",
  "End_user.no": "no",
  "End_user.yes": "sì",
  "End_user.Bingding_Agent": "Agente legante",
  "End_user.Agent_Code": "agente:",
  "End_user.please_select": "Si prega di scegliere",
  "plant.input_email": "Inserisci l'indirizzo email dell'utente",
  "plant.search": "ricerca",
  "plant.edit": "modifica",
  "plant.delete": "elimina",
  "plant.edit_plant": "Modifica scena",
  "plant.input_station": "Inserisci il nome della scena",
  "plant.lable_StationName": "Nome scena",
  "plant.lable_StationType": "Tipo di scena",
  "plant.lable_PVCapacity": "Capacità delle celle solari",
  "plant.lable_InstalltionDate": "data di installazione",
  "plant.lable_Country": "paese",
  "plant.lable_City": "città",
  "plant.lable_Address": "indirizzo",
  "plant.lable_TimeZone": "fuso orario",
  "plant.lable_Energyprice": "Prezzo unitario dell'energia",
  "plant.lable_IncomeUnit": "Unità di reddito",
  "plant.input_StationName": "Inserisci il nome della scena",
  "plant.input_StationType": "Seleziona il tipo",
  "plant.input_PVCapacity": "Inserire la capacità della batteria",
  "plant.input_InstalltionDate": "Seleziona la data di installazione",
  "plant.input_Country": "Seleziona un paese",
  "plant.input_City": "Seleziona una città",
  "plant.input_Address": "Inserisci l'indirizzo",
  "plant.input_TimeZone": "Scegli un fuso orario",
  "plant.input_Energyprice": "Inserisci il prezzo unitario",
  "plant.input_IncomeUnit": "Seleziona unità di reddito",
  "plant.max_20": "Il numero massimo di caratteri non può superare i 20",
  "plant.max_5": "Il numero massimo di caratteri non può superare 5",
  "plant.max_8": "Il numero massimo di caratteri non può superare 8",
  "plant.format": "Inserisci il formato corretto",
  "plant.close": "chiudi",
  "plant.submit": "Invia",
  "plant.title_delete": "Cancellare?",
  "plant.no": "no",
  "plant.yes": "sì",
  "plant.powerGeneration": "Produzione di energia elettrica",
  "plant.powerConsumption": "Consumo di energia elettrica",
  "plant.spontaneousSelfUse": "Autoconsumo",
  "plant.selfSufficient": "Autosufficienza",
  "plant.photovoltaicPowerGeneration": "Potenza fotovoltaica",
  "plant.electricPowerConsumption": "Potenza di consumo",
  "plant.spontaneousSelfUsePower": "Potenza di autoconsumo",
  "plant.buyPowers": "Potenza di acquisto di energia elettrica",
  "plant.sellPowers": "Potenza di vendita di energia elettrica",
  "plant.selfSufficientPower": "Potenza di autosufficienza",
  "plant.batterySOC": "SOC della batteria di accumulo",
  "plant.storageChargingPower": "Potenza di carica della batteria di accumulo",
  "plant.storageDischargePower": "Potenza di scarica della batteria di accumulo",
  "plant.co2emissionReduction": "Riduzione di CO2",
  "plant.plantPowerGeneration": "Produzione di energia cumulativa dell’impianto",
  "plant.equivalentTreePlanting": "Numero equivalente di alberi piantati",
  "plant.saveStandardCoal": "Risparmio di carbone standard",
  "plant.today": "Odierna",
  "plant.month": "Mensile",
  "plant.year": "Anno in corso",
  "plant.total": "Cumulativa",
  "datalog.email": "Inserisci il tuo indirizzo email",
  "datalog.datalogSn": "Inserire il numero di serie del collettore",
  "datalog.search": "ricerca",
  "datalog.Version": "Numero di versione",
  "datalog.setting": "istituito",
  "datalog.upgrade": "upgrade",
  "datalog.delete": "elimina",
  "datalog.title_datalog": "Impostazioni del raccoglitore",
  "datalog.span_info": "informazioni",
  "datalog.span_datalog": "Numero di serie del collettore:",
  "datalog.span_name": "Alias:",
  "datalog.span_time": "Tempo di aggiornamento:",
  "datalog.span_firmware": "Versione segnale/firmware:",
  "datalog.span_order": "comando",
  "datalog.span_settingdns": "Imposta nome dominio",
  "datalog.span_inputsetting": "Inserisci il nome di dominio",
  "datalog.span_upgrade": "Aggiorna il raccoglitore",
  "datalog.span_reset": "Riavvia il raccoglitore",
  "datalog.span_setup": "impostazione avanzata",
  "datalog.span_param": "parametro",
  "datalog.span_value": "valore",
  "datalog.btn_setup": "impostazione avanzata",
  "datalog.btn_setting": "istituito",
  "datalog.btn_settingdns": "Imposta nome dominio",
  "datalog.btn_upgrade": "upgrade",
  "datalog.btn_reset": "riavvia",
  "datalog.btn_read": "leggere",
  "datalog.btn_close": "Annulla",
  "datalog.methods_version": "Rileva aggiornamenti di versione?",
  "datalog.no": "no",
  "datalog.yes": "sì",
  "datalog.methods_delete": "Cancellare?",
  "datalog.methods_rereset": "Riavviare?",
  "datalog.methodes_inputDns": "Inserisci il nome di dominio",
  "datalog.methodes_DNS": "Vuoi impostare questo nome di dominio",
  "sotrage.select": "Si prega di scegliere",
  "sotrage.email": "Inserisci il tuo indirizzo email",
  "sotrage.datalogSn": "Inserire il numero di serie del collettore",
  "sotrage.deviceSn": "Inserire il numero di serie del dispositivo",
  "sotrage.search": "ricerca",
  "sotrage.storage": "Impostazioni di stoccaggio",
  "device.select": "Si prega di scegliere",
  "device.email": "Inserisci il tuo indirizzo email",
  "device.datalogSn": "Inserire il numero di serie del collettore",
  "device.deviceSn": "Inserire il numero di serie del dispositivo",
  "device.search": "ricerca",
  "device.title": "Impostazioni invertitore",
  "device.setting": "istituito",
  "device.setting_inverte": "Imposta parametri dell'inverter",
  "device.input_start_address": "Indirizzo di avvio del registro",
  "device.input_end_address": "Indirizzo del registro finale",
  "device.input_setting_value": "Inserisci il valore di impostazione",
  "device.read_data": "Leggere i dati del registro:",
  "device.input_start_read": "Indirizzo di avvio del registro",
  "device.input_end_read": "Termina l'indirizzo del registro",
  "device.btn_address": "Imposta indirizzo",
  "device.btn_value": "Imposta parametri",
  "device.btn_read": "leggere",
  "device.btn_close": "ritorno",
  "device.select_data": "Seleziona data",
  "device.workMode": "Modalità di lavoro",
  "device.alarmInfo": "Informazioni di allarme",
  "device.countryStandard": "Norme nazionali",
  "device.runningStatus": "Stato di Funzionamento",
  "device.inverterTemp": "Temperatura dell'invertitore(℃)",
  "device.dcdcTemp": "Temperatura della batteria (℃)",
  "device.mpptTemp": "Temperatura MPPT(℃)",
  "device.drmStatus": "Stato DRM",
  "device.version": "Versione",
  "device.communicationEquipment": "Apparecchiatura di comunicazione",
  "device.basicInfo": "Informazioni di base",
  "device.productName": "Nome del prodotto",
  "device.productType": "Tipo di prodotto",
  "device.productModel": "Modello di prodotto",
  "device.softVersion": "Versione del software",
  "device.softUpdateTime": "Ora di aggiornamento del software",
  "device.plant": "Centrale elettrica",
  "device.installer": "Installatore",
  "device.installPerson": "Installatore",
  "device.deviceRegisterDate": "Data di registrazione dell'apparecchiatura",
  "device.ownerEmail": "Email proprietario",
  "device.ownerReceiveTime": "Ora ricezione proprietario",
  "device.ownerFamily": "Famiglia proprietario",
  "device.versionInfo": "Informazioni versione",
  "device.searchSn": "Inserisci il SN per la ricerca",
  "device.user": "Utente",
  "device.userReceiveDate": "Data di ricezione dell'utente",
  "device.yuan": "Fonte: Fotovoltaico",
  "device.totalPower": "Potenza totale",
  "device.todayPowerGeneration": "Produzione Elettrica Odierna",
  "device.dataGateway": "Gateway dati",
  "device.optimizer": "Ottimizzatore",
  "device.chu": "Accumulo: Batteria di accumulo",
  "device.power": "Potenza",
  "device.todayChargingCapacity": "Carica odierna",
  "device.todayDischargingCapacity": "Scarica odierna",
  "device.he": "Carico: Carico di consumo",
  "device.todayElectricityConsumption": "Consumo di energia elettrica giornaliero",
  "device.totalElectricityConsumption": "Consumo di energia elettrica cumulativo",
  "device.wang": "Rete: Lato rete",
  "device.totalFrequency": "Frequenza totale",
  "device.buyPowers": "Acquistare energia elettrica",
  "device.sellPowers": "Vendere energia elettrica",
  "device.more": "Altro",
  "device.readWrite": "Strumento di lettura/scrittura diretta",
  "device.chargeAndDisChargeSetting": "Impostazioni di carica/scarica",
  "device.mutipleSave": "Invio in batch",
  "device.mutipleRead": "Lettura multipla",
  "device.deviceSnisExist": "Si prega di confermare se esiste l'SN dell'apparecchiatura",
  "device.saveSuccess": "Il comando dei parametri è stato inviato. Aggiorna la pagina o fai clic sul pulsante [Leggi] per confermare se i parametri sono attivi.",
  "device.saveFail": "Invio parametri fallito",
  "device.getParamsSuccess": "Ottenimento parametri riuscito",
  "device.getParamsFail": "Ottenimento parametri fallito",
  "device.operationalDataAnalysis": "Analisi dei dati di funzionamento",
  "device.pleaseSelect": "Si prega di selezionare la voce di dati a sinistra",
  "device.maxFour": "Le unità non possono essere più di 4",
  "device.maxFourOrTwenty": "Massimo 4 tipi o 20 opzioni consentite",
  "device.protocolDirectives": "Comando di protocollo",
  "device.dateRangeError": "L'intervallo di date deve essere entro 3 giorni",
  "device.noDeviceDetail": "Nessun dettaglio sull'apparecchiatura disponibile",
  "device.address": "Indirizzo registro",
  "device.faultClearing": "Cancellazione guasti",
  "device.chargeSetting": "Impostazione di ricarica",
  "device.dischargeSetting": "Impostazione di scarica",
  "battery.select": "Si prega di scegliere",
  "battery.email": "Inserisci il tuo indirizzo email",
  "battery.datalogSn": "Inserire il numero di serie del collettore",
  "battery.deviceSn": "Inserire il numero di serie del dispositivo",
  "battery.search": "ricerca",
  "socket.title": "impostazione della presa",
  "socket.setting": "istituito",
  "socket.span": "Sono stati impostati più indirizzi di registro e devono essere impostati più valori. Imposta valori da separare, ad esempio (1, 2, 3)",
  "socket.setting_device": "Imposta parametri dell' inverter:",
  "socket.startaddress": "Indirizzo di avvio del registro",
  "socket.stopaddress": "Termina l'indirizzo del registro",
  "socket.value": "Inserisci il valore di impostazione",
  "socket.readdata": "Leggere i dati del registro:",
  "socket.setting_address": "Imposta indirizzo",
  "socket.setting_value": "Imposta parametri",
  "socket.read": "leggere",
  "socket.return": "ritorno",
  "agent.close": "Annulla",
  "agent.submit": "Invia",
  "agent.input_email": "Inserisci il tuo indirizzo email",
  "agent.search": "ricerca",
  "agent.add_agent": "Aggiungi agente",
  "agent.import_device": "Importa dispositivi",
  "agent.edit": "modifica",
  "agent.title": "Aggiungi agente",
  "agent.email": "cassetta postale",
  "agent.password": "password",
  "agent.phone": "numero di telefono",
  "agent.company": "azienda",
  "agent.language": "lingua",
  "agent.address": "indirizzo",
  "agent.input_password": "Inserisci una password",
  "agent.input_phone": "Inserisci il tuo numero di telefono",
  "agent.input_company": "Seleziona un'azienda",
  "agent.input_language": "Inserisci la lingua",
  "agent.input_address": "Inserisci l'indirizzo",
  "agent.relus_email": "Inserisci un indirizzo email valido",
  "agent.title_edit": "Modifica agente",
  "agent.title_device": "Carica",
  "agent.span": "Esempio: Modulo esclusivo",
  "agent.btn_upload": "Carica",
  "agent.delete": "elimina",
  "agent.agent_delete": "Agente di cancellazione?",
  "ship.starttime": "ora di inizio",
  "ship.endtime": "Tempo di fine",
  "ship.deviceSn": "Inserire il numero di serie del dispositivo",
  "ship.select": "Seleziona un'azienda",
  "ship.search": "ricerca",
  "Firmware.file_name": "Inserisci il nome del file",
  "Firmware.search": "ricerca",
  "Firmware.add": "Aggiungi a",
  "Firmware.delete": "elimina",
  "Firmware.title": "Caricamento firmware",
  "Firmware.select_folder": "Seleziona cartella:",
  "Firmware.select_folder_type": "Seleziona il tipo di cartella",
  "Firmware.craete_folder": "Crea una nuova cartella",
  "Firmware.folder_path": "Percorso cartella:",
  "Firmware.folder_name": "Nome file:",
  "Firmware.input_folder_name": "Inserisci il nome del file",
  "Firmware.create": "crea cartella",
  "Firmware.listed_files": "Elenco file:",
  "Firmware.import_folder": "Importa file",
  "Firmware.uplad_folder": "Carica file",
  "Firmware.close": "ritorno",
  "Upgrade.starttime": "ora di inizio",
  "Upgrade.endtime": "Tempo di fine",
  "Upgrade.deviceSn": "Inserire il numero di serie del dispositivo",
  "Upgrade.type": "Seleziona il tipo",
  "Upgrade.search": "ricerca",
  "Upgrade.datalog": "collettore",
  "Upgrade.Inverter": "inverter",
  "Upgrade.Control": "controller",
  "datalogs_logs.starttime": "ora di inizio",
  "datalogs_logs.endtime": "Tempo di fine",
  "datalogs_logs.deviceSn": "Inserire il numero di serie del dispositivo",
  "datalogs_logs.Version": "Inserisci la versione",
  "datalogs_logs.search": "ricerca",
  "Logs.starttime": "ora di inizio",
  "Logs.endtime": "Tempo di fine",
  "Logs.deviceSn": "Inserire il numero di serie del dispositivo",
  "Logs.type": "Seleziona il tipo",
  "Logs.search": "ricerca",
  "Special.starttime": "ora di inizio",
  "Special.endtime": "Tempo di fine",
  "Special.deviceSn": "Inserire il numero di serie del dispositivo",
  "Special.datalogSn": "Inserire il numero di serie del collettore",
  "Special.type": "Seleziona il tipo",
  "Special.search": "ricerca",
  "Special.save": "conservazione",
  "Special.Examples": "Esempio: (2305210230,2305210139)",
  "App.System_Config": "configurazione del sistema",
  "App.APP_Version": "Versione dell'app",
  "App.Android_Version": "Versione Android:",
  "App.IOS_Version": "Versione IOS:",
  "App.APP_Type": "Tipo di app:",
  "App.New_Version": "Nuova versione",
  "App.update_content": "Aggiornamento descrizione: (diviso per \"/n\")",
  "App.Whether_update": "È obbligatorio aggiornare",
  "App.no": "no",
  "App.yes": "sì",
  "App.submit": "Invia",
  "Tips.app_submit": "Sei sicuro di modificare le informazioni?",
  "Tips.firmware_delete": "Sei sicuro di cancellare?",
  "Tips.firmware_deleteCDN": "Elimina file da CDN?",
  "Tips.yes": "sì",
  "Tips.no": "no",
  "global.DataDetails": "Dettagli dei dati",
  "global.device": "Impostazioni invertitore",
  "global.device_data": "Imposta parametri dell' inverter:",
  "global.storage": "Impostazioni di stoccaggio dell'energia",
  "global.storage_data": "Imposta parametri di accumulo dell'energia",
  "global.battery": "Impostazioni della batteria",
  "global.battery_data": "Imposta i parametri della batteria",
  "global.socket": "impostazione della presa",
  "global.socket_data": "Imposta parametri socket",
  "btn.setting_address": "Imposta indirizzo",
  "btn.close": "ritorno",
  "btn.submit": "Invia",
  "btn.Setting_parameters": "Imposta parametri",
  "btn.Reading": "leggere",
  "btn.search": "ricerca",
  "btn.add": "Aggiungi a",
  "btn.import": "Importa",
  "btn.download": "Esempio di download",
  "btn.edit": "modifica",
  "btn.login": "Accedi",
  "btn.export": "esportazione",
  "form.addShip": "Aggiungere attrezzature di spedizione",
  "form.editShip": "Modifica attrezzature di spedizione",
  "form.import": "Importa informazioni sul dispositivo",
  "form.shipSN": "Numero di serie della spedizione",
  "form.agent": "agente",
  "form.networkCall": "Indica se eseguire la chiamata alla rete di distribuzione",
  "form.warrantyPeriod": "Periodo di garanzia",
  "form.shiptime": "Tempi di consegna",
  "form.shiptype": "Tipo di spedizione",
  "form.classify": "classificazione",
  "form.file": "Trascina il file qui o fai clic su Carica",
  "form.edit_plant": "Modifica scena",
  "form.input_station": "Inserisci il nome della scena",
  "form.lable_StationName": "Nome scena",
  "form.lable_StationType": "Tipo di scena",
  "form.input_StationName": "Inserisci il nome della scena",
  "form.edit_plant_plant": "Modifica centrale elettrica",
  "form.input_station_plant": "Inserire il nome della centrale elettrica",
  "form.lable_StationName_plant": "Nome della centrale elettrica",
  "form.lable_StationType_plant": "Tipo di centrale elettrica",
  "form.input_StationName_plant": "Inserire il nome della centrale elettrica",
  "placeholder.select": "Si prega di scegliere",
  "placeholder.choiceCountry": "Seleziona un paese",
  "placeholder.choiceTimezone": "Scegli un fuso orario",
  "placeholder.enterEmail": "Inserisci il tuo indirizzo email",
  "placeholder.enterPhone": "Inserisci il tuo numero di telefono",
  "placeholder.verificationCode": "Inserisci il codice di verifica",
  "placeholder.enterPassword": "Inserisci una password di 6-20 cifre",
  "placeholder.confirmPassword": "Conferma la password",
  "placeholder.readAndAgree": "Ho letto e accetto",
  "placeholder.search": "ricerca",
  "placeholder.searchPlantName": "Ricerca del nome della centrale elettrica",
  "placeholder.searchDeviceName": "Cerca il nome del dispositivo",
  "placeholder.searchDataloggerName": "Cerca il nome del collezionista",
  "placeholder.enterPlantName": "Inserire il nome della centrale elettrica",
  "placeholder.enterPlantType": "Inserire il tipo di centrale elettrica",
  "placeholder.enterPVCapacity": "Inserire la capacità fotovoltaica",
  "placeholder.choiceInstallationDate": "Seleziona la data di installazione",
  "placeholder.enterPlantAddress": "Inserire l'indirizzo della centrale elettrica",
  "placeholder.enterOldPassword": "Inserisci la vecchia password",
  "placeholder.enterNewPassword": "Inserisci una nuova password",
  "placeholder.enterConfirmPassword": "Conferma la nuova password",
  "placeholder.enter": "Inserisci {scope}",
  "placeholder.country": "paese",
  "placeholder.city": "città",
  "placeholder.scanCodeAddPlant": "Scansiona il codice per aggiungere una centrale elettrica!",
  "placeholder.currentNoPlant": "Attualmente non ci sono centrali elettriche, clicca per aggiungere!",
  "placeholder.selectRepeatTime": "Seleziona un tempo di ripetizione",
  "placeholder.enterDatalogger": "Inserire il numero di serie del collettore",
  "placeholder.enterDeviceSN": "Inserire il numero di serie del dispositivo",
  "setting.general.needGreat": "Necessità di essere più grande di",
  "setting.general.needSmall": "Necessità di essere meno di",
  "setting.general.gapScope": "L'intervallo tra i parametri di input è",
  "setting.general.valScope": "La gamma dei parametri di input è",
  "setting.socket.switchStatus": "Interruttore a presa",
  "setting.socket.repetition": "Tempo di ripetizione",
  "setting.socket.enableOrNot": "È abilitato",
  "setting.socket.monday": "Lunedì",
  "setting.socket.tuesday": "Martedì",
  "setting.socket.wednesday": "Mercoledì",
  "setting.socket.thursday": "Giovedì",
  "setting.socket.friday": "Venerdì",
  "setting.socket.saturday": "Sabato",
  "setting.socket.sunday": "Domenica",
  "setting.type3.dischargeScheduleMode": "Modalità di scarica temporizzata",
  "setting.type3.timeDischarge": "Scarico a tempo determinato",
  "setting.type3.workingDay": "giorno feriale",
  "setting.type3.weekend": "fine settimana",
  "setting.type3.pureLightControlMode": "Modalità di controllo della luce pura",
  "setting.type3.stopDischarge": "Valore di impostazione SOC di arresto basso",
  "setting.type3.chargeTransferDischarge": "SOC carica completa per scaricare valore impostato",
  "setting.type3.batterySOCSetting": "Impostazione SOC batteria",
  "setting.type3.lowBatteryAlam": "Valore di impostazione dell'allarme di fascia bassa per SOC batteria",
  "setting.type3.lowBatteryShutdown": "Valore di impostazione di scarica di arresto basso per SOC batteria",
  "setting.type3.systemSetting": "Impostazioni di sistema",
  "setting.type3.systemWorkMode": "Modalità di funzionamento del sistema",
  "setting.type3.restoreFactory": "Ripristina impostazioni di fabbrica",
  "setting.type3.loadMode": "Modalità di carico",
  "setting.type3.timingDischarge": "Modalità di scarica temporizzata",
  "setting.type3.DCOutputNormallyClosed": "Uscita CC normalmente chiusa",
  "setting.type3.DCOutputNormallyOpen": "Uscita CC normalmente aperta",
  "setting.type3.ForcedPowerProtection": "Modalità di protezione obbligatoria dell'alimentazione",
  "setting.type3.mode": "modello",
  "setting.type3.startTime": "ora di inizio",
  "setting.type3.stopTime": "Tempo di fine",
  "setting.type3.onlyAddThree": "Aggiungi fino a 21 timer",
  "setting.type3.startCompareEnd": "L'ora di inizio del timer può essere solo inferiore all'ora di fine",
  "setting.type3.confirmClose": "Sei sicuro di voler chiudere?",
  "setting.type6.countryCode": "Codice paese",
  "setting.type6.poweradjppm": "Tasso di regolazione della potenza dell'invertitore",
  "setting.type6.enaINVTR": "Accensione/spegnimento remoto",
  "setting.type6.enaSysProtIF_selfCheck": "Autoprova dell'interfaccia di protezione del sistema",
  "setting.type6.enaRestoretodefault": "Ripristina valori predefiniti",
  "setting.type6.UV_resopnseTime": "Tempo di risposta sotto tensione del livello{num}",
  "setting.type6.UF_resopnseTime": "Tempo di risposta sottofrequenza del livello{num}",
  "setting.type6.OV_resopnseTime": "Tempo di risposta di sovratensione del livello{num}",
  "setting.type6.OF_resopnseTime": "Tempo di risposta overclocking del livello{num}",
  "setting.type6.open": "aperto",
  "setting.type6.recover": "recupero",
  "setting.type6.noHave": "niente",
  "setting.type6.activePowerSwitch": "Interruttore di alimentazione attivo",
  "setting.type6.activePowerPermillage": "Percentuale di potenza attiva per mille",
  "setting.type7.paramterSetting": "Impostazioni dei parametri",
  "setting.type7.batteryVoltage": "Tensione della batteria",
  "setting.type7.batteryCapacity": "Capacità della batteria",
  "setting.type7.PVChargingCurrent": "Corrente di carica fotovoltaica",
  "setting.type7.overVoltage": "Tensione di sovratensione",
  "setting.type7.chargingLimitVoltage": "Tensione limite di carica",
  "setting.type7.increaseChargeReturnVoltage": "Aumentare la tensione di ritorno di carica",
  "setting.type7.overDischargeVoltage": "Tensione di sovraccarico",
  "setting.type7.stopchangeCurrent": "Ferma la corrente di carica",
  "setting.type7.inverter485Address": "485 Indirizzo",
  "setting.type7.passwordValue": "Password utente",
  "setting.type7.inputPassword": "Inserimento della password",
  "setting.type7.recordFaultCodes": "Registra codici di errore",
  "setting.type7.isOpen": "Comando di accensione/spegnimento",
  "setting.type7.equalizingChargeCmd": "Caricare e bilanciare immediatamente",
  "setting.type7.reset": "Ripristina controllo",
  "setting.type7.factory": "Ripristina impostazioni di fabbrica",
  "setting.type7.clearAlarm": "Cancella l' avviso corrente",
  "setting.type7.clearHistory": "Cancella cronologia",
  "setting.type7.generatorSwitchCmd": "Commutazione del generatore",
  "setting.type7.nowTimeStr": "ora corrente",
  "setting.type7.setVal.reset": "reset",
  "setting.type7.setVal.recover": "recupero",
  "setting.type7.setVal.clearAlarm": "avviso di cancellazione",
  "setting.type7.setVal.clearHistory": "Cancella cronologia",
  "setting.type7.setVal.toggle": "switch",
  "setting.type8.systemSwitch": "Interruttore di sistema",
  "setting.type10.modeSelect": "modello",
  "setting.type10.standbyMode": "Modalità backup",
  "setting.type10.PureOffGrid": "Modalità di avvio off grid pura",
  "setting.type10.energyNet": "Impostazioni dell'uscita collegata alla griglia",
  "setting.type10.inverter0": "Inverter per integrare l'energia al carico locale",
  "setting.type10.inverter1": "Inverter per generare elettricità per la rete elettrica",
  "setting.type10.inverter2": "Inverter a carico locale con TC",
  "setting.type10.inverter3": "Inverter a carico locale o presa intelligente e contatore intelligente",
  "setting.type10.chargePriority": "Priorità di ricarica",
  "setting.type10.PVPriority": "Priorità data al fotovoltaico",
  "setting.type10.utilityPriority": "Priorità data all'elettricità di rete",
  "setting.type10.hybridModel": "Carica mista",
  "setting.type10.PVOnly": "Solo ricarica fotovoltaica",
  "setting.type10.batteryLowAlarm": "Punto di avvertimento della batteria scarica",
  "setting.type10.batteryLowShutdown": "Punto di arresto della batteria a basso consumo",
  "setting.type10.batteryFull": "Punto di arresto della batteria completamente carica",
  "setting.type10.ACCharging": "Tempo di ricarica",
  "setting.type10.startTime": "Orario di inizio",
  "setting.type10.endTime": "Tempo di fine",
  "setting.type10.forcedDischarge": "Tempo di scarico",
  "setting.type10.phaseGridSide": "Lato griglia",
  "setting.type10.power": "Potenza attiva di fase",
  "setting.type10.current": "Corrente di fase",
  "setting.type10.gridConnectionStandard": "Standard griglia",
  "setting.type10.baudRate": "485 baud rate",
  "setting.type10.disable": "Non abilitare",
  "setting.type10.enable": "Abilita",
  "setting.type10.ApprovalStandards": "Norme di certificazione",
  "setting.type10.antiRefluxPower": "Potenza antiriflusso",
  "setting.type10.antiRefluxSet": "Abilita anti-backflow",
  "setting.type10.batFullSocSet": "Valore di giudizio della saturazione della batteria (%)",
  "setting.type10.auxSourceSet": "Interruttore sorgente ausiliario",
  "setting.type10.timeSharingGridConnectedDischarge": "Scarico collegato alla griglia di divisione temporale",
  "setting.type10.timeSharingGridConnection": "Impostazione della connessione alla griglia di condivisione del tempo",
  "setting.type10.outputPower": "potenza di uscita",
  "setting.type10.onlyAddThree": "Aggiungi fino a {num} timer",
  "setting.type10.productModelNumber": "Modello di prodotto",
  "setting.type10.PleaseTurnOnThe_PCS_switchFirst": "Per favore accendi prima l'interruttore.",
  "setting.type10.ThereIs_a_conflictInTheChargingAndDischargingTime": "C'è un conflitto nel tempo di ricarica e scarico",
  "setting.type10.ChargeDischargeTimeSetting": "Impostazione del tempo di ricarica e scarico",
  "setting.type11.switchPCS": "Comando di accensione/spegnimento",
  "setting.type11.functionSwitch": "Interruttore di funzione",
  "setting.type11.maxChargeVol": "Tensione massima di carica (V)",
  "setting.type11.onGridMinDischargeVol": "Tensione di scarica minima per il collegamento alla rete (V)",
  "setting.type11.offGridOutputVol": "Tensione di uscita fuori rete (V)",
  "setting.type11.maxChargeCur": "Potenza massima di carica",
  "setting.type11.onGridMaxDischargeCur": "Corrente massima di scarica per il collegamento alla rete (A)",
  "setting.type11.offGridMaxDisChargeCur": "Corrente massima di scarico fuori rete (A)",
  "setting.type11.minSocBMS": "SOC minimo di BMS (%)",
  "setting.type11.minSocDischarge": "SOC minimo (%) per scarico intelligente",
  "setting.type11.maxSocDischarge": "Scarico intelligente massimo SOC (%)",
  "setting.type11.timeStr": "Tempo dell'attrezzatura",
  "setting.type11.timerSetting": "Impostazione del timer {num}",
  "setting.type11.chargeStartTime1": "Tempo di ricarica iniziale 1",
  "setting.type11.chargeLongTime1": "Durata della ricarica 1",
  "setting.type11.chargeTimeMaxSOC1": "SOC massimo (%) durante il periodo di ricarica 1",
  "setting.type11.chargeTimeCurrent1": "Periodo di ricarica 1 Corrente di ricarica (A)",
  "setting.type11.dischargeStartTime1": "Tempo di scarico iniziale 1",
  "setting.type11.dischargeLongTime1": "Durata dello scarico 1",
  "setting.type11.dischargeTimeMaxSOC1": "SOC minimo (%) durante il periodo di scarico 1",
  "setting.type11.dischargeTimeCurrent1": "Periodo di scarico 1 Corrente di scarico (A)",
  "setting.type11.chargeStartTime2": "Tempo di ricarica iniziale 2",
  "setting.type11.chargeLongTime2": "Durata della ricarica 2",
  "setting.type11.chargeTimeMaxSOC2": "SOC massimo durante il periodo di ricarica 2 (%)",
  "setting.type11.chargeTimeCurrent2": "Periodo di ricarica 2 Corrente di ricarica (A)",
  "setting.type11.dischargeStartTime2": "Tempo di scarico iniziale 2",
  "setting.type11.dischargeLongTime2": "Durata dello scarico 2",
  "setting.type11.dischargeTimeMaxSOC2": "SOC minimo (%) durante il periodo di scarico 2",
  "setting.type11.dischargeTimeCurrent2": "Periodo di scarico 2 Corrente di scarico (A)",
  "setting.type11.chargeStartTime3": "Tempo di ricarica iniziale 3",
  "setting.type11.chargeLongTime3": "Durata della ricarica 3",
  "setting.type11.chargeTimeMaxSOC3": "SOC massimo durante il periodo di ricarica 3 (%)",
  "setting.type11.chargeTimeCurrent3": "Periodo di ricarica 3 Corrente di ricarica (A)",
  "setting.type11.dischargeStartTime3": "Tempo di scarico iniziale 3",
  "setting.type11.dischargeLongTime3": "Durata dello scarico 3",
  "setting.type11.dischargeTimeMaxSOC3": "SOC minimo (%) durante il periodo di scarico 3",
  "setting.type11.dischargeTimeCurrent3": "Periodo di scarico 3 Corrente di scarico (A)",
  "setting.type11.chargeStartTime4": "Tempo di ricarica iniziale 4",
  "setting.type11.chargeLongTime4": "Durata della ricarica 4",
  "setting.type11.chargeTimeMaxSOC4": "SOC massimo durante il periodo di ricarica 4 (%)",
  "setting.type11.chargeTimeCurrent4": "Periodo di ricarica 4 Corrente di ricarica (A)",
  "setting.type11.dischargeStartTime4": "Tempo di scarico iniziale 4",
  "setting.type11.dischargeLongTime4": "Durata dello scarico 4",
  "setting.type11.dischargeTimeMaxSOC4": "SOC minimo (%) durante il periodo di scarico 4",
  "setting.type11.dischargeTimeCurrent4": "Periodo di scarico 4 Corrente di scarico (A)",
  "setting.type11.functionSwitchObj.val1": "Modalità intelligente",
  "setting.type11.functionSwitchObj.val2": "Modalità timer",
  "setting.type11.functionSwitchObj.val3": "Modalità di autouso spontaneo",
  "setting.type12.LEDSwitch": "Interruttore LED",
  "setting.type12.LEDSpeed": "Velocità LED",
  "setting.type12.LEDEffect": "Effetto LED",
  "setting.type12.LEDBrightness": "Luminosità LED",
  "setting.type12.dataColor": "Rappresentazione a colori dei dati",
  "setting.type12.LED1Color": "Colore LED1",
  "setting.type12.LED2Color": "Colore LED2",
  "setting.type12.LED3Color": "Colore LED3",
  "setting.type12.buzzerAlarm": "Allarme acustico",
  "setting.type12.overLoadToBypass": "Sovraccarico da bypassare",
  "setting.type12.lcdRestartPage": "Interfaccia principale senza recupero dell'operazione LCD",
  "setting.type12.overloadReset": "Riavvio sovraccarico",
  "setting.type12.overloadTemperature": "Riavvio a temperatura eccessiva",
  "setting.type12.backLightOn": "LCD senza retroilluminazione operativa",
  "setting.type12.inputSourceChangeAlarm": "Allarme cambio sorgente di ingresso",
  "setting.type12.faultCodeRecord": "Registrazione di errori del software di comunicazione",
  "setting.type12.solarFeedToGird": "Collegamento alla rete di energia solare inattiva",
  "setting.type12.switchOptions": "Cambia opzioni",
  "setting.type12.batteryParam": "Parametri della batteria",
  "setting.type12.outputParam": "Parametri di uscita",
  "setting.type12.ratedOutputVol": "Tensione nominale di uscita",
  "setting.type12.ratedOutputFreq": "Frequenza nominale di uscita",
  "setting.type12.inputVolRange": "Campo di tensione in ingresso",
  "setting.type12.outPutSourcePriority": "Priorità sorgente di output",
  "setting.type12.batType": "Tipo di batteria",
  "setting.type12.batUnderVol": "Tensione di interruzione della batteria",
  "setting.type12.batBulkVol": "Tensione di carica costante della batteria",
  "setting.type12.batFloatVol": "Tensione di carica del galleggiante della batteria",
  "setting.type12.maxChargingCur": "Corrente massima di carica",
  "setting.type12.maxAcChargingCur": "Corrente massima di carica CA",
  "setting.type12.chargeSourcePriority": "Priorità sorgente caricabatterie",
  "setting.type12.batReChargeVol": "Ripristina la tensione di carica",
  "setting.type12.batFullRestoreDischargeVol": "Ripristina tensione di scarica",
  "setting.type12.solarSupplyPriority": "Priorità data all'alimentazione solare",
  "setting.type12.resetPvStorage": "Ripristina i dati statistici FV",
  "setting.type12.countryRegulations": "Regolamenti nazionali",
  "setting.type12.acChargeStartTime": "Ora di inizio del funzionamento del caricatore di comunicazione",
  "setting.type12.acChargeEndTime": "Tempo di arresto del funzionamento del caricatore di comunicazione",
  "setting.type12.acSupplyStartTime": "Ora di inizio dell'alimentazione CA",
  "setting.type12.acSupplyEndTime": "Tempo di arresto dell'alimentazione CA",
  "setting.type12.restoreFactorySet": "Ripristina impostazioni di fabbrica",
  "setting.type12.parallelMode": "Modalità parallela",
  "setting.type12.bulkChargeVol": "Tensione di carica CV",
  "setting.type12.batEquSet": "Funzione di equalizzazione della batteria",
  "setting.type12.batEquTime": "Tempo medio di ricarica della batteria (min)",
  "setting.type12.batEquDay": "Intervallo medio di carica della batteria (d)",
  "setting.type12.batEquChargeVol": "Tensione media di carica della batteria (V)",
  "setting.type12.batEquTimeout": "Timeout di equalizzazione della batteria (min)",
  "setting.type12.equInfoSet": "Impostazione equilibrata delle informazioni",
  "setting.type12.val.slow": "lento",
  "setting.type12.val.medium": "in",
  "setting.type12.val.fast": "veloce",
  "setting.type12.val.low": "basso",
  "setting.type12.val.high": "alto",
  "setting.type12.val.powerCycle": "Ciclo energetico",
  "setting.type12.val.powerRotation": "Rotazione di potenza",
  "setting.type12.val.additionalPower": "Potenza supplementare",
  "setting.type12.val.powerUnchanged": "La potenza rimane invariata",
  "setting.type12.val.solarPowerInput": "Energia solare in ingresso",
  "setting.type12.val.batteryCapacity": "Percentuale della capacità della batteria",
  "setting.type12.val.percentageLoad": "Percentuale di carico",
  "setting.type12.val.energySource": "Fonte di energia",
  "setting.type12.val.batteryStatus": "Stato di carica e scarica della batteria",
  "setting.type12.val.blue": "blu",
  "setting.type12.val.cyan": "Colore blu",
  "setting.type12.val.green": "verde",
  "setting.type12.val.pink": "Rosa",
  "setting.type12.val.purple": "Viola;",
  "setting.type12.val.orange": "arancione",
  "setting.type12.val.yellow": "giallo",
  "setting.type12.val.white": "bianco",
  "setting.type12.val.inputOvlRange1": "Modalità APL (90-280V)",
  "setting.type12.val.inputOvlRange2": "Modalità UPS (170-280V)",
  "setting.type12.val.outputSource1": "Energia solare ->Pubblico ->Batteria",
  "setting.type12.val.outputSource2": "Energia solare ->Batteria ->Uso pubblico",
  "setting.type12.val.chargeSourcePriority1": "Priorità data al fotovoltaico",
  "setting.type12.val.chargeSourcePriority2": "Fotovoltaico e rete elettrica",
  "setting.type12.val.chargeSourcePriority3": "Solo fotovoltaico",
  "setting.type12.val.solarSupplyPriority1": "Utilità di carico della batteria",
  "setting.type12.val.solarSupplyPriority2": "Carico - Batteria - Utilità",
  "setting.type12.val.countryRegulations1": "India",
  "setting.type12.val.countryRegulations2": "Germania",
  "setting.type12.val.countryRegulations3": "Sudamerica",
  "setting.type12.val.parallelMode1": "Nessuna macchina parallela",
  "setting.type12.val.parallelMode2": "Funzionamento parallelo monofase",
  "setting.type12.val.outPutSourcePriority1": "Priorità data all'elettricità di rete",
  "setting.type12.val.outPutSourcePriority2": "Priorità data all'energia solare",
  "setting.type12.val.outPutSourcePriority3": "Energia solare ->batteria ->alimentazione di rete",
  "setting.ops15.invSwitch": "Interruttore invertitore",
  "setting.ops15.workMode": "Modalità di lavoro",
  "setting.ops15.workMode1": "Priorità della rete di alimentazione",
  "setting.ops15.workMode2": "Modalità griglia disattivata",
  "setting.ops15.workMode3": "Autouso spontaneo",
  "setting.ops15.invTime": "Tempo invertitore",
  "setting.ops15.batType": "Tipo di batteria",
  "setting.ops15.batType1": "Nessuna batteria",
  "setting.ops15.batType2": "Batteria al litio universale",
  "setting.ops15.batType3": "Batteria al piombo",
  "setting.ops15.batType4": "batteria al litio",
  "setting.ops15.timingTime": "Tempo cronometrato",
  "setting.ops15.offGirdSoc": "Scarico eccessivo SOC (%)",
  "setting.ops15.optimizeRevenue": "Ottimizzare le entrate",
  "setting.type19.totalActivePower": "Potenza attiva",
  "setting.type19.offgridSettings": "Impostazione fuori griglia",
  "setting.type19.gridConnectedControlMode": "Controllo connesso alla rete",
  "setting.type19.offGridControlMode": "Controllo fuori rete",
  "setting.type19.offgrid.gridNet": "Collegamento alla rete",
  "setting.type19.offgrid.offNet": "Fuori griglia",
  "setting.type22.parameterScope": "Intervallo dei parametri",
  "setting.type22.ACStartVoltage": "Regolazione della tensione di avviamento/frequenza",
  "setting.type22.highVoltage": "Alta tensione di avvio AC",
  "setting.type22.lowVoltage": "Avviamento AC bassa tensione",
  "setting.type22.pvStartLowVol": "Avviamento fotovoltaico a bassa tensione",
  "setting.type22.acUnderVol1": "Sottotensione AC di primo ordine (V)",
  "setting.type22.acOverVol1": "Sovratensione CA di primo ordine (V)",
  "setting.type22.acUnderVolTime1": "Tempo di primo ordine di sottotensione CA",
  "setting.type22.acOverVolTime1": "Tempo di sovratensione CA di primo ordine (s)",
  "setting.type22.acUnderVol2": "Sottotensione CA secondo ordine (V)",
  "setting.type22.acOverVol2": "Sovratensione CA secondo ordine (V)",
  "setting.type22.acUnderVolTime2": "Tempo (s) di secondo ordine di sottotensione CA",
  "setting.type22.acOverVolTime2": "Tempo (s) di sovratensione CA di secondo ordine",
  "setting.type22.startDelayTime": "Tempo di ritardo di inizio",
  "setting.type22.restartDelayTime": "Tempo di ritardo di riavvio",
  "setting.type22.ACStartFrequency": "Regolazione di sovratensione/sottotensione/frequenza",
  "setting.type22.highFrequency": "Avvio AC ad alta frequenza",
  "setting.type22.lowFrequency": "Avvio AC bassa frequenza",
  "setting.type22.acUnderFrequency1": "Sottofrequenza AC di primo ordine (Hz)",
  "setting.type22.acOverFrequency1": "AC Overfrequency First Order (Hz)",
  "setting.type22.acUnderFrequencyTime1": "Tempo (s) di primo ordine sotto frequenza AC",
  "setting.type22.acOverFrequencyTime1": "AC Overfrequency First Order Time (s)",
  "setting.type22.acUnderFrequency2": "Sottofrequenza AC secondo ordine (Hz)",
  "setting.type22.acOverFrequency2": "AC Overfrequency Second Order (Hz)",
  "setting.type22.acUnderFrequencyTime2": "Tempo (s) di secondo ordine sotto frequenza AC",
  "setting.type22.acOverFrequencyTime2": "AC Overfrequency Second Order Time (s)",
  "setting.type22.systemSetting": "Impostazioni informazioni dispositivo",
  "setting.type22.SNset": "Impostazione del numero di serie",
  "setting.type22.reactiveControlMode": "Modalità di controllo della potenza reattiva",
  "setting.type22.inputMode": "Modalità di ingresso",
  "setting.type22.startSolpe": "Inclinazione iniziale",
  "setting.type22.restartSolpe": "Riavvia pendenza",
  "setting.type22.reactivePercentage": "Percentuale di potenza reattiva",
  "setting.type22.activePercentage": "Percentuale di merito",
  "setting.type22.shutdown": "Interruttore remoto",
  "setting.type22.functionSelect": "Selezione delle funzioni",
  "setting.type22.manufacturer": "produttore",
  "setting.type22.setFunctionSelect.val1": "proibire",
  "setting.type22.setFunctionSelect.val2": "Abilita misure anti-backflow",
  "setting.type22.setManufacturer.val1": "Yingweiteng",
  "setting.type22.setManufacturer.val2": "Skyworth",
  "setting.type22.reactiveControlModeChoice.val1": "Controllo del fattore di potenza",
  "setting.type22.reactiveControlModeChoice.val2": "Controllo percentuale di potenza reattiva",
  "setting.type22.reactiveControlModeChoice.val3": "Controllo curva QV",
  "setting.type22.inputModeChoice.val1": "Modalità indipendente di ingresso",
  "setting.type22.inputModeChoice.val2": "Modalità parallela di ingresso",
  "setting.type22.inputModeChoice.val3": "Modalità sorgente CC",
  "title.login": "Accedi",
  "title.vistorLogin": "Accesso turistico",
  "title.createAccount": "Crea un account",
  "title.retrievePassword": "Recupera password",
  "title.userAgreement": "Accordo utente",
  "title.privacyPolicy": "Accordo sulla privacy",
  "title.phone": "Telefono",
  "title.addPlant": "Aggiungere centrale elettrica",
  "title.editPlant": "Modifica centrale elettrica",
  "title.accountInfo": "Informazioni sul conto",
  "title.changePassword": "Cambia password",
  "title.message": "Notifiche",
  "title.systemMessage": "Messaggio di sistema",
  "title.faultMessage": "Messaggio di errore",
  "title.deviceMessage": "Messaggio del dispositivo",
  "title.aboutUs": "circa",
  "title.device": "apparecchiature",
  "title.datalogger": "collettore",
  "title.setting": "istituito",
  "title.socketSetting": "impostazione della presa",
  "title.addSchedule": "Aggiungi timer",
  "title.editSchedule": "Modifica timer",
  "title.repetitionTime": "Tempo di ripetizione",
  "title.addDatalogger": "Aggiungi dispositivo",
  "title.connectWifi": "Percorso di connessione",
  "title.distributionNetworkStatus": "Stato della rete di distribuzione",
  "title.language": "lingua",
  "title.selectCountry": "Seleziona paese",
  "title.selectCity": "Seleziona città",
  "bar.home": "home page",
  "bar.energy": "analisi",
  "bar.plant": "centrale elettrica",
  "bar.user": "utente",
  "bar.endpoint": "terminale",
  "bar.mine": "il mio",
  "bar.my": "il mio",
  "button.logOut": "Esci",
  "button.rememberMe": "Ricorda la password dell'account",
  "button.forgetPassword": "Password dimenticata",
  "button.register": "registro",
  "button.ok": "Confermare",
  "button.send": "inviare",
  "button.auto": "automatico",
  "button.cancle": "Annulla",
  "button.yes": "sì",
  "button.close": "chiudi",
  "button.refresh": "Aggiorna",
  "button.next": "passo successivo",
  "button.redistributionNetwork": "Riorganizza la rete di distribuzione",
  "button.upload": "Carica",
  "button.confirm": "Confermare",
  "button.edit": "modifica",
  "button.delete": "elimina",
  "button.save": "conservazione",
  "button.allReady": "Tutti letti",
  "button.selectAll": "Seleziona tutto",
  "button.deselectAll": "Annulla tutta la selezione",
  "button.unsubscribe": "Annulla account",
  "button.later": "Più tardi",
  "button.upgrade": "da aggiornare",
  "button.unfollow": "Annulla Segui",
  "button.add": "Aggiungi a",
  "subtitle.NeedMoreHelp": "Altro aiuto",
  "subtitle.VisitSupportCenter": "Sfoglia il sito ufficiale per maggiori informazioni",
  "subtitle.energyFlowDiagram": "Diagramma del flusso energetico",
  "subtitle.selectTimezone": "Seleziona fuso orario",
  "subtitle.selectPlantType": "Seleziona il tipo di centrale elettrica",
  "subtitle.selectInstallationDate": "Seleziona data di installazione",
  "subtitle.selectCurrency": "Scegli valuta",
  "subtitle.selectDateType": "Seleziona tipo di data",
  "subtitle.selectDeviceType": "Seleziona tipo di dispositivo",
  "subtitle.socketBluetooth": "Socket Bluetooth",
  "subtitle.log": "diario",
  "subtitle.all": "intero",
  "subtitle.online": "on-line",
  "subtitle.offline": "off-line",
  "subtitle.normal": "normale",
  "subtitle.abnormal": "anormale",
  "subtitle.on": "aperto",
  "subtitle.off": "chiudi",
  "subtitle.todayEnergy": "Il consumo attuale di energia elettrica",
  "subtitle.totalEnergy": "Consumo totale di energia elettrica",
  "subtitle.totalRevenue": "Redditi totali",
  "subtitle.plantImage": "Foto delle centrali elettriche",
  "subtitle.plantName": "Nome della centrale elettrica",
  "subtitle.plantType": "Tipo di centrale elettrica",
  "subtitle.PVCapacity": "Capacità fotovoltaica",
  "subtitle.installationDate": "data di installazione",
  "subtitle.plantAddress": "Indirizzo della centrale elettrica",
  "subtitle.revenue": "reddito",
  "subtitle.timeZone": "fuso orario",
  "subtitle.updatePhone": "Aggiorna il numero di telefono",
  "subtitle.solar": "fotovoltaico",
  "subtitle.grid": "rete elettrica",
  "subtitle.battery": "Batteria",
  "subtitle.home": "carico",
  "subtitle.load": "carico",
  "subtitle.socket": "Presa",
  "subtitle.today": "giorno",
  "subtitle.day": "giorno",
  "subtitle.month": "mese",
  "subtitle.year": "anno",
  "subtitle.total": "totale",
  "subtitle.time": "tempo",
  "subtitle.Co2": "anidride carbonica",
  "subtitle.coal": "Carbone",
  "subtitle.deforestation": "Alberi",
  "subtitle.parameter": "parametro",
  "subtitle.schedule": "timer",
  "subtitle.countdown": "conto alla rovescia",
  "subtitle.socketSwitch": "Interruttore a presa",
  "subtitle.currency": "valuta",
  "subtitle.energyPrice": "Prezzo dell'elettricità",
  "subtitle.storagePlant": "Centrale elettrica di stoccaggio dell'energia",
  "subtitle.on-GridPlant": "Centrale elettrica collegata alla rete",
  "subtitle.photo": "ritratto della testa",
  "subtitle.email": "cassetta postale",
  "subtitle.account": "conto",
  "subtitle.version": "edizione",
  "subtitle.officalWebsite": "Sito ufficiale",
  "subtitle.SN": "numero di serie",
  "subtitle.wifiSignal": "Segnale WiFi",
  "subtitle.lastSync": "Finalmente sincronizzato",
  "subtitle.switch": "switch",
  "subtitle.happening": "In corso",
  "subtitle.restored": "Recuperato",
  "subtitle.details": "dettagli",
  "subtitle.warn": "dare un allarme",
  "subtitle.fault": "errore",
  "subtitle.status": "stato",
  "subtitle.level": "Grado",
  "subtitle.deviceType": "Tipo di attrezzatura",
  "subtitle.alarmStartTime": "Ora di inizio allarme",
  "subtitle.alarmEndTime": "Ora di fine allarme",
  "subtitle.solution": "risoluzione",
  "subtitle.noSolution": "Per la risoluzione dei problemi, consultare il manuale d'uso o contattare il servizio di assistenza.",
  "subtitle.loginIn": "Accesso",
  "subtitle.checkVersion": "Cerca aggiornamenti",
  "subtitle.versionUpgrade": "Aggiornamento della versione",
  "subtitle.alarmName": "Nome allarme",
  "subtitle.messageDetail": "Dettagli del messaggio",
  "subtitle.todayConsumption": "Il consumo energetico attuale",
  "subtitle.totalConsumption": "Consumo energetico",
  "subtitle.dataloggerSN": "Numero di serie del collettore",
  "subtitle.configurationGuidance": "Guida alla configurazione",
  "subtitle.guideVideo": "Video guida",
  "subtitle.manualInstuction": "Guida",
  "subtitle.manualInstuction4G": "Guida 4G",
  "subtitle.manualInstuctionMasterControl": "Manuale di controllo principale",
  "subtitle.masterControlConfiguration": "Rete principale di distribuzione di controllo",
  "subtitle.defaultConfiguration": "Rete di distribuzione predefinita",
  "subtitle.findEmail": "Recupero e-mail",
  "subtitle.findPhone": "Recupero cellulare",
  "subtitle.family": "famiglia",
  "subtitle.agent": "agente",
  "subtitle.endUsers": "utente finale",
  "subtitle.deviceManagement": "Dispositivo",
  "subtitle.deviceSN": "Numero di serie dell'apparecchiatura",
  "subtitle.firmwareVersion": "Versione firmware",
  "subtitle.alias": "alias",
  "subtitle.information": "informazioni",
  "subtitle.domainName": "nome di dominio",
  "subtitle.restartdatalogger": "Riavvia il raccoglitore",
  "subtitle.value": "valore",
  "subtitle.customizable": "personalizzato",
  "subtitle.ready": "leggere",
  "subtitle.deviceDetails": "dettagli del dispositivo",
  "subtitle.startAddress": "Indirizzo di avvio del registro",
  "subtitle.endAddress": "Termina l'indirizzo del registro",
  "subtitle.settingParam": "Imposta parametri",
  "subtitle.tariffType": "Tipo di prezzo dell'elettricità",
  "subtitle.fixed": "fisso",
  "subtitle.timeshare": "Ripartizione del tempo",
  "subtitle.addTime": "Aggiungi tempo",
  "subtitle.notAllDay": "Non tutto il giorno",
  "subtitle.dealer": "distributore",
  "subtitle.dealerNumber": "ID rivenditore",
  "subtitle.toggle": "switch",
  "subtitle.environmentalBenefit": "benefici ambientali",
  "subtitle.basicParam": "Parametri di base",
  "subtitle.realTimeParam": "Parametri in tempo reale",
  "subtitle.export": "esportazione",
  "subtitle.localDebug": "debug vicino alla fine",
  "subtitle.mode": "modalità",
  "subtitle.manuallyAdd": "Aggiungi manualmente",
  "subtitle.AttachTheDevice": "Apparecchiature per appendere",
  "subtitle.ammeter": "wattora",
  "subtitle.FeederPowerOnTheSameDay": "Alimentazione giornaliera alla rete",
  "subtitle.BatterySOC": "SOC batteria",
  "subtitle.DailyChargingCapacityOfTheBattery": "Capacità di carica giornaliera della batteria",
  "subtitle.DailyPowerConsumption": "Consumo energetico giornaliero",
  "subtitle.CumulativePowerGeneration": "Produzione di energia accumulata",
  "subtitle.total2": "totale",
  "subtitle.run": "funzione",
  "subtitle.StopIt": "Fermati",
  "subtitle.Optimizer": "ottimizzatore",
  "subtitle.DataGateways": "gateway dati",
  "subtitle.dataType": "tipo di dati",
  "subtitle.Model": "modello",
  "subtitle.TheAmountOfElectricityGeneratedToday": "Produzione Elettrica Odierna",
  "subtitle.CurrentPower": "Potenza corrente",
  "subtitle.AllOptimizerWorkingStatus": "Tutti gli stati di lavoro dell'ottimizzatore",
  "subtitle.WhenClosedAllOptimizersStopWorking": "Dopo l'arresto, tutti gli ottimizzatori smetteranno di funzionare",
  "subtitle.TheDataGatewayRestarts": "Riavvio del gateway dati",
  "subtitle.Reboot": "riavvia",
  "subtitle.Restarting": "Riavvio in corso",
  "subtitle.HardwareVersionNumber": "Numero di versione hardware",
  "subtitle.SoftwareVersionNumber": "Numero di versione del software",
  "subtitle.OutputPower": "potenza di uscita",
  "subtitle.OutputVoltage": "tensione di uscita",
  "subtitle.OutputCurrent": "Corrente di uscita",
  "subtitle.InputPower": "Potenza in ingresso",
  "subtitle.InputVoltage": "tensione di ingresso",
  "subtitle.InputCurrent": "Corrente di ingresso",
  "subtitle.OperationalStatus": "Stato di Funzionamento",
  "subtitle.temperature": "temperatura(℃)",
  "subtitle.DeviceAddress": "Indirizzo dell'attrezzatura",
  "subtitle.FeederMode": "Modalità rete di alimentazione",
  "subtitle.StandbyMode": "Modalità backup",
  "subtitle.Off-gridMode": "Modalità griglia disattivata",
  "subtitle.TimedChargingAndDischarging": "Caricamento e scarico a tempo determinato",
  "subtitle.WorkingModeSettings": "Impostazione modalità di lavoro",
  "subtitle.DeviceInformation": "Informazioni sulle apparecchiature",
  "subtitle.HMISoftwareVersion": "Versione software HMI",
  "subtitle.DSPSoftwareVersion": "Versione software DSP",
  "subtitle.ChargeAndDischargeTimePeriodSetting": "Impostazione del periodo di ricarica e scarico",
  "subtitle.ChargingPeriod": "Periodo di ricarica",
  "subtitle.DischargeTimePeriod": "Periodo di scarico",
  "subtitle.BatteryMinimumSOC(%)": "SOC minimo della batteria (%)",
  "subtitle.BatteryOvervoltageMethod(V)": "Valore del metodo di sovratensione della batteria (V)",
  "subtitle.BatteryUndervoltageThreshold(A)": "Soglia di sottotensione della batteria (A)",
  "subtitle.ChargingCurrentLimit(A)": "Limite di corrente di carica (A)",
  "subtitle.DischargeCurrentLimit(A)": "Limite della corrente di scarico (A)",
  "subtitle.Off-GridDischargeMinimumSOC(%)": "SOC minimo (%) per lo scarico fuori rete",
  "subtitle.Off-Grid-2-DischargeMinmumSOC(%)": "SOC minimo di scarico fuori griglia 2 (%)",
  "subtitle.Off-grid-2-DischargeMinimumBatteryVoltage(V)": "Tensione minima della batteria per scarica off grid 2 (V)",
  "subtitle.Auto-replenishment": "Ricarica automatica di energia",
  "subtitle.BatteryBMSActivationCommand": "Comando di attivazione BMS della batteria",
  "subtitle.ForcedFullCharge": "Carica forzata",
  "subtitle.ForceCharge2": "Tassa obbligatoria 2",
  "subtitle.ForceCharge1": "Tassa obbligatoria 1",
  "subtitle.DischargeEnabled": "Abilita scarico",
  "subtitle.ChargingEnabled": "Abilita ricarica",
  "subtitle.NumberOfOptimizers": "Numero di ottimizzatori",
  "subtitle.TheNameOfTheDevice": "Nome dell'apparecchiatura",
  "subtitle.GeneralSettings": "Impostazioni generali",
  "subtitle.Anti-backflowSwitch": "Interruttore anti-flusso",
  "subtitle.ReflowPowerLimit(W)": "Limite di potenza di riflusso (W)",
  "subtitle.OptimizerNumber": "Numero dell'ottimizzatore",
  "subtitle.reset": "Ripristina",
  "subtitle.areYouSure": "Sei sicuro di voler resettare",
  "subtitle.PhysicalView": "Vista fisica",
  "subtitle.LogicalView": "Vista logica",
  "subtitle.LayoutDrawing": "Layout",
  "tip.noData": "Nessun dato disponibile al momento",
  "tip.base.maxDistance": "più lontano",
  "tip.base.minDistance": "ultimamente",
  "tip.base.maxSize": "massimo",
  "tip.base.minSize": "minimo",
  "tip.request.loading": "Caricamento in corso",
  "tip.request.netWork": "Connessione di rete non riuscita, controlla la rete",
  "tip.request.connectServerFail": "Impossibile connettersi al server",
  "tip.request.requestTimeout": "timeout della richiesta",
  "tip.validate.choiceCountry": "Seleziona prima un paese",
  "tip.validate.country": "Il paese non può essere vuoto, selezionare il paese",
  "tip.validate.timeZone": "Il fuso orario non può essere vuoto, seleziona un fuso orario",
  "tip.validate.email": "Errore di formato email, inserisci un indirizzo email corretto",
  "tip.validate.verification": "Si prega di inviare prima il codice di verifica",
  "tip.validate.verificationError": "Errore del codice di verifica, inserisci un codice di verifica valido",
  "tip.validate.passwordFormTip": "Inserisci una password composta da 6-20 cifre di numeri e lettere",
  "tip.validate.passwordError": "Errore di formato password, inserisci una password composta da 6-20 cifre di numeri e lettere",
  "tip.validate.passwordError2": "Inserisci una password valida (la password non deve includere caratteri speciali, simboli o spazi)",
  "tip.validate.validatePassword": "Le due password che hai inserito non corrispondono. Controlla e reinseri",
  "tip.validate.confirmAgreement": "Si prega di leggere e accettare prima l'accordo sulla privacy",
  "tip.validate.plantName": "Il nome della centrale elettrica non può essere vuoto. Inserire il nome della centrale elettrica",
  "tip.validate.plantType": "Il tipo di centrale elettrica non può essere vuoto, selezionare il tipo di centrale elettrica",
  "tip.validate.pvCapacity": "La capacità della cella solare non può essere vuota, inserisci la capacità della batteria",
  "tip.validate.installationDate": "La data di installazione non può essere vuota, selezionare la data di installazione",
  "tip.validate.city": "La città non può essere vuota, seleziona una città",
  "tip.validate.incomeunit": "La valuta non può essere vuota, seleziona la valuta",
  "tip.validate.energyPrice": "Il prezzo dell'elettricità non può essere vuoto, inserisci il prezzo dell'elettricità",
  "tip.validate.firstChoiceCountry": "Seleziona prima un paese",
  "tip.validate.oldPassword": "La vecchia password non può essere vuota, inserisci la vecchia password",
  "tip.validate.newPassword": "La nuova password non può essere vuota, inserisci la nuova password",
  "tip.validate.confirmPassword": "Confermare la password non può essere vuota, confermare la password",
  "tip.validate.passwordNotMatch": "I due input della password sono incoerenti. Si prega di controllare e confermare prima di inviare",
  "tip.validate.SN1": "Il numero di serie non può essere vuoto",
  "tip.validate.SN2": "Il numero di serie deve essere lungo 10 cifre",
  "tip.validate.noSocketTimer": "Attualmente non c'è nessun timer socket disponibile. Clicca per aggiungerlo",
  "tip.validate.cameraPermission": "L'app richiede l'autorizzazione della fotocamera per la scansione e l'aggiunta di collettori",
  "tip.validate.searchingState": "Ricerca di Bluetooth, si prega di non fare clic di nuovo",
  "tip.validate.notInTheScope": "I parametri di input non rientrano nell'intervallo specificato",
  "tip.validate.enterDecimal": "Deve inserire {num} cifre decimali o intere",
  "tip.validate.integer": "Deve essere un numero intero",
  "tip.validate.phone": "Il numero di telefono cellulare supporta solo la Cina continentale, si prega di utilizzare e-mail per recuperare altri",
  "tip.validate.can`tEmpty": "{param} non può essere vuoto",
  "tip.validate.dealerSope": "L'intervallo di numeri del rivenditore è di 6-8 cifre",
  "tip.validate.firstChoicePlant": "Selezionare prima la centrale elettrica",
  "tip.log.permissionOpen": "Assicurarsi che la posizione e le autorizzazioni Bluetooth siano abilitate",
  "tip.log.openBluetoothSystem": "Apri impostazioni Bluetooth",
  "tip.log.openIosBtSystem": "Riavvia l'interruttore Bluetooth",
  "tip.log.openLocationSystem": "Apri impostazioni della posizione",
  "tip.log.bluetoothAuthorization": "Autorizzazione Bluetooth APP non abilitata",
  "tip.log.locationAuthorization": "Autorizzazione posizione APP non abilitata",
  "tip.log.searchSurroundingDevicesPermission": "Ricerca non autorizzata di dispositivi vicini",
  "tip.log.bluetoothNotPermission": "Bluetooth non attivato",
  "tip.log.locationNotPermission": "Posizionamento non abilitato",
  "tip.log.bluetoothPermission": "Bluetooth abilitato",
  "tip.log.locationPermission": "Posizionamento abilitato",
  "tip.log.bluetoothException": "Disconnessione anomala Bluetooth, confermare che il Bluetooth del dispositivo è acceso e quindi riconnettersi",
  "tip.log.listeningFailure": "Monitoraggio delle modifiche del valore delle funzionalità non riuscito, riconnettersi a Bluetooth",
  "tip.log.communicationException": "La comunicazione Bluetooth è anormale, si prega di riconnettersi a Bluetooth",
  "tip.log.reconnect": "Riconnezione Bluetooth",
  "tip.log.connectFail": "Connessione Bluetooth non riuscita",
  "tip.log.connect": "Collega Bluetooth",
  "tip.log.bluetoothService": "Abilita il servizio Bluetooth",
  "tip.log.locationService": "Abilita i servizi di localizzazione",
  "tip.log.notsupport": "La piattaforma corrente supporta la funzione Bluetooth chiamata",
  "tip.log.locationNotTurnOn": "Posizione non abilitata, impossibile cercare Bluetooth",
  "tip.log.init": "Inizializzazione Bluetooth",
  "tip.log.searching": "Ricerca di Bluetooth in giro",
  "tip.log.searchFail": "Non sono stati trovati dispositivi in giro, assicurarsi che il Bluetooth del dispositivo sia acceso, quindi fare clic su Aggiorna",
  "tip.log.stopSearch": "Interrompi la ricerca del Bluetooth circostante",
  "tip.log.stopSearchFail": "Interrompere la ricerca del Bluetooth circostante non riuscita",
  "tip.log.connectSuccess": "Connessione Bluetooth riuscita",
  "tip.log.setMTUsSuccess": "Imposta con successo l'unità massima di trasmissione",
  "tip.log.setMTUsFail": "Impostazione massima dell'unità di trasmissione non riuscita",
  "tip.log.closeSuccess": "Connessione Bluetooth disconnessa",
  "tip.log.closeFail": "Connessione Bluetooth non riuscita",
  "tip.log.wifiLoadFail": "Caricamento della lista WiFi non riuscito, inserire manualmente",
  "tip.log.bluetoothAbnormal": "Connessione Bluetooth anomala, tentativo di riconnettersi",
  "tip.log.getBluetoothServiceSuccess": "Servizio di dispositivi Bluetooth ottenuto con successo",
  "tip.log.getBluetoothServiceFail": "Ottenere il servizio del dispositivo Bluetooth non riuscito",
  "tip.log.getFeatureValuesSucess": "Ottenuti con successo tutti i valori delle funzionalità nel servizio specificato del dispositivo Bluetooth",
  "tip.log.getFeatureValuesFail": "Recupero di tutti i valori delle funzionalità dal servizio specificato del dispositivo Bluetooth non riuscito",
  "tip.log.subscriptionEigenvalueSuccess": "La funzione di notifica per le modifiche del valore delle funzionalità del dispositivo Bluetooth a bassa potenza è stata abilitata, iscriviti ai valori delle funzionalità",
  "tip.log.subscriptionEigenvalueFail": "Abilitare la funzione di notifica quando il valore delle funzionalità dei dispositivi Bluetooth a bassa potenza cambia, il valore delle funzionalità di abbonamento non è riuscito",
  "tip.log.monitoringSuccess": "Monitorato con successo l'evento di modifica del valore delle funzionalità dei dispositivi Bluetooth a bassa potenza",
  "tip.log.monitoringFail": "Monitoraggio dell'evento di modifica del valore delle funzionalità dei dispositivi Bluetooth a bassa potenza non riuscito",
  "tip.log.CRC": "Verifica CRC non riuscita",
  "tip.log.queryWiFi": "Elenco WiFi interrogato correttamente",
  "tip.log.queryWiFiState": "Comando di query elenco WiFi emesso con successo",
  "tip.log.wifiConenct": "Interrogazione sullo stato della connessione di routing",
  "tip.log.wifiFail": "Controllare l'account del router e la password e provare a riconnettersi",
  "tip.log.connectWiFiSuccess": "Connessione router riuscita",
  "tip.log.connectWiFiFail": "Connessione router non riuscita",
  "tip.log.routerAccount": "Errore dell'account router",
  "tip.log.routerPassword": "Errore della password del router",
  "tip.log.gettingIP": "Ottenere l'indirizzo IP del router",
  "tip.log.getIPFail": "Impossibile ottenere l'IP del router",
  "tip.log.queryServerState": "Rilasciato con successo il comando per interrogare lo stato di interazione tra il dispositivo e il server",
  "tip.log.server03": "C'è lo scambio di dati 03",
  "tip.log.server04": "C'è 04 scambio di dati",
  "tip.log.heartbeat": "Interazione dei dati relativi al battito cardiaco",
  "tip.log.noInteraction": "Nessuna interazione dati",
  "tip.log.bluetoothCommunication": "La comunicazione Bluetooth è stata stabilita",
  "tip.log.connectWiFi": "Connessione WiFi",
  "tip.log.getWiFiList": "Interrogazione della lista WiFi",
  "tip.log.wifiName": "Il nome WiFi non può essere vuoto, seleziona o inserisci 2.4WiFi",
  "tip.log.wifiPasword": "Il WiFi non può essere vuoto, inserisci la password",
  "tip.log.wifiPasswordError": "La password WiFi non può contenere caratteri speciali (ǎṅò•♢ ∝ ℃℉, ecc.)",
  "tip.log.masterControlId": "L'ID principale di controllo non può essere vuoto, inserisci l'ID",
  "tip.addDatalogger.noSearchDevice": "Impossibile trovare il dispositivo, assicurarsi che il Bluetooth del dispositivo sia acceso",
  "tip.addDatalogger.searchAroundBluetooth": "La rete Bluetooth circostante è disponibile",
  "tip.addDatalogger.scan": "Scansiona il codice QR o inserisci manualmente il numero di serie del collettore sotto il codice QR.",
  "tip.addDatalogger.connectBluetoothFail": "Connessione Bluetooth non riuscita, eseguire la scansione del codice QR o inserire manualmente il numero di serie del collettore sotto il codice QR prima di riconnettersi.",
  "tip.connectWifi.tip1": "Configura i dispositivi per unirsi alla rete",
  "tip.connectWifi.tip": "Si prega di scegliere 2.4G WiFi",
  "tip.connectWifi.devicePower": "Potenza delle apparecchiature",
  "tip.connectWifi.enterSSID": "Inserisci l'account del router",
  "tip.connectWifi.enterPassword": "Inserisci la password del router",
  "tip.connectWifi.masterId": "Inserire l'ID principale di controllo",
  "tip.connectWifi.commandSetFail": "Impostazione del comando non riuscita, riconnettiti al collettore",
  "tip.configurationState.connecting": "Collegamento in corso",
  "tip.configurationState.connectFail": "connessione non riuscita",
  "tip.configurationState.connectSuccess": "Connessione riuscita",
  "tip.configurationState.wait": "Un momento, per favore.",
  "tip.configurationState.addDeviceSuccess": "Dispositivo aggiunto correttamente",
  "tip.home.today": "Produzione giornaliera di energia elettrica",
  "tip.home.month": "Produzione mensile di elettricità",
  "tip.home.year": "Produzione annuale di energia",
  "tip.home.total": "Produzione totale di energia",
  "tip.home.homePower": "Carico totale domestico",
  "tip.home.socketPower": "Carico della presa",
  "tip.home.off-gridPower": "Carico fuori griglia",
  "tip.home.acPower": "Alimentazione di rete",
  "tip.home.on-gridPower": "Alimentazione connessa alla rete",
  "tip.home.others": "altro",
  "tip.home.latestVersion": "È già l'ultima versione",
  "tip.home.frontEndLoad": "Carico frontale",
  "tip.home.backEndLoad": "Carico fuori griglia",
  "tip.energy.choiceDate": "I dati attuali sono disponibili solo",
  "tip.energy.explain": "spiegare",
  "tip.energy.tip1.load": "L'energia consumata dal carico",
  "tip.energy.tip1.solar": "Convertire l'energia solare in energia elettrica per ricaricare la batteria o caricare l'alimentazione elettrica",
  "tip.energy.tip1.grid": "Energia accumulata venduta alla rete elettrica",
  "tip.energy.tip1.battery": "Energia elettrica accumulata utilizzata per caricare la batteria",
  "tip.energy.tip2": "#NOME?",
  "tip.energy.tip3.title": "Norme di calcolo dei contributi sociali",
  "tip.energy.tip3.title2": "1kWh equivale a:",
  "tip.energy.tip3.Co2": "Ridurre le emissioni di anidride carbonica:",
  "tip.energy.tip3.coal": "Risparmiare l'uso del carbone standard:",
  "tip.energy.tip3.deforestation": "Protezione degli alberi:",
  "tip.plant.comprehensive": "Selezione completa",
  "tip.plant.totalEnergyMax": "Il più alto consumo energetico totale",
  "tip.plant.totalEnergyMin": "Consumo energetico totale più basso",
  "tip.plant.realTimePower": "Potenza in tempo reale",
  "tip.plant.pvcapacityMax": "La più alta capacità fotovoltaica",
  "tip.plant.pvcapacityMin": "La capacità fotovoltaica è la più bassa",
  "tip.plant.installationDateMax": "La data di installazione più lontana",
  "tip.plant.installationDateMin": "Ultima data di installazione",
  "tip.plant.paramChoice": "Selezione dei parametri",
  "tip.plant.filter": "schermo",
  "tip.plant.addVisitor": "Aggiungi visitatore",
  "tip.plant.tip": "Consigli",
  "tip.plant.visitorTip": "Può essere condiviso solo con utenti registrati",
  "tip.plant.name": "nome",
  "tip.plant.permission": "giurisdizione",
  "tip.plant.read-write": "Leggi e scrivi",
  "tip.plant.onlyread": "sola lettura",
  "tip.plant.visitor": "visitatore",
  "tip.plant.unfollow": "Sei sicuro di non seguire questa centrale elettrica?",
  "tip.device.power": "potenza",
  "tip.device.type": "tipo",
  "tip.device.updateTime": "Tempo di aggiornamento",
  "tip.device.powerOnTime": "Power on time",
  "tip.device.todayEnergy": "Il consumo attuale di energia elettrica",
  "tip.device.signal": "intensità del segnale",
  "tip.device.deliveryWarning": "Spiacenti, questo dispositivo è stato consegnato agli utenti finali e non può essere eliminato. Puoi prima andare alla gestione delle centrali, ritirare la consegna e poi eliminare il dispositivo.",
  "common.ok": "OK",
  "tip.delDevice": "Sei sicuro di voler eliminare questo {device}?",
  "tip.currentNoDevice": "Attualmente non ci sono dispositivi disponibili",
  "tip.currentNoDatalog": "Attualmente non c'è nessun collezionista disponibile",
  "tip.messageInfo.storage": "Stoccaggio dell'energia",
  "tip.messageInfo.inverter": "inverter",
  "tip.messageInfo.microInverter": "Micro inverso",
  "tip.userLocation": "Posizione dell'utente",
  "tip.ops.setDomainName": "Sei sicuro di voler impostare questo nome di dominio?",
  "tip.ops.restartDatalogger": "Sei sicuro di voler riavviare il collettore?",
  "tip.opsLog.addUser": "Aggiungi utenti finali",
  "tip.opsLog.bindSuccess": "Obbligazione riuscita",
  "tip.opsLog.selectDate": "Seleziona data",
  "tip.opsLog.start": "inizio",
  "tip.opsLog.end": "fine",
  "tip.opsLog.upgrade": "upgrade",
  "tip.opsLog.operation": "operazione",
  "tip.opsLog.communication": "comunicazione",
  "tip.opsLog.type": "tipo",
  "tip.opsLog.content": "contenuto",
  "tip.opsLog.control": "controller",
  "tip.opsLog.command": "Tipo di comando",
  "tip.opsLog.reset": "Ripristina",
  "tip.opsLog.serverTime": "Tempo del server",
  "tip.opsLog.inverter": "intervallo",
  "tip.opsLog.bindAgent": "Rivenditore vincolato",
  "tip.opsLog.deleteDeviceSN": "Si prega di confermare se si desidera eliminarlo?",
  "tip.opsLog.recordLog": "Dispositivi che richiedono la registrazione",
  "tip.setting.productModelNumberRelevancyOn-gridPower": "La potenza attiva collegata alla rete non può superare la potenza massima del modello di prodotto selezionato",
  "productEquipment.productModelNumber": "Modello di prodotto",
  "productEquipment.warnMessage": "Informazioni sull'allarme",
  "productEquipment.customInstruction": "Istruzioni personalizzate",
  "productEquipment.firmwareUpdate": "Aggiornamento firmware",
  "productEquipment.historicalData": "dati storici",
  "productEquipment.linkageInformation": "Informazioni sulla connessione",
  "systemAuthority.systemSettings": "Impostazioni di sistema",
  "systemAuthority.authorityManagement": "Autorizzazione",
  "systemAuthority.accountManagement": "Ruolo",
  "systemAuthority.Disabled": "Disabilita",
  "systemAuthority.enable": "Abilita",
  "org.ChangeSupplier": "Cambia fornitore",
  "weather.clearSky": "Cielo sereno",
  "weather.fewClouds": "Poco nuvoloso",
  "weather.scatteredClouds": "Nuvole sparse",
  "weather.brokenClouds": "Nuvoloso",
  "weather.overcastClouds": "Cielo coperto",
  "weather.lightRain": "Pioggia leggera",
  "weather.moderateRain": "Pioggia moderata",
  "weather.heavyRain": "Pioggia forte",
  "weather.thunderstormWithLightRain": "Temporale con pioggia leggera",
  "weather.thunderstormWithRain": "Temporale con pioggia",
  "weather.thunderstormWithHeavyRain": "Temporale con pioggia forte",
  "weather.lightSnow": "Neve leggera",
  "weather.snow": "Neve",
  "weather.heavySnow": "Neve forte",
  "weather.sleet": "Nevischio",
  "weather.showerRain": "Rovescio di pioggia",
  "weather.lightShowerRain": "Rovescio di pioggia leggera",
  "weather.heavyShowerRain": "Rovescio di pioggia forte",
  "weather.mist": "Nebbia",
  "weather.smoke": "Fumo",
  "weather.haze": "Caligine",
  "weather.dust": "Polvere",
  "weather.fog": "Banchisa",
  "weather.sand": "Sabbia",
  "weather.ash": "Cenere",
  "weather.squall": "Raffica",
  "weather.tornado": "Tornado",
  "zh-CN": "Cinese",
  "en-US": "Inglese",
  "de-DE": "Tedesco",
  "fr-FR": "Francese",
  "it-IT": "Italiano",
  "uk-UA": "Ucraino",
  "th-TH": "Tailandese",
  "nl-NL": "Olandese",
  "language.management": "Multilingua",
  "sidebar.roleManagement": "Ruolo",
  "user.userEmail": "Email dell'utente",
  "user.agentCode": "Codice agente",
  "user.phoneModel": "Modello del telefono",
  "user.phoneOs": "Sistema operativo del telefono",
  "user.appVersion": "Versione dell'app",
  "user.country": "Paese",
  "user.createTime": "Ora di creazione",
  "user.loginTime": "Ora di accesso",
  "shipment.MdmCode": "Codice MDM",
  "product.createProduct": "Crea prodotto",
  "shipment.MaterialCode": "Codice MDM",
  "product.deviceSubclass": "Sottocategoria dispositivo",
  "shipment.supplier": "Fornitore",
  "product.networkingMode": "Modalità di rete",
  "product.productImage": "Immagine del prodotto",
  "product.bluetoothIcon": "Icona Bluetooth",
  "product.uploadOneBluetoothIcon": "È possibile caricare solo un'icona Bluetooth",
  "product.UploadUpTo9Photos": "Carica fino a 9 foto",
  "product.PleaseUploadNoBackground": "Carica immagini di dispositivi senza sfondo",
  "product.havePublished": "Pubblicato",
  "product.inDevelopment": "In sviluppo",
  "shipment.haierSn": "Haier SN",
  "shipment.category": "Categoria",
  "shipment.devType": "Tipo di sviluppo",
  "log.operationEmail": "Email operativa",
  "log.deviceSn": "Numero di serie del dispositivo",
  "log.opType": "Tipo di operazione",
  "log.opTime": "Tempo dell'operazione",
  "log.operator": "Operatore",
  "log.operationDescription": "Descrizione operazione",
  "log.content": "Contenuto dell'operazione",
  "log.params": "Parametri",
  "bTerminal.correlationDeleteTheDevice": "Se questo dispositivo viene eliminato, anche i dispositivi associati verranno eliminati contemporaneamente. Sei sicuro di voler eliminare?",
  "role.action": "Operazione",
  "role.add.select.menu": "Seleziona risorse del menu",
  "role.addRole": "Aggiungi ruolo",
  "role.addTip": "Supporta la configurazione delle autorizzazioni per gli utenti Web e APP lato B, ma non per gli utenti APP lato C.",
  "role.applySuccess": "Invio riuscito",
  "role.appPermissions": "Autorizzazioni menu APP",
  "role.base": "Informazioni di base",
  "role.edit": "Modifica",
  "role.exist": "Il carattere esiste già",
  "role.info": "Dettagli",
  "role.name": "Nome ruolo",
  "role.no": "Numero ruolo",
  "role.not.empty": "Le informazioni sui ruoli non possono essere vuote",
  "role.per.user": "Ad ogni utente può essere assegnato un solo ruolo",
  "role.permissions": "Autorizzazioni dati",
  "role.status": "Stato ruolo",
  "role.submit": "Invia",
  "role.type": "Tipo ruolo",
  "role.typeTip": "Amministratore installatore: Ruolo predefinito per il responsabile dell'organizzazione installatrice, ce n'è solo uno in tutta la piattaforma. Ruolo installatore: Ruoli che il responsabile dell'organizzazione installatrice può assegnare ai dipendenti, possono essercene più. Ruolo piattaforma: Ruoli utilizzabili da tutti tranne che dagli installatori.",
  "role.updateTime": "Ora aggiornamento",
  "role.webPermissions": "Autorizzazioni menu Web",
  "shipment.PleaseEnterMaterialCode": "Inserisci il codice materiale MDM",
  "product.PleaseEnterSupplier": "Inserisci il fornitore",
  "common.reset": "Ripristina",
  "common.confirm": "Confermare",
  "common.cancel": "Annulla",
  "common.save": "conservazione",
  "common.delete": "elimina",
  "common.add": "Nuovo",
  "common.edit": "modifica",
  "common.update": "Aggiornamento",
  "common.submit": "Invia",
  "common.tip": "ricorda",
  "common.success": "successo",
  "common.fail": "fail",
  "common.password": "password",
  "common.handleFail": "operazione fallita",
  "common.required": "Obbligatorio",
  "common.environmentChange": "Cambio di ambiente account, confermare per aggiornare l'account o eseguire nuovamente il login",
  "common.noPermissions": "Nessun contenuto ancora, contatta l'amministratore per la configurazione~",
  "plant.plantName": "Nome della centrale elettrica",
  "plant.country": "Paese/Regione",
  "plant.installer": "Installatore",
  "plant.installPerson": "Installatore",
  "plant.plantOverview": "Panoramica della centrale elettrica",
  "plant.deviceList": "Elenco delle apparecchiature",
  "device.operationMonitoring": "Monitoraggio operativo",
  "device.parameterControl": "Controllo parametri",
  "device.Fault&Alarm": "Guasto e allarme",
  "device.dynamicPriceTip": "La modalità AI per questo dispositivo è abilitata dal proprietario della casa, non è possibile salvare questo parametro.",
  "device.paramRangeErrorDefault": "Errore intervallo parametri, l'intervallo di input dovrebbe essere ",
  "device.paramRangeError": "Errore intervallo parametri",
  "plant.dataUpdate": "Aggiornamento dati",
  "plant.pleaseSelectDate": "Si prega di selezionare la data",
  "validate.requiredFormat": "Si prega di inserire secondo il formato di esempio",
  "plant.addStation": "Aggiungi pianta",
  "product.ProtocolCode": "ID prodotto IoT",
  "product.IoIDandPlatformSource": "ID del prodotto IoT e fonte della piattaforma",
  "product.productIdCannotRepeat": "L'ID del prodotto non può essere duplicato",
  "product.deviceTypeAccess.maxAddRows": "Puoi aggiungere al massimo 2 voci",
  "product.accessPlatformCannotRepeat": "La fonte piattaforma non puo essere duplicata",
  "product.productId": "ID prodotto",
  "product.powerType": "Tipo di alimentazione",
  "product.power": "Potenza nominale kW",
  "system.taskCenter": "Centro Attività",
  "task.name": "Nome Attività",
  "task.type": "Tipo Attività",
  "task.status": "Stato",
  "task.createDate": "Data di Creazione",
  "task.progress": "Progresso",
  "task.view": "Visualizza",
  "task.stop": "Interrompi",
  "task.stopConfirm": "Sei sicuro di voler interrompere l'attività?",
  "task.stopSuccess": "Attività interrotta con successo",
  "task.stopFail": "Interruzione attività fallita",
  "task.confirm": "Conferma",
  "task.cancel": "Annulla",
  "task.mutipleSearch": "Ricerca Multipla",
  "task.mutipleSend": "Invio Multiplo",
  "task.taskDetail": "Dettagli Attività",
  "task.equipmentList": "Lista Apparecchiature",
  "task.fileLimit": "È possibile caricare solo file xls/xlsx",
  "task.reChoose": "Svuota la lista e seleziona di nuovo",
  "task.tip": "Trascina il file qui, oppure",
  "task.upload": "Clicca per Caricare",
  "task.templateDownload": "Scarica Modello",
  "task.mutipleHandleParams": "Parametri di Elaborazione Multipla",
  "common.previousStep": "Passo Precedente",
  "task.requiredProductModel": "Seleziona un modello di prodotto",
  "task.requiredEquipmentList": "Carica la lista delle apparecchiature",
  "task.equipmentListTip": "I dati della tabella sono vuoti o il caricamento è fallito, si prega di verificare",
  "task.requiredParameter": "Seleziona un parametro",
  "task.writeValue": "Scrivi Valore",
  "task.progressRate": "Tasso di Completamento",
  "task.readTime": "Tempo di Lettura",
  "task.sendTime": "Tempo di Invio",
  "task.mutipleSearchTemplate": "Modello di Ricerca Multipla",
  "task.mutipleSendTemplate": "Modello di Invio Multiplo",
  "task.uploadSuccess": "Caricamento Riuscito",
  "task.sendSuccess": "Attività Creata con Successo",
  "task.inProgress": "In Corso",
  "task.completed": "Completato",
  "task.failed": "Fallito",
  "task.success": "Successo",
  "system.configureImport": "Importazione configurazione",
  "product.DeviceHlepInstructions": "Istruzioni per l'aiuto al dispositivo",
  "product.addDeviceHlepInstructions": "Aggiungi istruzioni per l'aiuto al dispositivo",
  "product.deviceInstallationGuideFirst": "Si prega di caricare le immagini della guida all'installazione del dispositivo per guidare gli installatori passo dopo passo attraverso l'installazione e le operazioni dell'app.",
  "product.deviceInstallationGuideSecond": "Si raccomanda di includere istruzioni per entrare nella modalità di configurazione di rete del dispositivo, posizione del codice QR SN, creazione del sito, aggiunta del dispositivo, operazioni Bluetooth, configurazione rapida, ecc.",
  "product.mdnTip": "Prime 9 cifre del SN Haier",
  "Firmware.secretType": "Metodo di cifratura",
  "common.copySuccess": "Copia riuscita",
  "bTerminal.ModifyTheNameOfTheDevice": "Modifica nome dispositivo",
  "bTerminal.changeFailed": "Modifica non riuscita",
  "bTerminal.OnlyWithin100Characters": "Limitato a 100 caratteri o meno in cinese, inglese e numeri",
  "bTerminal.OnlyWithin30Characters": "Limitato a 30 caratteri o meno in cinese, inglese e numeri",
  "bTerminal.rename": "Rinomina",
  "sidebar.prefill": "Valutazioni & Feedback",
  "paramters.basicInformation": "Informazioni di Base",
  "paramters.DCSide": "Lato DC",
  "paramters.ACSide": "Lato AC",
  "paramters.stringCurrent": "Corrente di Stringa",
  "paramters.moreParamters": "Ulteriori Informazioni",
  "paramters.debugInformation": "Informazioni di Debug",
  "paramters.current": "Corrente",
  "paramters.voltage": "Tensione",
  "paramters.power": "Potenza",
  "paramters.init": "Inizializzazione",
  "paramters.wait": "In Attesa",
  "paramters.normal": "Normale",
  "paramters.abnormal": "Guasto",
  "paramters.burn": "Burn-in",
  "system.reportCenter": "Centro Report",
  "system.reportMonth": "Report Mensile",
  "system.reportYear": "Report Annuale",
  "system.selfServiceReport": "Self-service",
  "system.selfServiceReport.hour": "Ora",
  "system.selfServiceReport.selectPlant": "Seleziona la centrale",
  "system.selfServiceReport.selectYear": "Seleziona anno",
  "system.selfServiceReport.metricSelection": "Selezione indicatori",
  "system.selfServiceReport.required": "Obbligatorio",
  "system.selfServiceReport.startTimeCannotBeLater": "L'ora di inizio non può essere successiva all'ora di fine",
  "system.selfServiceReport.fieldIsRequired": "{field} è obbligatorio",
  "system.selfServiceReport.hourTimeTooltipLine1": "L'ora rappresenta il periodo di 1 ora che inizia da quell'ora piena",
  "system.selfServiceReport.hourTimeTooltipLine2": "(es. 15:00 = 15:00–15:59)",
  "report.exportAll": "Esporta tutto",
  "report.installedCapacity": "Potenza installata",
  "report.capacityErrorTip": "L'intervallo del filtro della potenza installata non è valido",
  "report.exportFailed": "Esportazione fallita, riprova più tardi",
  "report.firstChoiceTime": "Seleziona prima una data, poi esporta",
  "placeholder.selectScope": "Selezionare {scope}",
  "register.accountVerification": "Verifica account",
  "register.companyRegistration": "Registrazione azienda",
  "register.staffRegistration": "Registrazione personale",
  "register.companyInfo": "Fornire le informazioni sull'azienda di seguito",
  "register.companyFullName": "Nome completo dell'azienda",
  "register.installationCountryNotice": "Selezionare attentamente il paese in cui è registrato l'installatore. Non è possibile installare il sistema al di fuori dell'area di registrazione.",
  "register.detailAddress": "Indirizzo dettagliato",
  "register.postalCode": "Codice postale",
  "register.contactName": "Nome del contatto",
  "register.contactInfo": "Telefono o email del contatto",
  "register.applyJoinCompany": "Richiedi di unirti all'azienda",
  "register.companyCodeInfo": "Compilare il codice aziendale e le informazioni personali per unirsi a un'azienda registrata",
  "register.registrationCode": "Codice di registrazione azienda",
  "register.codeHint": "Il codice può essere ottenuto contattando l'amministratore dell'azienda",
  "register.realName": "Nome",
  "register.accountVerificationInfo": "Scegliere uno dei seguenti metodi per completare la registrazione dell'account",
  "register.emailRegistration": "Registrazione email",
  "register.sixDigitCode": "Codice di verifica a 6 cifre",
  "register.getVerificationCode": "Ottieni codice di verifica",
  "register.resendAfterSeconds": "Reinvia dopo {seconds}s",
  "register.resendAfterMinutes": "Reinvia dopo {minutes}min",
  "register.resendAfterMinutesSeconds": "Reinvia dopo {minutes}min{seconds}s",
  "register.password6to20": "Password di 6-20 caratteri",
  "register.password8to20": "Password di 8-20 caratteri",
  "register.phoneNumber": "Numero di telefono",
  "register.phoneRegistration": "Registrazione telefono",
  "register.optionalEmail": "Opzionale: Indirizzo email",
  "register.previousPage": "Pagina precedente",
  "register.goToLogin": "Vai al login",
  "register.completeRegistration": "Completa la registrazione",
  "register.accountAlreadyRegistered": "Questa email o numero di telefono è già registrato. Accedi o usa un altro account.",
  "register.emailAlreadyRegistered": "Questa email è già registrata. Accedi direttamente o utilizza un altro account.",
  "register.phoneAlreadyRegistered": "Questo numero di telefono è già registrato. Accedi direttamente o utilizza un altro account.",
  "register.companyAlreadyRegistered": "L'azienda '{companyName}' è già registrata",
  "register.companyExistOptions": "È possibile tornare a modificare il nome dell'azienda o richiedere di unirsi a questa azienda",
  "register.returnToModify": "Torna a Modifica",
  "register.companyRegisteredApplyJoin": "Richiedi di unirti",
  "register.companyRegisteredApplyJoinFull": "Azienda già registrata? Richiedi di unirti",
  "register.validation.selectCountry": "Selezionare paese/regione",
  "register.validation.selectCity": "Selezionare città",
  "register.validation.enterDetailAddress": "Inserire indirizzo dettagliato",
  "register.validation.enterCorrectPostalCode": "Inserire formato codice postale corretto",
  "register.validation.enterContactName": "Inserire nome contatto",
  "register.validation.enterRegistrationCode": "Inserire codice di registrazione azienda",
  "register.validation.enterYourName": "Inserire il tuo nome",
  "register.validation.enterPassword": "Inserire password",
  "register.validation.passwordLength": "La lunghezza della password deve essere di 6-20 caratteri",
  "register.validation.passwordLength8to20": "La lunghezza della password deve essere di 8-20 caratteri",
  "register.validation.passwordComplexity": "La password deve contenere almeno tre tipi di caratteri diversi (numeri, lettere maiuscole, lettere minuscole, caratteri speciali)",
  "register.validation.enterPasswordAgain": "Inserire nuovamente la password",
  "register.validation.passwordMismatch": "Le due password non corrispondono",
  "register.validation.correctPhoneFormat": "Inserire formato numero di telefono corretto",
  "register.validation.correctPhoneOrEmailFormat": "Inserire formato numero di telefono o email corretto",
  "register.validation.correctEmailFormat": "Inserire formato email corretto",
  "register.validation.enterVerificationCode": "Inserire codice di verifica",
  "register.validation.sixDigitNumber": "Il codice di verifica deve essere di 6 cifre",
  "register.validation.enterCompanyName": "Inserire nome azienda",
  "register.validation.companyRegisteredChooseAction": "Azienda già registrata, scegliere un'azione",
  "register.message.searchCompanyFailed": "Ricerca azienda fallita",
  "register.message.checkCompanyStatusFailed": "Verifica stato azienda fallita",
  "register.message.getCityListFailed": "Recupero elenco città fallito",
  "register.message.companyRegisteredChooseAction": "Azienda già registrata, scegliere un'azione",
  "register.message.completeCompanyInfo": "Completare le informazioni sull'azienda",
  "register.message.completeStaffInfo": "Completare le informazioni sul personale",
  "register.message.enterEmailFirst": "Inserire prima l'indirizzo email",
  "register.message.correctEmailFormat": "Inserire formato email corretto",
  "register.message.verificationCodeSent": "Codice di verifica inviato a: {contact}",
  "register.message.sendVerificationCodeFailed": "Invio codice di verifica fallito",
  "register.message.enterPhoneFirst": "Inserire prima il numero di telefono",
  "register.message.correctPhoneFormat": "Inserire formato numero di telefono corretto",
  "register.message.completeAccountInfoAndFixErrors": "Completare le informazioni dell'account e correggere gli errori",
  "register.message.companyRegistrationSuccess": "Registrazione azienda riuscita!",
  "register.message.companyRegistrationFailed": "Registrazione azienda fallita",
  "register.message.staffRegistrationSuccess": "Registrazione personale riuscita!",
  "register.message.staffRegistrationFailed": "Registrazione personale fallita",
  "register.message.phoneRegistrationNotAvailable": "La registrazione tramite numero di telefono non è attualmente disponibile. Rimanete sintonizzati.",
  "register.tooltip.title": "Come trovare il codice di registrazione dell'azienda?",
  "register.tooltip.appPathTitle": "1. Nell'APP",
  "register.tooltip.appPathDesc": "Vai su Utente -> tocca l'avatar -> Informazioni account per visualizzare il codice di registrazione dell'azienda.",
  "register.tooltip.webPathTitle": "2. Nella console Web",
  "register.tooltip.webPathDesc": "Vai su Gestione organizzazione -> Informazioni organizzazione per visualizzare il codice di registrazione dell'azienda.",
  "registerAccomplish.applicationComplete": "Domanda completata",
  "registerAccomplish.congratulations": "Congratulazioni, hai completato la registrazione.",
  "registerAccomplish.companyRegisterCodeIs": "Il codice di registrazione della tua azienda è",
  "registerAccomplish.certificationRequired": "Devi continuare al centro di certificazione per l'autenticazione, altrimenti non puoi attivare i dispositivi.",
  "registerAccomplish.greenChannelInfo": "Per situazioni di emergenza speciali nei reparti, per non ritardare l'installazione in loco, è possibile scegliere il canale verde per ottenere un permesso temporaneo per attivare i dispositivi per 2 mesi.",
  "registerAccomplish.certificationCenter": "Centro di certificazione",
  "registerAccomplish.greenChannel": "Canale verde",
  "registerAccomplish.returnToLogin": "Torna alla pagina di accesso",
  "registerAccomplish.useHaierEnergyApp": "È possibile utilizzare l'APP Haier Energy per aggiungere dispositivi.",
  "registerAccomplish.applyingGreenChannel": "Stai richiedendo il canale verde",
  "registerAccomplish.greenChannelDescription1": "Questo canale è solo per alcune situazioni di emergenza speciali, per evitare di ritardare l'installazione in loco, per l'attivazione dei dispositivi.",
  "registerAccomplish.greenChannelDescription2": "Le autorizzazioni dell'account ottenute tramite questo canale sono autorizzazioni temporanee e il periodo di validità per l'attivazione dei dispositivi è di 2 mesi.",
  "registerAccomplish.greenChannelDescription3": "È necessario recarsi al centro di certificazione entro 2 mesi per completare l'autenticazione e ottenere l'autorizzazione permanente per attivare i dispositivi.",
  "registerAccomplish.confirmSubmit": "Conferma invio",
  "registerAccomplish.returnToPrevious": "Torna alla pagina precedente",
  "registerAccomplish.applicationSubmittedSuccessfully": "La tua domanda è stata inviata con successo!",
  "registerAccomplish.missingAgentIdParameter": "Parametro agentId mancante, impossibile richiedere il canale verde",
  "registerAccomplish.greenChannelApplicationSuccess": "Richiesta canale verde riuscita!",
  "registerAccomplish.greenChannelApplicationFailed": "Richiesta canale verde fallita",
  "registerAccomplish.enterSystem": "Entra nel sistema",
  "registerAccomplish.pleaseLoginFirst": "Effettua prima l'accesso",
  "org.phoneNumber": "Numero di telefono",
  "org.certificationStatus": "Stato della certificazione",
  "org.permission": "Permesso",
  "org.accountSource": "Origine dell'account",
  "org.certificationStatusTip": "Attualmente valido solo per i permessi di aggiunta dispositivi nell'app Haier Energy",
  "org.unauthenticated": "Non autenticato",
  "org.authenticated": "Autenticato",
  "org.noNeedToAuthenticate": "Nessuna autenticazione richiesta",
  "org.unauthorized": "Non autorizzato",
  "org.authorized": "Autorizzato",
  "org.temporaryAuthorization": "Autorizzazione temporanea",
  "org.remainingDays": "Giorni rimanenti: {scope} giorni",
  "org.allocated": "Assegnato",
  "org.registered": "Registrato",
  "org.authorization": "Autorizzazione",
  "org.addressDetail": "Indirizzo dettagliato",
  "org.postalCode": "Codice postale",
  "org.accountSwitch": "Cambio account",
  "org.viewAccountInfo": "Visualizza informazioni account",
  "org.baseInfo": "Informazioni di base",
  "org.certificationInfo": "Informazioni di certificazione",
  "org.restDays": "Giorni rimanenti",
  "org.applyTime": "Data di richiesta",
  "org.certificationTime": "Data di certificazione",
  "org.registerCode": "Codice di registrazione",
  "org.registrationTip": "Durante la registrazione, puoi inserire il codice di registrazione aziendale per richiedere di unirti all'azienda.",
  "org.authenticationTip": "Ce compte a été désactivé et ne peut pas être autorisé.",
  "org.authenticationTip2": "Ce compte a déjà été autorisé ou bénéficie d'une autorisation temporaire encore valide ; une nouvelle autorisation n'est pas possible.",
  "org.temporaryAuthorizationTip": "L'autorisation est temporaire par défaut, d'une durée de 3 mois.",
  "org.temporaryAuthorizationSuccess": "Autorisation réussie",
  "report.allSelect": "Seleziona tutto",
  "report.compare": "Confronta",
  "report.energy": "Potenza attiva",
  "report.ipv": "Corrente CC",
  "report.vpv": "Tensione CC",
  "report.fac": "Frequenza CA",
  "report.vac": "Tensione CA",
  "report.iac": "Corrente CA",
  "report.temperature": "Temperatura interna",
  "report.str_cur": "Corrente stringa",
  "report.inverterCompare": "Confronto inverter",
  "report.inverterCompareTip": "Già aggiunto alla lista, non aggiungere di nuovo",
  "report.pleaseChooseInverter": "Si prega di selezionare un inverter",
  "report.pleaseChooseCompare": "Si prega di selezionare gli elementi da confrontare",
  "report.compareItem": "Elementi da confrontare",
  "system.inverterCompare": "Confronto parametri inverter",
  "shipment.deviceSource": "Origine della spedizione",
  "shipment.shippingCustomer": "Cliente di spedizione",
  "shipment.customerContact": "Contatto cliente",
  "shipment.tag": "Tag",
  "shipment.addTag": "Aggiungi tag",
  "shipment.editTag": "Modifica tag",
  "shipment.tagContent": "Contenuto tag",
  "shipment.tagColor": "Colore tag",
  "placeholder.selectShippingCustomer": "Seleziona il cliente di spedizione",
  "placeholder.enterCustomerContact": "Inserisci il contatto del cliente",
  "placeholder.selectTag": "Seleziona tag",
  "placeholder.enterTagContent": "Inserisci il contenuto del tag",
  "placeholder.noResult": "Nessun tag corrispondente",
  "validation.enterTagContent": "Inserisci il contenuto del tag",
  "validation.selectTagColor": "Seleziona il colore del tag",
  "shipment.operationRecordTitle": "Registro operazioni",
  "shipment.boundUserWarning": "Questo dispositivo è già associato a un utente e il cliente di spedizione non può essere aggiornato.",
  "shipment.batchBoundUserWarning": "Spiacenti, i dispositivi selezionati includono dispositivi già associati a utenti, il cliente di spedizione non può essere aggiornato in batch.",
  "shipment.uploadEquipmentListRequired": "Carica il file dell'elenco dei dispositivi",
  "shipment.errorDataTipTitle": "Promemoria dati anomali",
  "shipment.downloadImportResult": "Scarica risultato importazione",
  "shipment.downloading": "Download in corso...",
  "shipment.noFailedDataToDownload": "Nessun dato non riuscito da scaricare",
  "shipment.deleteTagConfirm": "Sei sicuro di voler eliminare il tag \"{tagName}\"?",
  "common.addSuccess": "Aggiunto con successo",
  "common.editSuccess": "Modificato con successo",
  "product.basicProperties": "Proprietà di base",
  "product.specialProperties": "Proprietà speciali",
  "product.platformRelated": "Relativo alla piattaforma",
  "product.maxPvChannels": "Numero massimo di stringhe PV supportate",
  "product.componentManufacturer": "Produttore del modulo",
  "product.componentType": "Tipo di modulo",
  "product.ratedPower": "Potenza nominale",
  "product.mppVoltage": "Tensione MPP",
  "product.mppCurrent": "Corrente MPP",
  "product.openCircuitVoltage": "Tensione a circuito aperto",
  "product.shortCircuitCurrent": "Corrente di corto circuito",
  "product.maxPowerTempCoeff": "Coeff. temperatura potenza massima",
  "product.openVoltageTempCoeff": "Coeff. temperatura tensione a circuito aperto",
  "product.shortCurrentTempCoeff": "Coeff. temperatura corrente di corto circuito",
  "product.componentEfficiency": "Efficienza di conversione nominale del modulo",
  "product.firstYearDegradation": "Tasso di degrado del primo anno",
  "product.annualDegradation": "Tasso di degrado annuale",
  "product.fillFactor": "Fattore di riempimento",
  "product.placeholder.range_0_9999_2dp": "0-9999, fino a due decimali",
  "product.placeholder.range_0_99_2dp": "0-99, fino a due decimali",
  "product.placeholder.range_0_999_2dp": "0-999, fino a due decimali",
  "product.placeholder.range_neg1_1_2dp": "-1-1, fino a due decimali",
  "product.rule.range_0_9999_2dp": "Inserire un numero tra 0 e 9999, massimo due decimali",
  "product.rule.range_0_99_2dp": "Inserire un numero tra 0 e 99, massimo due decimali",
  "product.rule.range_0_999_2dp": "Inserire un numero tra 0 e 999, massimo due decimali",
  "product.rule.range_neg1_1_2dp": "Inserire un numero tra -1 e 1, massimo due decimali",
  "product.ivScanSupport": "Supporta scansione curva IV",
  "system.intelligentDiagnosis": "Diagnosi intelligente",
  "system.ivline": "Curva IV",
  "subtitle.ivlineCreate": "Attività di scansione",
  "diagnosis.diagnosisTime": "Ora di Diagnosi",
  "diagnosis.faultQuantity": "Numero di Guasti",
  "diagnosis.scanCompleteTime": "Orario Completamento Scan",
  "diagnosis.scanProgress": "Progresso Scan",
  "diagnosis.newTask": "Nuovo Compito",
  "diagnosis.deleteTask": "Elimina Compito",
  "diagnosis.deleteTaskSuccess": "Compito eliminato con successo",
  "diagnosis.closeAll": "Cancella Tutto",
  "diagnosis.startScan": "Avvia Scan",
  "diagnosis.pleaseChooseInverter": "Seleziona l'inverter",
  "diagnosis.stringSetting": "Impostazione Stringa",
  "diagnosis.taskSetting": "Impostazione Compito",
  "diagnosis.batchComponentSetting": "Impostazione Batch Componenti",
  "diagnosis.componentType": "Tipo Componente",
  "diagnosis.maxPower": "Potenza Massima (Pmax)",
  "diagnosis.bestWorkingVoltage": "Tensione di Funzionamento Ottimale (Vmpp)",
  "diagnosis.bestWorkingCurrent": "Corrente di Funzionamento Ottimale (Impp)",
  "diagnosis.openCircuitVoltage": "Tensione a Vuoto (Voc)",
  "diagnosis.shortCircuitCurrent": "Corrente di Cortocircuito (Isc)",
  "diagnosis.maxPowerTemperatureCoefficient": "Coefficiente Termico della Potenza Massima",
  "diagnosis.openCircuitVoltageTemperatureCoefficient": "Coefficiente Termico della Tensione a Vuoto",
  "diagnosis.shortCircuitCurrentTemperatureCoefficient": "Coefficiente Termico della Corrente di Cortocircuito",
  "diagnosis.nominalComponentConversionEfficiency": "Efficienza Nominale di Conversione del Componente",
  "diagnosis.firstYearDecayRate": "Tasso di Degradazione del Primo Anno",
  "diagnosis.yearlyDecayRate": "Tasso di Degradazione Annuale",
  "diagnosis.fillFactor": "Fattore di Riempimento",
  "diagnosis.componentManufacturer": "Produttore del Componente",
  "diagnosis.componentAmount": "Quantità Componenti",
  "diagnosis.capacity": "Capacità della Stringa",
  "diagnosis.stringAmount": "Numero di Stringhe (pezzi)",
  "diagnosis.inverterSerialNumber": "Numero di Serie dell'Inverter",
  "diagnosis.totalCapacity": "Capacità Totale delle Stringhe",
  "diagnosis.pleaseFillInAllItems": "Campi mancanti, controlla",
  "diagnosis.moreParamters": "Altri Parametri",
  "diagnosis.envParam": "Parametri Ambientali",
  "diagnosis.startTask": "Avvia Compito",
  "diagnosis.startTaskSuccess": "Compito avviato con successo",
  "diagnosis.start": "Avvia",
  "diagnosis.noDevice": "Nessun dispositivo trovato",
  "register.contactAdminForCode": "Si prega di contattare l'amministratore dell'azienda per ottenere il codice di registrazione dell'azienda",
  "register.provideCompanyInfoBelow": "Si prega di fornire le informazioni dell'azienda di seguito",
  "login.success": "Accesso riuscito",
  "flowData.existingInvTip": "Avviso:\nINV esistente > 0 indica che il solare sta generando elettricità;\nINV esistente < 0 indica che l'inverter sta consumando elettricità.",
  "flowData.alert": "Il valore attuale di INV esistente < 0 indica che l'inverter esterno sta consumando energia.",
  "dialog.confirm": "Ho capito",
  "paramters.deviceTotalInformation": "Informazioni Totali Dispositivo",
  "paramters.innerInverter": "Inverter Interno",
  "paramters.outerInverter": "Inverter Esterno",
  "paramters.outerInverterFromPvSide": "Dal Contatore Lato PV",
  "paramters.activePower": "Potenza Attiva",
  "paramters.apparentPower": "Potenza Apparente",
  "paramters.reactivePower": "Potenza Reattiva",
  "paramters.powerFactor": "Fattore di Potenza",
  "paramters.phaseA": "Fase A",
  "paramters.phaseB": "Fase B",
  "paramters.phaseC": "Fase C",
  "paramters.charge": "Carica",
  "paramters.discharge": "Scarica",
  "paramters.sell": "Vendi energia",
  "paramters.buy": "Compra energia",
  "bw_param_ctrl_group_WorkMode": "Modalità Lavoro",
  "bw_param_ctrl_name_GRID_Meter_negate": "GRID_Meter_negate",
  "bw_param_ctrl_name_GridBreake": "Interruttore di Rete",
  "bw_param_ctrl_name_BBSOC_lx1": "SOC per L1 Power-off",
  "bw_param_ctrl_name_BBSOC_lx2": "SOC per L2 Power-off",
  "bw_param_ctrl_name_BBSOC_lx3": "SOC per L3 Power-off",
  "bw_param_ctrl_option_ON": "SU",
  "bw_param_ctrl_name_Systemmode": "Modalità Sistema",
  "bw_param_ctrl_name_UPSReserveSoc": "Soc di Riserva UPS",
  "bw_param_ctrl_option_OFF": "OFF",
  "bw_param_ctrl_option_B5": "Modello monofase 5Kw",
  "bw_param_ctrl_name_DispatchActivepower": "Potenza Attiva Programmata",
  "bw_param_ctrl_option_withoutBattery": "Senza Batteria",
  "bw_param_ctrl_name_InvSub": "Inv sub",
  "bw_param_ctrl_name_MAXFeedintogridpercent": "Percentuale Massima Immissione in Rete",
  "bw_param_ctrl_option_T4": "Modello trifase 4Kw",
  "bw_param_ctrl_option_T5": "Modello trifase 5Kw",
  "bw_param_ctrl_option_T6": "Modello trifase 6Kw",
  "bw_param_ctrl_option_T8": "Modello trifase 8Kw",
  "bw_param_ctrl_option_S3": "Stoccaggio di energia monofase modello 3Kw",
  "bw_param_ctrl_option_S5": "Stoccaggio di energia monofase modello 5Kw",
  "bw_param_ctrl_option_S6": "Stoccaggio di energia monofase modello 6Kw",
  "bw_param_ctrl_option_S8": "Stoccaggio di energia monofase modello 8Kw",
  "bw_param_ctrl_option_Grid&PV useCT": "Rete&PV usa CT",
  "bw_param_ctrl_note_MAXFeedintogridpercent": "Il rapporto tra la potenza massima di alimentazione e la capacità fotovoltaica installata (compresa tutta la capacità fotovoltaica collegata all'inverter fotovoltaico e all'inverter di stoccaggio di energia)",
  "bw_param_ctrl_option_Grid&PVUseMeter": "Rete&PV usano Contatore",
  "bw_param_ctrl_note_PVCapacityofGridInverter": "Capacità fotovoltaica totale installata collegata all'inverter di stoccaggio di energia",
  "bw_param_ctrl_option_T10": "Modello trifase 10Kw",
  "bw_param_ctrl_name_DispatchReactivepower": "Potenza Reattiva Programmata",
  "bw_param_ctrl_name_Grid_Regulation": "Regolazione Rete",
  "bw_param_ctrl_option_Enablecharge&dischargeTimePeriodControl": "Abilita Controllo Carica/Scarica Temporale",
  "bw_param_ctrl_name_Timeperiodcontrolflag": "Flag Controllo Periodo Temporale",
  "bw_param_ctrl_note_BatteryReady": "Per impostazione predefinita la connessione della batteria è \"con batteria\". Se non è collegata alcuna batteria (cioè l'inverter è collegato a fotovoltaico ma non a moduli di batteria), selezionare 'senza batteria' o l'unità cercherà una batteria che non è presente e entrerà in modalità di guasto.",
  "bw_param_ctrl_option_withBattery": "Con Batteria",
  "bw_param_ctrl_name_PV_Meter_negate": "PV_Meter_negate",
  "bw_param_ctrl_option_OnlyEnableDischargeTimePeriodControl": "Only Enable discharge Time period control",
  "bw_param_ctrl_name_EMSReset": "Ripristino EMS",
  "bw_param_ctrl_name_FactoryReset": "Ripristino di fabbrica",
  "bw_param_ctrl_name_DSPReset": "Reset DSP",
  "bw_param_ctrl_group_RemoteReset": "Reset remoto",
  "bw_param_ctrl_option_FactoryReset": "Reset",
  "bw_param_ctrl_option_DSPReset": "Reset",
  "bw_param_ctrl_option_EMSReset": "Reset",
  "bw_param_ctrl_group_BackupBox": "Backup Box",
  "bw_param_ctrl_name_BBPrio_lx1": "Priorità strategica L1",
  "bw_param_ctrl_name_BBPrio_lx2": "Priorità strategica L2",
  "bw_param_ctrl_name_BBPrio_lx3": "Priorità strategica L3",
  "bw_param_ctrl_note_BBSOC_lx3": "Il SOC della priorità 3 deve essere superiore al SOC della priorità 1 e al SOC della priorità 2.",
  "bw_param_ctrl_note_BBSOC_lx1": "Il SOC della priorità 1 deve essere il min.SOC di L1, L2 e L3.",
  "bw_param_ctrl_note_BBSOC_lx2": "Il SOC della priorità 2 deve essere superiore al SOC della priorità 1.",
  "bw_param_ctrl_option_1": "1",
  "bw_param_ctrl_option_3": "3",
  "bw_param_ctrl_option_2": "2",
  "bw_param_ctrl_name_BBLoadEnable": "Backup-box Abilita",
  "bw_param_ctrl_name_MeterCTSelect": "Selezione CT del Contatore",
  "bw_param_ctrl_option_GridUse CT&PVUseMeter": "Rete usa CT, PV usa Contatore",
  "bw_param_ctrl_name_ChargeCutSoc": "Soc di Interruzione Carica",
  "bw_param_ctrl_option_HybridMode": "Modalità Ibrida",
  "bw_param_ctrl_name_PVCapacityStorage": "Capacità PV per Accumulo",
  "bw_param_ctrl_name_DispatchTime": "Tempo Programmazione",
  "bw_param_ctrl_name_DispatchStart": "Avvio Programmazione",
  "bw_param_ctrl_name_UPSreserveenable": "Abilita Riserva UPS",
  "bw_param_ctrl_option_selfuse": "Autoconsumo",
  "bw_param_ctrl_option_DCMode": "Modalità DC",
  "bw_param_ctrl_name_PVCapacityofGridInverter": "Capacità PV dell'Inverter di Rete",
  "bw_param_ctrl_name_RTC": "RTC",
  "bw_param_ctrl_option_Normal": "Normale",
  "bw_param_ctrl_group_SystemInfo": "Info Sistema",
  "bw_param_ctrl_note_Systemmode": "DC: 1.Newly installato sistema fotovoltaico con inverter di stoccaggio di energia ibrido che si collega direttamente ai pannelli fotovoltaici. 2.Batteria sistema senza inverter fotovoltaico che si collega direttamente alla rete e viene caricato solo dalla rete\n\nAC: sistema fotovoltaico di retrofitting che comprende l'inverter fotovoltaico che si collega ai pannelli fotovoltaici e alla rete. I pannelli non possono connettersi direttamente all'inverter di stoccaggio di energia ibrido.\n\nIbrido: l'intero sistema comprende un inverter fotovoltaico che si collega alla rete e un inverter di stoccaggio di energia ibrido che si collega direttamente ai pannelli fotovoltaici\"",
  "bw_param_ctrl_group_GridMeterSettings": "Impostazioni Contatore Rete",
  "bw_param_ctrl_option_Forced charging and discharging": "Carica e Scarica Forzata",
  "bw_param_ctrl_note_ChargeCutSoc": "Limite superiore della carica SOC della batteria.",
  "bw_param_ctrl_option_OnlyEnableChargeTimeperiod control": "Abilita Solo Controllo Carica Temporale",
  "bw_param_ctrl_option_Disable": "Disabilita",
  "bw_param_ctrl_group_BatterySettings": "Impostazioni Batteria",
  "bw_param_ctrl_name_BatteryReady": "Batteria Pronta",
  "bw_param_ctrl_option_GridUse Meter&PVUseCT": "Rete usa Contatore, PV usa CT",
  "bw_param_ctrl_name_DispatchSOC": "SOC Programmato",
  "bw_param_ctrl_option_Disable TimePeriodControl": "Disabilita Controllo Temporale",
  "bw_param_ctrl_option_Enable": "Abilita",
  "bw_param_ctrl_option_TOU": "TOU (Tariffazione Oraria)",
  "bw_param_ctrl_name_ChargeTimeSlot1": "Fascia Oraria Carica 1",
  "bw_param_ctrl_name_ChargeTimeSlot2": "Fascia Oraria Carica 2",
  "bw_param_ctrl_note_Timeperiodcontrolflag": "Le impostazioni di ricarica e scarica hanno effetto solo quando la modalità \"TOU\" è selezionata.",
  "bw_param_ctrl_group_GridSafetyConfig": "Configurazione Sicurezza Rete",
  "bw_param_ctrl_group_SystemConfig": "Configurazione Sistema",
  "bw_param_ctrl_option_ACMode": "Modalità AC",
  "bw_param_ctrl_option_Reverse": "Inverso",
  "bw_param_ctrl_option_NotEnabledChargeSetting": "La funzione di carica/scarica non è abilitata",
  "bw_param_ctrl_group_Charge&DischargeSettings": "Impostazioni Carica/Scarica",
  "bw_param_ctrl_name_DispatchMode": "Modalità Programmazione",
  "bw_param_ctrl_note_GridBreake": "Si prega di selezionare in base alle specifiche effettive dell'interruttore sul lato della griglia dell'inverter. Se la specifica è compilata in modo errato, potrebbe causare l'interruttore di innesto.",
  "bw_param_ctrl_note_PVCapacityStorage": "Capacità fotovoltaica totale installata collegata all'inverter fotovoltaico",
  "bw_param_ctrl_name_DischargeTimeSlot2": "Fascia Oraria Scarica 2",
  "bw_param_ctrl_name_DischargeTimeSlot1": "Fascia Oraria Scarica 1",
  "bw_param_ctrl_group_GridDispatch": "Programmazione Rete",
  "jl_param_ctrl_group_OnOff": "Accensione/spegnimento inverter",
  "jl_param_ctrl_name_OnOff": "Accensione/spegnimento inverter",
  "jl_param_ctrl_option_PowerOFF": "Spegni",
  "jl_param_ctrl_option_PowerON": "Accendi",
  "product.multipleLanguage": "Impostazioni multilingua del modello Thing",
  "product.multipleLanguageNote": "Libreria terminologica multilingua del modello Thing",
  "product.entryCode": "Codice termine",
  "product.entryValue": "Valore termine",
  "product.endpoint": "Endpoint",
  "product.module": "Modulo",
  "product.tag": "Etichetta",
  "product.editLanguage": "Modifica multilingua",
  "product.addLanguage": "Aggiungi multilingua",
  "product.maintainInfo": "Informazioni di manutenzione",
  "product.statusChangeSuccess": "Stato aggiornato con successo",
  "product.statusChangeFail": "Aggiornamento dello stato fallito",
  "product.syncIotI18n": "Sincronizza voci modello IoT Qingluo",
  "product.confirmSyncIotI18n": "Sei sicuro di voler sincronizzare le voci del modello IoT Qingluo?",
  "button.sync": "Sincronizza pacchetto multilingua",
  "plant.withdrawDelivery": "Lieferung zurückziehen",
  "plant.deliverUser": "Benutzer übergeben",
  "plant.withdrawDeliveryTip": "Nach dem Zurückziehen der Lieferung kann der Endnutzer dieses Kraftwerk nicht mehr verwalten. Bitte vorsichtig vorgehen.",
  "plant.undelivered": "Nicht übergeben",
  "plant.deliverManage": "Übergabe-Verwaltung",
  "plant.email_format_error": "E-Mail-Formatfehler",
  "plant.deliverUserTip": "Hinweis: Nutzer können sich bei Haier Energy mit ihrer E-Mail anmelden und die installierten Geräte über die App überwachen und steuern.",
  "plant.enterUserAccount": "Inserisci l'account utente",
  "plant.deliverUserTipUnified": "Nota: quando gli utenti accedono a Haier Energy con numero di telefono o email, possono monitorare e controllare i dispositivi installati tramite l'app.",
  "plant.placeholderPhoneOrEmail": "Inserisci numero di telefono o email",
  "plant.phoneOrEmailFormatError": "Inserisci un numero di telefono o un'email validi",
  "plant.deliverSuccess": "Übergabe erfolgreich",
  "plant.known": "Verstanden",
  "plant.notRegistered": "Nicht registriert",
  "plant.noPermission": "Sie haben keine Berechtigung, die Übergabe zurückzuziehen. Nur Plattform-Superadmins und Installateur-Admins dürfen dies tun.",
  "plant.scanQRCode": "Bitte lassen Sie den Eigentümer den untenstehenden QR-Code scannen",
  "plant.qrCodeExpireTip": "Dieser Autorisierungscode wird nach erfolgreichem Empfang ungültig.",
  "plant.transferMethod": "Metodo di trasferimento",
  "plant.transferRecord": "Storico trasferimenti",
  "plant.operationTime": "Ora dell'operazione",
  "plant.operator": "Operatore",
  "plant.transferType": "Tipo di trasferimento",
  "plant.userIdentifier": "Identificatore utente",
  "plant.transferResult": "Risultato del trasferimento",
  "plant.totalRecordCount": "Totale {count} record",
  "device.Yield": "Yield",
  "device.ExistingINV": "Existing INV",
  "sidebar.dictManage": "Gestione dizionario",
  "subtitle.dictData": "Dati dizionario",
  "dict.dictname": "Etichetta dizionario",
  "dict.dictnameen": "Chiave dizionario",
  "dict.dictdataname": "Etichetta dati",
  "dict.dictdatavalue": "Valore dati",
  "dict.i18nCode": "Codice lingua",
  "dict.dictsort": "Ordinamento",
  "dict.addDict": "Aggiungi dizionario",
  "dict.addDictData": "Aggiungi voce dizionario",
  "dict.editDict": "Modifica dizionario",
  "dict.editDictData": "Modifica voce dizionario",
  "device.otaTabTip": "Avviso: al termine dell'aggiornamento, il dispositivo sarà brevemente offline. Si prega di riavviarlo.",
  "product.accessPlatform": "Plattformquelle",
  "product.valueFilter": "Valore termine vuoto",
  "setting.type22.restrictCounterCurrent.val1": "Limita potenza totale trifase",
  "setting.type22.restrictCounterCurrent.val2": "Limita potenza monofase",
  "setting.type22.disable": "Disabilita",
  "setting.type22.enable": "Abilita",
  "setting.type22.meterSelect.str": "Contatore Stonray",
  "setting.type22.meterSelect.df": "Contatore Dongfan",
  "setting.type22.meterSelect.dh": "Contatore Donghong",
  "setting.type22.meterSelect.zt": "Contatore Chint",
  "setting.type22.meterSelect.yb": "Yeebon",
  "setting.type22.meterSelect.yz": "Ingeteam",
  "setting.type22.meterSelect.nky": "Contatore intelligente Nengkongyun",
  "workorder.searchCreateTime": "Ora di creazione",
  "workorder.statusAll": "Tutti",
  "workorder.statusPending": "In sospeso",
  "workorder.statusCompleted": "Completato",
  "workorder.statusClosed": "Chiuso",
  "workorder.no": "Numero ordine di lavoro",
  "workorder.tableDescription": "Descrizione",
  "workorder.plant": "Impianto",
  "workorder.device": "Dispositivo",
  "workorder.tableStatus": "Stato",
  "workorder.owner": "Responsabile",
  "workorder.handler": "Operatore",
  "workorder.handledTime": "Ora di elaborazione",
  "workorder.creator": "Creatore",
  "workorder.createTime": "Ora di creazione",
  "workorder.timeTooltip": "Ora nel fuso orario dell'impianto",
  "workorder.tableAction": "Operazione",
  "workorder.actionDetails": "Dettagli",
  "workorder.actionHandle": "Gestisci",
  "workorder.actionCancel": "Annulla",
  "workorder.createTitle": "Crea ordine di lavoro",
  "workorder.description": "Descrizione del guasto",
  "workorder.images": "Immagini del guasto",
  "workorder.handleTitle": "Gestisci ordine di lavoro",
  "workorder.group": "Informazioni di gestione",
  "workorder.feedback": "Feedback di gestione",
  "workorder.handleimages": "Immagini della gestione",
  "workorder.detailsTitle": "Dettagli ordine di lavoro",
  "workorder.detailsGroup": "Informazioni ordine di lavoro",
  "workorder.uploadSuccess": "Caricamento riuscito",
  "workorder.uploadNums": "Massimo 3 immagini consentite",
  "workorder.uploadFormatTip": "Formato file non valido. Caricare file in formato JPG, JPEG o PNG",
  "workorder.uploadFormat": "Caricare file non superiori a 5 MB in formato PNG/JPG/JPEG",
  "workorder.uploadImage": "Carica",
  "workorder.cancelTip": "L'annullamento di questo ordine di lavoro lo chiuderà automaticamente. Continuare?",
  "workorder.basicInformation": "Informazioni di base",
  "common.networkUnstable": "La connessione di rete è stata persa, controlla le impostazioni di rete",
  "common.networkFull": "Internet è di nuovo pieno come il sole",
  "common.networkSlow": "La rete attuale è lenta, attendi pazientemente o controlla le impostazioni di rete",
  "common.requestTimeout": "Richiesta scaduta, controlla la rete o riprova più tardi",
  "priceConfig.currentEffectivePrice": "Tariffa attualmente in vigore",
  "priceConfig.currencyUnitLabel": "Unità di valuta:",
  "priceConfig.addPrice": "Aggiungi tariffa",
  "priceConfig.effectiveTimeLabel": "Periodo di validità",
  "priceConfig.powerPrice": "Tariffa energetica",
  "priceConfig.additionalFees": "Costi aggiuntivi",
  "priceConfig.lastUpdateTime": "Ultimo aggiornamento",
  "priceConfig.lastUpdateTimeLabel": "Ultimo aggiornamento",
  "priceConfig.emptyCurrent": "Nessuna tariffa in vigore. Fai clic sul pulsante per configurare.",
  "priceConfig.emptyUpcoming": "Nessuna tariffa in arrivo",
  "priceConfig.upcomingTitle": "Tariffa in arrivo",
  "priceConfig.copyPriceTitle": "Copia tariffa",
  "priceConfig.deletePriceTitle": "Elimina tariffa",
  "priceConfig.deleteConfirmText": "Conferma l'eliminazione della seguente tariffa",
  "priceConfig.otherPrice": "Altri costi",
  "priceConfig.deleteWarning": "Se questa tariffa è attualmente in vigore, influenzerà il calcolo dei ricavi e l'esecuzione delle strategie AI.",
  "priceConfig.priceTypeLabel": "Tipo di tariffa",
  "priceConfig.timeOfUse": "Fasce orarie",
  "priceConfig.dynamic": "Dinamica",
  "priceConfig.timeOfUsePrice": "Tariffa a fasce orarie",
  "priceConfig.dynamicPrice": "Tariffa dinamica",
  "priceConfig.effectiveDatePlaceholder": "Seleziona una data di validità",
  "priceConfig.copyEffectiveDatePlaceholder": "Seleziona una data di validità",
  "priceConfig.nextStep": "Avanti",
  "priceConfig.buyPriceTitle": "Tariffa di acquisto",
  "priceConfig.feedInPriceTitle": "Tariffa di immissione in rete",
  "priceConfig.addTimePeriod": "Aggiungi intervallo orario",
  "priceConfig.electricitySurchargeTitle": "Sovrapprezzo energia",
  "priceConfig.electricitySurchargeTooltip": "Costo aggiuntivo per ogni kWh acquistato.",
  "priceConfig.fixedFeeTitle": "Quota fissa",
  "priceConfig.fixedFeeTooltip": "Quota base fissa per periodo di fatturazione, indipendente da consumo o potenza.",
  "priceConfig.hasFeeYes": "Sì",
  "priceConfig.countryLabel": "Paese",
  "priceConfig.secondaryRegionLabel": "Regione di secondo livello",
  "priceConfig.secondaryRegionPlaceholder": "Seleziona una regione di secondo livello",
  "priceConfig.currencyUnitPlaceholder": "Seleziona un'unità di valuta",
  "priceConfig.powerMarketLabel": "Mercato elettrico",
  "priceConfig.powerMarketPlaceholder": "Seleziona un mercato elettrico",
  "priceConfig.electricitySurchargePlaceholder": "Max 7 cifre intere, 8 decimali, ≥ 0",
  "priceConfig.fixedFeePlaceholder": "Max 7 cifre intere, 8 decimali, ≥ 0",
  "priceConfig.priceInputPlaceholder": "Inserisci il prezzo elettricità (max 7 cifre intere, 8 decimali, ≥ 0)",
  "priceConfig.timePlaceholder": "Seleziona l'ora",
  "priceConfig.selectEffectiveTimeTip": "Seleziona il periodo di validità",
  "priceConfig.selectPriceTypeTip": "Seleziona il tipo di tariffa",
  "priceConfig.selectCountryTip": "Seleziona il paese",
  "priceConfig.selectSecondaryRegionTip": "Seleziona la regione di secondo livello",
  "priceConfig.selectCurrencyUnitTip": "Seleziona un'unità di valuta",
  "priceConfig.selectPowerMarketTip": "Seleziona un mercato elettrico",
  "priceConfig.electricitySurchargeInputTip": "Inserisci il sovrapprezzo energia (max 7 cifre intere, 8 decimali, ≥ 0)",
  "priceConfig.electricitySurchargeRangeTip": "Sovrapprezzo energia: al massimo 7 cifre intere, 8 decimali, ≥ 0",
  "priceConfig.fixedFeeInputTip": "Inserisci la quota fissa (max 7 cifre intere, 8 decimali, ≥ 0)",
  "priceConfig.fixedFeeRangeTip": "Quota fissa: al massimo 7 cifre intere, 8 decimali, ≥ 0",
  "priceConfig.buyTimeFullDayTip": "Gli intervalli tariffari di acquisto devono coprire 24 ore",
  "priceConfig.feedInTimeFullDayTip": "Gli intervalli tariffari di immissione in rete devono coprire 24 ore",
  "priceConfig.buyTimeNoOverlapTip": "Gli intervalli tariffari di acquisto non possono sovrapporsi",
  "priceConfig.feedInTimeNoOverlapTip": "Gli intervalli tariffari di immissione in rete non possono sovrapporsi",
  "priceConfig.loadFail": "Caricamento dati tariffa non riuscito",
  "priceConfig.copySelectPriceTip": "Nessuna tariffa selezionata, impossibile copiare",
  "priceConfig.copyMissingPlantTip": "Informazioni sull'impianto mancanti, impossibile copiare la tariffa",
  "priceConfig.copySuccess": "Copia riuscita",
  "priceConfig.copyFail": "Copia non riuscita",
  "priceConfig.networkTimeout": "Timeout di rete. Riprovare dopo il ripristino della connessione.",
  "priceConfig.copyUnsupportedTip": "Questo tipo di tariffa non può essere copiato",
  "priceConfig.deleteSelectPriceTip": "Nessuna tariffa selezionata",
  "priceConfig.deleteIdMissingTip": "Impossibile ottenere l'ID tariffa, eliminazione non riuscita",
  "priceConfig.deleteSuccess": "Eliminazione riuscita",
  "priceConfig.deleteFail": "Eliminazione non riuscita",
  "priceConfig.missingPlantInfoTip": "Informazioni sull'impianto mancanti",
  "priceConfig.confirmGiveUpCreateTip": "Vuoi davvero annullare la creazione di questa tariffa?",
  "priceConfig.confirmGiveUpEditTip": "Vuoi davvero annullare la modifica di questa tariffa?",
  "priceConfig.pageTitleAdd": "Aggiungi tariffa",
  "priceConfig.pageTitleEdit": "Modifica tariffa",
  "priceConfig.pageTitleView": "Visualizza tariffa",
  "priceConfig.createSuccess": "Creazione riuscita",
  "priceConfig.editSuccess": "Modifica riuscita",
  "priceConfig.saveFail": "Salvataggio non riuscito",
  "priceConfig.dateRangePermanent": "{start} fino a tempo indeterminato",
  "priceConfig.dateRange": "{start} - {end}",
  "priceConfig.routeTitle": "Prezzo energia",
  "priceConfig.priceLabel": "Prezzo",
  "priceConfig.surchargeLabel": "Sovrapprezzo",
  "priceConfig.fixedFeeLabel": "Canone fisso",
  "button.copy": "Copia",
  "common.view": "Visualizza",
  "screen.platform": "Piattaforma di Gestione dell'Energia",
  "plantScreen.title": "Gestione Impianto",
  "plantScreen.DailyElectricityGenerated": "Energia Giornaliera Generata",
  "plantScreen.DailyElectricityUsed": "Energia Giornaliera Utilizzata",
  "plantScreen.DailyElectricityPurchased": "Energia Giornaliera Acquistata",
  "plantScreen.DailyElectricitySold": "Energia Giornaliera Venduta",
  "plantScreen.ChargingStatus": "Stato di Ricarica",
  "plantScreen.BatteryLevel": "Livello Batteria",
  "plantScreen.PhotovoltaicStatus": "Stato Fotovoltaico",
  "plantScreen.GridStatus": "Stato della Rete",
  "plantScreen.Charging": "In Carica",
  "plantScreen.Discharging": "In Scarica",
  "plantScreen.Generating": "In Generazione",
  "plantScreen.Idle": "Inattivo",
  "plantScreen.pvIDLE": "Non in Generazione",
  "plantScreen.BuyingElectricity": "Acquisto Elettricità",
  "plantScreen.SellingElectricity": "Vendita Elettricità",
  "plantScreen.netdead": "Fuori Rete",
  "plantScreen.day": "Giorno",
  "plantScreen.month": "Mese",
  "plantScreen.year": "Anno",
  "plantScreen.life": "Cumulato",
  "plantScreen.BatterySOC": "SOC Batteria",
  "plantScreen.PowerAnalysis": "Analisi della Potenza",
  "plantScreen.EquivalentRevenue": "Ricavo Equivalente",
  "plantScreen.EnergyAnalysis": "Analisi dell'Energia",
  "plantScreen.SocialContribution": "Contributo Sociale",
  "plantScreen.Photovoltaic": "Fotovoltaico",
  "plantScreen.Grid": "Rete",
  "plantScreen.Battery": "Batteria",
  "plantScreen.Load": "Carico",
  "plantScreen.Daily": "Giornaliero",
  "plantScreen.Monthly": "Mensile",
  "plantScreen.Yearly": "Annuale",
  "plantScreen.Cumulative": "Cumulativo",
  "plantScreen.Unit": "Unità",
  "plantScreen.ElectricityGeneration": "Generazione Elettrica",
  "plantScreen.ElectricityConsumption": "Consumo Elettrico",
  "plantScreen.ChartSet.explain": "Nota: Potenza > 0 = Scarica; Potenza < 0 = Ricarica.",
  "plantScreen.ChartSet.Self-consumption": "Autoconsumo",
  "plantScreen.ChartSet.GridElectricity": "Immissione in Rete",
  "plantScreen.ChartSet.Self-Sufficiency": "Autosufficienza",
  "plantScreen.ChartSet.PurchasedElectricity": "Elettricità Acquistata",
  "plantScreen.ChartSet.PVPower": "Potenza FV",
  "plantScreen.ChartSet.ConsumptionPower": "Potenza di consumo",
  "plantScreen.ChartSet.BatterySOC": "SOC Batteria",
  "plantScreen.ChartSet.BatteryChargingPower": "Potenza di Carica Batteria",
  "plantScreen.ChartSet.BatteryDischargingPower": "Potenza di Scarica Batteria",
  "plantScreen.ProtectedForest": "Foresta Protetta",
  "plantScreen.CO2Emission": "Emissioni di CO2",
  "plantScreen.Media": "Carbone",
  "plant.EquivalentBenefit.GridView": "Beneficio Equivalente = Autoconsumo * Tariffa Acquisto + Immissione in Rete * Tariffa Vendita",
  "plant.MonitoringScreen": "Schermo di Monitoraggio",
  "plantScreen.ChartSet.explainPower": "Nota: Potenza della rete > 0 = Vendita di elettricità; Potenza della rete < 0 = Acquisto di elettricità.",
  "cookie.necessary": "Cookie strettamente necessari",
  "cookie.performance": "Cookie di prestazione",
  "cookie.functional": "Cookie funzionali",
  "cookie.targeting": "Cookie di targeting",
  "cookie.necessaryExplain": "Questi cookie sono strettamente necessari per il funzionamento del sito web e non possono essere disattivati nei nostri sistemi. Di solito vengono impostati solo in risposta ad azioni da te effettuate che costituiscono una richiesta di servizi, come l'impostazione delle preferenze di privacy, l'accesso o la compilazione di moduli. Puoi impostare il tuo browser per bloccare o ricevere avvisi riguardo questi cookie, ma alcune parti del sito potrebbero non funzionare. Questi cookie non memorizzano alcuna informazione personale identificabile.",
  "cookie.performanceExplain": "Questi cookie ci permettono di contare le visite e le fonti di traffico in modo da poter misurare e migliorare le prestazioni del nostro sito. Ci aiutano a sapere quali sono le pagine più e meno popolari e a vedere come i visitatori si muovono all'interno del sito. Tutte le informazioni raccolte da questi cookie sono aggregate e quindi anonime. Se non consenti questi cookie, non sapremo quando hai visitato il nostro sito e non saremo in grado di monitorarne le prestazioni.",
  "cookie.functionalExplain": "Questi cookie consentono al sito web di fornire funzionalità avanzate e personalizzazione. Possono essere impostati da noi o da fornitori terzi i cui servaggi abbiamo aggiunto alle nostre pagine. Se non consenti questi cookie, alcuni o tutti questi servizi potrebbero non funzionare correttamente.",
  "cookie.targetingExplain": "Questi cookie possono essere impostati sul nostro sito dai nostri partner pubblicitari. Possono essere utilizzati da quelle aziende per creare un profilo dei tuoi interessi e mostrarti annunci pertinenti su altri siti. Non memorizzano direttamente informazioni personali, ma si basano sull'identificazione univoca del tuo browser e dispositivo internet. Se non consenti questi cookie, riceverai pubblicità meno mirata.",
  "cookie.necessaryAccount": "Verifica ID",
  "cookie.necessaryAccountExplain": "Utilizzato per mantenere lo stato di accesso dell'utente, è una funzione fondamentale dell'autenticazione del sito web e della gestione delle sessioni. Senza questo cookie, gli account utente potrebbero non essere visualizzati correttamente sulle pagine visitate.",
  "cookie.sessionManagement": "Gestione della sessione",
  "cookie.sessionManagementExplain": "Utilizzato per identificare in modo univoco le sessioni utente, mantenendo funzioni chiave come lo stato di accesso dell'utente, il contenuto del carrello e i dati dei moduli.",
  "cookie.userInfo": "Informazioni utente",
  "cookie.userInfoExplain": "Utilizzato per monitorare metriche aziendali come visualizzazioni di pagina (PV) e visitatori unici (UV), analizzare il traffico di sistema e il coinvolgimento degli utenti, per ottimizzare la priorità delle funzionalità e l'allineamento con le esigenze principali.",
  "cookie.deviceInfo": "Informazioni sul dispositivo",
  "cookie.deviceInfoExplain": "In base a diversi sistemi operativi, modelli di dispositivo e tipi di browser, risolve problemi di layout e compatibilità tra i terminali, ottimizzando le funzioni di adattamento per diversi dispositivi.",
  "cookie.pageInfo": "Informazioni sulla pagina",
  "cookie.pageInfoExplain": "Registra i percorsi di accesso alle pagine, le richieste API e i tempi di caricamento delle risorse per identificare colli di bottiglia delle prestazioni, errori di richiesta ed errori di codice, assistendo il team di sviluppo nella rapida risoluzione dei problemi.",
  "cookie.networkInfo": "Informazioni di rete",
  "cookie.networkInfoExplain": "Analizza la posizione geografica e le reti dei provider di servizi Internet (ISP) per identificare accessi dannosi e traffico anomalo, ottimizzando l'efficienza della distribuzione dei contenuti per i provider di servizi cloud.",
  "cookie.userPreference": "Preferenze dell'interfaccia",
  "cookie.userPreferenceExplain": "Utilizzato solo per registrare le preferenze dell'interfaccia utente per migliorare l'esperienza dell'utente, non è una funzione fondamentale richiesta per il funzionamento del sito web.",
  "cookie.longTerm": "Lungo termine",
  "cookie.duration180": "180 giorni",
  "cookie.durationSession": "Sessione",
  "cookie.bannerExplain": "Per ottimizzare la tua esperienza di navigazione, utilizziamo i cookie principalmente per registrare lo stato di accesso, ricordare le tue preferenze e adattarci alle tue abitudini di navigazione. Cliccando su 'Accetta tutto' acconsenti alla nostra Cookie Policy.",
  "cookie.acceptNecessary": "Solo necessari",
  "cookie.openPreferences": "Impostazioni preferenze",
  "cookie.acceptAll": "Accetta tutto",
  "cookie.cookieSet": "Impostazioni cookie",
  "cookie.cookieSetExplain": "Per maggiori informazioni, vedere",
  "cookie.cookiePolicy": "Cookie Policy",
  "cookie.cookieCategory": "Categoria di cookie",
  "cookie.cookieName": "Nome del cookie",
  "cookie.cookieDescription": "Scopo",
  "cookie.cookieDuration": "Periodo di validità",
  "cookie.cookieSwitch": "Interruttore",
  "cookie.savePreferences": "Salva preferenze",
  "cookie.preferencesTitle": "Preferenze cookie",
  "cookie.cookiePolicyText": "Cookie Policy",
  "common.currentVersion": "Versione Corrente",
  "common.versionUpdateNotice": "Notifica di Aggiornamento della Versione",
  "common.later": "Maggiori Informazioni",
  "common.immediateUpdate": "Aggiorna Ora",
  "sidebar.policyConfig": "Configurazione Policy",
  "common.addScope": "Aggiungi {scope}",
  "editor.header.title": "Intestazione",
  "editor.header.text": "Paragrafo",
  "editor.fontSize.title": "Dimensione carattere",
  "editor.fontSize.default": "Dimensione carattere predefinita",
  "editor.fontFamily.title": "Famiglia font",
  "editor.fontFamily.default": "Font predefinito",
  "editor.bold": "Grassetto",
  "editor.italic": "Corsivo",
  "editor.underline": "Sottolineato",
  "editor.through": "Barrato",
  "editor.code": "Codice in linea",
  "editor.sub": "Pedice",
  "editor.sup": "Apice",
  "editor.clearStyle": "Pulisci formattazione",
  "editor.color.color": "Colore testo",
  "editor.color.bgColor": "Colore sfondo",
  "editor.color.default": "Colore predefinito",
  "editor.color.clear": "Pulisci colore",
  "editor.bulletedList": "Elenco puntato",
  "editor.numberedList": "Elenco numerato",
  "editor.todo": "Lista di controllo",
  "editor.todo.title": "Da fare",
  "editor.emotion.title": "Emoji",
  "editor.justifyLeft": "Allinea a sinistra",
  "editor.justifyRight": "Allinea a destra",
  "editor.justifyCenter": "Centra",
  "editor.justifyJustify": "Giustifica",
  "editor.indent": "Aumenta rientro",
  "editor.delIndent": "Riduci rientro",
  "editor.lineHeight.title": "Altezza riga",
  "editor.lineHeight.default": "Altezza riga predefinita",
  "editor.blockquote": "Citazione",
  "editor.link.insert": "Inserisci collegamento",
  "editor.link.text": "Testo collegamento",
  "editor.link.url": "URL collegamento",
  "editor.link.unLink": "Rimuovi collegamento",
  "editor.link.edit": "Modifica collegamento",
  "editor.link.view": "Visualizza collegamento",
  "editor.image.netImage": "Immagine web",
  "editor.image.delete": "Elimina immagine",
  "editor.image.edit": "Modifica immagine",
  "editor.image.viewLink": "Visualizza collegamento",
  "editor.image.src": "URL immagine",
  "editor.image.desc": "Descrizione immagine",
  "editor.image.link": "Collegamento immagine",
  "editor.video.insert": "Inserisci video",
  "editor.video.delete": "Elimina video",
  "editor.video.uploadVideo": "Carica video",
  "editor.video.insertVideo": "Inserisci video",
  "editor.video.videoSrc": "URL video",
  "editor.video.videoSrcPlaceHolder": "Inserire URL video",
  "editor.video.videoPoster": "Copertina video",
  "editor.video.videoPosterPlaceHolder": "Inserire URL copertina",
  "editor.video.ok": "OK",
  "editor.video.editSize": "Modifica dimensioni",
  "editor.video.width": "Larghezza",
  "editor.video.height": "Altezza",
  "editor.table.header": "Tabella",
  "editor.table.insertTable": "Inserisci tabella",
  "editor.table.deleteTable": "Elimina tabella",
  "editor.table.insertRow": "Inserisci riga",
  "editor.table.deleteRow": "Elimina riga",
  "editor.table.insertCol": "Inserisci colonna",
  "editor.table.deleteCol": "Elimina colonna",
  "editor.table.widthAuto": "Larghezza automatica",
  "editor.table.widthFixed": "Larghezza fissa",
  "editor.codeBlock.title": "Blocco codice",
  "editor.divider": "Riga divisoria",
  "editor.emotion": "Emoji",
  "editor.insertFormula": "Inserisci formula",
  "editor.fullScreen": "Schermo intero",
  "editor.undo": "Annulla",
  "editor.redo": "Ripeti",
  "editor.delete": "Elimina",
  "editor.enter": "Invio",
  "editor.ok": "OK",
  "editor.cancel": "Annulla",
  "editor.uploadImgMaxSize": "Dimensione max immagine",
  "editor.uploadImgMaxSizeErr": "Dimensione immagine supera il limite",
  "editor.uploadImgMaxLength": "Numero max immagini",
  "editor.uploadImgMaxLengthErr": "Numero immagini supera il limite",
  "editor.uploadVideoMaxSize": "Dimensione max video",
  "editor.uploadVideoMaxSizeErr": "Dimensione video supera il limite",
  "editor.placeholder": "Inserisci contenuto...",
  "UserHome.plantFlow.load": "Carichi",
  "UserHome.plantFlow.grid": "Rete",
  "UserHome.plantFlow.battery": "Batteria",
  "UserHome.plantFlow.pv": "PV",
  "solid.snake.test": "msln",
  "plant.running.status.alarm": "Allarme",
  "end.web": "web",
  "test.label_G_P_C_L2": "Gen L2 Potenza",
  "device.offline": "Dispositivo offline",
  "solid.snake.msf.test": "",
  "bigboss.shaed.test": "",
  "ywt.60419.AllowCounterCurrentPower": "Potenza di ritorno consentita",
  "ywt.60419.internalharderror0": "nessuna anomalia",
  "ywt.60419.loadDropMode": "Modalità di riduzione del carico",
  "ywt.60419.loadDropMode11": "riduzione della potenza per singola macchina in prevenzione del flusso inverso",
  "ywt.60419.meterCommQuality": "Kommunikationsqualität des Stromzählers",
  "ywt.60419.meterRPower": "Leistung des Stromzählers Phase R",
  "ywt.60419.meterSelect": "Selezione del contatore elettrico",
  "ywt.60419.meterSPower": "Leistung des Stromzählers Phase S",
  "ywt.60419.meterTPower": "Potenza della fase T del meter",
  "ywt.60419.multiReverseFlowEnable": "Abilitazione della protezione contro il ritorno per più dispositivi",
  "ywt.60419.restrictCounterCurrent": "Modalità di limitazione del ritorno",
  "ywt.60419.singleReverseFlowEnable": "Abilitazione della protezione contro il ritorno per un solo dispositivo",
  "bw_param_ctrl_group_ParallelSetting": " Impostazioni parallelo",
  "bw_param_ctrl_group_SpecialSetting": "Impostazioni speciali",
  "bw_param_ctrl_name_PhaseOrderResume": "Ripresa ordine delle fasi",
  "bw_param_ctrl_note_ParallelModeSetting": "Impostare se l'inverter è un'unità master o slave in funzionamento parallelo.",
  "bw_param_ctrl_option_host": "Master in modalità parallela",
  "bw_param_ctrl_option_PhaseOrderResume": "Ripristina",
  "bw_param_ctrl_option_single": "Modalità non parallela (Modalità singola)",
  "bw_param_ctrl_option_Slave": "Slave in modalità parallela",
  "0X3809-F-0607": "Guasto protezione sovratemperatura morsetti PV",
  "0X3809-F-1103": "Anomalia autotest relè",
  "0X3809-F-3112": "Guasto aggancio fase tensione rete",
  "0X3809-F-3113": "Anomalia sequenza fasi rete",
  "0X3809-S-0101": "1. Verificare se le connessioni dei moduli fotovoltaici sono normali e se i moduli presentano danni, polvere sulla superficie o ombreggiamento.\n2. Verificare se i moduli fotovoltaici sono correttamente collegati e se le loro specifiche di tensione sono superiori all'intervallo di tensione di funzionamento dell'inverter.\n3. Verificare se c'è un cortocircuito nei moduli fotovoltaici.",
  "0X3809-S-0102": "1. Verificare se le connessioni dei moduli fotovoltaici sono normali e se i moduli presentano danni, polvere sulla superficie o ombreggiamento.\n2. Verificare se i moduli fotovoltaici sono correttamente collegati e se le loro specifiche di tensione sono superiori all'intervallo di tensione di funzionamento dell'inverter.\n3. Verificare se c'è un cortocircuito nei moduli fotovoltaici.",
  "0X3809-S-0103": "1. Verificare se le connessioni dei moduli fotovoltaici sono normali e se i moduli presentano danni, polvere sulla superficie o ombreggiamento.\n2. Verificare se i moduli fotovoltaici sono correttamente collegati e se le loro specifiche di tensione sono superiori all'intervallo di tensione di funzionamento dell'inverter.\n3. Verificare se c'è un cortocircuito nei moduli fotovoltaici.",
  "0X3809-S-0301": "1. Si verifica spesso al mattino presto; si prega di verificare la pulizia della superficie del pannello fotovoltaico.\n2. Verificare se i pannelli fotovoltaici sono collegati correttamente e se le loro specifiche di tensione superano l'intervallo di tensione di funzionamento dell'inverter.\n3. Riavviare l'inverter. Se il guasto persiste, contattare il proprio rivenditore.",
  "0X3809-S-0302": "1. Si verifica spesso al mattino presto; si prega di verificare la pulizia della superficie del pannello fotovoltaico.\n2. Verificare se i pannelli fotovoltaici sono collegati correttamente e se le loro specifiche di tensione superano l'intervallo di tensione di funzionamento dell'inverter.\n3. Riavviare l'inverter. Se il guasto persiste, contattare il proprio rivenditore.",
  "0X3809-S-0303": "1. Si verifica spesso al mattino presto; si prega di verificare la pulizia della superficie del pannello fotovoltaico.\n2. Verificare se i pannelli fotovoltaici sono collegati correttamente e se le loro specifiche di tensione superano l'intervallo di tensione di funzionamento dell'inverter.\n3. Riavviare l'inverter. Se il guasto persiste, contattare il proprio rivenditore.",
  "0X3809-S-0304": "1. Si verifica spesso al mattino presto; si prega di verificare la pulizia della superficie del pannello fotovoltaico.\n2. Verificare se i pannelli fotovoltaici sono collegati correttamente e se le loro specifiche di tensione superano l'intervallo di tensione di funzionamento dell'inverter.\n3. Riavviare l'inverter. Se il guasto persiste, contattare il proprio rivenditore.",
  "0X3809-S-0501": "Si prega di riavviare l'inverter. Se il guasto persiste, contattare il proprio rivenditore.",
  "0X3809-S-0502": "Si prega di riavviare l'inverter. Se il guasto persiste, contattare il proprio rivenditore.",
  "0X3809-S-0503": "Si prega di riavviare l'inverter. Se il guasto persiste, contattare il proprio rivenditore.",
  "0X3809-S-0504": "Si prega di riavviare l'inverter. Se il guasto persiste, contattare il proprio rivenditore.",
  "0X3809-S-0505": "Si prega di riavviare l'inverter. Se il guasto persiste, contattare il proprio rivenditore.",
  "0X3809-S-0506": "Si prega di riavviare l'inverter. Se il guasto persiste, contattare il proprio rivenditore.",
  "0X3809-S-0507": "Si prega di riavviare l'inverter. Se il guasto persiste, contattare il proprio rivenditore.",
  "0X3809-S-0508": "Si prega di riavviare l'inverter. Se il guasto persiste, contattare il proprio rivenditore.",
  "0X3809-S-0601": "1. Verificare se la ventola è bloccata da corpi estranei\n2. Verificare se il condotto d'aria del dissipatore è ostruito\n3. Riavviare l'inverter dopo il raffreddamento. Se non può ripristinarsi, contattare il rivenditore",
  "0X3809-S-0602": "1. Verificare se la ventola è bloccata da corpi estranei\n2. Verificare se il condotto d'aria del dissipatore è ostruito\n3. Riavviare l'inverter dopo il raffreddamento. Se non può ripristinarsi, contattare il rivenditore",
  "0X3809-S-0603": "1. Verificare se la ventola è bloccata da corpi estranei\n2. Verificare se il condotto d'aria del dissipatore è ostruito\n3. Riavviare l'inverter dopo il raffreddamento. Se non può ripristinarsi, contattare il rivenditore",
  "0X3809-S-0604": "1. Verificare se la ventola è bloccata da corpi estranei\n2. Verificare se il condotto d'aria del dissipatore è ostruito\n3. Riavviare l'inverter dopo il raffreddamento. Se non può ripristinarsi, contattare il rivenditore",
  "0X3809-S-0605": "1. Verificare se la ventola è bloccata da corpi estranei\n2. Verificare se il condotto d'aria del dissipatore è ostruito\n3. Riavviare l'inverter dopo il raffreddamento. Se non può ripristinarsi, contattare il rivenditore",
  "0X3809-S-0606": "1. Verificare se la ventola è bloccata da corpi estranei\n2. Verificare se il condotto d'aria del dissipatore è ostruito\n3. Riavviare l'inverter dopo il raffreddamento. Se non può ripristinarsi, contattare il rivenditore",
  "0X3809-S-0607": "1. Verificare se la ventola è bloccata da corpi estranei\n2. Verificare se il condotto d'aria del dissipatore è ostruito\n3. Riavviare l'inverter dopo il raffreddamento. Se non può ripristinarsi, contattare il rivenditore",
  "0X3809-S-0701": "1. Verificare se il modulo presenta un guasto a terra.\n2. Verificare la presenza di connessioni allentate nel circuito CC.\n3. Se non vengono riscontrati problemi nel circuito CC, spegnere l'alimentazione per 5 minuti e ripristinarla. Se il problema persiste, contattare il proprio rivenditore.",
  "0X3809-S-0801": "1. Guasto del circuito di pilotaggio.\n2. Spegnere e riavviare l'inverter. Se non può ripristinarsi, contattare il proprio rivenditore.",
  "0X3809-S-0901": "1. Guasto della scheda di controllo\n2. Spegnere e riavviare l'inverter. Se non può ripristinarsi, contattare il rivenditore",
  "0X3809-S-0902": "1. Guasto della scheda di controllo\n2. Spegnere e riavviare l'inverter. Se non può ripristinarsi, contattare il rivenditore",
  "0X3809-S-0903": "1. Guasto della scheda di controllo\n2. Spegnere e riavviare l'inverter. Se non può ripristinarsi, contattare il rivenditore",
  "0X3809-S-0904": "1. Guasto della scheda di controllo\n2. Spegnere e riavviare l'inverter. Se non può ripristinarsi, contattare il rivenditore",
  "0X3809-S-0905": "1. Guasto della scheda di controllo\n2. Spegnere e riavviare l'inverter. Se non può ripristinarsi, contattare il rivenditore",
  "0X3809-S-0906": "1. Guasto della scheda di controllo\n2. Spegnere e riavviare l'inverter. Se non può ripristinarsi, contattare il rivenditore",
  "0X3809-S-0907": "1. Guasto della scheda di controllo\n2. Spegnere e riavviare l'inverter. Se non può ripristinarsi, contattare il rivenditore",
  "0X3809-S-1001": "1. Se si verifica occasionalmente, può essere causato da anomalie occasionali delle linee esterne. Riavviare l'inverter ripristinerà il funzionamento normale.\n2. Se si verifica frequentemente o non può essere ripristinato per un lungo periodo, verificare se la messa a terra delle stringhe fotovoltaiche è affidabile.",
  "0X3809-S-1002": "1. Se si verifica occasionalmente, può essere causato da anomalie occasionali delle linee esterne. Riavviare l'inverter ripristinerà il funzionamento normale.\n2. Se si verifica frequentemente o non può essere ripristinato per un lungo periodo, verificare se la messa a terra delle stringhe fotovoltaiche è affidabile.",
  "0X3809-S-1003": "1. Se si verifica occasionalmente, può essere causato da anomalie occasionali delle linee esterne. Riavviare l'inverter ripristinerà il funzionamento normale.\n2. Se si verifica frequentemente o non può essere ripristinato per un lungo periodo, verificare se la messa a terra delle stringhe fotovoltaiche è affidabile.",
  "0X3809-S-1004": "1. Se si verifica occasionalmente, può essere causato da anomalie occasionali delle linee esterne. Riavviare l'inverter ripristinerà il funzionamento normale.\n2. Se si verifica frequentemente o non può essere ripristinato per un lungo periodo, verificare se la messa a terra delle stringhe fotovoltaiche è affidabile.",
  "0X3809-S-1101": "1. Verificare se il filo di terra lato AC è sotto tensione.\n2. Guasto relè interno.\n3. Spegnere e riavviare l'inverter. Se non può ripristinarsi, contattare il rivenditore.",
  "0X3809-S-1102": "1. Verificare se il filo di terra lato AC è sotto tensione.\n2. Guasto relè interno.\n3. Spegnere e riavviare l'inverter. Se non può ripristinarsi, contattare il rivenditore.",
  "0X3809-S-1103": "1. Verificare se il filo di terra lato AC è sotto tensione.\n2. Guasto relè interno.\n3. Spegnere e riavviare l'inverter. Se non può ripristinarsi, contattare il rivenditore.",
  "0X3809-S-1201": "1. Ventola interna danneggiata\n2. Guasto del circuito di rilevamento della ventola\n3. Spegnere e riavviare l'inverter. Se non può ripristinarsi, contattare il rivenditore",
  "0X3809-S-1901": "Spegnere e riavviare l'inverter. Se non può ripristinarsi, contattare il rivenditore.",
  "0X3809-S-1902": "Spegnere e riavviare l'inverter. Se non può ripristinarsi, contattare il rivenditore.",
  "0X3809-S-1903": "Spegnere e riavviare l'inverter. Se non può ripristinarsi, contattare il rivenditore.",
  "0X3809-S-1904": "Spegnere e riavviare l'inverter. Se non può ripristinarsi, contattare il rivenditore.",
  "0X3809-S-1905": "Spegnere e riavviare l'inverter. Se non può ripristinarsi, contattare il rivenditore.",
  "0X3809-S-1906": "Spegnere e riavviare l'inverter. Se non può ripristinarsi, contattare il rivenditore.",
  "0X3809-S-1907": "Spegnere e riavviare l'inverter. Se non può ripristinarsi, contattare il rivenditore.",
  "0X3809-S-3101": "1. Verificare se un interruttore automatico nel quadro elettrico è scattato.\n2. Misurare se la tensione effettiva supera l'intervallo dell'inverter.\n3. Se la tensione è fuori intervallo, è possibile regolare i valori di protezione da sovratensione e sottotensione dell'inverter.",
  "0X3809-S-3102": "1. Verificare se un interruttore automatico nel quadro elettrico è scattato.\n2. Misurare se la tensione effettiva supera l'intervallo dell'inverter.\n3. Se la tensione è fuori intervallo, è possibile regolare i valori di protezione da sovratensione e sottotensione dell'inverter.",
  "0X3809-S-3103": "1. Verificare se un interruttore automatico nel quadro elettrico è scattato.\n2. Misurare se la tensione effettiva supera l'intervallo dell'inverter.\n3. Se la tensione è fuori intervallo, è possibile regolare i valori di protezione da sovratensione e sottotensione dell'inverter.",
  "0X3809-S-3104": "1. Verificare se un interruttore automatico nel quadro elettrico è scattato.\n2. Misurare se la tensione effettiva supera l'intervallo dell'inverter.\n3. Se la tensione è fuori intervallo, è possibile regolare i valori di protezione da sovratensione e sottotensione dell'inverter.",
  "0X3809-S-3105": "1. Verificare se un interruttore automatico nel quadro elettrico è scattato.\n2. Misurare se la tensione effettiva supera l'intervallo dell'inverter.\n3. Se la tensione è fuori intervallo, è possibile regolare i valori di protezione da sovratensione e sottotensione dell'inverter.",
  "0X3809-S-3106": "1. Verificare se un interruttore automatico nel quadro elettrico è scattato.\n2. Misurare se la tensione effettiva supera l'intervallo dell'inverter.\n3. Se la tensione è fuori intervallo, è possibile regolare i valori di protezione da sovratensione e sottotensione dell'inverter.",
  "0X3809-S-3107": "1. Verificare se un interruttore automatico nel quadro elettrico è scattato.\n2. Misurare se la tensione effettiva supera l'intervallo dell'inverter.\n3. Se la tensione è fuori intervallo, è possibile regolare i valori di protezione da sovratensione e sottotensione dell'inverter.",
  "0X3809-S-3108": "1. Verificare se un interruttore automatico nel quadro elettrico è scattato.\n2. Misurare se la tensione effettiva supera l'intervallo dell'inverter.\n3. Se la tensione è fuori intervallo, è possibile regolare i valori di protezione da sovratensione e sottotensione dell'inverter.",
  "0X3809-S-3109": "1. Verificare se un interruttore automatico nel quadro elettrico è scattato.\n2. Misurare se la tensione effettiva supera l'intervallo dell'inverter.\n3. Se la tensione è fuori intervallo, è possibile regolare i valori di protezione da sovratensione e sottotensione dell'inverter.",
  "0X3809-S-3110": "1. Verificare se un interruttore automatico nel quadro elettrico è scattato.\n2. Misurare se la tensione effettiva supera l'intervallo dell'inverter.\n3. Se la tensione è fuori intervallo, è possibile regolare i valori di protezione da sovratensione e sottotensione dell'inverter.",
  "0X3809-S-3111": "1. Verificare se un interruttore automatico nel quadro elettrico è scattato.\n2. Misurare se la tensione effettiva supera l'intervallo dell'inverter.\n3. Se la tensione è fuori intervallo, è possibile regolare i valori di protezione da sovratensione e sottotensione dell'inverter.",
  "0X3809-S-3112": "1. Verificare se un interruttore automatico nel quadro elettrico è scattato.\n2. Misurare se la tensione effettiva supera l'intervallo dell'inverter.\n3. Se la tensione è fuori intervallo, è possibile regolare i valori di protezione da sovratensione e sottotensione dell'inverter.",
  "0X3809-S-3113": "1. Verificare se un interruttore automatico nel quadro elettrico è scattato.\n2. Misurare se la tensione effettiva supera l'intervallo dell'inverter.\n3. Se la tensione è fuori intervallo, è possibile regolare i valori di protezione da sovratensione e sottotensione dell'inverter.",
  "0X3809-S-3301": "1. Verificare la presenza di connessioni allentate nella rete elettrica.\n2. Regolare l'intervallo di frequenza in modo appropriato.",
  "0X3809-S-3302": "1. Verificare la presenza di connessioni allentate nella rete elettrica.\n2. Regolare l'intervallo di frequenza in modo appropriato.",
  "0X3809-S-3303": "1. Verificare la presenza di connessioni allentate nella rete elettrica.\n2. Regolare l'intervallo di frequenza in modo appropriato.",
  "0X3809-S-3304": "1. Verificare la presenza di connessioni allentate nella rete elettrica.\n2. Regolare l'intervallo di frequenza in modo appropriato.",
  "0X3809-S-3305": "1. Verificare la presenza di connessioni allentate nella rete elettrica.\n2. Regolare l'intervallo di frequenza in modo appropriato.",
  "0X3809-S-3306": "1. Verificare la presenza di connessioni allentate nella rete elettrica.\n2. Regolare l'intervallo di frequenza in modo appropriato.",
  "0X3809-S-3701": "Verificare se l'inverter è stato spento manualmente.",
  "0X3809-S-3801": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3802": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3803": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3804": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3805": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3806": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3807": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3808": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3809": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3810": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3811": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3812": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3813": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3814": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3815": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3816": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3817": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3818": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3819": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3820": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3901": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3902": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3903": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3904": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3905": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3906": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3907": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3908": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3909": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3910": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3911": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3912": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3913": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3914": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3915": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3916": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3917": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3918": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3919": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-3920": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-4101": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-4201": "Verificare se la tensione N-PE è anomala",
  "0X3809-S-4301": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3809-S-4401": "Spegnere l'inverter e disconnettere gli interruttori di ingresso/uscita. Riavviare l'inverter dopo 5 minuti. Se il guasto non viene eliminato, contattare il rivenditore.",
  "0X3807-F-02": "Allarme cortocircuito PV2",
  "0X3807-F-03": "Allarme bassa tensione PV",
  "0X3807-S-0101": "1. Verificare se la ventola è bloccata da corpi estranei\n2. Verificare se la ventola ruota normalmente\n3. Riavviare l'inverter; se non può ripristinarsi, sostituire la ventola",
  "0X3807-S-0102": "1. Verificare se la ventola è bloccata da corpi estranei\n2. Verificare se la ventola ruota normalmente\n3. Riavviare l'inverter; se non può ripristinarsi, sostituire la ventola",
  "0X3807-S-0103": "1. Verificare se la ventola è bloccata da corpi estranei\n2. Verificare se la ventola ruota normalmente\n3. Riavviare l'inverter; se non può ripristinarsi, sostituire la ventola",
  "0X3807-S-0104": "1. Verificare se la ventola è bloccata da corpi estranei\n2. Verificare se la ventola ruota normalmente\n3. Riavviare l'inverter; se non può ripristinarsi, sostituire la ventola",
  "0X3807-S-0105": "1. Verificare se la ventola è bloccata da corpi estranei\n2. Verificare se la ventola ruota normalmente\n3. Riavviare l'inverter; se non può ripristinarsi, sostituire la ventola",
  "0X3807-S-0106": "1. Verificare se la ventola è bloccata da corpi estranei\n2. Verificare se la ventola ruota normalmente\n3. Riavviare l'inverter; se non può ripristinarsi, sostituire la ventola",
  "0X3807-S-0107": "1. Verificare se la ventola è bloccata da corpi estranei\n2. Verificare se la ventola ruota normalmente\n3. Riavviare l'inverter; se non può ripristinarsi, sostituire la ventola",
  "0X3807-S-0108": "1. Verificare se la ventola è bloccata da corpi estranei\n2. Verificare se la ventola ruota normalmente\n3. Riavviare l'inverter; se non può ripristinarsi, sostituire la ventola",
  "0X3807-S-0109": "1. Verificare se la ventola è bloccata da corpi estranei\n2. Verificare se la ventola ruota normalmente\n3. Riavviare l'inverter; se non può ripristinarsi, sostituire la ventola",
  "0X3807-S-0110": "1. Verificare se la ventola è bloccata da corpi estranei\n2. Verificare se la ventola ruota normalmente\n3. Riavviare l'inverter; se non può ripristinarsi, sostituire la ventola",
  "0X3807-S-0401": "Verificare se il cablaggio del contatore è errato.",
  "0X3807-S-0402": "Verificare se il cablaggio del contatore è errato.",
  "0X3807-S-0404": "Verificare se il cablaggio del contatore è errato.",
  "0X3807-S-0408": "Verificare se il cablaggio del contatore è errato.",
  "0X3807-S-0416": "Verificare se il cablaggio del contatore è errato.",
  "0X3807-S-0500": "1. Se si verifica occasionalmente, potrebbe essere dovuto a un'anomalia temporanea della rete. L'inverter riprenderà il normale funzionamento dopo il ritorno alla normalità della rete.\n2. Se questo guasto viene segnalato frequentemente, verificare se la rete è anomala.",
  "0X3807-S-0601": "Dopo lo spegnimento, verificare se la tensione del modulo è normale. Se il riavvio non risolve il problema, ciò indica un guasto interno dell'inverter.",
  "0X3807-S-02": "Dopo lo spegnimento, verificare se la tensione del modulo è normale. Se il riavvio non risolve il problema, ciò indica un guasto interno dell'inverter.",
  "0X3807-S-03": "Dopo lo spegnimento, verificare se la tensione del modulo è normale. Se il riavvio non risolve il problema, ciò indica un guasto interno dell'inverter.",
  "In Alarm": "In Allarme",
  "device.category.energyStorageCabinet": "Armadio di stoccaggio energia",
  "device.category.commercialRobot": "Robot industriale commerciale",
  "device.category.pvinverter": "Invertitore fotovoltaico",
  "collector.upgrade.progress": "Progresso dell'aggiornamento del collezionista",
  "device.upgrade.progress": "Progresso dell'aggiornamento del dispositivo",
  "failed.to.obtain.firmware": "Impossibile ottenere il firmware",
  "file.CRC.check.failed": "Controllo CRC del file non riuscito",
  "burning.timed.out": "Timeout durante la scrittura",
  "burning.failed": "Scrittura fallita",
  "shujvabng": "Data Stick (Bumai)",
  "paramSet.select.dataError.tip": "L'opzione non è l'opzione ottimale, per favore reimpostala.",
  "ywt.60419.pbusVol": "Tensione PBUS",
  "bw_param_qqq": "Impostazione Modalità Parallelo",
  "paramSet.dateTime.title.month": "M",
  "ywt.60419.invRTemp": "Temperatura del modulo INV R(℃)",
  "ywt.60419.sGridVol": "S tensione di fase della rete",
  "paramSet.dateTime.title.year": "A",
  "50500_0x7572-C-15": "Dissipatore di calore guasto ad alta temperatura",
  "50500_0x7572-C-14": "Guasto ARC",
  "ywt.60419.btDspDebugInfo8": "Informazioni di debug DSP BT 8",
  "ywt.60419.btDspDebugInfo7": "Informazioni di debug DSP BT 7",
  "ywt.60419.btDspDebugInfo6": "Informazioni di debug DSP BT 6",
  "ywt.60419.sPhaseDci": "Guasto DCI fase S",
  "50500_0x756F-S-6": "Guasto softstart DC / DC\n 1. Controllare il fusibile della batteria;\n 2. Riavviare e verificare se è normale;\n 3. Cerchi l'aiuto da noi, se non può tornare allo stato noarmal",
  "50500_0x756F-S-7": "INV Relay Fault 1.Confirm that the wiring between each device is correct\n1.Confirm that the wiring between each device is correct\n2. Restart and check whether it is in normal;\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x756F-S-4": "EEPROM Read Fault\n1.Confirm that the wiring between each device is correct\n2. Restart and check whether it is in normal;\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x756F-S-5": "EEPROM Write Fault\n1.Confirm that the wiring between each device is correct\n2. Restart and check whether it is in normal;\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x756F-S-8": "Auxiliary power supply failure\n1. Wait for minutes then check;\n2. Remove wifi plug or other communicator;\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x756F-S-9": "Avaria alimentazione ausiliaria\n 1. Attendere minuti quindi controllare;\n 2. Rimuovere la spina wifi o altro comunicatore;\n 3. Cerchi l'aiuto da noi, se non può tornare allo stato noarmal",
  "ywt.60419.armDebugInfo7": "Informazioni di debug ARM 7",
  "ywt.60419.armDebugInfo5": "Informazioni di debug ARM 5",
  "ywt.60419.armDebugInfo6": "Informazioni di debug ARM 6",
  "50500_0x756F-S-2": "GFCI Device Fault\n1.Confirm that the wiring between each device is correct\n2. Restart and check whether it is in normal;\n3. Seek help from us, if can’t go back to noarmal state",
  "ywt.60419.armDebugInfo3": "Informazioni di debug ARM 3",
  "ywt.60419.armDebugInfo4": "Informazioni di debug ARM 4",
  "ywt.60419.armDebugInfo1": "Informazioni di debug ARM 1",
  "ywt.60419.armDebugInfo2": "Informazioni di debug ARM 2",
  "50500_0x756F-C-6": "CC / CC _ Softsart _ Guasto",
  "50500_0x756F-C-9": "AuxPowerBoard _ Guasto",
  "ywt.60419.deratedPower": "Potenza di declassamento",
  "50500_0x7570-F-14": "Soft _ Start _ Fallito",
  "50500_0x7570-F-12": "Parallelo _ CANBus _ Guasto",
  "50500_0x756F-C-13": "Cambio modalità di lavoro",
  "ywt.60419.todayPvEnergy": "Produzione di energia giornaliera",
  "ywt.60419.btDspDebugInfo1": "Informazioni di debug DSP BT 1",
  "ywt.60419.invSTemp": "Temperatura modulo INV S(℃)",
  "ywt.60419.btDspDebugInfo5": "Informazioni di debug DSP BT 5",
  "ywt.60419.btDspDebugInfo4": "Informazioni di debug DSP BT 4",
  "ywt.60419.btDspDebugInfo3": "Informazioni di debug DSP BT 3",
  "ywt.60419.btDspDebugInfo2": "Informazioni di debug DSP BT 2",
  "ywt.60419.dcInsulationImpedance": "Impedenza di isolamento DC",
  "test.label_G_P_C_L1": "Gen L1 Potenza",
  "ywt.60419.internalHardwareError": "anomalia hardware interna alla macchina",
  "ywt.60419.versionStr": "Numero di versione",
  "test.label_G_P_C_L5": "Tensione Gen L2",
  "common.50500.xnl_RTparam_name_G_P_V_L2": "Tensione Gen L2",
  "test.label_G_P_C_L4": "Tensione Gen L1",
  "common.50500.xnl_RTparam_name_G_P_V_L3": "Tensione Gen L3",
  "test.label_G_P_C_L3": "Gen L3 Potenza",
  "common.50500.xnl_RTparam_name_G_P_V_L1": "Tensione Gen L1",
  "test.label_G_P_C_L6": "Tensione Gen L3",
  "ywt.60419.envTemp": "Temperatura ambiente(℃)",
  "bw_param_ctrl_name_ParallelSetting": "Stato parallelo",
  "ywt.60419.rGridVol": "Tensione di fase della rete R",
  "ywt.60419.scanStatus": "Stato di scansione I/V",
  "ywt.60419.groupStrCurrent1": "Corrente di stringa 1",
  "ywt.60419.invTTemp": "Temperatura modulo INV T(℃)",
  "ywt.60419.groupStrCurrent2": "Corrente di stringa 2",
  "ywt.60419.groupStrCurrent5": "Corrente di stringa 5",
  "ywt.60419.groupStrCurrent6": "Corrente di stringa 6",
  "ywt.60419.groupStrCurrent3": "Corrente di stringa 3",
  "ywt.60419.groupStrCurrent4": "Corrente di stringa 4",
  "ywt.60419.groupStrCurrent9": "Corrente di stringa 9",
  "ywt.60419.groupStrCurrent7": "Corrente di stringa 7",
  "ywt.60419.groupStrCurrent8": "Corrente di stringa 8",
  "ywt.60419.pvInputVol2": "Tensione d'ingresso PV2",
  "ywt.60419.pvInputVol1": "Tensione d'ingresso PV1",
  "ywt.60419.pvPower2": "Potenza PV 2",
  "ywt.60419.pvPower1": "Potenza PV 1",
  "ywt.60419.pvPower8": "Potenza PV 8",
  "ywt.60419.pvPower7": "Potenza PV 7",
  "ywt.60419.pvPower9": "Potenza PV 9",
  "50500_0x7571-S-10": "1.Confirm that the wiring between each device is correct\n2. Check the AC voltage is in the range of standard voltage in specification;\n3.Seek help from us, if can’t go back to noarmal state",
  "ywt.60419.pvPower4": "Potenza PV 4",
  "50500_0x7571-S-15": "Frequenza della rete fuori portata\n 1. Controllare che la frequenza sia nell'intervallo delle specifiche o meno;\n 2. Controllare se i cavi CA sono saldamente e correttamente collegati;\n 3. cercare aiuto da noi, se non può tornare allo stato normale.",
  "ywt.60419.pvPower3": "Potenza PV 3",
  "ywt.60419.pvPower6": "Potenza PV 6",
  "50500_0x7571-S-13": "Guasto della batteria di backup. \n 1. Controllare la capacità della batteria;\n 2. Controllare la connessione tra batterie e inverter;\n 3. Se l'invertitore non può tornare alla normalità dopo la riduzione del carico, chiedere aiuto a noi",
  "ywt.60419.pvPower5": "Potenza PV 5",
  "50500_0x7571-S-14": "Frequenza della rete fuori portata\n 1. Controllare che la frequenza sia nell'intervallo delle specifiche o meno;\n 2. Controllare se i cavi CA sono saldamente e correttamente collegati;\n 3. cercare aiuto da noi, se non può tornare allo stato normale.",
  "50500_0x7570-C-14": "Soft _ Start _ Fallito",
  "50500_0x7570-C-12": "Parallelo _ CANBus _ Guasto",
  "ywt.60419.pvInputVol9": "Tensione d'ingresso PV9",
  "ywt.60419.pvInputVol8": "Tensione d'ingresso PV8",
  "ywt.60419.pvInputVol7": "Tensione d'ingresso PV7",
  "ywt.60419.pvInputVol6": "Tensione d'ingresso PV6",
  "ywt.60419.pvInputVol5": "Tensione d'ingresso PV5",
  "ywt.60419.pvInputVol4": "Tensione d'ingresso PV4",
  "ywt.60419.pvInputVol3": "Tensione d'ingresso PV3",
  "ywt.60419.pvChargeTime": "Tempo di generazione di energia",
  "ywt.60419.invDspDebugInfo1": "Informazioni di debug INV DSP 1",
  "ywt.60419.invDspDebugInfo2": "Informazioni di debug INV DSP 2",
  "ywt.60419.invDspDebugInfo3": "Informazioni di debug INV DSP 3",
  "ywt.60419.invDspDebugInfo4": "Informazioni di debug INV DSP 4",
  "ywt.60419.invDspDebugInfo5": "Informazioni di debug INV DSP 5",
  "ywt.60419.invDspDebugInfo6": "Informazioni di debug INV DSP 6",
  "ywt.60419.invDspDebugInfo7": "Informazioni di debug INV DSP 7",
  "ywt.60419.invDspDebugInfo8": "Informazioni di debug INV DSP 8",
  "ywt.60419.workStatus0": "Inizializzazione",
  "ywt.60419.workStatus1": "Attendere",
  "ywt.60419.workStatus2": "Collegamento alla rete",
  "ywt.60419.workStatus3": "Guasto",
  "ywt.60419.workStatus4": "Programma di masterizzazione dei dati",
  "ywt.60419.workStatus5": "Fuori rete",
  "ywt.60419.rPhaseDci": "Guasto DCI fase R",
  "50500_0x756F-F-13": "Cambio modalità di lavoro",
  "50500_0x756F-F-12": "Batt Mode Changed",
  "common.50500.xnl_RTparam_name_G_P_C_L2": "Gen L2 Potenza",
  "common.50500.xnl_RTparam_name_G_P_C_L1": "Gen L1 Potenza",
  "common.50500.xnl_RTparam_name_G_P_C_L3": "Gen L3 Potenza",
  "paramSet.dateTime.title.hour": "H",
  "ywt.60419.tOnGridCurrent": "Corrente di rete di fase T",
  "ywt.60419.trGridVol": "Tensione del cavo di rete TR",
  "paramSet.dateTime.title.minute": "Min",
  "ywt.60419.loadPower": "Lastleistung",
  "50500_0x7572-S-15": "La temperatura del dissipatore di calore è troppo alta\n 1. Controllare se la temperatura dell'ambiente di lavoro è troppo alta;\n 2. Spegni l'inverter per 10 minuti e riavvia;\n 3. cercare aiuto da noi, se non può tornare allo stato normale.",
  "50500_0x7572-S-14": "1. Il rilevamento dei guasti dell'arco è solo per il mercato statunitense;\n 2. Controllare il collegamento del cavo del modulo fotovoltaico e cancellare il guasto;\n 3. cercare aiuto da noi, se non può tornare allo stato normale.",
  "ywt.60419.tPhaseDci": "Guasto DCI fase T",
  "50500_0x7572-S-13": "1.Confirm that the load is appropriate\n2.Ensure sufficient PV energy and Reduce the load appropriately\n3.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7572-S-12": "1.Confirm that the wiring between each device is correct\n2. Seek help from us, if can’t go back to noarmal state",
  "ywt.60419.pvPower11": "Potenza PV 11",
  "50500_0x7572-S-11": "1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3.Seek help from us, if can’t go back to noarmal state",
  "ywt.60419.pvPower10": "Potenza PV 10",
  "50500_0x7572-S-10": "Batt Shutdown Fault\n1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7570-F-8": "AC _ Attivo _ Batt _ Guasto",
  "50500_0x7570-F-9": "La sbarra DC è sbilanciata",
  "ywt.60419.reactivePower": "Potenza reattiva",
  "50500_0x7570-F-0": "Attivo _ Batteria _ Tenere",
  "50500_0x7570-F-1": "AC su guasto corrente dell'hardware",
  "50500_0x7570-F-3": "DC su guasto corrente dell'hardware",
  "50500_0x7570-F-5": "TZ _ EmergSStop _ Guasto",
  "50500_0x7570-F-6": "La corrente di dispersione CA è transitoria sulla corrente",
  "50500_0x7570-F-7": "Guasto all'impedenza dell'isolamento DC",
  "ywt.60419.rsGirdVol": "Tensione di rete RS",
  "ywt.60419.rOnGridCurrent": "Corrente connessa alla rete fase R",
  "ywt.60419.pvInputVol11": "Tensione d'ingresso PV11",
  "ywt.60419.pvInputVol10": "Tensione d'ingresso PV10",
  "ywt.60419.pvInputVol12": "Tensione d'ingresso PV12",
  "50500_0x7571-F-13": "BCAKUP _ Batteria _ Guasto",
  "50500_0x7571-F-14": "AC su frequenza",
  "50500_0x7571-F-15": "AC frequenza inferiore",
  "50500_0x7570-S-3": "Lato DC sopra guasto corrente\n 1. Controlli il modulo di PV si collega e la batteria si collega;\n 2. Spegnere l'interruttore DC e l'interruttore AC e quindi attendere un minuto, quindi riaccendere l'interruttore DC / AC;\n 3. cercare aiuto da noi, se non può tornare allo stato normale.",
  "50500_0x7570-S-5": "Cerca aiuto da noi, questo fallimento difficilmente accade.",
  "50500_0x7570-S-6": "Guasto corrente di dispersione\n 1. Controlli il cavo del modulo di PV e dell'invertitore;\n 2. Riavviare l'inverter;\n 3. cercare aiuto da noi, se non può tornare allo stato normale.",
  "50500_0x7570-S-7": "La resistenza di isolamento PV è troppo bassa\n 1. Controllare che il collegamento dei pannelli fotovoltaici e dell'inverter sia saldo e corretto;\n 2. Controllare se il cavo PE dell'inverter è collegato a terra;\n 3. cercare aiuto da noi, se non può tornare allo stato normale.",
  "50500_0x7570-S-8": "AC_Active_Batt_Fault\n1.Check the battery fuse;\n2.Confirm that the wiring between each device is correct\n3.Confirm that the device parameter settings are correct\n4. Seek help from us, if can’t go back to noarmal state",
  "50500_0x7570-S-9": "1. Si prega di attendere un po 'e controllare se è normale;\n 2. Se ancora lo stesso, e spegnere l'interruttore DC e l'interruttore AC e attendere un minuto e quindi accendere l'interruttore DC / AC;\n 3. cercare aiuto da noi, se non può tornare allo stato normale.",
  "ywt.60419.totalPvEnergy": "Produzione totale di energia",
  "50500_0x7570-S-0": "1.Check  insulation in the battery pack.\n2.Confirm that the wiring between each device is correct\n3.Confirm that the device parameter settings are correct\n4.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7570-S-1": "AC lato sopra guasto corrente\n 1. Controlli prego se il potere del carico di sostegno ed il potere comune del carico sono all'interno della gamma;\n 2. Riavviare e verificare se è normale;\n 3. cercare aiuto da noi, se non può tornare allo stato normale.",
  "50500_0x7570-C-3": "DC su guasto corrente dell'hardware",
  "50500_0x7570-C-5": "TZ _ EmergSStop _ Guasto",
  "50500_0x7570-C-6": "La corrente di dispersione CA è transitoria sulla corrente",
  "50500_0x7570-C-7": "Guasto all'impedenza dell'isolamento DC",
  "50500_0x7570-C-8": "AC _ Attivo _ Batt _ Guasto",
  "50500_0x7570-C-9": "La sbarra DC è sbilanciata",
  "50500_0x7571-C-8": "Sistema _ parallelo _ Stop",
  "50500_0x7571-C-9": "Linea AC bassa tensione",
  "50500_0x7571-C-6": "DCLLC _ Sopra _ Corrente",
  "50500_0x7571-C-7": "Batt _ Sopra _ Corrente",
  "50500_0x756F-S-12": "Batt Mode Changed\n1.Confirm that the wiring between each device is correct\n2. Restart and check whether it is in normal;\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x7571-C-4": "DCLLC _ Soft _ Over _ Cur",
  "50500_0x7571-C-5": "Battery OV ",
  "50500_0x7570-C-0": "Attivo _ Batteria _ Tenere",
  "50500_0x756F-S-14": "INV OCP \n1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3.Confirm that the device parameter settings are correct\n4.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7570-C-1": "AC su guasto corrente dell'hardware",
  "50500_0x7571-C-2": "Nessuna griglia CA",
  "50500_0x756F-S-13": "Modalità di lavoro inverter cambiata\n 1. attendere un minuto e controllare;\n 2. Cerchi l'aiuto da noi, se non può ritornare allo stato normale.",
  "paramSet.dateTime.title.second": "S",
  "50500_0x7571-S-8": "Nel sistema parallelo, a causa di altri guasti dell'inverter.\n 1. Attendere minuti, quindi controllare tutti gli inverter in questo sistema parallelo;\n 2. Se l'invertitore non può tornare allo stato normale, registrare i codici di errore di tutti gli invertitori, quindi chiedere aiuto a noi.",
  "50500_0x7571-S-7": "1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3.Confirm that the device parameter settings are correct\n4.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7571-S-6": "1.Confirm that the wiring between each device is correct\n2.Confirm that the PV voltage is not too low\n3.Confirm that the load is appropriate\n4.Confirm that the device parameter settings are correct\n5.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7571-S-5": "1.Confirm if the battery specifications match our device\n2.Confirm that the wiring between each device is correct\n3.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7571-S-4": "DCLLC_Soft_Over_Cur\n1.Confirm that the wiring between each device is correct\n2.Confirm that the device parameter settings are correct\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x7571-S-2": "Nessuna utilità\n 1. Si prega di confermare che la griglia è persa o meno;\n 2. Controllare che la connessione alla rete sia buona o meno;\n 3. Controllare che l'interruttore tra inverter e rete sia acceso o meno;\n 4. Cercare aiuto da noi, se non può tornare allo stato normale.",
  "ywt.60419.groupStrCurrent23": "Corrente di stringa 23",
  "ywt.60419.groupStrCurrent22": "Corrente di stringa 22",
  "ywt.60419.groupStrCurrent21": "Corrente di stringa 21",
  "ywt.60419.groupStrCurrent20": "Corrente di stringa 20",
  "ywt.60419.pvInputCurrent9": "Corrente d'ingresso PV9",
  "ywt.60419.stGirdVol": "Tensione della linea di rete ST",
  "50500_0x7571-F-5": "Battery OV ",
  "50500_0x7571-F-6": "DCLLC _ Sopra _ Corrente",
  "50500_0x7571-F-4": "DCLLC _ Soft _ Over _ Cur",
  "ywt.60419.groupStrCurrent19": "Corrente di stringa 19",
  "ywt.60419.groupStrCurrent18": "Corrente di stringa 18",
  "50500_0x7571-F-2": "Nessuna griglia CA",
  "ywt.60419.groupStrCurrent17": "Corrente di stringa 17",
  "ywt.60419.groupStrCurrent16": "Corrente di stringa 16",
  "ywt.60419.groupStrCurrent15": "Corrente di stringa 15",
  "ywt.60419.groupStrCurrent14": "Corrente di stringa 14",
  "ywt.60419.groupStrCurrent13": "Corrente di stringa 13",
  "ywt.60419.groupStrCurrent12": "Corrente di stringa 12",
  "ywt.60419.groupStrCurrent11": "Corrente di stringa 11",
  "50500_0x7571-F-9": "Linea AC bassa tensione",
  "ywt.60419.groupStrCurrent10": "Corrente di stringa 10",
  "50500_0x7571-F-7": "Batt _ Sopra _ Corrente",
  "50500_0x7571-F-8": "Sistema _ parallelo _ Stop",
  "ywt.60419.pvInputCurrent7": "Corrente d'ingresso PV7",
  "ywt.60419.leakCurrent": "Corrente di dispersione",
  "ywt.60419.pvInputCurrent8": "Corrente d'ingresso PV8",
  "ywt.60419.pvInputCurrent5": "Corrente d'ingresso PV5",
  "ywt.60419.pvInputCurrent6": "Corrente d'ingresso PV6",
  "ywt.60419.pvInputCurrent3": "Corrente d'ingresso PV3",
  "ywt.60419.pvInputCurrent4": "Corrente d'ingresso PV4",
  "ywt.60419.pvInputCurrent1": "Corrente d'ingresso PV1",
  "ywt.60419.pvInputCurrent2": "Corrente d'ingresso PV2",
  "ywt.60419.scanPercentage": "Percentuale di scansione I/V",
  "ywt.60419.powerFactor": "Fattore di potenza ",
  "ywt.60419.onGridCountdown": "Conto alla rovescia per la connessione alla rete",
  "50500_0x7572-S-6": "PV Volt High Fault \n1. Check whether PV voltage is normal;\n2.Confirm that the wiring between each device is correct\n3. Seek help from us, if can not go back to normal state.",
  "50500_0x7572-S-5": "DC Volt Low Fault\n1.Check whether PV voltage is normal;\n2.Check whether battery voltage is normal;\n3.Confirm that the wiring between each device is correct\n4. Seek help from us, if can not go back to normal state.",
  "50500_0x7572-S-8": "Batt Over Load Fault\n1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7572-S-7": "Tensione della batteria bassa\n 1. Controllare se la tensione della batteria è troppo bassa;\n 2. Se la tensione della batteria è troppo bassa, utilizzando PV o griglia per caricare la batteria;\n 3. cercare aiuto da noi, se non può tornare allo stato normale.",
  "50500_0x7572-S-2": "GFCI Consistent Frault",
  "50500_0x7572-S-1": "Grid Volt Consistent Fault\n1. Check whether grid voltage is normal;\n2. Check whether AC cables are firmly and correctly connected;\n3. Seek help from us, if can not go back to normal state.",
  "50500_0x7572-S-3": "Inter Comm Fault\n1.Confirm that the wiring between each device is correct\n2. Seek help from us, if can not go back to normal state.",
  "50500_0x7572-S-9": "1.Confirm that the wiring between each device is correct\n2.Confirm that the device parameter settings are correct\n3. Seek help from us, if can’t go back to noarmal state",
  "ywt.60419.radiatorTemp": "Temperatura del radiatore(℃)",
  "50500_0x7572-C-7": "La tensione della sbarra collettrice CC è troppo bassa",
  "ywt.60419.rsGridFrequency": "Frequenza di rete RS",
  "50500_0x7572-S-0": "INV Volt Consistent Fauit\n1. Check whether grid voltage is normal;\n2. Check whether AC cables are firmly and correctly connected;\n3. Seek help from us, if can not go back to normal state.",
  "50500_0x7572-C-9": "Difetto di comunicazione BMBMS",
  "50500_0x756F-F-9": "AuxPowerBoard _ Guasto",
  "50500_0x756F-F-2": "GFCI Device Fault",
  "50500_0x7570-S-12": "Solo per inverter che lavorano in parallelo\n 1. Controllare l'impostazione parallela secondo le istruzioni;\n 2. Verificare la connessione del CANBus;\n 3. Cerca aiuto da noi",
  "50500_0x756F-F-4": "EEPROM Read Fault",
  "50500_0x7570-S-14": "Soft_Start_Failed\n1.Confirm that the wiring between each device is correct\n2.Confirm that the device parameter settings are correct\n3.Confirm that the battery level is not too low\n4. Seek help from us, if can’t go back to noarmal state",
  "50500_0x756F-F-6": "CC / CC _ Softsart _ Guasto",
  "50500_0x756F-F-5": "EEPROM Write Fault",
  "50500_0x7571-C-15": "AC frequenza inferiore",
  "ywt.60419.activePower": "Potenza attiva",
  "50500_0x7570-S-11": "Parallel Set Faut \n1.Confirm that the device parameter settings are correct\n2.Confirm that the wiring between each device is correct\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x7571-C-14": "AC su frequenza",
  "50500_0x7570-S-10": "Bus Volt unbanlence\n1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x756F-F-7": "INV Relay Fault",
  "50500_0x7571-C-13": "BCAKUP _ Batteria _ Guasto",
  "paramSet.dateTime.title.day": "J",
  "50500_0x7572-F-14": "Guasto ARC",
  "50500_0x7572-F-15": "Dissipatore di calore guasto ad alta temperatura",
  "50500_0x7572-F-7": "La tensione della sbarra collettrice CC è troppo bassa",
  "50500_0x7572-F-9": "Difetto di comunicazione BMBMS",
  "ywt.60419.meterPower": "Gesamtleistung des Stromzählers",
  "paramSet.input.dataError.tip": "Il valore non rientra in un intervallo ragionevole, per favore reimpostalo.",
  "ywt.60419.workStatus": "Stato di funzionamento dell'inverter",
  "ywt.60419.tGridVol": "Tensione di fase di rete T",
  "ywt.60419.sOnGridCurrent": "Corrente di rete di fase S",
  "ywt.60419.nbusVol": "Tensione NBUS",
  "ywt.60419.pvInputCurrent10": "Corrente d'ingresso PV10",
  "ywt.60419.pvInputCurrent11": "Corrente d'ingresso PV11",
  "ywt.60419.pvInputCurrent12": "Corrente d'ingresso PV12",
  "current.collector.upgrade.progress": "Il progresso dell'aggiornamento corrente del raccoltatore è",
  "CSP Plant": "Centrale termosolare a concentrazione",
  "platformType.android": "Android",
  "platformType.ios": "IOS",
  "NC2022": "New Caledonia_NC2022",
  "EN50549_IE": "EU_EN50549_IE",
  "PR_240VAC": "PR_240VAC",
  "VDE0126_GR": "France_VDE0126_GR",
  "PPDS": "Czechia_PPDS",
  "NCRFG": "Poland_NCRFG",
  "NF50549_1": "France_NF50549_1",
  "RESERVE_SFAY_E": "China_NBT32004",
  "50901.ctrl_ESS_Advanced_Config-System.grid_ct_reverse_enable": "Abilita inversione Grid CT",
  "50901.ctrl_ESS_Advanced_Config-System.pv_ct_reverse_enable": "Abilita inversione PV CT",
  "50901.ctrl_ESS_Advanced_Config-System.grid_meter_ratio": "Impostazione rapporto di trasformazione contatore Grid CT",
  "50901.ctrl_ESS_Advanced_Config-System.pv_meter_ratio": "Impostazione rapporto di trasformazione contatore PV CT",
  "50901.ctrl_Config-Grid Profile.country": "Paese / Paese standard di rete",
  "50901.ctrl_Device.meterConfiguration": "Configurazione contatore",
  "50901.ctrl_WorkMode.workMode": "Modalità di funzionamento EMS",
  "50901.ctrl_ESS_Advanced_Config-System": "Configurazione avanzata - Sistema",
  "50901.ctrl_Config-Grid Profile": "Configurazione - Parametri di rete",
  "50901.ctrl_Device": "Controllo_Dispositivo",
  "50901.ctrl_WorkMode": "Modalità Operativa",
  "connect.type.wifi": "Rete wireless",
  "connect.type.lan": "LAN",
  "50901.ctrl_WorkModeSetting": "Impostazione della modalità di lavoro",
  "50901.ctrl_WorkMode-Backup": "Modalità di funzionamento - Backup",
  "50901.ctrl_WorkMode-economic": "Modalità di funzionamento - Economico",
  "50901.ctrl_WorkMode-forceCharge": "Modalità di funzionamento - Carica forzata",
  "50901.ctrl_WorkMode-forceDischarge": "Modalità di funzionamento - Scarica forzata",
  "50901.ctrl_WorkMode-peakMeter": "Modalità di funzionamento - Contatore di picco ",
  "50901.ctrl_WorkMode-Selfuse": "Modalità di funzionamento - Auto-consumo ",
  "50901.ctrl_WorkMode-TOU": "Modalità di funzionamento - TOU",
  "50901.ctrl_WorkMode-TOU.touModeReserveSoc.desc": "Modalità TOU - SOC riservato",
  "50901.ctrl_Device.meterConfiguration.desc": "Descrizione della configurazione del contatore",
  "50901.ctrl_Config-Grid Profile.country.desc": "Descrizione del paese / paese standard di connessione alla rete",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timerModeBatterySocEnable.0": "Disattivare",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timerModeBatterySocEnable.1": "Attivare",
  "50901.ctrl_Dry_Contact_Generator.genPracticeModeWeek.0": "Disattivare",
  "50901.ctrl_Dry_Contact_Generator.genPracticeModeWeek.1": "Attivare",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange20.0": "Disattivare",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange20.1": "Attivare",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange21.0": "Disattivare",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange21.1": "Attivare",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange22.0": "Disattivare",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange22.1": "Attivare",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange23.0": "Disattivare",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange23.1": "Attivare",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange24.0": "Disattivare",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange24.1": "Attivare",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange26.1": "Attivare",
  "50901.ctrl_Device.meterConfiguration.0": "Nessun tipo di contatore",
  "50901.ctrl_Device.meterConfiguration.1": "Configurare il contatore lato rete",
  "50901.ctrl_Device.meterConfiguration.2": "Configurare il contatore PV",
  "50901.ctrl_Device.meterConfiguration.3": "Configurare il contatore lato rete + PV",
  "Do_not_connect": "Non connettere",
  "connect.type.Do.not.connect": "Non connettere",
  "platformType.web": "Web",
  "50901.Backup": "Riserva",
  "50901.Battery": "Batteria",
  "50901.ClockSetting": "Impostazione Orologio",
  "50901.Connection": "Connessione Comunicazione",
  "50901.ctrl_Config": "Controllo Connessione Comunicazione",
  "50901.ctrl_Config.Device.checkTime.desc": "Descrizione ora dispositivo",
  "50901.ctrl_Dry_Contact": "Impostazione Contatti Puliti",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.chargingPileRatedCurrent.desc": "Corrente nominale colonnina ricarica",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.homeInletBreakerRatedCurrent.desc": "Corrente nominale interruttore principale",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatterySocEnable.desc": "Abilita SOC batteria modalità programmata",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatteryStartSoc.desc": "SOC avvio batteria modalità programmata",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatteryStopSoc.desc": "SOC spegnimento batteria modalità programmata",
  "50901.ctrl_ESS_Advanced_Config": "Configurazione Avanzata",
  "50901.ctrl_Safety": "Norme Di Sicurezza",
  "50901.ctrl_WorkMode.TOU.touModeReserveSoc.desc": "SOC riservato modalità TOU",
  "50901.DCI": "Isolamento Cc",
  "50901.Device": "Dispositivo",
  "50901.economic": "Modalità Economica",
  "50901.EPS": "Alimentazione Di Emergenza",
  "50901.forceCharge": "Carica Forzata",
  "50901.forceDischarge": "Scarica Forzata",
  "50901.FRT": "Ride-Through Di Frequenza",
  "50901.FW": "Deriva Di Frequenza",
  "50901.Gateway": "Gateway",
  "50901.Generator": "Generatore",
  "50901.Grid Profile": "Parametri Di Rete",
  "50901.otaHttpUrl.otaHttpUrl.desc": "Descrizione comando aggiornamento",
  "50901.peakMeter": "Misurazione Picchi",
  "50901.PV": "Chint Monofase",
  "50901.RCD": "Protezione Dispersione",
  "50901.real_time.copy_dspVersionMainUVersion.desc": "Descrizione Versione Dsp (Versione U Principale)",
  "50901.real_time.dTSReset.desc": "Descrizione reset data stick",
  "50901.real_time.数据分析_AC光伏功率.tag": "Potenza Fv Ca",
  "50901.real_time.数据分析_AC光伏无功功率.tag": "Potenza Reattiva Fv Ca",
  "50901.real_time.数据分析_AC光伏有功功率.tag": "Potenza Attiva Fv Ca",
  "50901.real_time.数据分析_AC光伏电压.tag": "Tensione Fv Ca",
  "50901.real_time.数据分析_AC光伏电流.tag": "Corrente Fv Ca",
  "50901.real_time.数据分析_EPS功率.tag": "Potenza Eps",
  "50901.real_time.数据分析_EPS电压.tag": "Tensione Eps",
  "50901.real_time.数据分析_EPS电流.tag": "Corrente Eps",
  "50901.real_time.数据分析_单体SOC.tag": "SOC cella",
  "50901.real_time.数据分析_发电机功率.tag": "Potenza generatore",
  "50901.real_time.数据分析_发电机电压.tag": "Tensione Generatore",
  "50901.real_time.数据分析_发电机电流.tag": "Corrente Generatore",
  "50901.real_time.数据分析_混逆光伏功率.tag": "Potenza Fv Inverter Ibrido",
  "50901.real_time.数据分析_混逆光伏电压.tag": "Tensione Fv Inverter Ibrido",
  "50901.real_time.数据分析_混逆光伏电流.tag": "Corrente Fv Inverter Ibrido",
  "50901.real_time.数据分析_电池包.tag": "Batteria (pacco)",
  "50901.real_time.数据分析_电网功率.tag": "Potenza rete",
  "50901.real_time.数据分析_电网电压.tag": "Tensione rete",
  "50901.real_time.数据分析_电网电流.tag": "Corrente rete",
  "50901.RPC": "No",
  "50901.RR": "Velocità Di Variazione",
  "50901.RT": "Significato Del Valore Di Enumerazione 0",
  "50901.Settings": "Modalità Operativa",
  "50901.Settings-Load_Control": "Controllo Carico",
  "50901.Settings-Manual_Control": "Significato Del Valore Di Enumerazione 0",
  "50901.Switch": "Commutazione Modalità",
  "50901.System": "Significato Del Valore Di Enumerazione 0",
  "50901.VRT": "Significato Del Valore Di Enumerazione 0",
  "50901.VW": "Deriva Di Tensione",
  "50901.ctrl_Config.Device.networkingType.desc": "Descrizione tipo connessione",
  "50901.fault.arcFault.desc": "Descrizione guasto arco elettrico",
  "50901.fault.arcSelfTestFault.desc": "Descrizione errore autotest arco",
  "50901.fault.armCommunicationFault.desc": "Descrizione guasto comunicazione ARM",
  "50901.fault.auxiliaryPowerAbnormality.desc": "Descrizione anomalia alimentazione ausiliaria",
  "50901.Fault.batteryCapacityAbnormality.desc": "Descrizione anomalia capacità batteria",
  "50901.Fault.batteryFault.desc": "Descrizione guasto batteria",
  "50901.Fault.batteryForceChargeRequest.desc": "Descrizione richiesta carica forzata batteria",
  "50901.Fault.bmsCanCommunicationAbnormality.desc": "Descrizione anomalia comunicazione CAN BMS",
  "50901.fault.busbarAbnormality.desc": "Descrizione anomalia bus CC",
  "50901.fault.cmpssBiasCalculationError.desc": "Descrizione errore calcolo offset CMPSS",
  "50901.fault.comparatorFault.desc": "Descrizione guasto comparatore",
  "50901.fault.driveAbnormality.desc": "Descrizione anomalia pilotaggio",
  "50901.Fault.dspPwrCommunicationAbnormality.desc": "Descrizione anomalia comunicazione alimentazione DSP",
  "50901.Fault.dspSafCommunicationAbnormality.desc": "Descrizione anomalia comunicazione sicura DSP",
  "50901.Fault.dtsCommunicationAbnormality.desc": "Descrizione anomalia comunicazione DTS",
  "50901.Fault.dtu1Rs485CommunicationAbnormality.desc": "Descrizione anomalia comunicazione DTU1 RS485",
  "50901.Fault.dtu2Rs485CommunicationAbnormality.desc": "Descrizione anomalia comunicazione DTU2 RS485",
  "50901.Fault.dtu3Rs485CommunicationAbnormality.desc": "Descrizione anomalia comunicazione DTU3 RS485",
  "50901.Fault.dtu4Rs485CommunicationAbnormality.desc": "Descrizione anomalia comunicazione DTU4 RS485",
  "50901.Fault.dtu5Rs485CommunicationAbnormality.desc": "Descrizione anomalia comunicazione DTU5 RS485",
  "50901.fault.e2rpomFault.desc": "Descrizione guasto EEPROM",
  "50901.fault.emergencyStopSwitchStatus.desc": "Descrizione arresto di emergenza",
  "50901.fault.epsOverload.desc": "Descrizione sovraccarico EPS",
  "50901.fault.epsRelayProtection.desc": "Descrizione protezione relè EPS",
  "50901.fault.epsVoltageAbnormality.desc": "Descrizione anomalia tensione EPS",
  "50901.Fault.evCharger1CommunicationAbnormality.desc": "Descrizione anomalia comunicazione colonnina ricarica EV 1",
  "50901.Fault.evCharger1Fault.desc": "Descrizione guasto colonnina ricarica 1",
  "50901.Fault.evCharger2CommunicationAbnormality.desc": "Descrizione anomalia comunicazione colonnina ricarica EV 2",
  "50901.Fault.evCharger2Fault.desc": "Descrizione guasto colonnina ricarica 2",
  "50901.fault.fanFault.desc": "Descrizione guasto ventola",
  "50901.Fault.fanSpeedAbnormality.desc": "Descrizione anomalia velocità ventola",
  "50901.fault.fiveVoltPowerSupplyFault.desc": "Descrizione guasto alimentazione 5V",
  "50901.fault.flashCommunicationFault.desc": "Descrizione guasto comunicazione memoria flash",
  "50901.fault.frequencyVariationRateOutOfRange.desc": "Descrizione superamento limite velocità variazione frequenza",
  "50901.fault.genAbnormality.desc": "Descrizione anomalia generatore",
  "50901.fault.genOverload.desc": "Descrizione sovraccarico generatore",
  "50901.fault.genPortOvercurrent.desc": "Descrizione sovracorrente porta generatore",
  "50901.fault.genRelayAFault.desc": "Descrizione guasto relè A generatore",
  "50901.fault.genRelayBFault.desc": "Descrizione guasto relè B generatore",
  "50901.fault.gridCurrentDcOffsetOutOfRange.desc": "Descrizione superamento limite offset CC corrente rete",
  "50901.fault.gridMeter.desc": "Descrizione errore comunicazione contatore di rete",
  "50901.Fault.gridMeterCommunicationAbnormality.desc": "Descrizione anomalia comunicazione contatore di rete",
  "50901.Fault.gridMeterTypeError.desc": "Descrizione errore tipo contatore di rete",
  "50901.fault.gridOffVoltageDcOffsetOutOfRange.desc": "Descrizione superamento limite offset CC tensione off-grid",
  "50901.fault.gridOverfrequency.desc": "Descrizione sovrafrequenza rete",
  "50901.fault.gridOvervoltage.desc": "Descrizione sovratensione rete",
  "50901.fault.gridPortOvercurrent.desc": "Descrizione sovracorrente porta rete",
  "50901.fault.gridPowerOutage.desc": "Descrizione mancanza rete",
  "50901.fault.gridRelayProtection.desc": "Descrizione protezione relè rete",
  "50901.fault.gridUnderfrequency.desc": "Descrizione sottofrequenza rete",
  "50901.fault.gridUndervoltage.desc": "Descrizione sottotensione rete",
  "50901.fault.gridVoltageAbnormality.desc": "Descrizione anomalia tensione rete",
  "50901.Fault.hmidCommunicationAbnormality.desc": "Descrizione anomalia comunicazione interfaccia utente",
  "50901.Fault.hmidMachineFault.desc": "Descrizione guasto dispositivo interfaccia utente",
  "50901.fault.insulationFault.desc": "Descrizione guasto isolamento",
  "50901.fault.interruptOverflow.desc": "Descrizione overflow interrupt",
  "50901.fault.inverterCanCommunicationFailed.desc": "Descrizione errore comunicazione CAN inverter",
  "50901.fault.inverterCommunicationFailed.desc": "Descrizione errore comunicazione inverter",
  "50901.fault.kmRelayFault.desc": "Descrizione guasto relè KM",
  "50901.fault.lineToEarthFault.desc": "Descrizione guasto verso terra (fase-terra)",
  "50901.fault.loadRelayAFault.desc": "Descrizione guasto relè carico A",
  "50901.fault.loadRelayBFault.desc": "Descrizione guasto relè carico B",
  "50901.fault.lowAmbientTemperature.desc": "Descrizione temperatura ambiente troppo bassa",
  "50901.Fault.lowDtuVersion.desc": "Descrizione versione DTU troppo bassa",
  "50901.fault.machineTypeMismatch.desc": "Descrizione modello non corrispondente",
  "50901.Fault.masterSlaveCommunicationAbnormality.desc": "Descrizione anomalia comunicazione master-slave",
  "50901.fault.meterWiringAbnormality.desc": "Descrizione anomalia cablaggio contatore",
  "50901.fault.microelectronicFault.desc": "Descrizione guasto microelettronico",
  "50901.fault.neutralWireNotConnected.desc": "Descrizione neutro non collegato",
  "50901.fault.neutralWireToEarthFault.desc": "Descrizione guasto neutro-terra",
  "50901.fault.overTemperature.desc": "Descrizione sovratemperatura",
  "50901.fault.overtemperatureAlarm.desc": "Descrizione allarme surriscaldamento",
  "50901.fault.pllLockFailed.desc": "Descrizione errore aggancio PLL",
  "50901.fault.preSynchronizationFailed.desc": "Descrizione errore presincronizzazione",
  "50901.fault.pvFault.desc": "Descrizione guasto FV",
  "50901.Fault.pvMeterCommunicationAbnormality.desc": "Descrizione anomalia comunicazione contatore FV",
  "50901.Fault.pvMeterTypeError.desc": "Descrizione errore tipo contatore FV",
  "50901.fault.pvPortOvercurrent.desc": "Descrizione sovracorrente porta FV",
  "50901.fault.pvRelayAbFault.desc": "Descrizione guasto relè AB FV",
  "50901.fault.pvVoltageExceedingBusVoltage.desc": "Descrizione tensione FV supera tensione bus",
  "50901.fault.rcdFault.desc": "Descrizione guasto interruttore differenziale",
  "50901.fault.rcdSelfTestFault.desc": "Descrizione errore autotest interruttore differenziale",
  "50901.fault.reconnectionFailed.desc": "Descrizione errore riconnessione",
  "50901.fault.samplingBiasAbnormality.desc": "Descrizione anomalia offset campionamento",
  "50901.fault.shutDown.desc": "Descrizione spegnimento sistema",
  "50901.Fault.slaveWrongBatteryConnection.desc": "Descrizione errore connessione batteria slave",
  "50901.fault.smartloadPortOvercurrent.desc": "Descrizione sovracorrente porta carico intelligente",
  "50901.fault.spiCommunicationFault.desc": "Descrizione guasto comunicazione SPI",
  "50901.Fault.sustainedNegativeLoad.desc": "Descrizione carico negativo persistente",
  "50901.fault.temperatureAbnormality.desc": "Descrizione anomalia temperatura",
  "50901.fault.tenMinuteOvervoltage.desc": "Descrizione sovratensione 10 minuti",
  "50901.fault.threePointThreeVoltPowerSupplyFault.desc": "Descrizione guasto alimentazione 3.3V",
  "50901.fault.twelveVoltPowerSupplyFault.desc": "Descrizione guasto alimentazione 12V",
  "50901.fault.versionMismatch.desc": "Descrizione mancata corrispondenza versione",
  "50901.fault.wiringAbnormality.desc": "Descrizione anomalia cablaggio",
  "50901.real_time.12vAuxiliaryVoltageSampling.desc": "Descrizione campionamento tensione ausiliaria 12V",
  "50901.real_time.12vOutputVoltageSampling.desc": "Descrizione campionamento tensione uscita 12V",
  "50901.real_time.3_3vAuxiliaryVoltageSampling.desc": "Descrizione campionamento tensione ausiliaria 3.3V",
  "50901.real_time.5vAuxiliaryVoltageSampling.desc": "Descrizione campionamento tensione ausiliaria 5V",
  "50901.real_time.afciVersion.desc": "Descrizione versione AFCI",
  "50901.real_time.ambientTemperatureSampling.desc": "Descrizione campionamento temperatura ambiente",
  "50901.real_time.appSoftwareVersion.desc": "Descrizione versione software APP",
  "50901.real_time.batteryChargePower.desc": "Descrizione capacità di carica cumulativa batteria",
  "50901.real_time.batteryConnectionStatus.desc": "Descrizione stato connessione batteria",
  "50901.real_time.batteryCurrent.desc": "Descrizione corrente batteria",
  "50901.real_time.batteryDailyChargeEnergy.desc": "Descrizione capacità di carica giornaliera batteria",
  "50901.real_time.batteryDailyDischargeEnergy.desc": "Descrizione capacità di scarica giornaliera batteria",
  "50901.real_time.batteryDischargePower.desc": "Descrizione capacità di scarica cumulativa batteria",
  "50901.real_time.batteryModuleNum.desc": "Descrizione numero celle in serie (per modulo)",
  "50901.real_time.batteryPower.desc": "Descrizione potenza batteria (carica/scarica)",
  "50901.real_time.batteryPowerWholeSystem.desc": "Descrizione potenza totale batteria (intero sistema)",
  "50901.real_time.batterySoc.desc": "Descrizione SOC batteria",
  "50901.real_time.batteryToLoadPower.desc": "Descrizione potenza batteria verso carico",
  "50901.real_time.batterytotCap.desc": "Descrizione capacità totale installata batteria",
  "50901.real_time.batteryType_04.desc": "Descrizione tipo batteria",
  "50901.real_time.batteryVoltage.desc": "Descrizione tensione batteria",
  "50901.real_time.batteryWorkingStatus.desc": "Descrizione Stato Batteria",
  "50901.real_time.bootSoftwareVersion.desc": "Descrizione versione software bootloader",
  "50901.real_time.communicationStickHardwareVersion.desc": "Descrizione versione hardware chiavetta comunicazione",
  "50901.real_time.communicationStickSn.desc": "Descrizione SN chiavetta comunicazione",
  "50901.real_time.communicationStickSoftwareVersion.desc": "Descrizione versione software chiavetta comunicazione",
  "50901.real_time.dailyBatteryToLoadEnergy.desc": "Descrizione energia oggi batteria verso carico",
  "50901.real_time.dailyExportEnergyToGrid.desc": "Descrizione energia venduta oggi",
  "50901.real_time.dailyGridToLoadEnergy.desc": "Descrizione energia oggi rete verso carico",
  "50901.real_time.dailyImportEnergyFromGrid.desc": "Descrizione energia acquistata oggi",
  "50901.real_time.dailyPvToBatteryEnegry.desc": "Descrizione energia oggi FV verso batteria",
  "50901.real_time.dailyPvToGridEnegry.desc": "Descrizione energia oggi FV verso rete",
  "50901.real_time.dailyPvToLoadEnegry.desc": "Descrizione energia oggi FV verso carico",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.desc": "Descrizione stato DRM (per Australia/Germania/Austria)",
  "50901.real_time.dspVersionAuxiliaryUVersion.desc": "Descrizione versione DSP (versione U ausiliaria)",
  "50901.real_time.externalFanSpeed1.desc": "Descrizione velocità ventola esterna 1",
  "50901.real_time.externalFanSpeed2.desc": "Descrizione velocità ventola esterna 2",
  "50901.real_time.externalFanSpeed3.desc": "Descrizione velocità ventola esterna 3",
  "50901.real_time.externalFanSpeed4.desc": "Descrizione velocità ventola esterna 4",
  "50901.real_time.firmwareBuildTimeDateHour.desc": "Descrizione data/ora costruzione firmware",
  "50901.real_time.firmwareBuildTimeYearMonth.desc": "Descrizione mese/anno costruzione firmware",
  "50901.real_time.firmwareCrc.desc": "Descrizione CRC firmware",
  "50901.real_time.firmwareEndAddressHigh.desc": "Descrizione indirizzo fine firmware (alto)",
  "50901.real_time.firmwareEndAddressLow.desc": "Descrizione indirizzo fine firmware (basso)",
  "50901.real_time.firmwareInformationCrc.desc": "Descrizione CRC informazioni firmware",
  "50901.real_time.firmwareStartAddressHigh.desc": "Descrizione indirizzo inizio firmware (alto)",
  "50901.real_time.firmwareStartAddressLow.desc": "Descrizione indirizzo inizio firmware (basso)",
  "50901.real_time.generatorCurrentA.desc": "Descrizione corrente fase A generatore",
  "50901.real_time.generatorCurrentB.desc": "Descrizione corrente fase B generatore",
  "50901.real_time.generatorCurrentC.desc": "Descrizione corrente fase C generatore",
  "50901.real_time.generatorDailyYield.desc": "Descrizione produzione giornaliera generatore",
  "50901.real_time.generatorPower.desc": "Descrizione potenza generatore",
  "50901.real_time.generatorPowerA.desc": "Descrizione potenza fase A generatore",
  "50901.real_time.generatorPowerB.desc": "Descrizione potenza fase B generatore",
  "50901.real_time.generatorPowerC.desc": "Descrizione potenza fase C generatore",
  "50901.real_time.generatorTotalYield.desc": "Descrizione produzione cumulativa generatore",
  "50901.real_time.gridBuyPower.desc": "Descrizione energia acquistata cumulativa",
  "50901.real_time.gridCurrentA.desc": "Descrizione corrente fase A lato rete",
  "50901.real_time.gridCurrentB.desc": "Descrizione corrente fase B lato rete",
  "50901.real_time.gridCurrentC.desc": "Descrizione corrente fase C lato rete",
  "50901.real_time.gridMeasurementOfRadiatorTemperature.desc": "Descrizione temperatura dissipatore lato rete",
  "50901.real_time.gridMeterSerialNumber.desc": "Descrizione numero seriale contatore lato rete",
  "50901.real_time.gridPower.desc": "Descrizione potenza lato rete",
  "50901.real_time.gridPowerA.desc": "Descrizione potenza fase A lato rete",
  "50901.real_time.gridPowerB.desc": "Descrizione potenza fase B lato rete",
  "50901.real_time.gridPowerC.desc": "Descrizione potenza fase C lato rete",
  "50901.real_time.gridPowerFactor.desc": "Descrizione fattore di potenza lato rete",
  "50901.real_time.gridPowerFactorA.desc": "Descrizione fattore di potenza fase A lato rete",
  "50901.real_time.gridPowerFactorB.desc": "Descrizione fattore di potenza fase B lato rete",
  "50901.real_time.gridPowerFactorC.desc": "Descrizione fattore di potenza fase C lato rete",
  "50901.real_time.gridPowerWholeSystem.desc": "Descrizione potenza totale rete (intero sistema)",
  "50901.real_time.gridReactivePower.desc": "Descrizione potenza reattiva lato rete",
  "50901.real_time.gridReactivePowerA.desc": "Descrizione potenza reattiva fase A lato rete",
  "50901.real_time.gridReactivePowerB.desc": "Descrizione potenza reattiva fase B lato rete",
  "50901.real_time.gridReactivePowerC.desc": "Descrizione potenza reattiva fase C lato rete",
  "50901.real_time.gridSellPower.desc": "Descrizione energia venduta cumulativa",
  "50901.real_time.gridTotalFrequency.desc": "Descrizione frequenza lato rete",
  "50901.real_time.gridVoltageA.desc": "Descrizione tensione fase A lato rete",
  "50901.real_time.gridVoltageB.desc": "Descrizione tensione fase B lato rete",
  "50901.real_time.gridVoltageC.desc": "Descrizione tensione fase C lato rete",
  "50901.real_time.hoymilesSerialNumber.desc": "Descrizione numero seriale Hoymiles",
  "50901.real_time.internalFanSpeed1.desc": "Descrizione velocità ventola interna 1",
  "50901.real_time.internalFanSpeed2.desc": "Descrizione velocità ventola interna 2",
  "50901.real_time.internalFanSpeed3.desc": "Descrizione velocità ventola interna 3",
  "50901.real_time.inverterHardwareVersion.desc": "Descrizione versione hardware inverter",
  "50901.real_time.inverterModelNumber.desc": "Descrizione codice modello inverter",
  "50901.real_time.inverterSideRadiatorTemperature.desc": "Descrizione temperatura dissipatore lato inverter",
  "50901.real_time.inverterTemp.desc": "Descrizione temperatura interna funzionamento inverter",
  "50901.real_time.loadEnergy.desc": "Descrizione consumo energetico giornaliero carico",
  "50901.real_time.loadPowerWholeSystem.desc": "Descrizione potenza totale carico (intero sistema)",
  "50901.real_time.macAddr.desc": "Descrizione indirizzo MAC",
  "50901.real_time.materType.desc": "Descrizione tipo contatore",
  "50901.real_time.maxCellSoc.desc": "Descrizione SOC cella massima",
  "50901.real_time.maxCellSocCellId.desc": "Descrizione indice corrispondente SOC cella massima",
  "50901.real_time.maxCellTemperature.desc": "Descrizione temperatura cella massima",
  "50901.real_time.maxCellTemperatureCellId.desc": "Descrizione indice corrispondente temperatura cella massima",
  "50901.real_time.maxCellVoltage.desc": "Descrizione tensione cella massima",
  "50901.real_time.maxCellVoltageCellId.desc": "Descrizione indice corrispondente tensione cella massima",
  "50901.real_time.MaxChargeCurrent.desc": "Descrizione corrente massima di carica",
  "50901.real_time.MaxDisChargeCurrent.desc": "Descrizione corrente massima di scarica",
  "50901.real_time.meterFlag.desc": "Descrizione flag contatore",
  "50901.real_time.minCellSoc.desc": "Descrizione SOC cella minima",
  "50901.real_time.minCellSocCellId.desc": "Descrizione indice corrispondente SOC cella minima",
  "50901.real_time.minCellTemperature.desc": "Descrizione temperatura cella minima",
  "50901.real_time.minCellTemperatureCellId.desc": "Descrizione indice corrispondente temperatura cella minima",
  "50901.real_time.minCellVoltage.desc": "Descrizione tensione cella minima",
  "50901.real_time.minCellVoltageCellId.desc": "Descrizione indice corrispondente tensione cella minima",
  "50901.real_time.mpptTemp.desc": "Descrizione temperatura dissipatore lato FV",
  "50901.real_time.numberOfChargingAndDischargingCyclesOfBatteryPack.desc": "Descrizione numero cicli carica/scarica pacco batteria",
  "50901.real_time.oemModelName.desc": "Descrizione nome modello OEM",
  "50901.real_time.oemSerialNumber.desc": "Descrizione numero seriale OEM",
  "50901.real_time.packCurrent.desc": "Descrizione corrente pacco batteria",
  "50901.real_time.packNum.desc": "Descrizione quantità in parallelo (numero pacchi batteria)",
  "50901.real_time.packPower.desc": "Descrizione potenza pacco batteria",
  "50901.real_time.packSoc.desc": "Descrizione SOC pacco batteria",
  "50901.real_time.packSoh.desc": "Descrizione SOH pacco batteria",
  "50901.real_time.packVoltage.desc": "Descrizione tensione pacco batteria",
  "50901.real_time.powerGeneration.desc": "Descrizione produzione cumulativa FV",
  "50901.real_time.pv1RealTimePower.desc": "Descrizione potenza istantanea FV1",
  "50901.real_time.pv2RealTimePower.desc": "Descrizione potenza istantanea FV2",
  "50901.real_time.pv3RealTimePower.desc": "Descrizione potenza istantanea FV3",
  "50901.real_time.pv4RealTimePower.desc": "Descrizione potenza istantanea FV4",
  "50901.real_time.pvDailyYield.desc": "Descrizione produzione giornaliera FV",
  "50901.real_time.pvMeterConnectionStatus.desc": "Descrizione stato connessione contatore FV",
  "50901.real_time.pvMeterCurrentA.desc": "Descrizione corrente fase A contatore FV",
  "50901.real_time.pvMeterCurrentB.desc": "Descrizione corrente fase B contatore FV",
  "50901.real_time.pvMeterCurrentC.desc": "Descrizione corrente fase C contatore FV",
  "50901.real_time.pvMeterDailyYield.desc": "Descrizione produzione giornaliera inverter esterno",
  "50901.real_time.pvMeterFrequency.desc": "Descrizione frequenza contatore FV",
  "50901.real_time.pvMeterPhaseAActivePower.desc": "Descrizione potenza attiva fase A contatore FV",
  "50901.real_time.pvMeterPhaseAPowerFactor.desc": "Descrizione fattore di potenza fase A contatore FV",
  "50901.real_time.pvMeterPhaseAReactivePower.desc": "Descrizione potenza reattiva fase A contatore FV",
  "50901.real_time.pvMeterPhaseBActivePower.desc": "Descrizione potenza attiva fase B contatore FV",
  "50901.real_time.pvMeterPhaseBPowerFactor.desc": "Descrizione fattore di potenza fase B contatore FV",
  "50901.real_time.pvMeterPhaseBReactivePower.desc": "Descrizione potenza reattiva fase B contatore FV",
  "50901.real_time.pvMeterPhaseCActivePower.desc": "Descrizione potenza attiva fase C contatore FV",
  "50901.real_time.pvMeterPhaseCPowerFactor.desc": "Descrizione fattore di potenza fase C contatore FV",
  "50901.real_time.pvMeterPhaseCReactivePower.desc": "Descrizione potenza reattiva fase C contatore FV",
  "50901.real_time.pvMeterPower.desc": "Descrizione potenza contatore FV",
  "50901.real_time.pvMeterPowerA.desc": "Descrizione potenza fase A contatore FV",
  "50901.real_time.pvMeterPowerB.desc": "Descrizione potenza fase B contatore FV",
  "50901.real_time.pvMeterPowerC.desc": "Descrizione potenza fase C contatore FV",
  "50901.real_time.pvMeterSerialNumber.desc": "Descrizione numero seriale contatore FV",
  "50901.real_time.pvMeterTotalYield.desc": "Descrizione produzione cumulativa inverter esterno",
  "50901.real_time.pvMeterVoltageA.desc": "Descrizione tensione fase A contatore FV",
  "50901.real_time.pvMeterVoltageB.desc": "Descrizione tensione fase B contatore FV",
  "50901.real_time.pvMeterVoltageC.desc": "Descrizione tensione fase C contatore FV",
  "50901.real_time.pvPower.desc": "Descrizione potenza FV",
  "50901.real_time.pvPowerWholeSystem.desc": "Descrizione potenza totale FV (intero sistema)",
  "50901.real_time.pvToBatteryPower.desc": "Descrizione potenza FV verso batteria",
  "50901.real_time.pvToGridPower.desc": "Descrizione potenza FV verso rete",
  "50901.real_time.pvToLoadPower.desc": "Descrizione potenza FV verso carico",
  "50901.real_time.relayStatus.desc": "Descrizione stato relè",
  "50901.real_time.relaySupplyVoltageSampling.desc": "Descrizione campionamento tensione alimentazione relè",
  "50901.real_time.rssi.desc": "Descrizione intensità segnale",
  "50901.real_time.soh.desc": "Descrizione SOH",
  "50901.real_time.ssid.desc": "Descrizione SSID",
  "50901.real_time.totalBatteryToLoadEnergy.desc": "Descrizione energia cumulativa batteria verso carico",
  "50901.real_time.totalGridToLoadEnergy.desc": "Descrizione energia cumulativa rete verso carico",
  "50901.real_time.totalLoadEnergy.desc": "Descrizione consumo energetico cumulativo carico",
  "50901.real_time.totalPvToBatteryEnegry.desc": "Descrizione energia cumulativa FV verso batteria",
  "50901.real_time.totalPvToGridEnegry.desc": "Descrizione energia cumulativa FV verso rete",
  "50901.real_time.totalPvToLoadEnegry.desc": "Descrizione energia cumulativa FV verso carico",
  "50901.warning.batteryHighVoltageAlarm.desc": "Descrizione allarme sovratensione batteria",
  "50901.warning.batteryLowVoltageAlarm.desc": "Descrizione sottotensione batteria",
  "50901.warning.batteryPackChargeHighVoltageAlarm.desc": "Descrizione allarme sovratensione carica pacco batteria",
  "50901.warning.batteryPackDischargeLowVoltageAlarm.desc": "Descrizione allarme sottotensione scarica pacco batteria",
  "50901.warning.canCommunicationTimeout.desc": "Descrizione timeout comunicazione CAN",
  "50901.warning.chargeHighTemperatureAlarm.desc": "Descrizione allarme alta temperatura carica",
  "50901.warning.chargeLowTemperatureAlarm.desc": "Descrizione allarme bassa temperatura carica",
  "50901.warning.dischargeHighTemperatureAlarm.desc": "Descrizione allarme alta temperatura scarica",
  "50901.warning.dischargeLowTemperatureAlarm.desc": "Descrizione allarme bassa temperatura scarica",
  "50901.warning.hardwareProtection.desc": "Descrizione protezione hardware",
  "50901.warning.inputOvervoltageAlarm.desc": "Descrizione allarme sovratensione ingresso",
  "50901.warning.lowBatteryEnergy.desc": "Descrizione batteria scarica",
  "50901..absoluteTime.desc": "Descrizione tempo assoluto",
  "50901..batteryHealing.desc": "Descrizione recupero batteria",
  "50901..connectionRouterStatus.desc": "Descrizione stato connessione router",
  "50901..connectionServerStatus.desc": "Descrizione stato connessione servizio cloud",
  "50901..dfs.desc": "Descrizione insieme capacità",
  "50901..dspVersionMainUVersion.desc": "Descrizione versione DSP (versione U principale)",
  "50901..timeZone.desc": "Descrizione fuso orario",
  "50901.ctrl_Config.ClockSetting.ClockSetting.desc": "Descrizione impostazione orologio",
  "50901.ctrl_Config.ClockSetting.clockSetting_day.desc": "Descrizione impostazione orologio - giorno",
  "50901.ctrl_Config.ClockSetting.clockSetting_hour.desc": "Descrizione impostazione orologio - ora",
  "50901.ctrl_Config.ClockSetting.clockSetting_minute.desc": "Descrizione impostazione orologio - minuto",
  "50901.ctrl_Config.ClockSetting.clockSetting_month.desc": "Descrizione impostazione orologio - mese",
  "50901.ctrl_Config.ClockSetting.clockSetting_second.desc": "Descrizione impostazione orologio - secondo",
  "50901.ctrl_Config.ClockSetting.clockSetting_weekday.desc": "Descrizione impostazione orologio - giorno settimana",
  "50901.ctrl_Config.ClockSetting.clockSetting_year.desc": "Descrizione impostazione orologio - anno",
  "50901.ctrl_Config.Device.masterSlave.desc": "Descrizione master/slave",
  "50901.ctrl_Config.Gateway.ambientTemperatureThreshold.desc": "Descrizione soglia temperatura ambiente",
  "50901.ctrl_Config.Gateway.boardAmbientTemperatureThreshold.desc": "Descrizione soglia temperatura ambiente scheda circuito",
  "50901.ctrl_Config.Gateway.gatewayCommunicationAddress.desc": "Descrizione indirizzo comunicazione gateway",
  "50901.ctrl_WorkMode.Backup.backupSoc.desc": "Descrizione SOC riserva",
  "50901.ctrl_WorkMode.economic.economicModeSoc.desc": "Descrizione SOC modalità economica",
  "50901.ctrl_WorkMode.economic.economyModeDateNumber.desc": "Descrizione indice data modalità economica",
  "50901.ctrl_WorkMode.economic.section1PeakStartHour1.desc": "Descrizione ora 1 inizio picco sezione 1",
  "50901.ctrl_WorkMode.economic.section1PeakStartHour2.desc": "Descrizione ora 2 inizio picco sezione 1",
  "50901.ctrl_WorkMode.economic.section1PeakStartMinute1.desc": "Descrizione minuto 1 inizio picco sezione 1",
  "50901.ctrl_WorkMode.economic.section1PeakStartMinute2.desc": "Descrizione minuto 2 inizio picco sezione 1",
  "50901.ctrl_WorkMode.economic.section1PeakStopHour1.desc": "Descrizione ora 1 fine picco sezione 1",
  "50901.ctrl_WorkMode.economic.section1PeakStopHour2.desc": "Descrizione ora 2 fine picco sezione 1",
  "50901.ctrl_WorkMode.economic.section1PeakStopMinute1.desc": "Descrizione minuto 1 fine picco sezione 1",
  "50901.ctrl_WorkMode.economic.section1PeakStopMinute2.desc": "Descrizione minuto 2 fine picco sezione 1",
  "50901.ctrl_WorkMode.economic.section1StartDay.desc": "Descrizione giorno inizio sezione 1",
  "50901.ctrl_WorkMode.economic.section1StartMonth.desc": "Descrizione mese inizio sezione 1",
  "50901.ctrl_WorkMode.economic.section1StopDay.desc": "Descrizione giorno fine sezione 1",
  "50901.ctrl_WorkMode.economic.section1StopMonth.desc": "Descrizione mese fine sezione 1",
  "50901.ctrl_WorkMode.economic.section1ValleyStartHour1.desc": "Descrizione ora 1 inizio bassa valle sezione 1",
  "50901.ctrl_WorkMode.economic.section1ValleyStartHour2.desc": "Descrizione ora 2 inizio bassa valle sezione 1",
  "50901.ctrl_WorkMode.economic.section1ValleyStartMinute1.desc": "Descrizione minuto 1 inizio bassa valle sezione 1",
  "50901.ctrl_WorkMode.economic.section1ValleyStartMinute2.desc": "Descrizione minuto 2 inizio bassa valle sezione 1",
  "50901.ctrl_WorkMode.economic.section1ValleyStopHour1.desc": "Descrizione ora 1 fine bassa valle sezione 1",
  "50901.ctrl_WorkMode.economic.section1ValleyStopHour2.desc": "Descrizione ora 2 fine bassa valle sezione 1",
  "50901.ctrl_WorkMode.economic.section1ValleyStopMinute1.desc": "Descrizione minuto 1 fine bassa valle sezione 1",
  "50901.ctrl_WorkMode.economic.section1ValleyStopMinute2.desc": "Descrizione minuto 2 fine bassa valle sezione 1",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.desc": "Descrizione intervallo settimana 1 sezione 1",
  "50901.ctrl_WorkMode.economic.section1WeekRange2.desc": "Descrizione intervallo settimana 2 sezione 1",
  "50901.ctrl_WorkMode.economic.section2PeakStartHour1.desc": "Descrizione ora 1 inizio picco sezione 2",
  "50901.ctrl_WorkMode.economic.section2PeakStartHour2.desc": "Descrizione ora 2 inizio picco sezione 2",
  "50901.ctrl_WorkMode.economic.section2PeakStartMinute1.desc": "Descrizione minuto 1 inizio picco sezione 2",
  "50901.ctrl_WorkMode.economic.section2PeakStartMinute2.desc": "Descrizione minuto 1 inizio picco sezione 2",
  "50901.ctrl_WorkMode.economic.section2PeakStopHour1.desc": "Descrizione ora 1 fine picco sezione 2",
  "50901.ctrl_WorkMode.economic.section2PeakStopHour2.desc": "Descrizione ora 2 fine picco sezione 2",
  "50901.ctrl_WorkMode.economic.section2PeakStopMinute1.desc": "Descrizione minuto 1 fine picco sezione 2",
  "50901.ctrl_WorkMode.economic.section2PeakStopMinute2.desc": "Descrizione minuto 2 fine picco sezione 2",
  "50901.ctrl_WorkMode.economic.section2StartDay.desc": "Descrizione giorno inizio sezione 2",
  "50901.ctrl_WorkMode.economic.section2StartMonth.desc": "Descrizione mese inizio sezione 2",
  "50901.ctrl_WorkMode.economic.section2StopDay.desc": "Descrizione giorno fine sezione 2",
  "50901.ctrl_WorkMode.economic.section2StopMonth.desc": "Descrizione mese fine sezione 2",
  "50901.ctrl_WorkMode.economic.section2ValleyStartHour1.desc": "Descrizione ora 1 inizio bassa valle sezione 2",
  "50901.ctrl_WorkMode.economic.section2ValleyStartHour2.desc": "Descrizione ora 2 inizio bassa valle sezione 2",
  "50901.ctrl_WorkMode.economic.section2ValleyStartMinute1.desc": "Descrizione minuto 1 inizio bassa valle sezione 2",
  "50901.ctrl_WorkMode.economic.section2ValleyStartMinute2.desc": "Descrizione minuto 2 inizio bassa valle sezione 2",
  "50901.ctrl_WorkMode.economic.section2ValleyStopHour1.desc": "Descrizione ora 1 fine bassa valle sezione 2",
  "50901.ctrl_WorkMode.economic.section2ValleyStopHour2.desc": "Descrizione ora 2 fine bassa valle sezione 2",
  "50901.ctrl_WorkMode.economic.section2ValleyStopMinute1.desc": "Descrizione minuto 1 fine bassa valle sezione 2",
  "50901.ctrl_WorkMode.economic.section2ValleyStopMinute2.desc": "Descrizione minuto 2 fine bassa valle sezione 2",
  "50901.ctrl_WorkMode.economic.section2WeekRange1.desc": "Descrizione intervallo settimana 1 sezione 2",
  "50901.ctrl_WorkMode.economic.section2WeekRange2.desc": "Descrizione intervallo settimana 2 sezione 2",
  "50901.ctrl_WorkMode.economic.section3PeakStartHour1.desc": "Descrizione ora 1 inizio picco sezione 3",
  "50901.ctrl_WorkMode.economic.section3PeakStartHour2.desc": "Descrizione ora 2 inizio picco sezione 3",
  "50901.ctrl_WorkMode.economic.section3PeakStartMinute1.desc": "Descrizione minuto 2 inizio picco sezione 3",
  "50901.ctrl_WorkMode.economic.section3PeakStartMinute2.desc": "Descrizione minuto 1 inizio picco sezione 3",
  "50901.ctrl_WorkMode.economic.section3PeakStopHour1.desc": "Descrizione ora 1 fine picco sezione 3",
  "50901.ctrl_WorkMode.economic.section3PeakStopHour2.desc": "Descrizione ora 2 fine picco sezione 3",
  "50901.ctrl_WorkMode.economic.section3PeakStopMinute1.desc": "Descrizione minuto 1 fine picco sezione 3",
  "50901.ctrl_WorkMode.economic.section3PeakStopMinute2.desc": "Descrizione minuto 2 fine picco sezione 3",
  "50901.ctrl_WorkMode.economic.section3StartDay.desc": "Descrizione giorno inizio sezione 3",
  "50901.ctrl_WorkMode.economic.section3StartMonth.desc": "Descrizione mese inizio sezione 3",
  "50901.ctrl_WorkMode.economic.section3StopDay.desc": "Descrizione giorno fine sezione 3",
  "50901.ctrl_WorkMode.economic.section3StopMonth.desc": "Descrizione mese fine sezione 3",
  "50901.ctrl_WorkMode.economic.section3ValleyStartHour1.desc": "Descrizione ora 1 inizio bassa valle sezione 3",
  "50901.ctrl_WorkMode.economic.section3ValleyStartHour2.desc": "Descrizione ora 2 inizio bassa valle sezione 3",
  "50901.ctrl_WorkMode.economic.section3ValleyStartMinute1.desc": "Descrizione minuto 1 inizio bassa valle sezione 3",
  "50901.ctrl_WorkMode.economic.section3ValleyStartMinute2.desc": "Descrizione minuto 2 inizio bassa valle sezione 3",
  "50901.ctrl_WorkMode.economic.section3ValleyStopHour1.desc": "Descrizione ora 1 fine bassa valle sezione 3",
  "50901.ctrl_WorkMode.economic.section3ValleyStopHour2.desc": "Descrizione ora 2 fine bassa valle sezione 3",
  "50901.ctrl_WorkMode.economic.section3ValleyStopMinute1.desc": "Descrizione minuto 1 fine bassa valle sezione 3",
  "50901.ctrl_WorkMode.economic.section3ValleyStopMinute2.desc": "Descrizione minuto 2 fine bassa valle sezione 3",
  "50901.ctrl_WorkMode.economic.section3WeekRange1.desc": "Descrizione intervallo settimana 1 sezione 3",
  "50901.ctrl_WorkMode.economic.section3WeekRange2.desc": "Descrizione intervallo settimana 2 sezione 3",
  "50901.ctrl_WorkMode.economic.section4PeakStartHour1.desc": "Descrizione ora 1 inizio picco sezione 4",
  "50901.ctrl_WorkMode.economic.section4PeakStartHour2.desc": "Descrizione ora 2 inizio picco sezione 4",
  "50901.ctrl_WorkMode.economic.section4PeakStartMinute1.desc": "Descrizione minuto 1 inizio picco sezione 4",
  "50901.ctrl_WorkMode.economic.section4PeakStartMinute2.desc": "Descrizione minuto 2 inizio picco sezione 4",
  "50901.ctrl_WorkMode.economic.section4PeakStopHour1.desc": "Descrizione ora 1 fine picco sezione 4",
  "50901.ctrl_WorkMode.economic.section4PeakStopHour2.desc": "Descrizione ora 2 fine picco sezione 4",
  "50901.ctrl_WorkMode.economic.section4PeakStopMinute1.desc": "Descrizione minuto 1 fine picco sezione 4",
  "50901.ctrl_WorkMode.economic.section4PeakStopMinute2.desc": "Descrizione minuto 2 fine picco sezione 4",
  "50901.ctrl_WorkMode.economic.section4StartDay.desc": "Descrizione giorno inizio sezione 4",
  "50901.ctrl_WorkMode.economic.section4StartMonth.desc": "Descrizione mese inizio sezione 4",
  "50901.ctrl_WorkMode.economic.section4StopDay.desc": "Descrizione giorno fine sezione 4",
  "50901.ctrl_WorkMode.economic.section4StopMonth.desc": "Descrizione mese fine sezione 4",
  "50901.ctrl_WorkMode.economic.section4ValleyStartHour1.desc": "Descrizione ora 1 inizio bassa valle sezione 4",
  "50901.ctrl_WorkMode.economic.section4ValleyStartHour2.desc": "Descrizione ora 2 inizio bassa valle sezione 4",
  "50901.ctrl_WorkMode.economic.section4ValleyStartMinute1.desc": "Descrizione minuto 1 inizio bassa valle sezione 4",
  "50901.ctrl_WorkMode.economic.section4ValleyStartMinute2.desc": "Descrizione minuto 2 inizio bassa valle sezione 4",
  "50901.ctrl_WorkMode.economic.section4ValleyStopHour1.desc": "Descrizione ora 1 fine bassa valle sezione 4",
  "50901.ctrl_WorkMode.economic.section4ValleyStopHour2.desc": "Descrizione ora 2 fine bassa valle sezione 4",
  "50901.ctrl_WorkMode.economic.section4ValleyStopMinute1.desc": "Descrizione minuto 1 fine bassa valle sezione 4",
  "50901.ctrl_WorkMode.economic.section4ValleyStopMinute2.desc": "Descrizione minuto 2 fine bassa valle sezione 4",
  "50901.ctrl_WorkMode.economic.section4WeekRange1.desc": "Descrizione intervallo settimana 1 sezione 4",
  "50901.ctrl_WorkMode.economic.section4WeekRange2.desc": "Descrizione intervallo settimana 2 sezione 4",
  "50901.ctrl_WorkMode.forceCharge.forceChargeSoc.desc": "Descrizione SOC carica forzata",
  "50901.ctrl_WorkMode.forceCharge.maximumChargePower.desc": "Descrizione potenza massima carica",
  "50901.ctrl_WorkMode.forceDischarge.forceDischargeSoc.desc": "Descrizione SOC scarica forzata",
  "50901.ctrl_WorkMode.forceDischarge.maximumDischargePower.desc": "Descrizione potenza massima scarica",
  "50901.ctrl_WorkMode.peakMeter.peakMeterPower.desc": "Descrizione potenza contatore picco",
  "50901.ctrl_WorkMode.peakMeter.peakMeterSoc.desc": "Descrizione SOC contatore picco",
  "50901.ctrl_WorkMode.Selfuse.selfUsedSoc.desc": "Descrizione SOC autoconsumo",
  "50901.ctrl_WorkMode.Switch.workMode.desc": "Descrizione modalità operativa EMS",
  "50901.ctrl_WorkMode.TOU.timeOfUseRange.desc": "Descrizione intervallo orario modalità TOU",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgEndH.desc": "Descrizione H fine carica Time1",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgEndMin.desc": "Descrizione minuto fine carica Time1",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgPower.desc": "Descrizione potenza carica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStartH.desc": "Descrizione H inizio carica Time1",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStartMin.desc": "Descrizione min inizio carica Time1",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStopSoc.desc": "Descrizione capacità di interruzione carica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgEndH.desc": "Descrizione H fine scarica Time1",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgEndMin.desc": "Descrizione minuto fine scarica Time1",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgPower.desc": "Descrizione potenza scarica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStartH.desc": "Descrizione H inizio scarica Time1",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStartMin.desc": "Descrizione min inizio scarica Time1",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStopSoc.desc": "Descrizione capacità di interruzione scarica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgEndH.desc": "Descrizione H fine carica Time2",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgEndMin.desc": "Descrizione minuto fine carica Time2",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgPower.desc": "Descrizione potenza carica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStartH.desc": "Descrizione H inizio carica Time2",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStartMin.desc": "Descrizione min inizio carica Time2",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStopSoc.desc": "Descrizione capacità di interruzione carica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgEndH.desc": "Descrizione H fine scarica Time2",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgEndMin.desc": "Descrizione minuto fine scarica Time2",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgPower.desc": "Descrizione potenza scarica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStartH.desc": "Descrizione H inizio scarica Time2",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStartMin.desc": "Descrizione min inizio scarica Time2",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStopSoc.desc": "Descrizione capacità di interruzione scarica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgEndH.desc": "Descrizione H fine carica Time3",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgEndMin.desc": "Descrizione minuto fine carica Time3",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgPower.desc": "Descrizione potenza carica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStartH.desc": "Descrizione H inizio carica Time3",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStartMin.desc": "Descrizione min inizio carica Time3",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStopSoc.desc": "Descrizione capacità di interruzione carica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgEndH.desc": "Descrizione H fine scarica Time3",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgEndMin.desc": "Descrizione minuto fine scarica Time3",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgPower.desc": "Descrizione potenza scarica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStartH.desc": "Descrizione H inizio scarica Time3",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStartMin.desc": "Descrizione min inizio scarica Time3",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStopSoc.desc": "Descrizione capacità di interruzione scarica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgEndH.desc": "Descrizione H fine carica Time4",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgEndMin.desc": "Descrizione minuto fine carica Time4",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgPower.desc": "Descrizione potenza carica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStartH.desc": "Descrizione H inizio carica Time4",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStartMin.desc": "Descrizione min inizio carica Time4",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStopSoc.desc": "Descrizione capacità di interruzione carica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgEndH.desc": "Descrizione H fine scarica Time4",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgEndMin.desc": "Descrizione minuto fine scarica Time4",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgPower.desc": "Descrizione potenza scarica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStartH.desc": "Descrizione H inizio scarica Time4",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStartMin.desc": "Descrizione min inizio scarica Time4",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStopSoc.desc": "Descrizione potenza di interruzione scarica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgEndH.desc": "Descrizione H fine carica Time5",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgEndMin.desc": "Descrizione minuto fine carica Time5",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgPower.desc": "Descrizione potenza carica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStartH.desc": "Descrizione H inizio carica Time5",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStartMin.desc": "Descrizione min inizio carica Time5",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStopSoc.desc": "Descrizione capacità di interruzione carica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgEndH.desc": "Descrizione H fine scarica Time5",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgEndMin.desc": "Descrizione minuto fine scarica Time5",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgPower.desc": "Descrizione potenza scarica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStartH.desc": "Descrizione H inizio scarica Time5",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStartMin.desc": "Descrizione min inizio scarica Time5",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStopSoc.desc": "Descrizione capacità di interruzione scarica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgEndH.desc": "Descrizione H fine carica Time6",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgEndMin.desc": "Descrizione minuto fine carica Time6",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgPower.desc": "Descrizione potenza carica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStartH.desc": "Descrizione H inizio carica Time6",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStartMin.desc": "Descrizione min inizio carica Time6",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStopSoc.desc": "Descrizione capacità di interruzione carica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgEndH.desc": "Descrizione H fine scarica Time6",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgEndMin.desc": "Descrizione minuto fine scarica Time6",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgPower.desc": "Descrizione potenza scarica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStartH.desc": "Descrizione H inizio scarica Time6",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStartMin.desc": "Descrizione min inizio scarica Time6",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStopSoc.desc": "Descrizione capacità di interruzione scarica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgEndH.desc": "Descrizione H fine carica Time7",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgEndMin.desc": "Descrizione minuto fine carica Time7",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgPower.desc": "Descrizione potenza scarica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStartH.desc": "Descrizione H inizio carica Time7",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStartMin.desc": "Descrizione min inizio carica Time7",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStopSoc.desc": "Descrizione capacità di interruzione scarica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgEndH.desc": "Descrizione H fine scarica Time7",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgEndMin.desc": "Descrizione minuto fine scarica Time7",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgPower.desc": "Descrizione potenza scarica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStartH.desc": "Descrizione H inizio scarica Time7",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStartMin.desc": "Descrizione min inizio scarica Time7",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStopSoc.desc": "Descrizione capacità di interruzione scarica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgEndH.desc": "Descrizione H fine carica Time8",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgEndMin.desc": "Descrizione minuto fine carica Time8",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgPower.desc": "Descrizione potenza carica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStartH.desc": "Descrizione H inizio carica Time8",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStartMin.desc": "Descrizione min inizio carica Time8",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStopSoc.desc": "Descrizione capacità di interruzione carica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgEndH.desc": "Descrizione H fine scarica Time8",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgEndMin.desc": "Descrizione minuto fine scarica Time8",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgPower.desc": "Descrizione potenza scarica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStartH.desc": "Descrizione H inizio scarica Time8",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStartMin.desc": "Descrizione min inizio scarica Time8",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStopSoc.desc": "Descrizione capacità di interruzione scarica",
  "50901.real_time.bmsSoftwareVersion.desc": "Descrizione versione software BMS",
  "50901.real_time.commAddress10Slave9.desc": "Descrizione indirizzo comunicazione 10 (slave 9)",
  "50901.real_time.commAddress1Master.desc": "Descrizione indirizzo comunicazione 1 (master)",
  "50901.real_time.commAddress2Slave1.desc": "Descrizione indirizzo comunicazione 2 (slave 1)",
  "50901.real_time.commAddress3Slave2.desc": "Descrizione indirizzo comunicazione 3 (slave 2)",
  "50901.real_time.commAddress3Slave3.desc": "Descrizione indirizzo comunicazione 4 (slave 3)",
  "50901.real_time.commAddress4Slave4.desc": "Descrizione indirizzo comunicazione 5 (slave 4)",
  "50901.real_time.commAddress6Slave6.desc": "Descrizione indirizzo comunicazione 6 (slave 5)",
  "50901.real_time.commAddress7Slave6.desc": "Descrizione indirizzo comunicazione 7 (slave 6)",
  "50901.real_time.commAddress8Slave7.desc": "Descrizione indirizzo comunicazione 8 (slave 7)",
  "50901.real_time.commAddress9Slave8.desc": "Descrizione indirizzo comunicazione 9 (slave 8)",
  "50901.real_time.epsCurrentA.desc": "Descrizione corrente fase A lato EPS",
  "50901.real_time.epsCurrentB.desc": "Descrizione corrente fase B lato EPS",
  "50901.real_time.epsCurrentC.desc": "Descrizione corrente fase C lato EPS",
  "50901.real_time.epsPower.desc": "Descrizione potenza lato EPS",
  "50901.real_time.epsPowerA.desc": "Descrizione potenza fase A lato EPS",
  "50901.real_time.epsPowerB.desc": "Descrizione potenza fase B lato EPS",
  "50901.real_time.epsPowerC.desc": "Descrizione potenza fase C lato EPS",
  "50901.real_time.epsVoltageA.desc": "Descrizione tensione fase A lato EPS",
  "50901.real_time.epsVoltageB.desc": "Descrizione tensione fase B lato EPS",
  "50901.real_time.epsVoltageC.desc": "Descrizione tensione fase C lato EPS",
  "50901.real_time.essAccessPoint.desc": "Descrizione punto di accesso ESS",
  "50901.real_time.generatorConnectionStatus.desc": "Descrizione stato connessione generatore",
  "50901.real_time.generatorVoltageA.desc": "Descrizione tensione fase A generatore",
  "50901.real_time.generatorVoltageB.desc": "Descrizione tensione fase B generatore",
  "50901.real_time.generatorVoltageC.desc": "Descrizione tensione fase C generatore",
  "50901.real_time.invAcFrequency.desc": "Descrizione frequenza uscita CA inverter",
  "50901.real_time.inverCombinedActivePower.desc": "Descrizione potenza uscita CA inverter",
  "50901.real_time.invRatedPower.desc": "Descrizione potenza nominale",
  "50901.real_time.invRunningtime.desc": "Descrizione ore funzionamento inverter (Hoymiles: tempo normale)",
  "50901.real_time.machineSnMaster.desc": "Descrizione SN unità master",
  "50901.real_time.machineSnSlave1.desc": "Descrizione SN slave 1",
  "50901.real_time.machineSnSlave2.desc": "Descrizione SN slave 2",
  "50901.real_time.machineSnSlave3.desc": "Descrizione SN slave 3",
  "50901.real_time.machineSnSlave4.desc": "Descrizione SN slave 4",
  "50901.real_time.machineSnSlave5.desc": "Descrizione SN slave 5",
  "50901.real_time.machineSnSlave6.desc": "Descrizione SN slave 6",
  "50901.real_time.machineSnSlave7.desc": "Descrizione SN slave 7",
  "50901.real_time.machineSnSlave8.desc": "Descrizione SN slave 8",
  "50901.real_time.machineSnSlave9.desc": "Descrizione SN slave 9",
  "50901.real_time.numberOfUnits.desc": "Descrizione quantità unità",
  "50901.real_time.phaseAOfInverterActivePower.desc": "Descrizione potenza fase A lato CA inverter",
  "50901.real_time.phaseAOfInverterSideCurrent.desc": "Descrizione corrente fase A lato CA inverter",
  "50901.real_time.phaseAOfInverterSideVoltage.desc": "Descrizione tensione fase A lato CA inverter",
  "50901.real_time.phaseBOfInverterActivePower.desc": "Descrizione potenza fase B lato CA inverter",
  "50901.real_time.phaseBOfInverterSideCurrent.desc": "Descrizione corrente fase B lato CA inverter",
  "50901.real_time.phaseBOfInverterSideVoltage.desc": "Descrizione tensione fase B lato CA inverter",
  "50901.real_time.phaseCOfInverterActivePower.desc": "Descrizione potenza fase C lato CA inverter",
  "50901.real_time.phaseCOfInverterSideCurrent.desc": "Descrizione corrente fase C lato CA inverter",
  "50901.real_time.phaseCOfInverterSideVoltage.desc": "Descrizione tensione fase C lato CA inverter",
  "50901.real_time.pv1Current.desc": "Descrizione corrente FV1",
  "50901.real_time.pv1Power.desc": "Descrizione potenza FV1",
  "50901.real_time.pv1Voltage.desc": "Descrizione tensione FV1",
  "50901.real_time.pv2Current.desc": "Descrizione corrente FV2",
  "50901.real_time.pv2Power.desc": "Descrizione potenza FV2",
  "50901.real_time.pv2Voltage.desc": "Descrizione tensione FV2",
  "50901.real_time.pv3Current.desc": "Descrizione corrente FV3",
  "50901.real_time.pv3Power.desc": "Descrizione potenza FV3",
  "50901.real_time.pv3Voltage.desc": "Descrizione tensione FV3",
  "50901.real_time.pv4Current.desc": "Descrizione corrente FV4",
  "50901.real_time.pv4Power.desc": "Descrizione potenza FV4",
  "50901.real_time.pv4Voltage.desc": "Descrizione tensione FV4",
  "50901.real_time.pvConnectionStatus.desc": "Descrizione stato connessione FV",
  "50901.real_time.serviceEntranceBreakerCurrent.desc": "Descrizione corrente interruttore ingresso servizio",
  "50901.real_time.workStatus.desc": "Descrizione stato operativo",
  "50901..antiIslandingEnable.desc": "Descrizione abilitazione anti-islanding",
  "50901..apcEn.desc": "Descrizione abilitazione APC",
  "50901..apcPwrLmt.desc": "Descrizione limite potenza APC",
  "50901..apcRamp.desc": "Descrizione rampa APC",
  "50901..drmEnable.desc": "Descrizione abilitazione DRM",
  "50901..fixPfTr.desc": "Descrizione tempo FixPF_Tr",
  "50901..functionCode.desc": "Descrizione codice funzione",
  "50901..fwDelayTime.desc": "Descrizione tempo ritardo FW",
  "50901..fwOverFdroop.desc": "Descrizione coefficiente droop sovrafrequenza FW",
  "50901..fwUnderFdroop.desc": "Descrizione coefficiente droop sottofrequenza FW",
  "50901..gcfExportHardTime.desc": "Descrizione tempo limite rigido esportazione GCF",
  "50901..gcfGenerationHardLimitRatio.desc": "Descrizione rapporto limite rigido generazione GCF",
  "50901..gcfGenerationHardTime.desc": "Descrizione tempo limite rigido generazione GCF",
  "50901..gcfGenerationSoftLimitRatio.desc": "Descrizione rapporto limite morbido generazione GCF",
  "50901..gcfImportHardTime.desc": "Descrizione tempo limite rigido importazione GCF",
  "50901..gcfImportLimitRatio.desc": "Descrizione rapporto limite importazione GCF",
  "50901..gcfReconnectionTime.desc": "Descrizione tempo riconnessione GCF",
  "50901..gridLevel2LimitTimeScale.desc": "Descrizione scala temporale limite secondario rete",
  "50901..permitEnable.desc": "Descrizione abilitazione permesso",
  "50901..phaseOrderInverseDisable.desc": "Descrizione disabilitazione inversione sequenza fasi",
  "50901..pqFuncCode.desc": "Descrizione codice funzione PQ",
  "50901..pqP1.desc": "Descrizione PQ_P1",
  "50901..pqP2.desc": "Descrizione PQ_P2",
  "50901..pqP3.desc": "Descrizione PQ_P3",
  "50901..pqP4.desc": "Descrizione PQ_P4",
  "50901..pqP5.desc": "Descrizione PQ_P5",
  "50901..pqP6.desc": "Descrizione PQ_P6",
  "50901..pqQ1.desc": "Descrizione PQ_Q1",
  "50901..pqQ2.desc": "Descrizione PQ_Q2",
  "50901..pqQ3.desc": "Descrizione PQ_Q3",
  "50901..pqQ4.desc": "Descrizione PQ_Q4",
  "50901..pqQ5.desc": "Descrizione PQ_Q5",
  "50901..pqQ6.desc": "Descrizione PQ_Q6",
  "50901..pqTr.desc": "Descrizione tempo PQ_Tr",
  "50901..relayU16NlineRlyTestDis.desc": "Descrizione disabilitazione test relè N",
  "50901..rpaP1.desc": "Descrizione RPA_P1",
  "50901..rpaP2.desc": "Descrizione RPA_P2",
  "50901..rpaQ1.desc": "Descrizione RPA_Q1",
  "50901..rpaQ2.desc": "Descrizione RPA_Q2",
  "50901..vvTr.desc": "Descrizione tempo VV_Tr",
  "50901..wattRegulationPriority.desc": "Descrizione priorità regolazione watt",
  "50901..wpfTr.desc": "Descrizione tempo WPF_Tr",
  "50901.ctrl_Config.Battery.absorptionVoltage.desc": "Descrizione tensione di assorbimento",
  "50901.ctrl_Config.Battery.batteryCapacity.desc": "Descrizione capacità BMS",
  "50901.ctrl_Config.Battery.endChargeVoltage.desc": "Descrizione tensione fine carica",
  "50901.ctrl_Config.Battery.endOfChargeCurrent.desc": "Descrizione corrente fine carica",
  "50901.ctrl_Config.Battery.equalizationChargeTimeout.desc": "Descrizione timeout carica equalizzazione",
  "50901.ctrl_Config.Battery.equalizationEnable.desc": "Descrizione abilitazione equalizzazione",
  "50901.ctrl_Config.Battery.equalizationIntervalDays.desc": "Descrizione giorni intervallo equalizzazione",
  "50901.ctrl_Config.Battery.equalizationTime.desc": "Descrizione tempo equalizzazione",
  "50901.ctrl_Config.Battery.equalizationVoltage.desc": "Descrizione tensione equalizzazione",
  "50901.ctrl_Config.Battery.floatVoltage.desc": "Descrizione tensione di floating",
  "50901.ctrl_Config.Battery.initialResistance.desc": "Descrizione resistenza iniziale",
  "50901.ctrl_Config.Battery.maximumChargeLimit.desc": "Descrizione valore limite massimo carica",
  "50901.ctrl_Config.Battery.maximumDischargeLimit.desc": "Descrizione valore limite massimo scarica",
  "50901.ctrl_Config.Battery.temperatureCorrectionFactor.desc": "Descrizione coefficiente correzione temperatura",
  "50901.ctrl_Config.Connection.dtu_comm_enable.desc": "Descrizione abilitazione comunicazione DTU",
  "50901.ctrl_Config.Device.arcFaultClear.desc": "Descrizione cancellazione guasto arco",
  "50901.ctrl_Config.Device.batActivate.desc": "Descrizione attivazione batteria",
  "50901.ctrl_Config.Device.batteryBalancing.desc": "Descrizione bilanciamento batteria",
  "50901.ctrl_Config.Device.clearFault.desc": "Descrizione cancellazione guasto",
  "50901.ctrl_Config.Device.parallelNetworking.desc": "Descrizione rete parallela",
  "50901.ctrl_Config.Device.restartSystem.desc": "Descrizione riavvio sistema",
  "50901.ctrl_Config.Device.restoreDefault.desc": "Descrizione ripristino valori predefiniti",
  "50901.ctrl_Config.Device.selfTest.desc": "Descrizione autotest",
  "50901.ctrl_Config.Device.systemPowerOnOff.desc": "Descrizione accensione/spegnimento sistema",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeEndH.desc": "Descrizione ora H fine carica controllo generatore",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeEndMin.desc": "Descrizione minuto fine carica controllo generatore",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeStartH.desc": "Descrizione Ora H Inizio Carica Controllo Generatore",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeStartMin.desc": "Descrizione Minuto Inizio Carica Controllo Generatore",
  "50901.ctrl_Dry_Contact.Generator.generatorCloseBatteryCapacity.desc": "Descrizione Capacità Batteria Spegnimento Generatore",
  "50901.ctrl_Dry_Contact.Generator.generatorMode.desc": "Descrizione modalità generatore",
  "50901.ctrl_Dry_Contact.Generator.generatorOpenBatteryCapacity.desc": "Descrizione Capacità Batteria Avvio Generatore",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.desc": "Descrizione Frequenza Modalità Esercizio Generatore",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeEn.desc": "Descrizione modalità esercizio generatore",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeRunningTime.desc": "Descrizione Durata Modalità Esercizio Generatore",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeStartH.desc": "Descrizione ora avvio modalità esercizio generatore",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeStartMin.desc": "Descrizione minuto avvio modalità esercizio generatore",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek.desc": "Descrizione Tempo Avvio Modalità Esercizio Generatore",
  "50901.ctrl_Dry_Contact.Generator.quietTime1EndH.desc": "Descrizione ora H fine tempo standby 1",
  "50901.ctrl_Dry_Contact.Generator.quietTime1EndMin.desc": "Descrizione minuto fine tempo standby 1",
  "50901.ctrl_Dry_Contact.Generator.quietTime1StartH.desc": "Descrizione ora H inizio tempo standby 1",
  "50901.ctrl_Dry_Contact.Generator.quietTime1StartMin.desc": "Descrizione minuto inizio tempo standby 1",
  "50901.ctrl_Dry_Contact.Generator.quietTime2EndH.desc": "Descrizione ora H fine tempo standby 2",
  "50901.ctrl_Dry_Contact.Generator.quietTime2EndMin.desc": "Descrizione minuto fine tempo standby 2",
  "50901.ctrl_Dry_Contact.Generator.quietTime2StartH.desc": "Descrizione ora H inizio tempo standby 2",
  "50901.ctrl_Dry_Contact.Generator.quietTime2StartMin.desc": "Descrizione minuto inizio tempo standby 2",
  "50901.ctrl_Dry_Contact.Generator.quietTimeEnable.desc": "Descrizione Abilitazione Tempo Standby",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.desc": "Descrizione modalità controllo carico",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange1.desc": "Descrizione controllo carico lunedì",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange2.desc": "Descrizione controllo carico martedì",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange3.desc": "Descrizione controllo carico mercoledì",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange4.desc": "Descrizione controllo carico giovedì",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange5.desc": "Descrizione controllo carico venerdì",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange6.desc": "Descrizione controllo carico sabato",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange7.desc": "Descrizione controllo carico domenica",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.manualModeSwitch.desc": "Descrizione interruttore modalità manuale",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.minimumOnLoadPower.desc": "Descrizione soglia potenza carico modalità carico",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.minimumOnTime.desc": "Descrizione tempo minimo inserzione controllo carico",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.offGridProtectionSoc.desc": "Descrizione SOC protezione off-grid",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange1.desc": "Descrizione intervallo orario 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange20.desc": "Descrizione lunedì",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange21.desc": "Descrizione martedì",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange22.desc": "Descrizione mercoledì",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange23.desc": "Descrizione giovedì",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange24.desc": "Descrizione venerdì",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange25.desc": "Descrizione sabato",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange26.desc": "Descrizione domenica",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour.desc": "Descrizione ora fine timer 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour_2.desc": "Descrizione ora fine timer 1_2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour_3.desc": "Descrizione ora fine intervallo 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute.desc": "Descrizione minuto fine timer 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute_2.desc": "Descrizione minuto fine timer 1_2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute_3.desc": "Descrizione minuto fine intervallo 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min.desc": "Descrizione minuto inizio timer 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min_2.desc": "Descrizione minuto inizio timer 1_2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min_3.desc": "Descrizione minuto inizio intervallo 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour.desc": "Descrizione ora fine timer 2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour_2.desc": "Descrizione ora fine timer 2_2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour_3.desc": "Descrizione ora fine intervallo 2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes.desc": "Descrizione minuto fine timer 2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes_2.desc": "Descrizione minuto fine timer 2_2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes_3.desc": "Descrizione minuto fine intervallo 2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes.desc": "Descrizione minuto inizio timer 2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes_2.desc": "Descrizione minuto inizio timer 2_2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes_3.desc": "Descrizione minuto inizio intervallo 2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour.desc": "Descrizione ora inizio timer 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour_2.desc": "Descrizione ora inizio timer 1_2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour_3.desc": "Descrizione ora inizio intervallo 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour.desc": "Descrizione ora inizio timer 2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour_2.desc": "Descrizione ora inizio timer 2_2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour_3.desc": "Descrizione ora inizio intervallo 2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange1.desc": "Descrizione lunedì",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange2.desc": "Descrizione martedì",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange3.desc": "Descrizione mercoledì",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange4.desc": "Descrizione giovedì",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange5.desc": "Descrizione venerdì",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange6.desc": "Descrizione sabato",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange7.desc": "Descrizione domenica",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.desc": "Descrizione modalità operativa contatti puliti",
  "50901.ctrl_ESS_Advanced_Config.Battery.batDischargePowerWhenPartialPeak.desc": "Descrizione Potenza Max Scarica Batteria In Picco",
  "50901.ctrl_ESS_Advanced_Config.Battery.batGridFeedPowerWhenPeak.desc": "Descrizione Potenza Immissione Rete In Picco",
  "50901.ctrl_ESS_Advanced_Config.Battery.batteryMaxChargePower.desc": "Descrizione Potenza Max Carica Batteria",
  "50901.ctrl_ESS_Advanced_Config.Battery.batteryMaxDischargePower.desc": "Descrizione Potenza Max Scarica Batteria",
  "50901.ctrl_ESS_Advanced_Config.Battery.leadAcidBatReplenishTime.desc": "Descrizione Tempo Manutenzione Batteria Al Piombo",
  "50901.ctrl_ESS_Advanced_Config.Battery.maxSoc.desc": "Descrizione Soc Massimo",
  "50901.ctrl_ESS_Advanced_Config.Battery.minSoc.desc": "Descrizione Soc Minimo",
  "50901.ctrl_ESS_Advanced_Config.Battery.replenishPower.desc": "Descrizione Compensazione Potenza",
  "50901.ctrl_ESS_Advanced_Config.Battery.rsvdReplenishPower.desc": "Descrizione Potenza Riserva Rsvd",
  "50901.ctrl_ESS_Advanced_Config.EPS.bypassDisable.desc": "Descrizione Disabilitazione Bypass",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode.desc": "Descrizione Modalità Eps",
  "50901.ctrl_ESS_Advanced_Config.EPS.pvIslandModeEn.desc": "Descrizione Abilitazione Modalità Fv",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_high_limit_freq.desc": "Descrizione limite superiore frequenza generatore",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_high_limit_volt.desc": "Descrizione limite superiore tensione generatore",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_low_limit_freq.desc": "Descrizione limite inferiore frequenza generatore",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_low_limit_volt.desc": "Descrizione limite inferiore tensione generatore",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_rated_power.desc": "Descrizione potenza carica batteria da generatore in parallelo multi-unità",
  "50901.ctrl_ESS_Advanced_Config.PV.mppt_global_scan_enable.desc": "Descrizione Abilitazione Scansione Globale",
  "50901.ctrl_ESS_Advanced_Config.System.gridInPowerLimitationWhenValley.desc": "Descrizione Limite Potenza Rete",
  "50901.ctrl_ESS_Advanced_Config.System.mid_gateway_enable.desc": "Descrizione Abilitazione Mid/Gateway",
  "50901.ctrl_ESS_Advanced_Config.System.threePhaseUnbalanceEnable.desc": "Descrizione Abilitazione Squilibrio Trifase",
  "50901.ctrl_Safety.DCI.dciEnable.desc": "Descrizione abilitazione DCI",
  "50901.ctrl_Safety.DCI.lowerLimit.desc": "Descrizione corrente limite inferiore DCI",
  "50901.ctrl_Safety.DCI.lowerTime.desc": "Descrizione tempo limite inferiore DCI",
  "50901.ctrl_Safety.DCI.upperLimit.desc": "Descrizione corrente limite superiore DCI",
  "50901.ctrl_Safety.DCI.upperTime.desc": "Descrizione tempo limite superiore DCI",
  "50901.ctrl_Safety.FRT.frtFuncCode.desc": "Descrizione codice funzione FRT",
  "50901.ctrl_Safety.FRT.frtHighLimit1.desc": "Descrizione limite superiore frequenza 1",
  "50901.ctrl_Safety.FRT.frtHighLimit1Time.desc": "Descrizione durata limite superiore frequenza 1",
  "50901.ctrl_Safety.FRT.frtHighLimit2.desc": "Descrizione limite superiore frequenza 2",
  "50901.ctrl_Safety.FRT.frtHighLimit2Time.desc": "Descrizione durata limite superiore frequenza 2",
  "50901.ctrl_Safety.FRT.frtHighLimit3.desc": "Descrizione limite superiore frequenza 3",
  "50901.ctrl_Safety.FRT.frtHighLimit3Time.desc": "Descrizione durata limite superiore frequenza 3",
  "50901.ctrl_Safety.FRT.frtLowLimit1.desc": "Descrizione limite inferiore frequenza 1",
  "50901.ctrl_Safety.FRT.frtLowLimit1Time.desc": "Descrizione durata limite inferiore frequenza 1",
  "50901.ctrl_Safety.FRT.frtLowLimit2.desc": "Descrizione limite inferiore frequenza 2",
  "50901.ctrl_Safety.FRT.frtLowLimit2Time.desc": "Descrizione durata limite inferiore frequenza 2",
  "50901.ctrl_Safety.FRT.frtLowLimit3.desc": "Descrizione limite inferiore frequenza 3",
  "50901.ctrl_Safety.FRT.frtLowLimit3Time.desc": "Descrizione durata limite inferiore frequenza 3",
  "50901.ctrl_Safety.FW.fwDiffInBatMode.desc": "Descrizione abilitazione differenza modalità batteria FW",
  "50901.ctrl_Safety.FW.fwEnable.desc": "Descrizione abilitazione FW",
  "50901.ctrl_Safety.FW.fwFuncCode.desc": "Descrizione codice funzione FW",
  "50901.ctrl_Safety.FW.fwOverEndFreq.desc": "Descrizione frequenza fine sovrafrequenza FW",
  "50901.ctrl_Safety.FW.fwOverStartFreq.desc": "Descrizione frequenza inizio sovrafrequenza FW",
  "50901.ctrl_Safety.FW.fwOverTransFreq.desc": "Descrizione frequenza transizione sovrafrequenza FW",
  "50901.ctrl_Safety.FW.fwRecoveryLowerFrequency.desc": "Descrizione limite inferiore frequenza ripristino FW",
  "50901.ctrl_Safety.FW.fwRecoveryStableTime.desc": "Descrizione tempo stabilizzazione ripristino FW",
  "50901.ctrl_Safety.FW.fwRecoveryUpperFrequency.desc": "Descrizione limite superiore frequenza ripristino FW",
  "50901.ctrl_Safety.FW.fwTr.desc": "Descrizione tempo FW_Tr",
  "50901.ctrl_Safety.FW.fwUnderEndFreq.desc": "Descrizione frequenza fine sottofrequenza FW",
  "50901.ctrl_Safety.FW.fwUnderStartFreq.desc": "Descrizione frequenza inizio sottofrequenza FW",
  "50901.ctrl_Safety.FW.fwUnderStopFreq.desc": "Descrizione frequenza arresto sottofrequenza FW",
  "50901.ctrl_Safety.RCD.continueLimitTime.desc": "Descrizione tempo limite continuo RCD",
  "50901.ctrl_Safety.RCD.continueLimitValue.desc": "Descrizione corrente limite continuo RCD",
  "50901.ctrl_Safety.RCD.rcdEnable.desc": "Descrizione abilitazione RCD",
  "50901.ctrl_Safety.RCD.step1LimitTime.desc": "Descrizione tempo limite gradino 1 RCD",
  "50901.ctrl_Safety.RCD.step1LimitValue.desc": "Descrizione corrente limite gradino 1 RCD",
  "50901.ctrl_Safety.RCD.step2LimitTime.desc": "Descrizione tempo limite gradino 2 RCD",
  "50901.ctrl_Safety.RCD.step2LimitValue.desc": "Descrizione corrente limite gradino 2 RCD",
  "50901.ctrl_Safety.RCD.step3LimitTime.desc": "Descrizione tempo limite gradino 3 RCD",
  "50901.ctrl_Safety.RCD.step3LimitValue.desc": "Descrizione corrente limite gradino 3 RCD",
  "50901.ctrl_Safety.RPC.gcfEn.desc": "Descrizione abilitazione GCF",
  "50901.ctrl_Safety.RPC.gcfFuncCode.desc": "Descrizione codice funzione GCF",
  "50901.ctrl_Safety.RPC.rpcMode.desc": "Descrizione modalità RP",
  "50901.ctrl_Safety.RPC.rpcPf.desc": "Descrizione fattore di potenza PF RPC",
  "50901.ctrl_Safety.RPC.rpcReactPowerRatio.desc": "Descrizione rapporto potenza reattiva RPC",
  "50901.ctrl_Safety.RPC.rpcTr.desc": "Descrizione tempo RPC_Tr",
  "50901.ctrl_Safety.RPC.vvFuncCode.desc": "Descrizione codice funzione Volt-Var",
  "50901.ctrl_Safety.RPC.vvLockIn.desc": "Descrizione valore soglia inserzione VV",
  "50901.ctrl_Safety.RPC.vvLockOut.desc": "Descrizione valore soglia disinserzione VV",
  "50901.ctrl_Safety.RPC.vvQ1.desc": "Descrizione punto reattivo Q1",
  "50901.ctrl_Safety.RPC.vvQ2.desc": "Descrizione punto reattivo Q2",
  "50901.ctrl_Safety.RPC.vvQ3.desc": "Descrizione punto reattivo Q3",
  "50901.ctrl_Safety.RPC.vvQ4.desc": "Descrizione punto reattivo Q4",
  "50901.ctrl_Safety.RPC.vvV1.desc": "Descrizione punto tensione V1",
  "50901.ctrl_Safety.RPC.vvV2.desc": "Descrizione punto tensione V2",
  "50901.ctrl_Safety.RPC.vvV3.desc": "Descrizione punto tensione V3",
  "50901.ctrl_Safety.RPC.vvV4.desc": "Descrizione punto tensione V4",
  "50901.ctrl_Safety.RPC.vvVref.desc": "Descrizione valore riferimento Vref",
  "50901.ctrl_Safety.RPC.vvVrefTr.desc": "Descrizione tempo riferimento Tr Vref",
  "50901.ctrl_Safety.RPC.wpfFuncCode.desc": "Descrizione codice funzione WPF",
  "50901.ctrl_Safety.RPC.wpfLockIn.desc": "Descrizione valore soglia inserzione WPF",
  "50901.ctrl_Safety.RPC.wpfLockOut.desc": "Descrizione valore soglia disinserzione WPF",
  "50901.ctrl_Safety.RPC.wpfMinPFOver.desc": "Descrizione PF minimo sovrapotenza WPF",
  "50901.ctrl_Safety.RPC.wpfMinPFUnder.desc": "Descrizione PF minimo sottopotenza WPF",
  "50901.ctrl_Safety.RPC.wpfPowerEndRatio.desc": "Descrizione rapporto fine potenza WPF",
  "50901.ctrl_Safety.RPC.wpfPowerStartRatio.desc": "Descrizione rapporto inizio potenza WPF",
  "50901.ctrl_Safety.RR.rrFuncCode.desc": "Descrizione codice funzione RR",
  "50901.ctrl_Safety.RR.rrRurNm.desc": "Descrizione RR_RUR_NM",
  "50901.ctrl_Safety.RR.rrRurSs.desc": "Descrizione RR_RUR_SS",
  "50901.ctrl_Safety.RT.rtFreqRecoveryHighValue.desc": "Descrizione limite superiore recupero frequenza RT",
  "50901.ctrl_Safety.RT.rtFreqRecoveryLowValue.desc": "Descrizione limite inferiore recupero frequenza RT",
  "50901.ctrl_Safety.RT.rtFuncCode.desc": "Descrizione codice funzione RT",
  "50901.ctrl_Safety.RT.rtNMTime.desc": "Descrizione tempo RT_NM",
  "50901.ctrl_Safety.RT.rtSRTTime.desc": "Descrizione tempo RT_SRT",
  "50901.ctrl_Safety.RT.rtVoltRecoveryHighValue.desc": "Descrizione limite superiore recupero tensione RT",
  "50901.ctrl_Safety.RT.rtVoltRecoveryLowValue.desc": "Descrizione limite inferiore recupero tensione RT",
  "50901.ctrl_Safety.VRT.vrt10MinAvgVoltage.desc": "Descrizione tensione media 10 minuti",
  "50901.ctrl_Safety.VRT.vrtEn.desc": "Descrizione abilitazione VRT",
  "50901.ctrl_Safety.VRT.vrtFuncCode.desc": "Descrizione codice funzione VRT",
  "50901.ctrl_Safety.VRT.vrtHighLimit.desc": "Descrizione soglia alta tensione VRT",
  "50901.ctrl_Safety.VRT.vrtLowLimit.desc": "Descrizione soglia bassa tensione VRT",
  "50901.ctrl_Safety.VRT.vrtRecoveryStableTime.desc": "Descrizione tempo stabilizzazione ripristino VRT",
  "50901.ctrl_Safety.VRT.vrtTransientOverTime.desc": "Descrizione durata sovratensione istantanea",
  "50901.ctrl_Safety.VRT.vrtTransientOverVoltage.desc": "Descrizione soglia sovratensione istantanea",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit1.desc": "Descrizione limite superiore tensione 1",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit1Time.desc": "Descrizione durata limite superiore tensione 1",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit2.desc": "Descrizione limite superiore tensione 2",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit2Time.desc": "Descrizione durata limite superiore tensione 2",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit3.desc": "Descrizione limite superiore tensione 3",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit3Time.desc": "Descrizione durata limite superiore tensione 3",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit1.desc": "Descrizione limite inferiore tensione 1",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit1Time.desc": "Descrizione durata limite inferiore tensione 1",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit2.desc": "Descrizione limite inferiore tensione 2",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit2Time.desc": "Descrizione durata limite inferiore tensione 2",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit3.desc": "Descrizione limite inferiore tensione 3",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit3Time.desc": "Descrizione durata limite inferiore tensione 3",
  "50901.ctrl_Safety.VW.vwDiffInBatMode.desc": "Descrizione abilitazione differenza modalità batteria VW",
  "50901.ctrl_Safety.VW.vwEnable.desc": "Descrizione abilitazione VW",
  "50901.ctrl_Safety.VW.vwFuncCode.desc": "Descrizione codice funzione VW",
  "50901.ctrl_Safety.VW.vwOverEndVolt.desc": "Descrizione tensione fine sovratensione VW",
  "50901.ctrl_Safety.VW.vwOverKPVolt.desc": "Descrizione tensione KP / coefficiente sovratensione VW",
  "50901.ctrl_Safety.VW.vwOverStartVolt.desc": "Descrizione tensione inizio sovratensione VW",
  "50901.ctrl_Safety.VW.vwRecoveryLowerVoltage.desc": "Descrizione limite inferiore tensione ripristino VW",
  "50901.ctrl_Safety.VW.vwRecoveryStableTime.desc": "Descrizione tempo stabilizzazione ripristino VW",
  "50901.ctrl_Safety.VW.vwRecoveryUpperVoltage.desc": "Descrizione limite superiore tensione ripristino VW",
  "50901.ctrl_Safety.VW.vwTr.desc": "Descrizione tempo VW_Tr",
  "50901.ctrl_Safety.VW.vwUnderEndVolt.desc": "Descrizione tensione fine sottotensione VW",
  "50901.ctrl_Safety.VW.vwUnderKPVolt.desc": "Descrizione tensione KP / coefficiente sottotensione VW",
  "50901.ctrl_Safety.VW.vwUnderStartVolt.desc": "Descrizione tensione inizio sottotensione VW",
  "50901.ctrl_Safety_GCF.gcfExportHardLimitRatio.desc": "Descrizione rapporto limite rigido esportazione GCF",
  "50901.ctrl_Safety_GCF.gcfExportSoftLimitRatio.desc": "Descrizione rapporto limite morbido esportazione GCF",
  "50901.real_time.BatteryModel.desc": "Descrizione modello batteria",
  "50901.real_time.cfgMultPcsBmsFlag.desc": "Descrizione flag BMS",
  "50901.real_time.inverterSn.desc": "Descrizione SN inverter",
  "50901..brightness.desc": "Descrizione luminosità display",
  "50901.ctrl_Config.Device.networkingType.1": "Wifi",
  "50901.ctrl_Config.Device.networkingType.2": "Ethernet",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatterySocEnable.0": "Disabilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatterySocEnable.1": "Abilita",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.desc": "Descrizione Modalità Porta Generatore",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position.desc": "Descrizione Posizione Generatore",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_shutdown_delay.desc": "Descrizione Ritardo Spegnimento Generatore",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_sync_time.desc": "Descrizione Tempo Sincronizzazione Generatore",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_type.desc": "Descrizione Tipo Generatore",
  "50901.ctrl_ESS_Advanced_Config.Generator.max_run_time.desc": "Descrizione Tempo Massimo Funzionamento",
  "50901.ctrl_ESS_Advanced_Config.Generator.min_run_time.desc": "Descrizione Tempo Minimo Funzionamento",
  "50901.ctrl_ESS_Advanced_Config.Generator.run_protect_threshold.desc": "Descrizione Intervallo Protezione Funzionamento",
  "50901.ctrl_ESS_Advanced_Config.System.grid_ct_reverse_enable.desc": "Descrizione Abilitazione Inversione Ta Rete",
  "50901.ctrl_ESS_Advanced_Config.System.grid_meter_ratio.desc": "Descrizione Impostazione Rapporto Spire Ta Rete",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.desc": "Descrizione Modello Contatore",
  "50901.ctrl_ESS_Advanced_Config.System.pv_ct_reverse_enable.desc": "Descrizione Abilitazione Inversione Ta Fotovoltaico",
  "50901.ctrl_ESS_Advanced_Config.System.pv_meter_ratio.desc": "Descrizione Impostazione Rapporto Spire Ta Fotovoltaico",
  "50901.fault.arcFault.00": "Disabilita",
  "50901.fault.arcFault.01": "Abilita",
  "50901.fault.arcSelfTestFault.00": "Disabilita",
  "50901.fault.arcSelfTestFault.01": "Abilita",
  "50901.fault.armCommunicationFault.00": "Disabilita",
  "50901.fault.armCommunicationFault.01": "Abilita",
  "50901.fault.auxiliaryPowerAbnormality.00": "Disabilita",
  "50901.fault.auxiliaryPowerAbnormality.01": "Abilita",
  "50901.Fault.batteryCapacityAbnormality.00": "Disabilita",
  "50901.Fault.batteryCapacityAbnormality.01": "Abilita",
  "50901.Fault.batteryFault.00": "Disabilita",
  "50901.Fault.batteryFault.01": "Abilita",
  "50901.Fault.batteryForceChargeRequest.00": "Disabilita",
  "50901.Fault.batteryForceChargeRequest.01": "Abilita",
  "50901.Fault.bmsCanCommunicationAbnormality.00": "Disabilita",
  "50901.Fault.bmsCanCommunicationAbnormality.01": "Abilita",
  "50901.fault.busbarAbnormality.00": "Disabilita",
  "50901.fault.busbarAbnormality.01": "Abilita",
  "50901.fault.cmpssBiasCalculationError.00": "Disabilita",
  "50901.fault.cmpssBiasCalculationError.01": "Abilita",
  "50901.fault.comparatorFault.00": "Disabilita",
  "50901.fault.comparatorFault.01": "Abilita",
  "50901.fault.driveAbnormality.00": "Disabilita",
  "50901.fault.driveAbnormality.01": "Abilita",
  "50901.Fault.dspPwrCommunicationAbnormality.00": "Disabilita",
  "50901.Fault.dspPwrCommunicationAbnormality.01": "Abilita",
  "50901.Fault.dspSafCommunicationAbnormality.00": "Disabilita",
  "50901.Fault.dspSafCommunicationAbnormality.01": "Abilita",
  "50901.Fault.dtsCommunicationAbnormality.00": "Disabilita",
  "50901.Fault.dtsCommunicationAbnormality.01": "Abilita",
  "50901.Fault.dtu1Rs485CommunicationAbnormality.00": "Disabilita",
  "50901.Fault.dtu1Rs485CommunicationAbnormality.01": "Abilita",
  "50901.Fault.dtu2Rs485CommunicationAbnormality.00": "Disabilita",
  "50901.Fault.dtu2Rs485CommunicationAbnormality.01": "Abilita",
  "50901.Fault.dtu3Rs485CommunicationAbnormality.00": "Disabilita",
  "50901.Fault.dtu3Rs485CommunicationAbnormality.01": "Abilita",
  "50901.Fault.dtu4Rs485CommunicationAbnormality.00": "Disabilita",
  "50901.Fault.dtu4Rs485CommunicationAbnormality.01": "Abilita",
  "50901.Fault.dtu5Rs485CommunicationAbnormality.00": "Disabilita",
  "50901.Fault.dtu5Rs485CommunicationAbnormality.01": "Abilita",
  "50901.fault.e2rpomFault.00": "Disabilita",
  "50901.fault.e2rpomFault.01": "Abilita",
  "50901.fault.emergencyStopSwitchStatus.00": "Disabilita",
  "50901.fault.emergencyStopSwitchStatus.01": "Abilita",
  "50901.fault.epsOverload.00": "Disabilita",
  "50901.fault.epsOverload.01": "Abilita",
  "50901.fault.epsRelayProtection.00": "Disabilita",
  "50901.fault.epsRelayProtection.01": "Abilita",
  "50901.fault.epsVoltageAbnormality.00": "Disabilita",
  "50901.fault.epsVoltageAbnormality.01": "Abilita",
  "50901.Fault.evCharger1CommunicationAbnormality.00": "Disabilita",
  "50901.Fault.evCharger1CommunicationAbnormality.01": "Abilita",
  "50901.Fault.evCharger1Fault.00": "Disabilita",
  "50901.Fault.evCharger1Fault.01": "Abilita",
  "50901.Fault.evCharger2CommunicationAbnormality.00": "Disabilita",
  "50901.Fault.evCharger2CommunicationAbnormality.01": "Abilita",
  "50901.Fault.evCharger2Fault.00": "Disabilita",
  "50901.Fault.evCharger2Fault.01": "Abilita",
  "50901.fault.fanFault.00": "Disabilita",
  "50901.fault.fanFault.01": "Abilita",
  "50901.Fault.fanSpeedAbnormality.00": "Disabilita",
  "50901.Fault.fanSpeedAbnormality.01": "Abilita",
  "50901.fault.fiveVoltPowerSupplyFault.00": "Disabilita",
  "50901.fault.fiveVoltPowerSupplyFault.01": "Abilita",
  "50901.fault.flashCommunicationFault.00": "Disabilita",
  "50901.fault.flashCommunicationFault.01": "Abilita",
  "50901.fault.frequencyVariationRateOutOfRange.00": "Disabilita",
  "50901.fault.frequencyVariationRateOutOfRange.01": "Abilita",
  "50901.fault.genAbnormality.00": "Disabilita",
  "50901.fault.genAbnormality.01": "Abilita",
  "50901.fault.genOverload.00": "Disabilita",
  "50901.fault.genOverload.01": "Abilita",
  "50901.fault.genPortOvercurrent.00": "Disabilita",
  "50901.fault.genPortOvercurrent.01": "Abilita",
  "50901.fault.genRelayAFault.00": "Disabilita",
  "50901.fault.genRelayAFault.01": "Abilita",
  "50901.fault.genRelayBFault.00": "Disabilita",
  "50901.fault.genRelayBFault.01": "Abilita",
  "50901.fault.gridCurrentDcOffsetOutOfRange.00": "Disabilita",
  "50901.fault.gridCurrentDcOffsetOutOfRange.01": "Abilita",
  "50901.fault.gridMeter.00": "Disabilita",
  "50901.fault.gridMeter.01": "Abilita",
  "50901.Fault.gridMeterCommunicationAbnormality.00": "Disabilita",
  "50901.Fault.gridMeterCommunicationAbnormality.01": "Abilita",
  "50901.Fault.gridMeterTypeError.00": "Disabilita",
  "50901.Fault.gridMeterTypeError.01": "Abilita",
  "50901.fault.gridOffVoltageDcOffsetOutOfRange.00": "Disabilita",
  "50901.fault.gridOffVoltageDcOffsetOutOfRange.01": "Abilita",
  "50901.fault.gridOverfrequency.00": "Disabilita",
  "50901.fault.gridOverfrequency.01": "Abilita",
  "50901.fault.gridOvervoltage.00": "Disabilita",
  "50901.fault.gridOvervoltage.01": "Abilita",
  "50901.fault.gridPortOvercurrent.00": "Disabilita",
  "50901.fault.gridPortOvercurrent.01": "Abilita",
  "50901.fault.gridPowerOutage.00": "Disabilita",
  "50901.fault.gridPowerOutage.01": "Abilita",
  "50901.fault.gridRelayProtection.00": "Disabilita",
  "50901.fault.gridRelayProtection.01": "Abilita",
  "50901.fault.gridUnderfrequency.00": "Disabilita",
  "50901.fault.gridUnderfrequency.01": "Abilita",
  "50901.fault.gridUndervoltage.00": "Disabilita",
  "50901.fault.gridUndervoltage.01": "Abilita",
  "50901.fault.gridVoltageAbnormality.00": "Disabilita",
  "50901.fault.gridVoltageAbnormality.01": "Abilita",
  "50901.Fault.hmidCommunicationAbnormality.00": "Disabilita",
  "50901.Fault.hmidCommunicationAbnormality.01": "Abilita",
  "50901.Fault.hmidMachineFault.00": "Disabilita",
  "50901.Fault.hmidMachineFault.01": "Abilita",
  "50901.fault.insulationFault.00": "Disabilita",
  "50901.fault.insulationFault.01": "Abilita",
  "50901.fault.interruptOverflow.00": "Disabilita",
  "50901.fault.interruptOverflow.01": "Abilita",
  "50901.fault.inverterCanCommunicationFailed.00": "Disabilita",
  "50901.fault.inverterCanCommunicationFailed.01": "Abilita",
  "50901.fault.inverterCommunicationFailed.00": "Disabilita",
  "50901.fault.inverterCommunicationFailed.01": "Abilita",
  "50901.fault.kmRelayFault.00": "Disabilita",
  "50901.fault.kmRelayFault.01": "Abilita",
  "50901.fault.lineToEarthFault.00": "Disabilita",
  "50901.fault.lineToEarthFault.01": "Abilita",
  "50901.fault.loadRelayAFault.00": "Disabilita",
  "50901.fault.loadRelayAFault.01": "Abilita",
  "50901.fault.loadRelayBFault.00": "Disabilita",
  "50901.fault.loadRelayBFault.01": "Abilita",
  "50901.fault.lowAmbientTemperature.00": "Disabilita",
  "50901.fault.lowAmbientTemperature.01": "Abilita",
  "50901.Fault.lowDtuVersion.00": "Disabilita",
  "50901.Fault.lowDtuVersion.01": "Abilita",
  "50901.fault.machineTypeMismatch.00": "Disabilita",
  "50901.fault.machineTypeMismatch.01": "Abilita",
  "50901.Fault.masterSlaveCommunicationAbnormality.00": "Disabilita",
  "50901.Fault.masterSlaveCommunicationAbnormality.01": "Abilita",
  "50901.fault.meterWiringAbnormality.00": "Disabilita",
  "50901.fault.meterWiringAbnormality.01": "Abilita",
  "50901.fault.microelectronicFault.00": "Disabilita",
  "50901.fault.microelectronicFault.01": "Abilita",
  "50901.fault.neutralWireNotConnected.00": "Disabilita",
  "50901.fault.neutralWireNotConnected.01": "Abilita",
  "50901.fault.neutralWireToEarthFault.00": "Disabilita",
  "50901.fault.neutralWireToEarthFault.01": "Abilita",
  "50901.fault.overTemperature.00": "Disabilita",
  "50901.fault.overTemperature.01": "Abilita",
  "50901.fault.overtemperatureAlarm.00": "Disabilita",
  "50901.fault.overtemperatureAlarm.01": "Abilita",
  "50901.fault.pllLockFailed.00": "Disabilita",
  "50901.fault.pllLockFailed.01": "Abilita",
  "50901.fault.preSynchronizationFailed.00": "Disabilita",
  "50901.fault.preSynchronizationFailed.01": "Abilita",
  "50901.fault.pvFault.00": "Disabilita",
  "50901.fault.pvFault.01": "Abilita",
  "50901.Fault.pvMeterCommunicationAbnormality.00": "Disabilita",
  "50901.Fault.pvMeterCommunicationAbnormality.01": "Abilita",
  "50901.Fault.pvMeterTypeError.00": "Disabilita",
  "50901.Fault.pvMeterTypeError.01": "Abilita",
  "50901.fault.pvPortOvercurrent.00": "Disabilita",
  "50901.fault.pvPortOvercurrent.01": "Abilita",
  "50901.fault.pvRelayAbFault.00": "Disabilita",
  "50901.fault.pvRelayAbFault.01": "Abilita",
  "50901.fault.pvVoltageExceedingBusVoltage.00": "Disabilita",
  "50901.fault.pvVoltageExceedingBusVoltage.01": "Abilita",
  "50901.fault.rcdFault.00": "Disabilita",
  "50901.fault.rcdFault.01": "Abilita",
  "50901.fault.rcdSelfTestFault.00": "Disabilita",
  "50901.fault.rcdSelfTestFault.01": "Abilita",
  "50901.fault.reconnectionFailed.00": "Disabilita",
  "50901.fault.reconnectionFailed.01": "Abilita",
  "50901.fault.samplingBiasAbnormality.00": "Disabilita",
  "50901.fault.samplingBiasAbnormality.01": "Abilita",
  "50901.fault.shutDown.00": "Disabilita",
  "50901.fault.shutDown.01": "Abilita",
  "50901.Fault.slaveWrongBatteryConnection.00": "Disabilita",
  "50901.Fault.slaveWrongBatteryConnection.01": "Abilita",
  "50901.fault.smartloadPortOvercurrent.00": "Disabilita",
  "50901.fault.smartloadPortOvercurrent.01": "Abilita",
  "50901.fault.spiCommunicationFault.00": "Disabilita",
  "50901.fault.spiCommunicationFault.01": "Abilita",
  "50901.Fault.sustainedNegativeLoad.00": "Disabilita",
  "50901.Fault.sustainedNegativeLoad.01": "Abilita",
  "50901.fault.temperatureAbnormality.00": "Disabilita",
  "50901.fault.temperatureAbnormality.01": "Abilita",
  "50901.fault.tenMinuteOvervoltage.00": "Disabilita",
  "50901.fault.tenMinuteOvervoltage.01": "Abilita",
  "50901.fault.threePointThreeVoltPowerSupplyFault.00": "Disabilita",
  "50901.fault.threePointThreeVoltPowerSupplyFault.01": "Abilita",
  "50901.fault.twelveVoltPowerSupplyFault.00": "Disabilita",
  "50901.fault.twelveVoltPowerSupplyFault.01": "Abilita",
  "50901.fault.versionMismatch.00": "Disabilita",
  "50901.fault.versionMismatch.01": "Abilita",
  "50901.fault.wiringAbnormality.00": "Disabilita",
  "50901.fault.wiringAbnormality.01": "Abilita",
  "50901.real_time.relayStatus.02": "Alimentazione Generatore A",
  "50901.real_time.relayStatus.03": "Alimentazione Generatore A",
  "50901.real_time.relayStatus.04": "Alimentazione Generatore B",
  "50901.real_time.relayStatus.05": "Alimentazione Generatore B",
  "50901.real_time.relayStatus.06": "Alimentazione Generatore Ab",
  "50901.real_time.relayStatus.07": "Alimentazione Generatore Ab",
  "50901.real_time.relayStatus.08": "Alimentazione Carico Critico A",
  "50901.real_time.relayStatus.09": "Alimentazione Carico Critico A",
  "50901.real_time.relayStatus.10": "Alimentazione Carico Critico B",
  "50901.real_time.relayStatus.14": "Riservato",
  "50901.real_time.relayStatus.15": "Riservato",
  "50901.warning.batteryHighVoltageAlarm.00": "Disabilita",
  "50901.warning.batteryHighVoltageAlarm.01": "Abilita",
  "50901.warning.batteryLowVoltageAlarm.00": "Disabilita",
  "50901.warning.batteryLowVoltageAlarm.01": "Abilita",
  "50901.warning.batteryPackChargeHighVoltageAlarm.00": "Disabilita",
  "50901.warning.batteryPackChargeHighVoltageAlarm.01": "Abilita",
  "50901.warning.batteryPackDischargeLowVoltageAlarm.00": "Disabilita",
  "50901.warning.batteryPackDischargeLowVoltageAlarm.01": "Abilita",
  "50901.warning.canCommunicationTimeout.00": "Disabilita",
  "50901.warning.canCommunicationTimeout.01": "Abilita",
  "50901.warning.chargeHighTemperatureAlarm.00": "Disabilita",
  "50901.warning.chargeHighTemperatureAlarm.01": "Abilita",
  "50901.warning.chargeLowTemperatureAlarm.00": "Disabilita",
  "50901.warning.chargeLowTemperatureAlarm.01": "Abilita",
  "50901.warning.dischargeHighTemperatureAlarm.00": "Disabilita",
  "50901.warning.dischargeHighTemperatureAlarm.01": "Abilita",
  "50901.warning.dischargeLowTemperatureAlarm.00": "Disabilita",
  "50901.warning.dischargeLowTemperatureAlarm.01": "Abilita",
  "50901.warning.hardwareProtection.00": "Disabilita",
  "50901.warning.hardwareProtection.01": "Abilita",
  "50901.warning.inputOvervoltageAlarm.00": "Disabilita",
  "50901.warning.inputOvervoltageAlarm.01": "Abilita",
  "50901.warning.lowBatteryEnergy.00": "Disabilita",
  "50901.warning.lowBatteryEnergy.01": "Abilita",
  "50901..connectionRouterStatus.0": "Non Connesso",
  "50901..connectionRouterStatus.1": "Connesso",
  "50901..connectionRouterStatus.3": "Non Connesso",
  "50901..connectionServerStatus.0": "Non Connesso",
  "50901..connectionServerStatus.1": "Connesso",
  "50901..connectionServerStatus.2": "Connesso",
  "50901..connectionServerStatus.3": "Non Connesso",
  "50901.ctrl_Config.Battery.equalizationEnable.0": "No",
  "50901.ctrl_Config.Battery.equalizationEnable.1": "Sì",
  "50901.ctrl_Config.Connection.dtu_comm_enable.0": "Disabilita",
  "50901.ctrl_Config.Connection.dtu_comm_enable.1": "Abilita",
  "50901.ctrl_Config.Device.arcFaultClear.0": "No",
  "50901.ctrl_Config.Device.arcFaultClear.1": "Sì",
  "50901.ctrl_Config.Device.batActivate.0": "No",
  "50901.ctrl_Config.Device.batActivate.1": "Sì",
  "50901.ctrl_Config.Device.batteryBalancing.0": "No",
  "50901.ctrl_Config.Device.batteryBalancing.1": "Sì",
  "50901.ctrl_Config.Device.clearFault.0": "No",
  "50901.ctrl_Config.Device.clearFault.1": "Sì",
  "50901.ctrl_Config.Device.masterSlave.0": "Singola Unità",
  "50901.ctrl_Config.Device.masterSlave.1": "Master",
  "50901.ctrl_Config.Device.masterSlave.2": "Slave",
  "50901.ctrl_Config.Device.parallelNetworking.0": "Non valido",
  "50901.ctrl_Config.Device.parallelNetworking.1": "In creazione rete",
  "50901.ctrl_Config.Device.parallelNetworking.2": "Sciogli rete",
  "50901.ctrl_Config.Device.restartSystem.0": "No",
  "50901.ctrl_Config.Device.restartSystem.1": "Sì",
  "50901.ctrl_Config.Device.restoreDefault.0": "No",
  "50901.ctrl_Config.Device.restoreDefault.1": "Sì",
  "50901.ctrl_Config.Device.selfTest.0": "No",
  "50901.ctrl_Config.Device.selfTest.1": "Sì",
  "50901.ctrl_Config.Device.systemPowerOnOff.0": "Ferma Sistema",
  "50901.ctrl_Config.Device.systemPowerOnOff.1": "Avvia Sistema",
  "50901.ctrl_Dry_Contact.Generator.generatorMode.0": "Off",
  "50901.ctrl_Dry_Contact.Generator.generatorMode.1": "Manuale",
  "50901.ctrl_Dry_Contact.Generator.generatorMode.2": "Automatico",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.0": "Nessuno",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.1": "Settimanale",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.2": "Ogni 2 Settimane",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.3": "Ogni 3 Settimane",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.4": "Ogni 4 Settimane",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeEn.0": "No",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeEn.1": "Sì",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek.0": "Disabilita",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek.1": "Abilita",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.1": "Manuale",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.2": "Modalità Oraria",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.3": "Carico Intelligente",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.4": "Carico Intelligente Off-Grid",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.5": "Colonnina Ricarica Ev",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange1.0": "Disabilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange1.1": "Abilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange2.0": "Disabilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange2.1": "Abilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange3.0": "Disabilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange3.1": "Abilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange4.0": "Disabilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange4.1": "Abilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange5.0": "Disabilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange5.1": "Abilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange6.0": "Disabilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange6.1": "Abilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange7.0": "Disabilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange7.1": "Abilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.manualModeSwitch.0": "No",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.manualModeSwitch.1": "Sì",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange20.0": "Disabilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange20.1": "Abilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange21.0": "Disabilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange21.1": "Abilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange22.0": "Disabilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange22.1": "Abilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange23.0": "Disabilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange23.1": "Abilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange24.0": "Disabilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange24.1": "Abilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange25.0": "Disabilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange25.1": "Abilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange26.0": "Disabilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange26.1": "Abilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange1.0": "Disabilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange1.1": "Abilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange2.0": "Disabilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange2.1": "Abilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange3.0": "Disabilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange3.1": "Abilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange4.0": "Disabilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange4.1": "Abilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange5.0": "Disabilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange5.1": "Abilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange6.0": "Disabilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange6.1": "Abilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange7.0": "Disabilita",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange7.1": "Abilita",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.0": "Nessuno",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.1": "Guasto A Terra",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.2": "Controllo Carico",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.3": "Generatore",
  "50901.ctrl_ESS_Advanced_Config.EPS.bypassDisable.0": "No",
  "50901.ctrl_ESS_Advanced_Config.EPS.bypassDisable.1": "Sì",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode.0": "Disabilitato",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode.1": "Alimentazione Emergenza",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode.2": "Gruppo Continuità",
  "50901.ctrl_ESS_Advanced_Config.EPS.pvIslandModeEn.0": "No",
  "50901.ctrl_ESS_Advanced_Config.EPS.pvIslandModeEn.1": "Sì",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.0": "Lunedì",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.1": "Martedì",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.2": "Mercoledì",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.3": "Giovedì",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.4": "Venerdì",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.5": "Sabato",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.6": "Domenica",
  "50901.ctrl_WorkMode.economic.section1WeekRange2.00": "Descrizione valore enum 0",
  "50901.ctrl_WorkMode.economic.section1WeekRange2.01": "Descrizione valore enum 1",
  "50901.ctrl_WorkMode.economic.section2WeekRange1.00": "Descrizione valore enum 0",
  "50901.ctrl_WorkMode.economic.section2WeekRange1.01": "Descrizione valore enum 2",
  "50901.ctrl_WorkMode.economic.section3WeekRange1.00": "Descrizione valore enum 0",
  "50901.ctrl_WorkMode.economic.section3WeekRange1.01": "Descrizione valore enum 2",
  "50901.ctrl_WorkMode.economic.section3WeekRange2.00": "Descrizione valore enum 0",
  "50901.ctrl_WorkMode.economic.section3WeekRange2.01": "Descrizione valore enum 1",
  "50901.ctrl_WorkMode.economic.section4WeekRange1.00": "Descrizione valore enum 0",
  "50901.ctrl_WorkMode.economic.section4WeekRange1.01": "Descrizione valore enum 2",
  "50901.ctrl_WorkMode.economic.section4WeekRange2.00": "Descrizione valore enum 0",
  "50901.ctrl_WorkMode.economic.section4WeekRange2.01": "Descrizione valore enum 1",
  "50901.real_time.batteryConnectionStatus.00": "No",
  "50901.real_time.batteryConnectionStatus.01": "Sì",
  "50901.real_time.BatteryModel.10": "Xin Yi Lv",
  "50901.real_time.BatteryModel.11": "Vestwoods Lv",
  "50901.real_time.BatteryModel.12": "Jk Hv",
  "50901.real_time.BatteryModel.13": "Byd Lv",
  "50901.real_time.BatteryModel.14": "Uz Hv",
  "50901.real_time.BatteryModel.15": "Zetara Lv",
  "50901.real_time.BatteryModel.16": "Feb Hv",
  "50901.real_time.BatteryModel.17": "Pytes Lv",
  "50901.real_time.BatteryModel.18": "Dmegc Lv",
  "50901.real_time.BatteryModel.19": "Weineng Lv",
  "50901.real_time.BatteryModel.2": "Pylon Hv",
  "50901.real_time.BatteryModel.20": "Weineng Hv",
  "50901.real_time.BatteryModel.21": "Gsl Lv",
  "50901.real_time.BatteryModel.22": "Hoy Lv",
  "50901.real_time.BatteryModel.23": "Hoy Hv",
  "50901.real_time.BatteryModel.24": "Feb Lv",
  "50901.real_time.BatteryModel.25": "Uhhome Lv",
  "50901.real_time.BatteryModel.26": "Uhhome Hv",
  "50901.real_time.BatteryModel.27": "Byd Hv",
  "50901.real_time.BatteryModel.28": "Vestwoods Hv",
  "50901.real_time.BatteryModel.29": "Phylion Hv",
  "50901.real_time.BatteryModel.3": "Dyness Lv",
  "50901.real_time.BatteryModel.30": "Hoymiles Lv",
  "50901.real_time.BatteryModel.31": "Pholion Lv",
  "50901.real_time.BatteryModel.32": "Wattsonic Lv",
  "50901.real_time.BatteryModel.33": "Enershare Hv",
  "50901.real_time.BatteryModel.34": "Beghelli Lv",
  "50901.real_time.BatteryModel.35": "Lvtopsun Lv",
  "50901.real_time.BatteryModel.36": "Pytes Hv",
  "50901.real_time.BatteryModel.37": "Lvtopsun Hv",
  "50901.real_time.BatteryModel.38": "Raja Hv",
  "50901.real_time.BatteryModel.39": "Felicity Lv",
  "50901.real_time.BatteryModel.4": "Dyness Hv",
  "50901.real_time.BatteryModel.5": "Sunwoda Lv",
  "50901.real_time.BatteryModel.6": "Uz Lv",
  "50901.real_time.BatteryModel.7": "Soluna Hv",
  "50901.real_time.BatteryModel.8": "Soluna Lv",
  "50901.real_time.BatteryModel.9": "Steltec Lv",
  "50901.real_time.batteryType_04.00": "Nessuna batteria",
  "50901.real_time.batteryType_04.01": "Batteria al litio",
  "50901.real_time.batteryType_04.02": "Batteria al piombo",
  "50901.real_time.batteryWorkingStatus.00": "Standby",
  "50901.real_time.batteryWorkingStatus.01": "In Carica",
  "50901.real_time.batteryWorkingStatus.02": "In Scarica",
  "50901.real_time.cfgMultPcsBmsFlag.00": "No",
  "50901.real_time.cfgMultPcsBmsFlag.01": "Sì",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.00": "Limite Potenza Rimosso, Modalità Predefinita",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.01": "Potenza Inverter 0, Off-Grid",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.02": "Potenza Carica Pc=0, Non Off-Grid",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.03": "Potenza Carica Pc<50%Pn Potenza Nominale",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.04": "Potenza Carica Pc<75%Pn Potenza Nominale && Potenza Reattiva Q=Qmax ±4%",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.05": "Potenza Carica Pc, Nessun Limite",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.06": "Potenza Scarica P=0, Non Off-Grid",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.07": "Potenza Scarica P<50%Pn Potenza Nominale",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.08": "Potenza Scarica P<75%Pn Potenza Nominale && Q= -Qmax±4%",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.09": "Potenza Scarica P, Nessun Limite",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.10": "Potenza Carica Pc<50%Pn Potenza Nominale --> Potenza Carica Ridotta A 0",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.11": "Potenza Carica Pc<50%Pn Potenza Nominale && Q=Qmax",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.12": "Potenza Scarica P<50%Pn Potenza Nominale --> Potenza Scarica Ridotta A 0",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.13": "Potenza Carica Pc<50%Pn Potenza Nominale && Q=-Qmax",
  "50901.real_time.materType.0": "Nessun contatore di rete",
  "50901.real_time.materType.1": "CHINT monofase",
  "50901.real_time.materType.2": "CHINT monofase",
  "50901.real_time.materType.3": "CHINT bifase",
  "50901.real_time.materType.5": "Modulo di misura",
  "50901.real_time.materType.6": "Acrel singolo circuito",
  "50901.real_time.materType.7": "Acrel doppio circuito",
  "50901.real_time.meterFlag.0": "Offline",
  "50901.real_time.meterFlag.1": "Online",
  "50901.real_time.meterFlag.3": "Comunicazione Gateway Normale",
  "50901.real_time.meterFlag.4": "Comunicazione Gateway Disconnessa",
  "50901.real_time.relayStatus.00": "Alimentazione Km1",
  "50901.real_time.relayStatus.01": "Alimentazione Km1",
  "50901.real_time.relayStatus.11": "Alimentazione Carico Critico B",
  "50901.real_time.relayStatus.12": "Riservato",
  "50901.real_time.relayStatus.13": "Riservato",
  "50901.real_time.workStatus.00": "Inizializzazione Alimentazione",
  "50901.real_time.workStatus.01": "Modalità Standby",
  "50901.real_time.workStatus.02": "Test Connessione Rete",
  "50901.real_time.workStatus.03": "Modalità Connessa Alla Rete",
  "50901.real_time.workStatus.04": "Modalità Guasto",
  "50901.real_time.workStatus.05": "Modalità Off-Grid",
  "50901.real_time.workStatus.06": "Modalità Bypass",
  "50901..antiIslandingEnable.0": "Disabilita",
  "50901..antiIslandingEnable.1": "Abilita",
  "50901..apcEn.0": "Disabilita",
  "50901..apcEn.1": "Abilita",
  "50901..drmEnable.0": "Disabilita",
  "50901..drmEnable.1": "Abilita",
  "50901..permitEnable.0": "Disabilita",
  "50901..permitEnable.1": "Abilita",
  "50901..phaseOrderInverseDisable.00": "Disabilita",
  "50901..phaseOrderInverseDisable.01": "Abilita",
  "50901..relayU16NlineRlyTestDis.00": "Disabilita",
  "50901..relayU16NlineRlyTestDis.01": "Abilita",
  "50901.ctrl_Config.Device.checkTime": "Ora Dispositivo",
  "50901.ctrl_Config.Device.networkingType": "Tipo Connessione Rete",
  "50901.ctrl_Config.Grid Profile.country.1": "En_En50549 (Predefinito)",
  "50901.ctrl_Config.Grid Profile.country.18": "USHECO_Rule14 (Hawaii)",
  "50901.ctrl_Config.Grid Profile.country.27": "Ieee1547_208 (Usa)",
  "50901.ctrl_Config.Grid Profile.country.29": "LX_US_50HZ (USA TEST)",
  "50901.ctrl_Config.Grid Profile.country.30": "Ieee1547_220 (Usa)",
  "50901.ctrl_Config.Grid Profile.country.44": "Us_Miso_208V (Usa)",
  "50901.ctrl_Config.Grid Profile.country.45": "Us_Miso_240V (Usa)",
  "50901.ctrl_Config.Grid Profile.country.9": "Us_Ieee1547 (Usa)",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.chargingPileRatedCurrent": "Corrente Nominale Colonnina Ricarica",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.homeInletBreakerRatedCurrent": "Corrente Nominale Interruttore Principale",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatterySocEnable": "Abilita Soc Batteria Modalità Programmata",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatteryStartSoc": "Soc Avvio Batteria Modalità Programmata",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatteryStopSoc": "Soc Spegnimento Batteria Modalità Programmata",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.0": "Proibito",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.1": "Fv Esterno",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.2": "Generatore Esterno",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.3": "Avvio Forzato",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.4": "Controllo Locale",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position.0": "Nessuno",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position.1": "Lato Generatore",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position.2": "Lato Rete",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_type.0": "Manuale",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_type.1": "Di/Do",
  "50901.ctrl_ESS_Advanced_Config.PV.mppt_global_scan_enable.0": "Disabilita",
  "50901.ctrl_ESS_Advanced_Config.PV.mppt_global_scan_enable.1": "Abilita",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.0": "Nessun Contatore Usato",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.1": "Contatore Monofase",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.2": "Contatore Bifase",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.3": "Contatore Trifase",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.4": "Contatore Intelligente (Hmid)",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.5": "Trasformatore Di Corrente (Ta)",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.6": "Acrel Contatore Monofase",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.7": "Acrel Contatore Bifase",
  "50901.ctrl_ESS_Advanced_Config.System.mid_gateway_enable.0": "Disabilita",
  "50901.ctrl_ESS_Advanced_Config.System.mid_gateway_enable.1": "Abilita",
  "50901.ctrl_ESS_Advanced_Config.System.threePhaseUnbalanceEnable.0": "Disabilita",
  "50901.ctrl_ESS_Advanced_Config.System.threePhaseUnbalanceEnable.1": "Abilita",
  "50901.ctrl_Safety.DCI.dciEnable.0": "Disabilita",
  "50901.ctrl_Safety.DCI.dciEnable.1": "Abilita",
  "50901.ctrl_Safety.FW.fwDiffInBatMode.0": "Disabilita",
  "50901.ctrl_Safety.FW.fwDiffInBatMode.1": "Abilita",
  "50901.ctrl_Safety.FW.fwEnable.0": "Disabilita",
  "50901.ctrl_Safety.FW.fwEnable.1": "Abilita",
  "50901.ctrl_Safety.RCD.rcdEnable.0": "Disabilita",
  "50901.ctrl_Safety.RCD.rcdEnable.1": "Abilita",
  "50901.ctrl_Safety.RPC.gcfEn.0": "Disabilita",
  "50901.ctrl_Safety.RPC.gcfEn.1": "Abilita",
  "50901.ctrl_Safety.RPC.rpcMode.00": "Disabilita",
  "50901.ctrl_Safety.RPC.rpcMode.01": "Fattore di potenza fisso, modalità PF",
  "50901.ctrl_Safety.RPC.rpcMode.02": "Potenza reattiva fissa, modalità Q",
  "50901.ctrl_Safety.RPC.rpcMode.03": "Curva PF(P), modalità PF(P)",
  "50901.ctrl_Safety.RPC.rpcMode.04": "W",
  "50901.ctrl_Safety.RPC.rpcMode.05": "PQ",
  "50901.ctrl_Safety.VRT.vrtEn.0": "Disabilita",
  "50901.ctrl_Safety.VRT.vrtEn.1": "Abilita",
  "50901.ctrl_Safety.VW.vwDiffInBatMode.0": "Disabilita",
  "50901.ctrl_Safety.VW.vwDiffInBatMode.1": "Abilita",
  "50901.ctrl_Safety.VW.vwEnable.0": "Disabilita",
  "50901.ctrl_Safety.VW.vwEnable.1": "Abilita",
  "50901.ctrl_WorkMode.TOU.touModeReserveSoc": "Soc Riservato Modalità Tou",
  "50901.fault.arcFault": "Guasto arco",
  "50901.fault.arcSelfTestFault": "Errore autotest arco",
  "50901.fault.armCommunicationFault": "Guasto comunicazione ARM",
  "50901.fault.auxiliaryPowerAbnormality": "Alimentazione ausiliaria anomala",
  "50901.Fault.batteryCapacityAbnormality": "Capacità Batteria Anomala",
  "50901.Fault.batteryFault": "Guasto batteria",
  "50901.Fault.batteryForceChargeRequest": "Richiesta Carica Forzata Batteria",
  "50901.Fault.bmsCanCommunicationAbnormality": "Comunicazione Can Bms Anomala",
  "50901.fault.busbarAbnormality": "Bus CC anomalo",
  "50901.fault.cmpssBiasCalculationError": "Errore calcolo offset CMPSS",
  "50901.fault.comparatorFault": "Guasto comparatore",
  "50901.fault.driveAbnormality": "Pilotaggio anomalo",
  "50901.Fault.dspPwrCommunicationAbnormality": "Comunicazione Alimentazione Dsp Anomala",
  "50901.Fault.dspSafCommunicationAbnormality": "Comunicazione Sicura Dsp Anomala",
  "50901.Fault.dtsCommunicationAbnormality": "Comunicazione Dts Anomala",
  "50901.Fault.dtu1Rs485CommunicationAbnormality": "Comunicazione Dtu1 Rs485 Anomala",
  "50901.Fault.dtu2Rs485CommunicationAbnormality": "Comunicazione Dtu2 Rs485 Anomala",
  "50901.Fault.dtu3Rs485CommunicationAbnormality": "Comunicazione Dtu3 Rs485 Anomala",
  "50901.Fault.dtu4Rs485CommunicationAbnormality": "Comunicazione Dtu4 Rs485 Anomala",
  "50901.Fault.dtu5Rs485CommunicationAbnormality": "Comunicazione Dtu5 Rs485 Anomala",
  "50901.fault.e2rpomFault": "Guasto EEPROM",
  "50901.fault.emergencyStopSwitchStatus": "Arresto Emergenza",
  "50901.fault.epsOverload": "Sovraccarico EPS",
  "50901.fault.epsRelayProtection": "Protezione relè EPS",
  "50901.fault.epsVoltageAbnormality": "Tensione EPS anomala",
  "50901.Fault.evCharger1CommunicationAbnormality": "Comunicazione Colonnina Ricarica Ev 1 Anomala",
  "50901.Fault.evCharger1Fault": "Guasto Colonnina Ricarica 1",
  "50901.Fault.evCharger2CommunicationAbnormality": "Comunicazione Colonnina Ricarica Ev 2 Anomala",
  "50901.Fault.evCharger2Fault": "Guasto Colonnina Ricarica 2",
  "50901.fault.fanFault": "Guasto ventola",
  "50901.Fault.fanSpeedAbnormality": "Velocità Ventola Anomala",
  "50901.fault.fiveVoltPowerSupplyFault": "Guasto Alimentazione 5V",
  "50901.fault.flashCommunicationFault": "Guasto comunicazione flash",
  "50901.fault.frequencyVariationRateOutOfRange": "Superamento limite velocità variazione frequenza",
  "50901.fault.genAbnormality": "Generatore anomalo",
  "50901.fault.genOverload": "Sovraccarico generatore",
  "50901.fault.genPortOvercurrent": "Sovracorrente Porta Generatore",
  "50901.fault.genRelayAFault": "Guasto Relè A Generatore",
  "50901.fault.genRelayBFault": "Guasto Relè B Generatore",
  "50901.fault.gridCurrentDcOffsetOutOfRange": "Superamento limite offset CC corrente rete",
  "50901.fault.gridMeter": "Errore Comunicazione Contatore Di Rete",
  "50901.Fault.gridMeterCommunicationAbnormality": "Comunicazione Contatore Di Rete Anomala",
  "50901.Fault.gridMeterTypeError": "Errore Tipo Contatore Di Rete",
  "50901.fault.gridOffVoltageDcOffsetOutOfRange": "Superamento limite offset CC tensione off-grid",
  "50901.fault.gridOverfrequency": "Sovrafrequenza rete",
  "50901.fault.gridOvervoltage": "Sovratensione rete",
  "50901.fault.gridPortOvercurrent": "Sovracorrente Porta Rete",
  "50901.fault.gridPowerOutage": "Mancanza rete",
  "50901.fault.gridRelayProtection": "Protezione relè rete",
  "50901.fault.gridUnderfrequency": "Sottofrequenza rete",
  "50901.fault.gridUndervoltage": "Sottotensione rete",
  "50901.fault.gridVoltageAbnormality": "Tensione rete anomala",
  "50901.Fault.hmidCommunicationAbnormality": "Comunicazione Interfaccia Utente Anomala",
  "50901.Fault.hmidMachineFault": "Guasto Dispositivo Interfaccia Utente",
  "50901.fault.insulationFault": "Guasto isolamento",
  "50901.fault.interruptOverflow": "Overflow interrupt",
  "50901.fault.inverterCanCommunicationFailed": "Errore Comunicazione Can Inverter",
  "50901.fault.inverterCommunicationFailed": "Errore Comunicazione Inverter",
  "50901.fault.kmRelayFault": "Guasto Relè Km",
  "50901.fault.lineToEarthFault": "Guasto verso terra (fase-terra)",
  "50901.fault.loadRelayAFault": "Guasto Relè Carico A",
  "50901.fault.loadRelayBFault": "Guasto Relè Carico B",
  "50901.fault.lowAmbientTemperature": "Temperatura ambiente troppo bassa",
  "50901.Fault.lowDtuVersion": "Versione Dtu Troppo Bassa",
  "50901.fault.machineTypeMismatch": "Modello non corrispondente",
  "50901.Fault.masterSlaveCommunicationAbnormality": "Comunicazione Master-Slave Anomala",
  "50901.fault.meterWiringAbnormality": "Cablaggio contatore anomalo",
  "50901.fault.microelectronicFault": "Guasto microelettronico",
  "50901.fault.neutralWireNotConnected": "Neutro non collegato",
  "50901.fault.neutralWireToEarthFault": "Guasto neutro-terra",
  "50901.fault.overTemperature": "Sovratemperatura",
  "50901.fault.overtemperatureAlarm": "Allarme Surriscaldamento",
  "50901.fault.pllLockFailed": "Errore aggancio PLL",
  "50901.fault.preSynchronizationFailed": "Errore presincronizzazione",
  "50901.fault.pvFault": "Guasto FV",
  "50901.Fault.pvMeterCommunicationAbnormality": "Comunicazione Contatore Fv Anomala",
  "50901.Fault.pvMeterTypeError": "Errore Tipo Contatore Fv",
  "50901.fault.pvPortOvercurrent": "Sovracorrente Porta Fv",
  "50901.fault.pvRelayAbFault": "Guasto Relè Ab Fv",
  "50901.fault.pvVoltageExceedingBusVoltage": "Tensione FV supera tensione bus",
  "50901.fault.rcdFault": "Guasto interruttore differenziale",
  "50901.fault.rcdSelfTestFault": "Errore autotest interruttore differenziale",
  "50901.fault.reconnectionFailed": "Errore riconnessione",
  "50901.fault.samplingBiasAbnormality": "Offset campionamento anomalo",
  "50901.fault.shutDown": "Spegnimento sistema",
  "50901.Fault.slaveWrongBatteryConnection": "Errore Connessione Batteria Slave",
  "50901.fault.smartloadPortOvercurrent": "Sovracorrente Porta Carico Intelligente",
  "50901.fault.spiCommunicationFault": "Guasto comunicazione SPI",
  "50901.Fault.sustainedNegativeLoad": "Carico Negativo Persistente",
  "50901.fault.temperatureAbnormality": "Temperatura anomala",
  "50901.fault.tenMinuteOvervoltage": "Sovratensione 10 minuti",
  "50901.fault.threePointThreeVoltPowerSupplyFault": "Guasto Alimentazione 3.3V",
  "50901.fault.twelveVoltPowerSupplyFault": "Guasto Alimentazione 12V",
  "50901.fault.versionMismatch": "Mancata corrispondenza versione",
  "50901.fault.wiringAbnormality": "Cablaggio anomalo",
  "50901.otaHttpUrl.otaHttpUrl": "Comando aggiornamento",
  "50901.real_time.12vAuxiliaryVoltageSampling": "Campionamento Tensione Ausiliaria 12V",
  "50901.real_time.12vOutputVoltageSampling": "Campionamento Tensione Uscita 12V",
  "50901.real_time.3_3vAuxiliaryVoltageSampling": "Campionamento Tensione Ausiliaria 3.3V",
  "50901.real_time.5vAuxiliaryVoltageSampling": "Campionamento Tensione Ausiliaria 5V",
  "50901.real_time.ambientTemperatureSampling": "Campionamento Temperatura Ambiente",
  "50901.real_time.appSoftwareVersion": "Versione Software App",
  "50901.real_time.batteryDailyChargeEnergy": "Capacità Di Carica Giornaliera Batteria",
  "50901.real_time.batteryDailyDischargeEnergy": "Capacità Di Scarica Giornaliera Batteria",
  "50901.real_time.batteryModuleNum": "Numero celle in serie (per modulo)",
  "50901.real_time.batteryPowerWholeSystem": "Potenza totale batteria (intero sistema)",
  "50901.real_time.batteryToLoadPower": "Potenza batteria verso carico",
  "50901.real_time.bootSoftwareVersion": "Versione Software Bootloader",
  "50901.real_time.communicationStickHardwareVersion": "Versione Hardware Chiavetta Comunicazione",
  "50901.real_time.communicationStickSn": "Sn Chiavetta Comunicazione",
  "50901.real_time.communicationStickSoftwareVersion": "Versione software chiavetta comunicazione",
  "50901.real_time.copy_dspVersionMainUVersion": "Versione Dsp (Versione U Principale)",
  "50901.real_time.dailyBatteryToLoadEnergy": "Energia oggi batteria verso carico",
  "50901.real_time.dailyExportEnergyToGrid": "Energia venduta oggi",
  "50901.real_time.dailyGridToLoadEnergy": "Energia oggi rete verso carico",
  "50901.real_time.dailyImportEnergyFromGrid": "Energia acquistata oggi",
  "50901.real_time.dailyPvToBatteryEnegry": "Energia oggi FV verso batteria",
  "50901.real_time.dailyPvToGridEnegry": "Energia oggi FV verso rete",
  "50901.real_time.dailyPvToLoadEnegry": "Energia oggi FV verso carico",
  "50901.real_time.dTSReset": "Reset Data Stick",
  "50901.real_time.firmwareBuildTimeDateHour": "Data/Ora Costruzione Firmware (Giorno/Ora)",
  "50901.real_time.firmwareBuildTimeYearMonth": "Mese/Anno Costruzione Firmware",
  "50901.real_time.firmwareCrc": "Crc Firmware",
  "50901.real_time.firmwareEndAddressHigh": "Indirizzo Fine Firmware (Alto)",
  "50901.real_time.firmwareEndAddressLow": "Indirizzo Fine Firmware (Basso)",
  "50901.real_time.firmwareInformationCrc": "Crc Informazioni Firmware",
  "50901.real_time.firmwareStartAddressHigh": "Indirizzo Inizio Firmware (Alto)",
  "50901.real_time.firmwareStartAddressLow": "Indirizzo Inizio Firmware (Basso)",
  "50901.real_time.generatorDailyYield": "Produzione giornaliera generatore",
  "50901.real_time.generatorPower": "Potenza Generatore",
  "50901.real_time.generatorPowerA": "Potenza fase A generatore",
  "50901.real_time.generatorPowerB": "Potenza fase B generatore",
  "50901.real_time.generatorPowerC": "Potenza fase C generatore",
  "50901.real_time.gridMeasurementOfRadiatorTemperature": "Temperatura Dissipatore Lato Rete",
  "50901.real_time.gridMeterSerialNumber": "Numero Seriale Contatore Lato Rete",
  "50901.real_time.gridPowerWholeSystem": "Potenza totale rete (intero sistema)",
  "50901.real_time.hoymilesSerialNumber": "Numero Seriale Hoymiles",
  "50901.real_time.inverterHardwareVersion": "Versione Hardware Inverter",
  "50901.real_time.inverterModelNumber": "Codice Modello Inverter",
  "50901.real_time.loadEnergy": "Consumo energetico giornaliero carico",
  "50901.real_time.loadPowerWholeSystem": "Potenza totale carico (intero sistema)",
  "50901.real_time.macAddr": "Indirizzo Mac",
  "50901.real_time.materType": "Tipo contatore",
  "50901.real_time.maxCellSoc": "SOC cella massima",
  "50901.real_time.maxCellSocCellId": "Indice SOC cella massima",
  "50901.real_time.maxCellTemperature": "Temperatura Cella Massima",
  "50901.real_time.maxCellTemperatureCellId": "Indice temperatura cella massima",
  "50901.real_time.maxCellVoltage": "Tensione Cella Massima",
  "50901.real_time.maxCellVoltageCellId": "Indice tensione cella massima",
  "50901.real_time.minCellSoc": "SOC cella minima",
  "50901.real_time.minCellSocCellId": "Indice SOC cella minima",
  "50901.real_time.minCellTemperature": "Temperatura Cella Minima",
  "50901.real_time.minCellTemperatureCellId": "Indice temperatura cella minima",
  "50901.real_time.minCellVoltage": "Tensione Cella Minima",
  "50901.real_time.minCellVoltageCellId": "Indice tensione cella minima",
  "50901.real_time.numberOfChargingAndDischargingCyclesOfBatteryPack": "Numero cicli pacco batteria",
  "50901.real_time.oemModelName": "Nome Modello Oem",
  "50901.real_time.oemSerialNumber": "Numero Seriale Oem",
  "50901.real_time.packCurrent": "Corrente pacco batteria",
  "50901.real_time.packPower": "Potenza pacco batteria",
  "50901.real_time.packSoc": "SOC pacco batteria",
  "50901.real_time.packSoh": "SOH pacco batteria",
  "50901.real_time.packVoltage": "Tensione pacco batteria",
  "50901.real_time.pv1RealTimePower": "Potenza istantanea FV1",
  "50901.real_time.pv2RealTimePower": "Potenza istantanea FV2",
  "50901.real_time.pv3RealTimePower": "Potenza istantanea FV3",
  "50901.real_time.pv4RealTimePower": "Potenza istantanea FV4",
  "50901.real_time.pvMeterSerialNumber": "Numero Seriale Contatore Fv",
  "50901.real_time.pvPower": "Potenza Fv",
  "50901.real_time.pvPowerWholeSystem": "Potenza totale FV (intero sistema)",
  "50901.real_time.pvToBatteryPower": "Potenza FV verso batteria",
  "50901.real_time.pvToGridPower": "Potenza FV verso rete",
  "50901.real_time.pvToLoadPower": "Potenza FV verso carico",
  "50901.real_time.relayStatus": "Stato Relè",
  "50901.real_time.relaySupplyVoltageSampling": "Campionamento Tensione Alimentazione Relè",
  "50901.real_time.rssi": "Intensità Segnale",
  "50901.real_time.ssid": "Ssid",
  "50901.warning.batteryHighVoltageAlarm": "Allarme Sovratensione Batteria",
  "50901.warning.batteryLowVoltageAlarm": "Sottotensione Batteria",
  "50901.warning.batteryPackChargeHighVoltageAlarm": "Allarme Sovratensione Carica Pacco Batteria",
  "50901.warning.batteryPackDischargeLowVoltageAlarm": "Allarme Sottotensione Scarica Pacco Batteria",
  "50901.warning.canCommunicationTimeout": "Timeout comunicazione CAN",
  "50901.warning.chargeHighTemperatureAlarm": "Allarme Alta Temperatura Carica",
  "50901.warning.chargeLowTemperatureAlarm": "Allarme Bassa Temperatura Carica",
  "50901.warning.dischargeHighTemperatureAlarm": "Allarme Alta Temperatura Scarica",
  "50901.warning.dischargeLowTemperatureAlarm": "Allarme Bassa Temperatura Scarica",
  "50901.warning.hardwareProtection": "Protezione hardware",
  "50901.warning.inputOvervoltageAlarm": "Allarme Sovratensione Ingresso",
  "50901.warning.lowBatteryEnergy": "Batteria scarica",
  "50901.ctrl_Config.ClockSetting.ClockSetting": "Impostazione Orologio",
  "50901.ctrl_Config.ClockSetting.clockSetting_day": "Impostazione Orologio - Giorno",
  "50901.ctrl_Config.ClockSetting.clockSetting_hour": "Impostazione Orologio - Ora",
  "50901.ctrl_Config.ClockSetting.clockSetting_minute": "Impostazione Orologio - Minuto",
  "50901.ctrl_Config.ClockSetting.clockSetting_month": "Impostazione Orologio - Mese",
  "50901.ctrl_Config.ClockSetting.clockSetting_second": "Impostazione Orologio - Secondo",
  "50901.ctrl_Config.ClockSetting.clockSetting_weekday": "Impostazione Orologio - Giorno Settimana",
  "50901.ctrl_Config.ClockSetting.clockSetting_year": "Impostazione Orologio - Anno",
  "50901.ctrl_Config.Device.masterSlave": "Master/Slave",
  "50901.ctrl_Config.Gateway.ambientTemperatureThreshold": "Soglia Temperatura Ambiente",
  "50901.ctrl_Config.Gateway.boardAmbientTemperatureThreshold": "Soglia Temperatura Ambiente Scheda Circuito",
  "50901.ctrl_Config.Gateway.gatewayCommunicationAddress": "Indirizzo Comunicazione Gateway",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgEndH": "Ora Fine Carica Periodo Utilizzo 1",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgEndMin": "Minuto Fine Carica Periodo Utilizzo 1",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgPower": "Potenza Carica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStartMin": "Minuto Inizio Carica Periodo Utilizzo 1",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStopSoc": "Capacità Interruzione Carica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgEndH": "Ora Fine Scarica Periodo Utilizzo 1",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgEndMin": "Minuto Fine Scarica Periodo Utilizzo 1",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgPower": "Potenza Scarica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStartMin": "Minuto Inizio Scarica Periodo Utilizzo 1",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStopSoc": "Capacità Interruzione Scarica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgEndH": "Ora Fine Carica Periodo Utilizzo 2",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgEndMin": "Minuto Fine Carica Periodo Utilizzo 2",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgPower": "Potenza Carica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStartMin": "Minuto Inizio Carica Periodo Utilizzo 2",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStopSoc": "Capacità Interruzione Carica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgEndH": "Ora Fine Scarica Periodo Utilizzo 2",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgEndMin": "Minuto Fine Scarica Periodo Utilizzo 2",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgPower": "Potenza Scarica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStartMin": "Minuto Inizio Scarica Periodo Utilizzo 2",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStopSoc": "Capacità Interruzione Scarica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgEndH": "Ora Fine Carica Periodo Utilizzo 3",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgEndMin": "Minuto Fine Carica Periodo Utilizzo 3",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgPower": "Potenza Carica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStartMin": "Minuto Inizio Carica Periodo Utilizzo 3",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStopSoc": "Capacità Interruzione Carica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgEndH": "Ora Fine Scarica Periodo Utilizzo 3",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgEndMin": "Minuto Fine Scarica Periodo Utilizzo 3",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgPower": "Potenza Scarica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStartMin": "Minuto Inizio Scarica Periodo Utilizzo 3",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStopSoc": "Capacità Interruzione Scarica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgEndH": "Ora Fine Carica Periodo Utilizzo 4",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgEndMin": "Minuto Fine Carica Periodo Utilizzo 4",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgPower": "Potenza Carica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStartMin": "Minuto Inizio Carica Periodo Utilizzo 4",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStopSoc": "Capacità Interruzione Carica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgEndH": "Ora Fine Scarica Periodo Utilizzo 4",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgEndMin": "Minuto Fine Scarica Periodo Utilizzo 4",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgPower": "Potenza Scarica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStartMin": "Minuto Inizio Scarica Periodo Utilizzo 4",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStopSoc": "Potenza Interruzione Scarica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgEndH": "Ora Fine Carica Periodo Utilizzo 5",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgEndMin": "Minuto Fine Carica Periodo Utilizzo 5",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgPower": "Potenza Carica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStartH": "Ora Inizio Carica Periodo Utilizzo 5",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStartMin": "Minuto Inizio Carica Periodo Utilizzo 5",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStopSoc": "Capacità Interruzione Carica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgEndH": "Ora Fine Scarica Periodo Utilizzo 5",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgEndMin": "Minuto Fine Scarica Periodo Utilizzo 5",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgPower": "Potenza Scarica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStartH": "Ora Inizio Scarica Periodo Utilizzo 5",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStartMin": "Minuto Inizio Scarica Periodo Utilizzo 5",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStopSoc": "Capacità Interruzione Scarica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgEndH": "Ora Fine Carica Periodo Utilizzo 6",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgEndMin": "Minuto Fine Carica Periodo Utilizzo 6",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgPower": "Potenza Carica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStartH": "Ora Inizio Carica Periodo Utilizzo 6",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStartMin": "Minuto Inizio Carica Periodo Utilizzo 6",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStopSoc": "Capacità Interruzione Carica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgEndH": "Ora Fine Scarica Periodo Utilizzo 6",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgEndMin": "Minuto Fine Scarica Periodo Utilizzo 6",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgPower": "Potenza Scarica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStartH": "Ora Inizio Scarica Periodo Utilizzo 6",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStartMin": "Minuto Inizio Scarica Periodo Utilizzo 6",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStopSoc": "Capacità Interruzione Scarica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgEndH": "Ora Fine Carica Periodo Utilizzo 7",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgEndMin": "Minuto Fine Carica Periodo Utilizzo 7",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgPower": "Potenza Scarica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStartH": "Ora Inizio Carica Periodo Utilizzo 7",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStartMin": "Minuto Inizio Carica Periodo Utilizzo 7",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStopSoc": "Capacità Interruzione Scarica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgEndH": "Ora Fine Scarica Periodo Utilizzo 7",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgEndMin": "Minuto Fine Scarica Periodo Utilizzo 7",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgPower": "Potenza Scarica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStartH": "Ora Inizio Scarica Periodo Utilizzo 7",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStartMin": "Minuto Inizio Scarica Periodo Utilizzo 7",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStopSoc": "Capacità Interruzione Scarica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgEndH": "Ora Fine Carica Periodo Utilizzo 8",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgEndMin": "Minuto Fine Carica Periodo Utilizzo 8",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgPower": "Potenza Carica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStartH": "Ora Inizio Carica Periodo Utilizzo 8",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStartMin": "Minuto Inizio Carica Periodo Utilizzo 8",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStopSoc": "Capacità Interruzione Carica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgEndH": "Ora Fine Scarica Periodo Utilizzo 8",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgEndMin": "Minuto Fine Scarica Periodo Utilizzo 8",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgPower": "Potenza Scarica",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStartH": "Ora Inizio Scarica Periodo Utilizzo 8",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStartMin": "Minuto Inizio Scarica Periodo Utilizzo 8",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStopSoc": "Capacità Interruzione Scarica",
  "50901.real_time.afciVersion": "Versione Afci",
  "50901.real_time.batteryChargePower": "Capacità Di Carica Cumulativa Batteria",
  "50901.real_time.batteryConnectionStatus": "Stato Connessione Batteria",
  "50901.real_time.batteryCurrent": "Corrente Batteria",
  "50901.real_time.batteryDischargePower": "Capacità Di Scarica Cumulativa Batteria",
  "50901.real_time.batteryPower": "Potenza Batteria (Carica/Scarica)",
  "50901.real_time.batterySoc": "Soc Batteria",
  "50901.real_time.batterytotCap": "Capacità totale installata batteria",
  "50901.real_time.batteryType_04": "Tipo Batteria",
  "50901.real_time.batteryVoltage": "Tensione Batteria",
  "50901.real_time.batteryWorkingStatus": "Stato Batteria",
  "50901.real_time.bmsSoftwareVersion": "Versione software BMS",
  "50901.real_time.commAddress10Slave9": "Indirizzo Comunicazione 10 (Slave 9)",
  "50901.real_time.commAddress1Master": "Indirizzo Comunicazione 1 (Master)",
  "50901.real_time.commAddress2Slave1": "Indirizzo Comunicazione 2 (Slave 1)",
  "50901.real_time.commAddress3Slave2": "Indirizzo Comunicazione 3 (Slave 2)",
  "50901.real_time.commAddress3Slave3": "Indirizzo Comunicazione 4 (Slave 3)",
  "50901.real_time.commAddress4Slave4": "Indirizzo Comunicazione 5 (Slave 4)",
  "50901.real_time.commAddress6Slave6": "Indirizzo Comunicazione 6 (Slave 5)",
  "50901.real_time.commAddress7Slave6": "Indirizzo Comunicazione 7 (Slave 6)",
  "50901.real_time.commAddress8Slave7": "Indirizzo Comunicazione 8 (Slave 7)",
  "50901.real_time.commAddress9Slave8": "Indirizzo Comunicazione 9 (Slave 8)",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria": "Stato Drm (Per Australia/Germania/Austria)",
  "50901.real_time.dspVersionAuxiliaryUVersion": "Versione Dsp (Versione U Ausiliaria)",
  "50901.real_time.epsCurrentA": "Corrente Fase A Lato Eps",
  "50901.real_time.epsCurrentB": "Corrente Fase B Lato Eps",
  "50901.real_time.epsCurrentC": "Corrente Fase C Lato Eps",
  "50901.real_time.epsPower": "Potenza Lato Eps",
  "50901.real_time.epsPowerA": "Potenza Fase A Lato Eps",
  "50901.real_time.epsPowerB": "Potenza Fase B Lato Eps",
  "50901.real_time.epsPowerC": "Potenza Fase C Lato Eps",
  "50901.real_time.epsVoltageA": "Tensione Fase A Lato Eps",
  "50901.real_time.epsVoltageB": "Tensione Fase B Lato Eps",
  "50901.real_time.epsVoltageC": "Tensione Fase C Lato Eps",
  "50901.real_time.essAccessPoint": "Punto Accesso Ess",
  "50901.real_time.externalFanSpeed1": "Velocità Ventola Esterna 1",
  "50901.real_time.externalFanSpeed2": "Velocità Ventola Esterna 2",
  "50901.real_time.externalFanSpeed3": "Velocità Ventola Esterna 3",
  "50901.real_time.externalFanSpeed4": "Velocità Ventola Esterna 4",
  "50901.real_time.generatorConnectionStatus": "Stato Connessione Generatore",
  "50901.real_time.generatorCurrentA": "Corrente Fase A Generatore",
  "50901.real_time.generatorCurrentB": "Corrente Fase B Generatore",
  "50901.real_time.generatorCurrentC": "Corrente Fase C Generatore",
  "50901.real_time.generatorTotalYield": "Produzione cumulativa generatore",
  "50901.real_time.generatorVoltageA": "Tensione Fase A Generatore",
  "50901.real_time.generatorVoltageB": "Tensione Fase B Generatore",
  "50901.real_time.generatorVoltageC": "Tensione Fase C Generatore",
  "50901.real_time.gridBuyPower": "Energia acquistata cumulativa",
  "50901.real_time.gridCurrentA": "Corrente Fase A Lato Rete",
  "50901.real_time.gridCurrentB": "Corrente Fase B Lato Rete",
  "50901.real_time.gridCurrentC": "Corrente Fase C Lato Rete",
  "50901.real_time.gridPower": "Potenza Lato Rete",
  "50901.real_time.gridPowerA": "Potenza Fase A Lato Rete",
  "50901.real_time.gridPowerB": "Potenza Fase B Lato Rete",
  "50901.real_time.gridPowerC": "Potenza Fase C Lato Rete",
  "50901.real_time.gridPowerFactor": "Fattore Di Potenza Lato Rete",
  "50901.real_time.gridPowerFactorA": "Fattore Di Potenza Fase A Lato Rete",
  "50901.real_time.gridPowerFactorB": "Fattore Di Potenza Fase B Lato Rete",
  "50901.real_time.gridPowerFactorC": "Fattore Di Potenza Fase C Lato Rete",
  "50901.real_time.gridReactivePower": "Potenza Reattiva Lato Rete",
  "50901.real_time.gridReactivePowerA": "Potenza Reattiva Fase A Lato Rete",
  "50901.real_time.gridReactivePowerB": "Potenza Reattiva Fase B Lato Rete",
  "50901.real_time.gridReactivePowerC": "Potenza Reattiva Fase C Lato Rete",
  "50901.real_time.gridSellPower": "Energia venduta cumulativa",
  "50901.real_time.gridTotalFrequency": "Frequenza Lato Rete",
  "50901.real_time.gridVoltageA": "Tensione Fase A Lato Rete",
  "50901.real_time.gridVoltageB": "Tensione Fase B Lato Rete",
  "50901.real_time.gridVoltageC": "Tensione Fase C Lato Rete",
  "50901.real_time.internalFanSpeed1": "Velocità Ventola Interna 1",
  "50901.real_time.internalFanSpeed2": "Velocità Ventola Interna 2",
  "50901.real_time.internalFanSpeed3": "Velocità Ventola Interna 3",
  "50901.real_time.invAcFrequency": "Frequenza uscita CA inverter",
  "50901.real_time.inverCombinedActivePower": "Potenza uscita CA inverter",
  "50901.real_time.inverterSideRadiatorTemperature": "Temperatura Dissipatore Lato Inverter",
  "50901.real_time.inverterTemp": "Temperatura Interna Funzionamento Inverter",
  "50901.real_time.invRatedPower": "Potenza Nominale",
  "50901.real_time.invRunningtime": "Ore Funzionamento Inverter (Hoymiles: Tempo Normale)",
  "50901.real_time.machineSnMaster": "Sn Unità Master",
  "50901.real_time.machineSnSlave1": "Sn Slave 1",
  "50901.real_time.machineSnSlave2": "Sn Slave 2",
  "50901.real_time.machineSnSlave3": "Sn Slave 3",
  "50901.real_time.machineSnSlave4": "Sn Slave 4",
  "50901.real_time.machineSnSlave5": "Sn Slave 5",
  "50901.real_time.machineSnSlave6": "Sn Slave 6",
  "50901.real_time.machineSnSlave7": "Sn Slave 7",
  "50901.real_time.machineSnSlave8": "Sn Slave 8",
  "50901.real_time.machineSnSlave9": "Sn Slave 9",
  "50901.real_time.MaxChargeCurrent": "Corrente Massima Carica",
  "50901.real_time.MaxDisChargeCurrent": "Corrente Massima Scarica",
  "50901.real_time.meterFlag": "Flag Contatore",
  "50901.real_time.mpptTemp": "Temperatura Dissipatore Lato Fv",
  "50901.real_time.numberOfUnits": "Quantità Unità",
  "50901.real_time.packNum": "Quantità In Parallelo (Numero Pacchi Batteria)",
  "50901.real_time.phaseAOfInverterActivePower": "Potenza fase A lato CA inverter",
  "50901.real_time.phaseAOfInverterSideCurrent": "Corrente fase A lato CA inverter",
  "50901.real_time.phaseAOfInverterSideVoltage": "Tensione fase A lato CA inverter",
  "50901.real_time.phaseBOfInverterActivePower": "Potenza fase B lato CA inverter",
  "50901.real_time.phaseBOfInverterSideCurrent": "Corrente fase B lato CA inverter",
  "50901.real_time.phaseBOfInverterSideVoltage": "Tensione fase B lato CA inverter",
  "50901.real_time.phaseCOfInverterActivePower": "Potenza fase C lato CA inverter",
  "50901.real_time.phaseCOfInverterSideCurrent": "Corrente fase C lato CA inverter",
  "50901.real_time.phaseCOfInverterSideVoltage": "Tensione fase C lato CA inverter",
  "50901.real_time.powerGeneration": "Produzione cumulativa FV",
  "50901.real_time.pv1Current": "Corrente Fv1",
  "50901.real_time.pv1Power": "Potenza Fv1",
  "50901.real_time.pv1Voltage": "Tensione Fv1",
  "50901.real_time.pv2Current": "Corrente Fv2",
  "50901.real_time.pv2Power": "Potenza Fv2",
  "50901.real_time.pv2Voltage": "Tensione Fv2",
  "50901.real_time.pv3Current": "Corrente Fv3",
  "50901.real_time.pv3Power": "Potenza Fv3",
  "50901.real_time.pv3Voltage": "Tensione Fv3",
  "50901.real_time.pv4Current": "Corrente Fv4",
  "50901.real_time.pv4Power": "Potenza Fv4",
  "50901.real_time.pv4Voltage": "Tensione Fv4",
  "50901.real_time.pvConnectionStatus": "Stato Connessione Fv",
  "50901.real_time.pvDailyYield": "Produzione Giornaliera Fv",
  "50901.real_time.pvMeterConnectionStatus": "Stato Connessione Contatore Fv",
  "50901.real_time.pvMeterCurrentA": "Corrente Fase A Contatore Fv",
  "50901.real_time.pvMeterCurrentB": "Corrente Fase B Contatore Fv",
  "50901.real_time.pvMeterCurrentC": "Corrente Fase C Contatore Fv",
  "50901.real_time.pvMeterDailyYield": "Produzione giornaliera inverter esterno",
  "50901.real_time.pvMeterFrequency": "Frequenza Contatore Fv",
  "50901.real_time.pvMeterPhaseAActivePower": "Potenza Attiva Fase A Contatore Fv",
  "50901.real_time.pvMeterPhaseAPowerFactor": "Fattore Di Potenza Fase A Contatore Fv",
  "50901.real_time.pvMeterPhaseAReactivePower": "Potenza Reattiva Fase A Contatore Fv",
  "50901.real_time.pvMeterPhaseBActivePower": "Potenza Attiva Fase B Contatore Fv",
  "50901.real_time.pvMeterPhaseBPowerFactor": "Fattore Di Potenza Fase B Contatore Fv",
  "50901.real_time.pvMeterPhaseBReactivePower": "Potenza Reattiva Fase B Contatore Fv",
  "50901.real_time.pvMeterPhaseCActivePower": "Potenza Attiva Fase C Contatore Fv",
  "50901.real_time.pvMeterPhaseCPowerFactor": "Fattore Di Potenza Fase C Contatore Fv",
  "50901.real_time.pvMeterPhaseCReactivePower": "Potenza Reattiva Fase C Contatore Fv",
  "50901.real_time.pvMeterPower": "Potenza Contatore Fv",
  "50901.real_time.pvMeterPowerA": "Potenza Fase A Contatore Fv",
  "50901.real_time.pvMeterPowerB": "Potenza Fase B Contatore Fv",
  "50901.real_time.pvMeterPowerC": "Potenza Fase C Contatore Fv",
  "50901.real_time.pvMeterTotalYield": "Produzione cumulativa inverter esterno",
  "50901.real_time.pvMeterVoltageA": "Tensione Fase A Contatore Fv",
  "50901.real_time.pvMeterVoltageB": "Tensione Fase B Contatore Fv",
  "50901.real_time.pvMeterVoltageC": "Tensione Fase C Contatore Fv",
  "50901.real_time.serviceEntranceBreakerCurrent": "Corrente Interruttore Ingresso Servizio",
  "50901.real_time.soh": "Soh",
  "50901.real_time.totalBatteryToLoadEnergy": "Energia cumulativa batteria verso carico",
  "50901.real_time.totalGridToLoadEnergy": "Energia cumulativa rete verso carico",
  "50901.real_time.totalLoadEnergy": "Consumo energetico cumulativo carico",
  "50901.real_time.totalPvToBatteryEnegry": "Energia cumulativa FV verso batteria",
  "50901.real_time.totalPvToGridEnegry": "Energia cumulativa FV verso rete",
  "50901.real_time.totalPvToLoadEnegry": "Energia cumulativa FV verso carico",
  "50901.real_time.workStatus": "Stato Operativo",
  "50901.ctrl_Config.Battery.absorptionVoltage": "Tensione Di Assorbimento",
  "50901.ctrl_Config.Battery.batteryCapacity": "Capacità BMS",
  "50901.ctrl_Config.Battery.endChargeVoltage": "Tensione Fine Carica",
  "50901.ctrl_Config.Battery.endOfChargeCurrent": "Corrente Fine Carica",
  "50901.ctrl_Config.Battery.equalizationChargeTimeout": "Timeout Carica Equalizzazione",
  "50901.ctrl_Config.Battery.equalizationEnable": "Abilitazione Equalizzazione",
  "50901.ctrl_Config.Battery.equalizationIntervalDays": "Giorni Intervallo Equalizzazione",
  "50901.ctrl_Config.Battery.equalizationTime": "Tempo Equalizzazione",
  "50901.ctrl_Config.Battery.equalizationVoltage": "Tensione Equalizzazione",
  "50901.ctrl_Config.Battery.floatVoltage": "Tensione Di Floating",
  "50901.ctrl_Config.Battery.initialResistance": "Resistenza Iniziale",
  "50901.ctrl_Config.Battery.maximumChargeLimit": "Valore Limite Massimo Carica",
  "50901.ctrl_Config.Battery.maximumDischargeLimit": "Valore Limite Massimo Scarica",
  "50901.ctrl_Config.Battery.temperatureCorrectionFactor": "Coefficiente Correzione Temperatura",
  "50901.ctrl_Config.Connection.dtu_comm_enable": "Abilitazione Comunicazione Dtu",
  "50901.ctrl_Config.Device.arcFaultClear": "Cancellazione guasto arco",
  "50901.ctrl_Config.Device.batActivate": "Attivazione Batteria",
  "50901.ctrl_Config.Device.batteryBalancing": "Bilanciamento Batteria",
  "50901.ctrl_Config.Device.clearFault": "Cancellazione guasto",
  "50901.ctrl_Config.Device.parallelNetworking": "Rete parallela",
  "50901.ctrl_Config.Device.restartSystem": "Riavvio Sistema",
  "50901.ctrl_Config.Device.restoreDefault": "Ripristino Valori Predefiniti",
  "50901.ctrl_Config.Device.selfTest": "Autotest",
  "50901.ctrl_Config.Device.systemPowerOnOff": "Accensione/Spegnimento Sistema",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeEndH": "Ora H Fine Carica Controllo Generatore",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeEndMin": "Minuto Fine Carica Controllo Generatore",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeStartH": "Ora H Inizio Carica Controllo Generatore",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeStartMin": "Minuto Inizio Carica Controllo Generatore",
  "50901.ctrl_Dry_Contact.Generator.generatorCloseBatteryCapacity": "Capacità Batteria Spegnimento Generatore",
  "50901.ctrl_Dry_Contact.Generator.generatorMode": "Modalità Generatore",
  "50901.ctrl_Dry_Contact.Generator.generatorOpenBatteryCapacity": "Capacità Batteria Avvio Generatore",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq": "Frequenza Modalità Esercizio Generatore",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeEn": "Modalità Esercizio Generatore",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeRunningTime": "Durata Modalità Esercizio Generatore",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeStartH": "Ora Avvio Modalità Esercizio Generatore",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeStartMin": "Minuto Avvio Modalità Esercizio Generatore",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek": "Tempo Avvio Modalità Esercizio Generatore",
  "50901.ctrl_Dry_Contact.Generator.quietTime1EndH": "Ora H Fine Tempo Standby 1",
  "50901.ctrl_Dry_Contact.Generator.quietTime1EndMin": "Minuto Fine Tempo Standby 1",
  "50901.ctrl_Dry_Contact.Generator.quietTime1StartH": "Ora H Inizio Tempo Standby 1",
  "50901.ctrl_Dry_Contact.Generator.quietTime1StartMin": "Minuto Inizio Tempo Standby 1",
  "50901.ctrl_Dry_Contact.Generator.quietTime2EndH": "Ora H Fine Tempo Standby 2",
  "50901.ctrl_Dry_Contact.Generator.quietTime2EndMin": "Minuto Fine Tempo Standby 2",
  "50901.ctrl_Dry_Contact.Generator.quietTime2StartH": "Ora H Inizio Tempo Standby 2",
  "50901.ctrl_Dry_Contact.Generator.quietTime2StartMin": "Minuto Inizio Tempo Standby 2",
  "50901.ctrl_Dry_Contact.Generator.quietTimeEnable": "Abilitazione Tempo Standby",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode": "Modalità Controllo Carico",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange1": "Controllo Carico Lunedì",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange2": "Controllo Carico Martedì",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange3": "Controllo Carico Mercoledì",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange4": "Controllo Carico Giovedì",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange5": "Controllo Carico Venerdì",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange6": "Controllo Carico Sabato",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange7": "Controllo Carico Domenica",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.manualModeSwitch": "Interruttore Modalità Manuale",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.minimumOnLoadPower": "Soglia Potenza Carico Modalità Carico",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.minimumOnTime": "Tempo Minimo Inserzione Controllo Carico",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.offGridProtectionSoc": "Soc Protezione Off-Grid",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange1": "Intervallo Orario 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange20": "Lunedì",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange21": "Martedì",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange22": "Mercoledì",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange23": "Giovedì",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange24": "Venerdì",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange25": "Sabato",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange26": "Domenica",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour": "Ora Fine Timer 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour_2": "Ora Fine Timer 1_2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour_3": "Ora Fine Intervallo 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute": "Minuto Fine Timer 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute_2": "Minuto Fine Timer 1_2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute_3": "Minuto Fine Intervallo 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min": "Minuto Inizio Timer 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min_2": "Minuto Inizio Timer 1_2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min_3": "Minuto Inizio Intervallo 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour": "Ora Fine Timer 2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour_2": "Ora Fine Timer 2_2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour_3": "Ora Fine Intervallo 2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes": "Minuto Fine Timer 2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes_2": "Minuto Fine Timer 2_2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes_3": "Minuto Fine Intervallo 2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes": "Minuto Inizio Timer 2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes_2": "Minuto Inizio Timer 2_2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes_3": "Minuto Inizio Intervallo 2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour": "Ora Inizio Timer 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour_2": "Ora Inizio Timer 1_2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour_3": "Ora Inizio Intervallo 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour": "Ora Inizio Timer 2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour_2": "Ora Inizio Timer 2_2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour_3": "Ora Inizio Intervallo 2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange1": "Lunedì",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange2": "Martedì",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange3": "Mercoledì",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange4": "Giovedì",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange5": "Venerdì",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange6": "Sabato",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange7": "Domenica",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode": "Modalità Operativa Contatti Puliti",
  "50901.ctrl_ESS_Advanced_Config.Battery.batDischargePowerWhenPartialPeak": "Potenza Max Scarica Batteria In Picco",
  "50901.ctrl_ESS_Advanced_Config.Battery.batGridFeedPowerWhenPeak": "Potenza Immissione Rete In Picco",
  "50901.ctrl_ESS_Advanced_Config.Battery.batteryMaxChargePower": "Potenza Max Carica Batteria",
  "50901.ctrl_ESS_Advanced_Config.Battery.batteryMaxDischargePower": "Potenza Max Scarica Batteria",
  "50901.ctrl_ESS_Advanced_Config.Battery.leadAcidBatReplenishTime": "Tempo Manutenzione Batteria Al Piombo",
  "50901.ctrl_ESS_Advanced_Config.Battery.maxSoc": "Soc Massimo",
  "50901.ctrl_ESS_Advanced_Config.Battery.minSoc": "Soc Minimo",
  "50901.ctrl_ESS_Advanced_Config.Battery.replenishPower": "Compensazione Potenza",
  "50901.ctrl_ESS_Advanced_Config.Battery.rsvdReplenishPower": "Potenza Riserva Rsvd",
  "50901.ctrl_ESS_Advanced_Config.EPS.bypassDisable": "Disabilitazione Bypass",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode": "Modalità Eps",
  "50901.ctrl_ESS_Advanced_Config.EPS.pvIslandModeEn": "Abilitazione Modalità Fv",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_high_limit_freq": "Limite Superiore Frequenza Generatore",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_high_limit_volt": "Limite Superiore Tensione Generatore",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_low_limit_freq": "Limite Inferiore Frequenza Generatore",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_low_limit_volt": "Limite Inferiore Tensione Generatore",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_rated_power": "Potenza Carica Batteria Da Generatore In Parallelo Multi-Unità",
  "50901.ctrl_ESS_Advanced_Config.PV.mppt_global_scan_enable": "Abilitazione Scansione Globale",
  "50901.ctrl_ESS_Advanced_Config.System.gridInPowerLimitationWhenValley": "Limite Potenza Rete",
  "50901.ctrl_ESS_Advanced_Config.System.threePhaseUnbalanceEnable": "Abilitazione Squilibrio Trifase",
  "50901.ctrl_Safety_GCF.gcfExportHardLimitRatio": "Rapporto limite rigido esportazione GCF",
  "50901.ctrl_WorkMode.Backup.backupSoc": "Soc Riserva",
  "50901.ctrl_WorkMode.economic.economicModeSoc": "Soc Modalità Economica",
  "50901.ctrl_WorkMode.economic.economyModeDateNumber": "Indice Data Modalità Economica",
  "50901.ctrl_WorkMode.economic.section1PeakStartHour1": "Ora 1 Inizio Picco Sezione 1",
  "50901.ctrl_WorkMode.economic.section1PeakStartHour2": "Ora 2 Inizio Picco Sezione 1",
  "50901.ctrl_WorkMode.economic.section1PeakStartMinute1": "Minuto 1 Inizio Picco Sezione 1",
  "50901.ctrl_WorkMode.economic.section1PeakStartMinute2": "Minuto 2 Inizio Picco Sezione 1",
  "50901.ctrl_WorkMode.economic.section1PeakStopHour1": "Ora 1 Fine Picco Sezione 1",
  "50901.ctrl_WorkMode.economic.section1PeakStopHour2": "Ora 2 Fine Picco Sezione 1",
  "50901.ctrl_WorkMode.economic.section1PeakStopMinute1": "Minuto 1 Fine Picco Sezione 1",
  "50901.ctrl_WorkMode.economic.section1PeakStopMinute2": "Minuto 2 Fine Picco Sezione 1",
  "50901.ctrl_WorkMode.economic.section1StartDay": "Giorno Inizio Sezione 1",
  "50901.ctrl_WorkMode.economic.section1StartMonth": "Mese Inizio Sezione 1",
  "50901.ctrl_WorkMode.economic.section1StopDay": "Giorno Fine Sezione 1",
  "50901.ctrl_WorkMode.economic.section1StopMonth": "Mese Fine Sezione 1",
  "50901.ctrl_WorkMode.economic.section1ValleyStartHour1": "Ora 1 Inizio Bassa Valle Sezione 1",
  "50901.ctrl_WorkMode.economic.section1ValleyStartHour2": "Ora 2 Inizio Bassa Valle Sezione 1",
  "50901.ctrl_WorkMode.economic.section1ValleyStartMinute1": "Minuto 1 Inizio Bassa Valle Sezione 1",
  "50901.ctrl_WorkMode.economic.section1ValleyStartMinute2": "Minuto 2 Inizio Bassa Valle Sezione 1",
  "50901.ctrl_WorkMode.economic.section1ValleyStopHour1": "Ora 1 Fine Bassa Valle Sezione 1",
  "50901.ctrl_WorkMode.economic.section1ValleyStopHour2": "Ora 2 Fine Bassa Valle Sezione 1",
  "50901.ctrl_WorkMode.economic.section1ValleyStopMinute1": "Minuto 1 Fine Bassa Valle Sezione 1",
  "50901.ctrl_WorkMode.economic.section1ValleyStopMinute2": "Minuto 2 Fine Bassa Valle Sezione 1",
  "50901.ctrl_WorkMode.economic.section1WeekRange1": "Intervallo settimana 1 sezione 1",
  "50901.ctrl_WorkMode.economic.section1WeekRange2": "Intervallo settimana 2 sezione 1",
  "50901.ctrl_WorkMode.economic.section2PeakStartHour1": "Ora 1 Inizio Picco Sezione 2",
  "50901.ctrl_WorkMode.economic.section2PeakStartHour2": "Ora 2 Inizio Picco Sezione 2",
  "50901.ctrl_WorkMode.economic.section2PeakStartMinute1": "Minuto 1 Inizio Picco Sezione 2",
  "50901.ctrl_WorkMode.economic.section2PeakStartMinute2": "Minuto 1 Inizio Picco Sezione 2",
  "50901.ctrl_WorkMode.economic.section2PeakStopHour1": "Ora 1 Fine Picco Sezione 2",
  "50901.ctrl_WorkMode.economic.section2PeakStopHour2": "Ora 2 Fine Picco Sezione 2",
  "50901.ctrl_WorkMode.economic.section2PeakStopMinute1": "Minuto 1 Fine Picco Sezione 2",
  "50901.ctrl_WorkMode.economic.section2PeakStopMinute2": "Minuto 2 Fine Picco Sezione 2",
  "50901.ctrl_WorkMode.economic.section2StartDay": "Giorno Inizio Sezione 2",
  "50901.ctrl_WorkMode.economic.section2StartMonth": "Mese Inizio Sezione 2",
  "50901.ctrl_WorkMode.economic.section2StopDay": "Giorno Fine Sezione 2",
  "50901.ctrl_WorkMode.economic.section2StopMonth": "Mese Fine Sezione 2",
  "50901.ctrl_WorkMode.economic.section2ValleyStartHour1": "Ora 1 Inizio Bassa Valle Sezione 2",
  "50901.ctrl_WorkMode.economic.section2ValleyStartHour2": "Ora 2 Inizio Bassa Valle Sezione 2",
  "50901.ctrl_WorkMode.economic.section2ValleyStartMinute1": "Minuto 1 Inizio Bassa Valle Sezione 2",
  "50901.ctrl_WorkMode.economic.section2ValleyStartMinute2": "Minuto 2 Inizio Bassa Valle Sezione 2",
  "50901.ctrl_WorkMode.economic.section2ValleyStopHour1": "Ora 1 Fine Bassa Valle Sezione 2",
  "50901.ctrl_WorkMode.economic.section2ValleyStopHour2": "Ora 2 Fine Bassa Valle Sezione 2",
  "50901.ctrl_WorkMode.economic.section2ValleyStopMinute1": "Minuto 1 Fine Bassa Valle Sezione 2",
  "50901.ctrl_WorkMode.economic.section2ValleyStopMinute2": "Minuto 2 Fine Bassa Valle Sezione 2",
  "50901.ctrl_WorkMode.economic.section2WeekRange1": "Intervallo settimana 1 sezione 2",
  "50901.ctrl_WorkMode.economic.section2WeekRange2": "Intervallo settimana 2 sezione 2",
  "50901.ctrl_WorkMode.economic.section3PeakStartHour1": "Ora 1 Inizio Picco Sezione 3",
  "50901.ctrl_WorkMode.economic.section3PeakStartHour2": "Ora 2 Inizio Picco Sezione 3",
  "50901.ctrl_WorkMode.economic.section3PeakStartMinute1": "Minuto 2 Inizio Picco Sezione 3",
  "50901.ctrl_WorkMode.economic.section3PeakStartMinute2": "Minuto 1 Inizio Picco Sezione 3",
  "50901.ctrl_WorkMode.economic.section3PeakStopHour1": "Ora 1 Fine Picco Sezione 3",
  "50901.ctrl_WorkMode.economic.section3PeakStopHour2": "Ora 2 Fine Picco Sezione 3",
  "50901.ctrl_WorkMode.economic.section3PeakStopMinute1": "Minuto 1 Fine Picco Sezione 3",
  "50901.ctrl_WorkMode.economic.section3PeakStopMinute2": "Minuto 2 Fine Picco Sezione 3",
  "50901.ctrl_WorkMode.economic.section3StartDay": "Giorno Inizio Sezione 3",
  "50901.ctrl_WorkMode.economic.section3StartMonth": "Mese Inizio Sezione 3",
  "50901.ctrl_WorkMode.economic.section3StopDay": "Giorno Fine Sezione 3",
  "50901.ctrl_WorkMode.economic.section3StopMonth": "Mese Fine Sezione 3",
  "50901.ctrl_WorkMode.economic.section3ValleyStartHour1": "Ora 1 Inizio Bassa Valle Sezione 3",
  "50901.ctrl_WorkMode.economic.section3ValleyStartHour2": "Ora 2 Inizio Bassa Valle Sezione 3",
  "50901.ctrl_WorkMode.economic.section3ValleyStartMinute1": "Minuto 1 Inizio Bassa Valle Sezione 3",
  "50901.ctrl_WorkMode.economic.section3ValleyStartMinute2": "Minuto 2 Inizio Bassa Valle Sezione 3",
  "50901.ctrl_WorkMode.economic.section3ValleyStopHour1": "Ora 1 Fine Bassa Valle Sezione 3",
  "50901.ctrl_WorkMode.economic.section3ValleyStopHour2": "Ora 2 Fine Bassa Valle Sezione 3",
  "50901.ctrl_WorkMode.economic.section3ValleyStopMinute1": "Minuto 1 Fine Bassa Valle Sezione 3",
  "50901.ctrl_WorkMode.economic.section3ValleyStopMinute2": "Minuto 2 Fine Bassa Valle Sezione 3",
  "50901.ctrl_WorkMode.economic.section3WeekRange1": "Intervallo settimana 1 sezione 3",
  "50901.ctrl_WorkMode.economic.section3WeekRange2": "Intervallo Settimana 2 Sezione 3",
  "50901.ctrl_WorkMode.economic.section4PeakStartHour1": "Ora 1 Inizio Picco Sezione 4",
  "50901.ctrl_WorkMode.economic.section4PeakStartHour2": "Ora 2 Inizio Picco Sezione 4",
  "50901.ctrl_WorkMode.economic.section4PeakStartMinute1": "Minuto 1 Inizio Picco Sezione 4",
  "50901.ctrl_WorkMode.economic.section4PeakStartMinute2": "Minuto 2 Inizio Picco Sezione 4",
  "50901.ctrl_WorkMode.economic.section4PeakStopHour1": "Ora 1 Fine Picco Sezione 4",
  "50901.ctrl_WorkMode.economic.section4PeakStopHour2": "Ora 2 Fine Picco Sezione 4",
  "50901.ctrl_WorkMode.economic.section4PeakStopMinute1": "Minuto 1 Fine Picco Sezione 4",
  "50901.ctrl_WorkMode.economic.section4PeakStopMinute2": "Minuto 2 Fine Picco Sezione 4",
  "50901.ctrl_WorkMode.economic.section4StartDay": "Giorno Inizio Sezione 4",
  "50901.ctrl_WorkMode.economic.section4StartMonth": "Mese Inizio Sezione 4",
  "50901.ctrl_WorkMode.economic.section4StopDay": "Giorno Fine Sezione 4",
  "50901.ctrl_WorkMode.economic.section4StopMonth": "Mese Fine Sezione 4",
  "50901.ctrl_WorkMode.economic.section4ValleyStartHour1": "Ora 1 Inizio Bassa Valle Sezione 4",
  "50901.ctrl_WorkMode.economic.section4ValleyStartHour2": "Ora 2 Inizio Bassa Valle Sezione 4",
  "50901.ctrl_WorkMode.economic.section4ValleyStartMinute1": "Minuto 1 Inizio Bassa Valle Sezione 4",
  "50901.ctrl_WorkMode.economic.section4ValleyStartMinute2": "Minuto 2 Inizio Bassa Valle Sezione 4",
  "50901.ctrl_WorkMode.economic.section4ValleyStopHour1": "Ora 1 Fine Bassa Valle Sezione 4",
  "50901.ctrl_WorkMode.economic.section4ValleyStopHour2": "Ora 2 Fine Bassa Valle Sezione 4",
  "50901.ctrl_WorkMode.economic.section4ValleyStopMinute1": "Minuto 1 Fine Bassa Valle Sezione 4",
  "50901.ctrl_WorkMode.economic.section4ValleyStopMinute2": "Minuto 2 Fine Bassa Valle Sezione 4",
  "50901.ctrl_WorkMode.economic.section4WeekRange1": "Intervallo settimana 1 sezione 4",
  "50901.ctrl_WorkMode.economic.section4WeekRange2": "Intervallo Settimana 2 Sezione 4",
  "50901.ctrl_WorkMode.forceCharge.forceChargeSoc": "Soc Carica Forzata",
  "50901.ctrl_WorkMode.forceCharge.maximumChargePower": "Potenza Massima Carica",
  "50901.ctrl_WorkMode.forceDischarge.forceDischargeSoc": "Soc Scarica Forzata",
  "50901.ctrl_WorkMode.forceDischarge.maximumDischargePower": "Potenza Massima Scarica",
  "50901.ctrl_WorkMode.peakMeter.peakMeterPower": "Potenza Contatore Picco",
  "50901.ctrl_WorkMode.peakMeter.peakMeterSoc": "Soc Contatore Picco",
  "50901.ctrl_WorkMode.Selfuse.selfUsedSoc": "Soc Autoconsumo",
  "50901.ctrl_WorkMode.Switch.workMode": "Modalità Operativa Ems",
  "50901.ctrl_WorkMode.TOU.timeOfUseRange": "Intervallo Orario Modalità Tou",
  "50901.real_time.BatteryModel": "Modello Batteria",
  "50901.real_time.cfgMultPcsBmsFlag": "Flag BMS",
  "50901.real_time.inverterSn": "Sn Inverter",
  "50901.ctrl_Config.Grid Profile.country": "Standard Paese/Connessione Alla Rete",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode": "Modalità Porta Generatore",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position": "Posizione Generatore",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_shutdown_delay": "Ritardo Spegnimento Generatore",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_sync_time": "Tempo Sincronizzazione Generatore",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_type": "Tipo Generatore",
  "50901.ctrl_ESS_Advanced_Config.Generator.max_run_time": "Tempo Massimo Funzionamento",
  "50901.ctrl_ESS_Advanced_Config.Generator.min_run_time": "Tempo Minimo Funzionamento",
  "50901.ctrl_ESS_Advanced_Config.Generator.run_protect_threshold": "Intervallo Protezione Funzionamento",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model": "Modello Contatore",
  "50901.ctrl_ESS_Advanced_Config.System.mid_gateway_enable": "Abilitazione Mid/Gateway",
  "50901.ctrl_Safety.DCI.dciEnable": "Abilitazione Dci",
  "50901.ctrl_Safety.DCI.lowerLimit": "Corrente Limite Inferiore Dci",
  "50901.ctrl_Safety.DCI.lowerTime": "Tempo Limite Inferiore Dci",
  "50901.ctrl_Safety.DCI.upperLimit": "Corrente Limite Superiore Dci",
  "50901.ctrl_Safety.DCI.upperTime": "Tempo Limite Superiore Dci",
  "50901.ctrl_Safety.FRT.frtFuncCode": "Codice Funzione Frt",
  "50901.ctrl_Safety.FRT.frtHighLimit1": "Limite Superiore Frequenza 1",
  "50901.ctrl_Safety.FRT.frtHighLimit1Time": "Durata Limite Superiore Frequenza 1",
  "50901.ctrl_Safety.FRT.frtHighLimit2": "Limite Superiore Frequenza 2",
  "50901.ctrl_Safety.FRT.frtHighLimit2Time": "Durata Limite Superiore Frequenza 2",
  "50901.ctrl_Safety.FRT.frtHighLimit3": "Limite Superiore Frequenza 3",
  "50901.ctrl_Safety.FRT.frtHighLimit3Time": "Durata Limite Superiore Frequenza 3",
  "50901.ctrl_Safety.FRT.frtLowLimit1": "Limite Inferiore Frequenza 1",
  "50901.ctrl_Safety.FRT.frtLowLimit1Time": "Durata Limite Inferiore Frequenza 1",
  "50901.ctrl_Safety.FRT.frtLowLimit2": "Limite Inferiore Frequenza 2",
  "50901.ctrl_Safety.FRT.frtLowLimit2Time": "Durata Limite Inferiore Frequenza 2",
  "50901.ctrl_Safety.FRT.frtLowLimit3": "Limite Inferiore Frequenza 3",
  "50901.ctrl_Safety.FRT.frtLowLimit3Time": "Durata Limite Inferiore Frequenza 3",
  "50901.ctrl_Safety.FW.fwDiffInBatMode": "Abilitazione Differenza Modalità Batteria Fw",
  "50901.ctrl_Safety.FW.fwEnable": "Abilitazione Fw",
  "50901.ctrl_Safety.FW.fwFuncCode": "Codice Funzione Fw",
  "50901.ctrl_Safety.FW.fwOverEndFreq": "Frequenza Fine Sovrafrequenza Fw",
  "50901.ctrl_Safety.FW.fwOverStartFreq": "Frequenza Inizio Sovrafrequenza Fw",
  "50901.ctrl_Safety.FW.fwOverTransFreq": "Frequenza Transizione Sovrafrequenza Fw",
  "50901.ctrl_Safety.FW.fwRecoveryLowerFrequency": "Limite Inferiore Frequenza Ripristino Fw",
  "50901.ctrl_Safety.FW.fwRecoveryStableTime": "Tempo Stabilizzazione Ripristino Fw",
  "50901.ctrl_Safety.FW.fwRecoveryUpperFrequency": "Limite Superiore Frequenza Ripristino Fw",
  "50901.ctrl_Safety.FW.fwTr": "Tempo Fw_Tr",
  "50901.ctrl_Safety.FW.fwUnderEndFreq": "Frequenza Fine Sottofrequenza Fw",
  "50901.ctrl_Safety.FW.fwUnderStartFreq": "Frequenza Inizio Sottofrequenza Fw",
  "50901.ctrl_Safety.FW.fwUnderStopFreq": "Frequenza Arresto Sottofrequenza Fw",
  "50901.ctrl_Safety.RCD.continueLimitTime": "Tempo Limite Continuo Rcd",
  "50901.ctrl_Safety.RCD.continueLimitValue": "Corrente Limite Continuo Rcd",
  "50901.ctrl_Safety.RCD.rcdEnable": "Abilitazione Rcd",
  "50901.ctrl_Safety.RCD.step1LimitTime": "Tempo Limite Gradino 1 Rcd",
  "50901.ctrl_Safety.RCD.step1LimitValue": "Corrente Limite Gradino 1 Rcd",
  "50901.ctrl_Safety.RCD.step2LimitTime": "Tempo Limite Gradino 2 Rcd",
  "50901.ctrl_Safety.RCD.step2LimitValue": "Corrente Limite Gradino 2 Rcd",
  "50901.ctrl_Safety.RCD.step3LimitTime": "Tempo Limite Gradino 3 Rcd",
  "50901.ctrl_Safety.RCD.step3LimitValue": "Corrente Limite Gradino 3 Rcd",
  "50901.ctrl_Safety.RPC.gcfEn": "Abilitazione Gcf",
  "50901.ctrl_Safety.RPC.gcfFuncCode": "Codice Funzione Gcf",
  "50901.ctrl_Safety.RPC.rpcMode": "Modalità Rp",
  "50901.ctrl_Safety.RPC.rpcPf": "Fattore Di Potenza Pf Rpc",
  "50901.ctrl_Safety.RPC.rpcReactPowerRatio": "Rapporto Potenza Reattiva Rpc",
  "50901.ctrl_Safety.RPC.rpcTr": "Tempo Rpc_Tr",
  "50901.ctrl_Safety.RPC.vvFuncCode": "Codice Funzione Volt-Var",
  "50901.ctrl_Safety.RPC.vvLockIn": "Valore Soglia Inserzione Vv",
  "50901.ctrl_Safety.RPC.vvLockOut": "Valore Soglia Disinserzione Vv",
  "50901.ctrl_Safety.RPC.vvQ1": "Punto Reattivo Q1",
  "50901.ctrl_Safety.RPC.vvQ2": "Punto Reattivo Q2",
  "50901.ctrl_Safety.RPC.vvQ3": "Punto Reattivo Q3",
  "50901.ctrl_Safety.RPC.vvQ4": "Punto Reattivo Q4",
  "50901.ctrl_Safety.RPC.vvV1": "Punto Tensione V1",
  "50901.ctrl_Safety.RPC.vvV2": "Punto Tensione V2",
  "50901.ctrl_Safety.RPC.vvV3": "Punto Tensione V3",
  "50901.ctrl_Safety.RPC.vvV4": "Punto Tensione V4",
  "50901.ctrl_Safety.RPC.vvVref": "Valore Riferimento Vref",
  "50901.ctrl_Safety.RPC.vvVrefTr": "Tempo Riferimento Tr Vref",
  "50901.ctrl_Safety.RPC.wpfFuncCode": "Codice Funzione Wpf",
  "50901.ctrl_Safety.RPC.wpfLockIn": "Valore Soglia Inserzione Wpf",
  "50901.ctrl_Safety.RPC.wpfLockOut": "Valore Soglia Disinserzione Wpf",
  "50901.ctrl_Safety.RPC.wpfMinPFOver": "Pf Minimo Sovrapotenza Wpf",
  "50901.ctrl_Safety.RPC.wpfMinPFUnder": "Pf Minimo Sottopotenza Wpf",
  "50901.ctrl_Safety.RPC.wpfPowerEndRatio": "Rapporto Fine Potenza Wpf",
  "50901.ctrl_Safety.RPC.wpfPowerStartRatio": "Rapporto Inizio Potenza Wpf",
  "50901.ctrl_Safety.RR.rrFuncCode": "Codice Funzione Rr",
  "50901.ctrl_Safety.RR.rrRurNm": "Rr_Rur_Nm",
  "50901.ctrl_Safety.RR.rrRurSs": "Rr_Rur_Ss",
  "50901.ctrl_Safety.RT.rtFreqRecoveryHighValue": "Limite Superiore Recupero Frequenza Rt",
  "50901.ctrl_Safety.RT.rtFreqRecoveryLowValue": "Limite Inferiore Recupero Frequenza Rt",
  "50901.ctrl_Safety.RT.rtFuncCode": "Codice Funzione Rt",
  "50901.ctrl_Safety.RT.rtNMTime": "Tempo Rt_Nm",
  "50901.ctrl_Safety.RT.rtSRTTime": "Tempo Rt_Srt",
  "50901.ctrl_Safety.RT.rtVoltRecoveryHighValue": "Limite Superiore Recupero Tensione Rt",
  "50901.ctrl_Safety.RT.rtVoltRecoveryLowValue": "Limite Inferiore Recupero Tensione Rt",
  "50901.ctrl_Safety.VRT.vrt10MinAvgVoltage": "Tensione Media 10 Minuti",
  "50901.ctrl_Safety.VRT.vrtEn": "Abilitazione Vrt",
  "50901.ctrl_Safety.VRT.vrtFuncCode": "Codice Funzione Vrt",
  "50901.ctrl_Safety.VRT.vrtHighLimit": "Soglia Alta Tensione Vrt",
  "50901.ctrl_Safety.VRT.vrtLowLimit": "Soglia Bassa Tensione Vrt",
  "50901.ctrl_Safety.VRT.vrtRecoveryStableTime": "Tempo Stabilizzazione Ripristino Vrt",
  "50901.ctrl_Safety.VRT.vrtTransientOverTime": "Durata Sovratensione Istantanea",
  "50901.ctrl_Safety.VRT.vrtTransientOverVoltage": "Soglia Sovratensione Istantanea",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit1": "Limite Superiore Tensione 1",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit1Time": "Durata Limite Superiore Tensione 1",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit2": "Limite Superiore Tensione 2",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit2Time": "Durata Limite Superiore Tensione 2",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit3": "Limite Superiore Tensione 3",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit3Time": "Durata Limite Superiore Tensione 3",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit1": "Limite Inferiore Tensione 1",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit1Time": "Durata Limite Inferiore Tensione 1",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit2": "Limite Inferiore Tensione 2",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit2Time": "Durata Limite Inferiore Tensione 2",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit3": "Limite Inferiore Tensione 3",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit3Time": "Durata Limite Inferiore Tensione 3",
  "50901.ctrl_Safety.VW.vwDiffInBatMode": "Abilitazione Differenza Modalità Batteria Vw",
  "50901.ctrl_Safety.VW.vwEnable": "Abilitazione Vw",
  "50901.ctrl_Safety.VW.vwFuncCode": "Codice Funzione Vw",
  "50901.ctrl_Safety.VW.vwOverEndVolt": "Tensione Fine Sovratensione Vw",
  "50901.ctrl_Safety.VW.vwOverKPVolt": "Tensione Kp / Coefficiente Sovratensione Vw",
  "50901.ctrl_Safety.VW.vwOverStartVolt": "Tensione Inizio Sovratensione Vw",
  "50901.ctrl_Safety.VW.vwRecoveryLowerVoltage": "Limite Inferiore Tensione Ripristino Vw",
  "50901.ctrl_Safety.VW.vwRecoveryStableTime": "Tempo Stabilizzazione Ripristino Vw",
  "50901.ctrl_Safety.VW.vwRecoveryUpperVoltage": "Limite Superiore Tensione Ripristino Vw",
  "50901.ctrl_Safety.VW.vwTr": "Tempo Vw_Tr",
  "50901.ctrl_Safety.VW.vwUnderEndVolt": "Tensione Fine Sottotensione Vw",
  "50901.ctrl_Safety.VW.vwUnderKPVolt": "Tensione Kp / Coefficiente Sottotensione Vw",
  "50901.ctrl_Safety.VW.vwUnderStartVolt": "Tensione Inizio Sottotensione Vw",
  "50901.ctrl_Safety_GCF.gcfExportSoftLimitRatio": "Rapporto limite morbido esportazione GCF",
  "50901.Selfuse": "Autoconsumo",
  "50901.TOU": "Tariffa Oraria",
  "50901.ctrl_Config.Device.meterConfiguration.desc": "Descrizione configurazione contatore",
  "50901.ctrl_Config.Grid Profile.country.desc": "Descrizione standard paese/connessione alla rete",
  "50901.ctrl_Config.Device.meterConfiguration.0": "Nessun Tipo Contatore",
  "50901.ctrl_Config.Device.meterConfiguration.1": "Contatore Di Rete Configurato",
  "50901.ctrl_Config.Device.meterConfiguration.2": "Contatore Fv Configurato",
  "50901.ctrl_Config.Device.meterConfiguration.3": "Contatori Rete+ Fv Configurato",
  "50901.ctrl_WorkMode.Switch.workMode.0": "Autoconsumo",
  "50901.ctrl_WorkMode.Switch.workMode.1": "Modalità Economica",
  "50901.ctrl_WorkMode.Switch.workMode.2": "Modalità Riserva",
  "50901.ctrl_WorkMode.Switch.workMode.3": "Modalità Off-Grid",
  "50901.ctrl_WorkMode.Switch.workMode.4": "Modalità Carica Forzata",
  "50901.ctrl_WorkMode.Switch.workMode.5": "Modalità Scarica Forzata",
  "50901.ctrl_WorkMode.Switch.workMode.6": "Modalità Peak Shaving",
  "50901.ctrl_WorkMode.Switch.workMode.7": "Modalità TOU",
  "50901.ctrl_ESS_Advanced_Config.System.grid_ct_reverse_enable.0": "Disabilita",
  "50901.ctrl_ESS_Advanced_Config.System.grid_ct_reverse_enable.1": "Abilita",
  "50901.ctrl_ESS_Advanced_Config.System.pv_ct_reverse_enable.0": "Disabilita",
  "50901.ctrl_ESS_Advanced_Config.System.pv_ct_reverse_enable.1": "Abilita",
  "50901.ctrl_Config.Device.meterConfiguration": "Configurazione Contatore",
  "50901.ctrl_ESS_Advanced_Config.System.grid_ct_reverse_enable": "Abilita Inversione Ta Rete",
  "50901.ctrl_ESS_Advanced_Config.System.grid_meter_ratio": "Impostazione Rapporto Spire Ta Rete",
  "50901.ctrl_ESS_Advanced_Config.System.pv_ct_reverse_enable": "Abilita Inversione Ta Fotovoltaico",
  "50901.ctrl_ESS_Advanced_Config.System.pv_meter_ratio": "Impostazione Rapporto Spire Ta Fotovoltaico",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStartH": "Ora Inizio Carica Periodo Di Utilizzo 1",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStartH": "Ora Inizio Scarica Periodo Di Utilizzo 1",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStartH": "Ora Inizio Carica Periodo Di Utilizzo 2",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStartH": "Ora Inizio Scarica Periodo Di Utilizzo 2",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStartH": "Ora Inizio Carica Periodo Di Utilizzo 3",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStartH": "Ora Inizio Scarica Periodo Di Utilizzo 3",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStartH": "Ora Inizio Carica Periodo Di Utilizzo 4",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStartH": "Ora Inizio Scarica Periodo Di Utilizzo 4",
  "50901.ctrl_Config.Grid Profile.country.0": "UE EN_EN50549",
  "50901.ctrl_Config.Grid Profile.country.10": "Australie AU AS 4777 AZ",
  "50901.ctrl_Config.Grid Profile.country.11": "Philippines PH",
  "50901.ctrl_Config.Grid Profile.country.12": "Brésil BR_Inmetro_220V",
  "50901.ctrl_Config.Grid Profile.country.13": "Pakistan PAK_EN 50549",
  "50901.ctrl_Config.Grid Profile.country.14": "Thaïlande THA-PEA",
  "50901.ctrl_Config.Grid Profile.country.15": "Italie IT_CEIO-21",
  "50901.ctrl_Config.Grid Profile.country.17": "Colombie CNO_1862_240V",
  "50901.ctrl_Config.Grid Profile.country.19": "Royaume-Uni UK_G98/G99",
  "50901.ctrl_Config.Grid Profile.country.2": "Australie AU_AS4777_A",
  "50901.ctrl_Config.Grid Profile.country.20": "Royaume-Uni UK_G98NI/G99NI",
  "50901.ctrl_Config.Grid Profile.country.21": "Équateur EC_IEEE1547",
  "50901.ctrl_Config.Grid Profile.country.22": "Slovénie SI_EN 50549",
  "50901.ctrl_Config.Grid Profile.country.23": "France FR_VFR 2019",
  "50901.ctrl_Config.Grid Profile.country.24": "Espagne ES_RD1699",
  "50901.ctrl_Config.Grid Profile.country.25": "Espagne ES_RD647",
  "50901.ctrl_Config.Grid Profile.country.26": "Lituanie LT_EN50549",
  "50901.ctrl_Config.Grid Profile.country.28": "Thaïlande THA-EMA",
  "50901.ctrl_Config.Grid Profile.country.3": "Autriche AT_TOR",
  "50901.ctrl_Config.Grid Profile.country.31": "Royaume-Uni UK_G98",
  "50901.ctrl_Config.Grid Profile.country.32": "Royaume-Uni UK_G99",
  "50901.ctrl_Config.Grid Profile.country.33": "Royaume-Uni UK_G98NI",
  "50901.ctrl_Config.Grid Profile.country.34": "Royaume-Uni UK_G99NI",
  "50901.ctrl_Config.Grid Profile.country.35": "Viêt Nam VN_CCDE",
  "50901.ctrl_Config.Grid Profile.country.36": "Panama PA_GRID_240V",
  "50901.ctrl_Config.Grid Profile.country.37": "Brésil BR_Inmetro_220V_US",
  "50901.ctrl_Config.Grid Profile.country.38": "Porto Rico LUMAPR-2024_208V",
  "50901.ctrl_Config.Grid Profile.country.39": "Porto Rico LUMAPR-2024_240V",
  "50901.ctrl_Config.Grid Profile.country.4": "Pologne PL_EN50549",
  "50901.ctrl_Config.Grid Profile.country.40": "Inde IND_IEC61727",
  "50901.ctrl_Config.Grid Profile.country.41": "Roumanie RO_Ordinul208_2018",
  "50901.ctrl_Config.Grid Profile.country.42": "Chine CN_GRID_2025",
  "50901.ctrl_Config.Grid Profile.country.43": "Irak IRAQ_GRID_2025",
  "50901.ctrl_Config.Grid Profile.country.46": "Arabie Saoudite SA_GRID_2025",
  "50901.ctrl_Config.Grid Profile.country.47": "Sri Lanka LK_IEC61727",
  "50901.ctrl_Config.Grid Profile.country.48": "République tchèque CZ_PPDS2020",
  "50901.ctrl_Config.Grid Profile.country.49": "Belgique BE_C10_26",
  "50901.ctrl_Config.Grid Profile.country.5": "Estonie EE_EVS_EN50549",
  "50901.ctrl_Config.Grid Profile.country.50": "Pays-Bas NL_NEN_EN50549_1",
  "50901.ctrl_Config.Grid Profile.country.51": "Ukraine UA_EN50549_1",
  "50901.ctrl_Config.Grid Profile.country.52": "Canada CA_IEEE1547_240V",
  "50901.ctrl_Config.Grid Profile.country.53": "Canada CA_IEEE1547_208V",
  "50901.ctrl_Config.Grid Profile.country.54": "Malaisie MY_CODE",
  "50901.ctrl_Config.Grid Profile.country.55": "Indonésie ID_GRID_220V",
  "50901.ctrl_Config.Grid Profile.country.56": "Afrique du Sud ZA_NRS097_2024",
  "50901.ctrl_Config.Grid Profile.country.57": "Suède SE_SS-EN 50549",
  "50901.ctrl_Config.Grid Profile.country.58": "Grèce GR_VDE0126",
  "50901.ctrl_Config.Grid Profile.country.59": "Luxembourg LU_EN50549",
  "50901.ctrl_Config.Grid Profile.country.6": "Hongrie HU_EN50549",
  "50901.ctrl_Config.Grid Profile.country.60": "Irlande IE_EN50438",
  "50901.ctrl_Config.Grid Profile.country.61": "Zambie ZAM_GRID_2025",
  "50901.ctrl_Config.Grid Profile.country.62": "Générateur GEN_GRID_50Hz",
  "50901.ctrl_Config.Grid Profile.country.63": "Générateur GEN_GRID_60Hz",
  "50901.ctrl_Config.Grid Profile.country.64": "Arabie Saoudite SA_GRID_2025_265V",
  "50901.ctrl_Config.Grid Profile.country.65": "Serbie SRB_EN50549_1",
  "50901.ctrl_Config.Grid Profile.country.66": "Suisse CH_NAEEA_NE7",
  "50901.ctrl_Config.Grid Profile.country.67": "Liban LB_GRID_2025",
  "50901.ctrl_Config.Grid Profile.country.68": "Chili CL_GRID_220V",
  "50901.ctrl_Config.Grid Profile.country.69": "Syrie SYR_GRID_2026",
  "50901.ctrl_Config.Grid Profile.country.7": "Australie AU_AS4777_B",
  "50901.ctrl_Config.Grid Profile.country.8": "Australie AU_AS4777_C",
  "alarm.trigger.condition": "attivato dal dispositivo",
  "alarm.iot": "IoT allarme",
  "module.alarmInfo": "Informazioni sull'allarme",
  "edit.failed": "Non è stato possibile modificare",
  "50901.real_time.BatteryModel.1": "Haier HV",
  "tag_test_3": "tag_test_3",
  "Transit_Warehouse": "Entrepôt de transit",
  "bw_Param_strl_option_GridUseMeter": "La rete elettrica utilizza contatori elettrici",
  "bw_Param_strl_option_GridUseCT": "La rete elettrica utilizza CT",
  "50901.fault.dSPSAFcomparatorFault": "Guasto Comparatore",
  "50901.fault.dSPPWRfanFault": "Guasto Ventola",
  "50901.fault.dSPPWRgridRelayProtection": "Protezione relè rete attivata",
  "50901.fault.dSPPWRmachineTypeMismatch": "Mancata Corrispondenza Tipo Macchina",
  "50901.fault.dSPSAFbatteryFault": "Guasto Batteria",
  "50901.fault.dSPSAFfanFault": "Guasto Ventola",
  "50901.fault.dSPSAFgridRelayProtection": "Innesco Protezione Relè Di Rete",
  "50901.fault.dSPPWRbatteryFault": "Guasto Lato Batteria",
  "50901.fault.dSPPWRcomparatorFault": "Guasto comparatore",
  "50901.fault.dSPSAFauxiliaryPowerAbnormality": "Anomalia Alimentazione Ausiliaria",
  "50901.fault.dSPSAFmachineTypeMismatch": "Mancata Corrispondenza Tipo Macchina",
  "50901.fault.dSPSAFsamplingBiasAbnormality": "Anomalia Bias Campionamento",
  "50901.fault.canCommunicationTimeout": "Timeout Comunicazione Can",
  "50901.fault.dSPPWRauxiliaryPowerAbnormality": "Alimentazione ausiliaria anomala",
  "50901.fault.dSPSAFarmCommunicationFault": "Guasto Comunicazione Arm",
  "50901.fault.dSPSAFspiCommunicationFault": "Guasto Comunicazione Spi",
  "50901.fault.dSPSAFversionMismatch": "Mancata Corrispondenza Versione",
  "50901.fault.dSPPWRarmCommunicationFault": "Guasto Comunicazione Arm",
  "50901.fault.dSPPWRsamplingBiasAbnormality": "Anomalia Bias Campionamento",
  "50901.fault.dSPPWRspiCommunicationFault": "Guasto Comunicazione Spi",
  "50901.fault.dSPPWRversionMismatch": "Mancata Corrispondenza Versione (Incoerenza Versione Software/Hardware)",
  "50901.fault.hardwareProtection": "Innesco Protezione Hardware",
  "50901.fault.lowBatteryEnergy": "Energia Batteria Troppo Bassa",
  "50901.fault.dSPPWRgridRelayProtection.0": "Disabilita",
  "50901.fault.dSPPWRgridRelayProtection.1": "Abilita",
  "50901.fault.dSPPWRmachineTypeMismatch.0": "Disabilita",
  "50901.fault.dSPPWRmachineTypeMismatch.1": "Abilita",
  "50901.fault.dSPPWRsamplingBiasAbnormality.0": "Disabilita",
  "50901.fault.dSPPWRbatteryFault.1": "Abilita",
  "50901.fault.dSPPWRcomparatorFault.0": "Disabilita",
  "50901.fault.dSPPWRcomparatorFault.1": "Abilita",
  "50901.fault.dSPPWRfanFault.0": "Disabilita",
  "50901.fault.dSPPWRfanFault.1": "Abilita",
  "50901.fault.canCommunicationTimeout.1": "Abilita",
  "50901.fault.dSPPWRarmCommunicationFault.0": "Disabilita",
  "50901.fault.dSPPWRarmCommunicationFault.1": "Abilita",
  "50901.fault.dSPPWRauxiliaryPowerAbnormality.0": "Disabilita",
  "50901.fault.dSPPWRauxiliaryPowerAbnormality.1": "Abilita",
  "50901.fault.dSPPWRbatteryFault.0": "Disabilita",
  "50901.fault.canCommunicationTimeout.0": "Disabilita",
  "50901.fault.dSPPWRsamplingBiasAbnormality.1": "Abilita",
  "50901.fault.hardwareProtection.1": "Abilita",
  "50901.fault.lowBatteryEnergy.0": "Disabilita",
  "50901.fault.lowBatteryEnergy.1": "Abilita",
  "50901.fault.dSPSAFsamplingBiasAbnormality.1": "Abilita",
  "50901.fault.dSPSAFspiCommunicationFault.0": "Disabilita",
  "50901.fault.dSPSAFspiCommunicationFault.1": "Abilita",
  "50901.fault.dSPSAFversionMismatch.0": "Disabilita",
  "50901.fault.dSPSAFversionMismatch.1": "Abilita",
  "50901.fault.hardwareProtection.0": "Disabilita",
  "50901.fault.dSPSAFarmCommunicationFault.0": "Disabilita",
  "50901.fault.dSPSAFgridRelayProtection.1": "Abilita",
  "50901.fault.dSPSAFmachineTypeMismatch.0": "Disabilita",
  "50901.fault.dSPSAFmachineTypeMismatch.1": "Abilita",
  "50901.fault.dSPSAFsamplingBiasAbnormality.0": "Disabilita",
  "50901.fault.dSPSAFbatteryFault.0": "Disabilita",
  "50901.fault.dSPSAFbatteryFault.1": "Abilita",
  "50901.fault.dSPSAFcomparatorFault.0": "Disabilita",
  "50901.fault.dSPSAFcomparatorFault.1": "Abilita",
  "50901.fault.dSPSAFfanFault.0": "Disabilita",
  "50901.fault.dSPSAFfanFault.1": "Abilita",
  "50901.fault.dSPPWRversionMismatch.0": "Disabilita",
  "50901.fault.dSPPWRversionMismatch.1": "Abilita",
  "50901.fault.dSPSAFarmCommunicationFault.1": "Abilita",
  "50901.fault.dSPSAFauxiliaryPowerAbnormality.0": "Disabilita",
  "50901.fault.dSPSAFauxiliaryPowerAbnormality.1": "Abilita",
  "50901.fault.dSPPWRspiCommunicationFault.0": "Disabilita",
  "50901.fault.dSPPWRspiCommunicationFault.1": "Abilita",
  "50901.fault.dSPSAFgridRelayProtection.0": "Disabilita",
  "50901..数据分析_电网功率.tag": "Potenza della rete elettrica",
  "50901..数据分析_单体SOC.tag": "Soc Singola Cella",
  "50901..数据分析_发电机功率.tag": "Potenza del generatore",
  "50901..数据分析_混逆光伏功率.tag": "Potenza Fotovoltaica Dell’inverter Ibrido",
  "50901..数据分析_电池包.tag": "Pacchetto di batterie",
  "50901..数据分析_电网电压.tag": "Tensione Di Rete",
  "50901..数据分析_电网电流.tag": "Corrente della rete elettrica",
  "50901.ctrl_Dry_Contact.HeatPump.hpBattSocDetectMode.desc": "Modalità Di Abilitazione Soc Per Batterie Della Pompa Di Calore 0: Disabilita 1: Abilita",
  "50901.ctrl_Dry_Contact.HeatPump.hpCloseSoc.desc": "Leggere, scrivere, segnalare",
  "50901.ctrl_Dry_Contact.HeatPump.hpDelayDetectTimeLmt.desc": "Leggere, scrivere, segnalare",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxFeedbackPower.desc": "Potenza Massima Di Immissione In Rete Della Pompa Di Calore",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxRunTimeOfOneDay.desc": "Leggere, scrivere, segnalare",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxTimeDetectEnable.desc": "Leggere, scrivere, segnalare",
  "50901.ctrl_Dry_Contact.HeatPump.hpMinRunTimeLmtOfOnce.desc": "Quando Il Tempo Di Funzionamento Singolo Raggiunge Questo Valore, La Modalità Di Controllo Della Pompa Di Calore È Disabilitata",
  "50901.ctrl_Dry_Contact.HeatPump.hpStartPower.desc": "Leggere, scrivere, segnalare",
  "50901.ctrl_Dry_Contact.HeatPump.hpStartSoc.desc": "Quando Il Soc Della Batteria Raggiunge Questo Valore, La Modalità Di Controllo Della Pompa Di Calore È Abilitata",
  "50901.ctrl_Dry_Contact.HeatPump.hpSupplyPower.desc": "Leggere, scrivere, segnalare",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkTimeParts.desc": "È Possibile Impostare Fino A 4 Periodi Di Funzionamento",
  "50901.Fault": "Guasto",
  "50901.Fault.arcFault.0": "Disabilita",
  "50901.Fault.arcFault.1": "Abilita",
  "50901.Fault.arcSelfTestFault.0": "Disabilita",
  "50901.Fault.arcSelfTestFault.1": "Abilita",
  "50901.Fault.batteryCapacityAbnormality.0": "Disable",
  "50901.Fault.batteryCapacityAbnormality.1": "enable",
  "50901.Fault.batteryForceChargeRequest.0": "disable",
  "50901.Fault.batteryForceChargeRequest.1": "enable",
  "50901.Fault.bmsCanCommunicationAbnormality.0": "Disabilita",
  "50901.Fault.bmsCanCommunicationAbnormality.1": "Abilita",
  "50901.Fault.busbarAbnormality.0": "Disabilita",
  "50901.Fault.busbarAbnormality.1": "Abilita",
  "50901.Fault.cmpssBiasCalculationError.0": "Disabilita",
  "50901.Fault.cmpssBiasCalculationError.1": "Abilita",
  "50901.Fault.driveAbnormality.0": "Disabilita",
  "50901.Fault.driveAbnormality.1": "Abilita",
  "50901.Fault.dspPwrCommunicationAbnormality.0": "disable",
  "50901.Fault.dspPwrCommunicationAbnormality.1": "Abilita",
  "50901.Fault.dspSafCommunicationAbnormality.0": "Disable",
  "50901.Fault.dspSafCommunicationAbnormality.1": "enable",
  "50901.Fault.dtsCommunicationAbnormality.0": "Disabilita",
  "50901.Fault.dtsCommunicationAbnormality.1": "Abilita",
  "50901.Fault.dtu1Rs485CommunicationAbnormality.0": "Disable",
  "50901.Fault.dtu1Rs485CommunicationAbnormality.1": "enable",
  "50901.Fault.dtu2Rs485CommunicationAbnormality.0": "disable",
  "50901.Fault.dtu2Rs485CommunicationAbnormality.1": "Enable",
  "50901.Fault.dtu3Rs485CommunicationAbnormality.0": "disable",
  "50901.Fault.dtu3Rs485CommunicationAbnormality.1": "Enable",
  "50901.Fault.dtu4Rs485CommunicationAbnormality.0": "disable",
  "50901.Fault.dtu4Rs485CommunicationAbnormality.1": "enable",
  "50901.Fault.dtu5Rs485CommunicationAbnormality.0": "Disable",
  "50901.Fault.dtu5Rs485CommunicationAbnormality.1": "enable",
  "50901.Fault.e2rpomFault.0": "Disabilita",
  "50901.Fault.e2rpomFault.1": "Abilita",
  "50901.Fault.epsOverload.0": "Disabilita",
  "50901.Fault.epsOverload.1": "Abilita",
  "50901.Fault.epsRelayProtection.0": "Disabilita",
  "50901.Fault.epsRelayProtection.1": "Abilita",
  "50901.Fault.epsVoltageAbnormality.0": "Disabilita",
  "50901.Fault.epsVoltageAbnormality.1": "Abilita",
  "50901.Fault.evCharger1CommunicationAbnormality.0": "Disable",
  "50901.Fault.evCharger1CommunicationAbnormality.1": "enable",
  "50901.Fault.evCharger1Fault.0": "disable",
  "50901.Fault.evCharger1Fault.1": "enable",
  "50901.Fault.evCharger2CommunicationAbnormality.0": "disable",
  "50901.Fault.evCharger2CommunicationAbnormality.1": "Enable",
  "50901.Fault.evCharger2Fault.0": "Disable",
  "50901.Fault.evCharger2Fault.1": "enable",
  "50901.Fault.fanSpeedAbnormality.0": "Disabilita",
  "50901.Fault.fanSpeedAbnormality.1": "Enable",
  "50901.Fault.flashCommunicationFault.0": "Disabilita",
  "50901.Fault.flashCommunicationFault.1": "Abilita",
  "50901.Fault.frequencyVariationRateOutOfRange.0": "Disabilita",
  "50901.Fault.frequencyVariationRateOutOfRange.1": "Abilita",
  "50901.Fault.genAbnormality.0": "Disabilita",
  "50901.Fault.genAbnormality.1": "Abilita",
  "50901.Fault.genOverload.0": "Disabilita",
  "50901.Fault.genOverload.1": "Abilita",
  "50901.fault.genRelayAFault.0": "disable",
  "50901.fault.genRelayAFault.1": "Enable",
  "50901.Fault.gridCurrentDcOffsetOutOfRange.0": "Disabilita",
  "50901.Fault.gridCurrentDcOffsetOutOfRange.1": "Abilita",
  "50901.Fault.gridMeterCommunicationAbnormality.0": "Disable",
  "50901.Fault.gridMeterCommunicationAbnormality.1": "Abilita",
  "50901.Fault.gridMeterTypeError.0": "disable",
  "50901.Fault.gridMeterTypeError.1": "Enable",
  "50901.Fault.gridOffVoltageDcOffsetOutOfRange.0": "Disabilita",
  "50901.Fault.gridOffVoltageDcOffsetOutOfRange.1": "Abilita",
  "50901.Fault.gridOverfrequency.0": "Disabilita",
  "50901.Fault.gridOverfrequency.1": "Abilita",
  "50901.Fault.gridOvervoltage.0": "Disabilita",
  "50901.Fault.gridOvervoltage.1": "Abilita",
  "50901.fault.gridPortOvercurrent.0": "Disabilita",
  "50901.fault.gridPortOvercurrent.1": "enable",
  "50901.Fault.gridPowerOutage.0": "Disabilita",
  "50901.Fault.gridPowerOutage.1": "Abilita",
  "50901.Fault.gridUnderfrequency.0": "Disabilita",
  "50901.Fault.gridUnderfrequency.1": "Abilita",
  "50901.Fault.gridUndervoltage.0": "Disabilita",
  "50901.Fault.gridUndervoltage.1": "Abilita",
  "50901.Fault.gridVoltageAbnormality.0": "Disabilita",
  "50901.Fault.gridVoltageAbnormality.1": "Abilita",
  "50901.Fault.hmidCommunicationAbnormality.0": "Disable",
  "50901.Fault.hmidCommunicationAbnormality.1": "enable",
  "50901.Fault.hmidMachineFault.0": "disable",
  "50901.Fault.hmidMachineFault.1": "Enable",
  "50901.Fault.insulationFault.0": "Disabilita",
  "50901.Fault.insulationFault.1": "Abilita",
  "50901.Fault.interruptOverflow.0": "Disabilita",
  "50901.Fault.interruptOverflow.1": "Abilita",
  "50901.fault.inverterCanCommunicationFailed.0": "Disable",
  "50901.fault.inverterCanCommunicationFailed.1": "enable",
  "50901.Fault.lineToEarthFault.0": "Disabilita",
  "50901.Fault.lineToEarthFault.1": "Abilita",
  "50901.fault.loadRelayAFault.0": "disable",
  "50901.fault.loadRelayAFault.1": "Abilita",
  "50901.fault.loadRelayBFault.0": "Disable",
  "50901.fault.loadRelayBFault.1": "enable",
  "50901.Fault.lowAmbientTemperature.0": "Disabilita",
  "50901.Fault.lowAmbientTemperature.1": "Abilita",
  "50901.Fault.lowDtuVersion.0": "Disable",
  "50901.Fault.lowDtuVersion.1": "Abilita",
  "50901.Fault.masterSlaveCommunicationAbnormality.0": "Disable",
  "50901.Fault.masterSlaveCommunicationAbnormality.1": "enable",
  "50901.Fault.meterWiringAbnormality.0": "Disabilita",
  "50901.Fault.meterWiringAbnormality.1": "Abilita",
  "50901.Fault.microelectronicFault.0": "Disabilita",
  "50901.Fault.microelectronicFault.1": "Abilita",
  "50901.Fault.neutralWireNotConnected.0": "Disabilita",
  "50901.Fault.neutralWireNotConnected.1": "Abilita",
  "50901.Fault.neutralWireToEarthFault.0": "Disabilita",
  "50901.Fault.neutralWireToEarthFault.1": "Abilita",
  "50901.Fault.overTemperature.0": "Disabilita",
  "50901.Fault.overTemperature.1": "Abilita",
  "50901.fault.overtemperatureAlarm.0": "disable",
  "50901.fault.overtemperatureAlarm.1": "Enable",
  "50901.Fault.pllLockFailed.0": "Disabilita",
  "50901.Fault.pllLockFailed.1": "Abilita",
  "50901.Fault.preSynchronizationFailed.0": "Disabilita",
  "50901.Fault.preSynchronizationFailed.1": "Abilita",
  "50901.Fault.pvFault.0": "Disabilita",
  "50901.Fault.pvFault.1": "Abilita",
  "50901.Fault.pvMeterCommunicationAbnormality.0": "Disabilita",
  "50901.Fault.pvMeterCommunicationAbnormality.1": "enable",
  "50901.Fault.pvMeterTypeError.0": "disable",
  "50901.Fault.pvMeterTypeError.1": "Enable",
  "50901.fault.pvRelayAbFault.0": "Disable",
  "50901.fault.pvRelayAbFault.1": "enable",
  "50901.Fault.pvVoltageExceedingBusVoltage.0": "Disabilita",
  "50901.Fault.pvVoltageExceedingBusVoltage.1": "Abilita",
  "50901.Fault.rcdFault.0": "Disabilita",
  "50901.Fault.rcdFault.1": "Abilita",
  "50901.Fault.rcdSelfTestFault.0": "Disabilita",
  "50901.Fault.rcdSelfTestFault.1": "Abilita",
  "50901.Fault.reconnectionFailed.0": "Disabilita",
  "50901.Fault.reconnectionFailed.1": "Abilita",
  "50901.Fault.shutDown.0": "Disabilita",
  "50901.Fault.shutDown.1": "Abilita",
  "50901.Fault.slaveWrongBatteryConnection.0": "Disable",
  "50901.Fault.slaveWrongBatteryConnection.1": "enable",
  "50901.fault.smartloadPortOvercurrent.0": "disable",
  "50901.fault.smartloadPortOvercurrent.1": "Enable",
  "50901.Fault.sustainedNegativeLoad.0": "Disabilita",
  "50901.Fault.sustainedNegativeLoad.1": "Abilita",
  "50901.Fault.temperatureAbnormality.0": "Disabilita",
  "50901.Fault.temperatureAbnormality.1": "Abilita",
  "50901.Fault.tenMinuteOvervoltage.0": "Disabilita",
  "50901.Fault.tenMinuteOvervoltage.1": "Abilita",
  "50901.fault.threePointThreeVoltPowerSupplyFault.0": "disable",
  "50901.fault.threePointThreeVoltPowerSupplyFault.1": "enable",
  "50901.Fault.wiringAbnormality.0": "Disabilita",
  "50901.Fault.wiringAbnormality.1": "Abilita",
  "50901.HeatPump": "Controllo Della Pompa Di Calore",
  "50901.real_time": "Significato Del Valore Di Enumerazione 0",
  "50901.warning": "Controllo Della Pompa Di Calore",
  "50901.warning.batteryHighVoltageAlarm.0": "Disabilita",
  "50901.warning.batteryHighVoltageAlarm.1": "Abilita",
  "50901.warning.batteryLowVoltageAlarm.0": "disable",
  "50901.warning.batteryLowVoltageAlarm.1": "Enable",
  "50901.warning.batteryPackChargeHighVoltageAlarm.0": "disable",
  "50901.warning.batteryPackChargeHighVoltageAlarm.1": "enable",
  "50901.warning.batteryPackDischargeLowVoltageAlarm.0": "Disabilita",
  "50901.warning.batteryPackDischargeLowVoltageAlarm.1": "enable",
  "50901.warning.chargeHighTemperatureAlarm.0": "disable",
  "50901.warning.chargeHighTemperatureAlarm.1": "Enable",
  "50901.warning.chargeLowTemperatureAlarm.0": "disable",
  "50901.warning.chargeLowTemperatureAlarm.1": "Enable",
  "50901.warning.dischargeHighTemperatureAlarm.0": "Disabilita",
  "50901.warning.dischargeHighTemperatureAlarm.1": "Enable",
  "50901.warning.dischargeLowTemperatureAlarm.0": "disable",
  "50901.warning.dischargeLowTemperatureAlarm.1": "enable",
  "50901.warning.inputOvervoltageAlarm.0": "disable",
  "50901.warning.inputOvervoltageAlarm.1": "Enable",
  "50901..cfgMultPcsBmsFlag.0": "No",
  "50901..cfgMultPcsBmsFlag.1": "Sì",
  "50901..hpTime2WeekRange1.0": "Disabilita",
  "50901..hpTime2WeekRange1.1": "enable",
  "50901..hpTime2WeekRange2.0": "disable",
  "50901..hpTime2WeekRange2.1": "Enable",
  "50901..hpTime2WeekRange3.0": "disable",
  "50901..hpTime2WeekRange3.1": "Abilita",
  "50901..hpTime2WeekRange4.0": "Disabilita",
  "50901..hpTime2WeekRange4.1": "Enable",
  "50901..hpTime2WeekRange5.0": "disable",
  "50901..hpTime2WeekRange5.1": "enable",
  "50901..hpTime2WeekRange6.0": "Disable",
  "50901..hpTime2WeekRange6.1": "Abilita",
  "50901..hpTime2WeekRange7.0": "Disabilita",
  "50901..hpTime2WeekRange7.1": "Enable",
  "50901..hpTime3WeekRange1.0": "disable",
  "50901..hpTime3WeekRange1.1": "enable",
  "50901..hpTime3WeekRange2.0": "Disable",
  "50901..hpTime3WeekRange2.1": "Abilita",
  "50901..hpTime3WeekRange3.0": "Disabilita",
  "50901..hpTime3WeekRange3.1": "Enable",
  "50901..hpTime3WeekRange4.0": "disable",
  "50901..hpTime3WeekRange4.1": "enable",
  "50901..hpTime3WeekRange5.0": "Disable",
  "50901..hpTime3WeekRange5.1": "Abilita",
  "50901..hpTime3WeekRange6.0": "Disabilita",
  "50901..hpTime3WeekRange6.1": "Enable",
  "50901..hpTime3WeekRange7.0": "disable",
  "50901..hpTime3WeekRange7.1": "Enable",
  "50901..hpTime4WeekRange1.0": "disable",
  "50901..hpTime4WeekRange1.1": "Abilita",
  "50901..hpTime4WeekRange2.0": "Disabilita",
  "50901..hpTime4WeekRange2.1": "Enable",
  "50901..hpTime4WeekRange3.0": "disable",
  "50901..hpTime4WeekRange3.1": "enable",
  "50901..hpTime4WeekRange4.0": "Disable",
  "50901..hpTime4WeekRange4.1": "Abilita",
  "50901..hpTime4WeekRange5.0": "Disabilita",
  "50901..hpTime4WeekRange5.1": "enable",
  "50901..hpTime4WeekRange6.0": "Disable",
  "50901..hpTime4WeekRange6.1": "enable",
  "50901..hpTime4WeekRange7.0": "Disable",
  "50901..hpTime4WeekRange7.1": "Abilita",
  "50901..materType.0": "Nessun Contatore Lato Rete",
  "50901..materType.1": "Monofase",
  "50901..materType.2": "Chint Monofase",
  "50901..materType.3": "Phase di fissura",
  "50901..materType.5": "Modulo Di Misura",
  "50901..materType.6": "Strada singola di Ancore",
  "50901..materType.7": "La doppia strada di Ancore",
  "50901..section1WeekRange1.0": "Lunedì",
  "50901..section1WeekRange1.1": "Martedì",
  "50901..section1WeekRange1.2": "Mercoledì",
  "50901..section1WeekRange1.3": "giovedì",
  "50901..section1WeekRange1.4": "venerdì",
  "50901..section1WeekRange1.5": "Sabato",
  "50901..section1WeekRange1.6": "Domenica",
  "50901..section1WeekRange2.0": "Significato Del Valore Di Enumerazione 0",
  "50901..section1WeekRange2.1": "Significato Del Valore Di Enumerazione 1",
  "50901..section2WeekRange1.0": "Significato Del Valore Di Enumerazione 0",
  "50901..section2WeekRange1.1": "Significato Del Valore Di Enumerazione 2",
  "50901..section3WeekRange1.0": "Significato Del Valore Di Enumerazione 0",
  "50901..section3WeekRange1.1": "Significato Del Valore Di Enumerazione 2",
  "50901..section4WeekRange1.0": "Significato Del Valore Di Enumerazione 0",
  "50901..section4WeekRange1.1": "Significato del valore 2",
  "50901.ctrl_Dry_Contact.HeatPump.hpBattSocDetectMode.0": "No",
  "50901.ctrl_Dry_Contact.HeatPump.hpBattSocDetectMode.1": "Sì",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange1.0": "Non permette",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange1.1": "Potenziare",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange2.0": "Non permette",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange2.1": "Abilita",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange3.0": "Disabilita",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange3.1": "Potenziare",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange4.0": "Non permette",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange4.1": "Potenziare",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange5.0": "Non permette",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange5.1": "Abilita",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange6.0": "Disabilita",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange6.1": "Potenziare",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange7.0": "Non permette",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange7.1": "Potenziare",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkMode.0": "No",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkMode.1": "Sì",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.6": "Controllo della pompa di calore",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange27.0": "Non permette",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange27.1": "Potenziare",
  "50901.ctrl_WorkMode.economic.section1WeekRange11.0": "Non permette",
  "50901.ctrl_WorkMode.economic.section1WeekRange11.1": "Potenziare",
  "50901.ctrl_WorkMode.economic.section1WeekRange12.0": "Disabilita",
  "50901.ctrl_WorkMode.economic.section1WeekRange12.1": "Abilita",
  "50901.ctrl_WorkMode.economic.section1WeekRange13.0": "Non permette",
  "50901.ctrl_WorkMode.economic.section1WeekRange13.1": "Potenziare",
  "50901.ctrl_WorkMode.economic.section1WeekRange14.0": "Non permette",
  "50901.ctrl_WorkMode.economic.section1WeekRange14.1": "Potenziare",
  "50901.ctrl_WorkMode.economic.section1WeekRange15.0": "Disabilita",
  "50901.ctrl_WorkMode.economic.section1WeekRange15.1": "Abilita",
  "50901.ctrl_WorkMode.economic.section1WeekRange16.0": "Non permette",
  "50901.ctrl_WorkMode.economic.section1WeekRange16.1": "Potenziare",
  "50901.ctrl_WorkMode.economic.section1WeekRange17.0": "Non permette",
  "50901.ctrl_WorkMode.economic.section1WeekRange17.1": "Abilita",
  "50901.ctrl_WorkMode.economic.section1WeekRange21.0": "Disabilita",
  "50901.ctrl_WorkMode.economic.section1WeekRange21.1": "Potenziare",
  "50901.ctrl_WorkMode.economic.section1WeekRange22.0": "Non permette",
  "50901.ctrl_WorkMode.economic.section1WeekRange22.1": "Potenziare",
  "50901.ctrl_WorkMode.economic.section1WeekRange23.0": "Non permette",
  "50901.ctrl_WorkMode.economic.section1WeekRange23.1": "Abilita",
  "50901.ctrl_WorkMode.economic.section1WeekRange24.0": "Disabilita",
  "50901.ctrl_WorkMode.economic.section1WeekRange24.1": "Potenziare",
  "50901.ctrl_WorkMode.economic.section1WeekRange25.0": "Non permette",
  "50901.ctrl_WorkMode.economic.section1WeekRange25.1": "Potenziare",
  "50901.ctrl_WorkMode.economic.section1WeekRange26.0": "Non permette",
  "50901.ctrl_WorkMode.economic.section1WeekRange26.1": "Abilita",
  "50901.ctrl_WorkMode.economic.section1WeekRange27.0": "Disabilita",
  "50901.ctrl_WorkMode.economic.section1WeekRange27.1": "Potenziare",
  "50901.ctrl_WorkMode.economic.section2WeekRange11.0": "Non permette",
  "50901.ctrl_WorkMode.economic.section2WeekRange11.1": "Potenziare",
  "50901.ctrl_WorkMode.economic.section2WeekRange12.0": "Non permette",
  "50901.ctrl_WorkMode.economic.section2WeekRange12.1": "Abilita",
  "50901.ctrl_WorkMode.economic.section2WeekRange13.0": "Disabilita",
  "50901.ctrl_WorkMode.economic.section2WeekRange13.1": "Potenziare",
  "50901.ctrl_WorkMode.economic.section2WeekRange14.0": "Non permette",
  "50901.ctrl_WorkMode.economic.section2WeekRange14.1": "Potenziare",
  "50901.ctrl_WorkMode.economic.section2WeekRange15.0": "Non permette",
  "50901.ctrl_WorkMode.economic.section2WeekRange15.1": "Abilita",
  "50901.ctrl_WorkMode.economic.section2WeekRange16.0": "Disabilita",
  "50901.ctrl_WorkMode.economic.section2WeekRange16.1": "Potenziare",
  "50901.ctrl_WorkMode.economic.section2WeekRange17.0": "Non permette",
  "50901.ctrl_WorkMode.economic.section2WeekRange17.1": "Potenziare",
  "50901.ctrl_WorkMode.economic.section2WeekRange21.0": "Non permette",
  "50901.ctrl_WorkMode.economic.section2WeekRange21.1": "Abilita",
  "50901.ctrl_WorkMode.economic.section2WeekRange22.0": "Disabilita",
  "50901.ctrl_WorkMode.economic.section2WeekRange22.1": "Potenziare",
  "50901.ctrl_WorkMode.economic.section2WeekRange23.0": "Non permette",
  "50901.ctrl_WorkMode.economic.section2WeekRange23.1": "Potenziare",
  "50901.ctrl_WorkMode.economic.section2WeekRange24.0": "Non permette",
  "50901.ctrl_WorkMode.economic.section2WeekRange24.1": "Abilita",
  "50901.ctrl_WorkMode.economic.section2WeekRange25.0": "Disabilita",
  "50901.ctrl_WorkMode.economic.section2WeekRange25.1": "Potenziare",
  "50901.ctrl_WorkMode.economic.section2WeekRange26.0": "Non permette",
  "50901.ctrl_WorkMode.economic.section2WeekRange26.1": "Potenziare",
  "50901.ctrl_WorkMode.economic.section2WeekRange27.0": "Non permette",
  "50901.ctrl_WorkMode.economic.section2WeekRange27.1": "Abilita",
  "50901.ctrl_WorkMode.economic.section3WeekRange11.0": "Disabilita",
  "50901.ctrl_WorkMode.economic.section3WeekRange11.1": "Potenziare",
  "50901.ctrl_WorkMode.economic.section3WeekRange12.0": "Non permette",
  "50901.ctrl_WorkMode.economic.section3WeekRange12.1": "Potenziare",
  "50901.ctrl_WorkMode.economic.section3WeekRange13.0": "Non permette",
  "50901.ctrl_WorkMode.economic.section3WeekRange13.1": "Abilita",
  "50901.ctrl_WorkMode.economic.section3WeekRange14.0": "Disabilita",
  "50901.ctrl_WorkMode.economic.section3WeekRange14.1": "Potenziare",
  "50901.ctrl_WorkMode.economic.section3WeekRange15.0": "Non permette",
  "50901.ctrl_WorkMode.economic.section3WeekRange15.1": "Potenziare",
  "50901.ctrl_WorkMode.economic.section3WeekRange16.0": "Non permette",
  "50901.ctrl_WorkMode.economic.section3WeekRange16.1": "Abilita",
  "50901.ctrl_WorkMode.economic.section3WeekRange17.0": "Disabilita",
  "50901.ctrl_WorkMode.economic.section3WeekRange17.1": "Potenziare",
  "50901.ctrl_WorkMode.economic.section3WeekRange2.0": "Significato del valore 0",
  "50901.ctrl_WorkMode.economic.section3WeekRange2.1": "Significato Del Valore Di Enumerazione 1",
  "50901.ctrl_WorkMode.economic.section4WeekRange11.0": "Non permette",
  "50901.ctrl_WorkMode.economic.section4WeekRange11.1": "Potenziare",
  "50901.ctrl_WorkMode.economic.section4WeekRange12.0": "Non permette",
  "50901.ctrl_WorkMode.economic.section4WeekRange12.1": "Abilita",
  "50901.ctrl_WorkMode.economic.section4WeekRange13.0": "Disabilita",
  "50901.ctrl_WorkMode.economic.section4WeekRange13.1": "Potenziare",
  "50901.ctrl_WorkMode.economic.section4WeekRange14.0": "Non permette",
  "50901.ctrl_WorkMode.economic.section4WeekRange14.1": "Potenziare",
  "50901.ctrl_WorkMode.economic.section4WeekRange15.0": "Non permette",
  "50901.ctrl_WorkMode.economic.section4WeekRange15.1": "Abilita",
  "50901.ctrl_WorkMode.economic.section4WeekRange16.0": "Disabilita",
  "50901.ctrl_WorkMode.economic.section4WeekRange16.1": "Potenziare",
  "50901.ctrl_WorkMode.economic.section4WeekRange17.0": "Non permette",
  "50901.ctrl_WorkMode.economic.section4WeekRange17.1": "Potenziare",
  "50901.ctrl_WorkMode.economic.section4WeekRange2.0": "Significato del valore 0",
  "50901.ctrl_WorkMode.economic.section4WeekRange2.1": "Significato Del Valore Di Enumerazione 1",
  "50901.fault.emergencyStopSwitchStatus.0": "Disable",
  "50901.fault.emergencyStopSwitchStatus.1": "Abilita",
  "50901.fault.fiveVoltPowerSupplyFault.0": "Disabilita",
  "50901.fault.fiveVoltPowerSupplyFault.1": "enable",
  "50901.fault.genPortOvercurrent.0": "disable",
  "50901.fault.genPortOvercurrent.1": "Enable",
  "50901.fault.genRelayBFault.0": "disable",
  "50901.fault.genRelayBFault.1": "Abilita",
  "50901.fault.gridMeter.0": "Disabilita",
  "50901.fault.gridMeter.1": "enable",
  "50901.fault.inverterCommunicationFailed.0": "disable",
  "50901.fault.inverterCommunicationFailed.1": "Enable",
  "50901.fault.kmRelayFault.0": "disable",
  "50901.fault.kmRelayFault.1": "Abilita",
  "50901.fault.pvPortOvercurrent.0": "Disabilita",
  "50901.fault.pvPortOvercurrent.1": "enable",
  "50901.fault.twelveVoltPowerSupplyFault.0": "Disable",
  "50901.fault.twelveVoltPowerSupplyFault.1": "enable",
  "50901.real_time.batteryConnectionStatus.0": "No",
  "50901.real_time.batteryConnectionStatus.1": "Sì",
  "50901.real_time.batteryType_04.0": "Nessuna Batteria",
  "50901.real_time.batteryType_04.1": "Batteria al litio",
  "50901.real_time.batteryType_04.2": "Batteria Al Piombo-Acido",
  "50901.real_time.packNum.0": "0",
  "50901.real_time.packNum.1": "1",
  "50901.real_time.packNum.1023": "10",
  "50901.real_time.packNum.127": "7",
  "50901.real_time.packNum.15": "4",
  "50901.real_time.packNum.16383": "14",
  "50901.real_time.packNum.2047": "11",
  "50901.real_time.packNum.255": "8",
  "50901.real_time.packNum.3": "2",
  "50901.real_time.packNum.31": "5",
  "50901.real_time.packNum.32767": "15",
  "50901.real_time.packNum.4095": "12",
  "50901.real_time.packNum.511": "9",
  "50901.real_time.packNum.63": "6",
  "50901.real_time.packNum.65535": "16",
  "50901.real_time.packNum.7": "3",
  "50901.real_time.packNum.8191": "13",
  "50901..parallelNetworking.0": "Non Valido",
  "50901..parallelNetworking.1": "Networking In Corso",
  "50901..parallelNetworking.2": "Dissolvere La Rete",
  "50901..phaseOrderInverseDisable.0": "disable",
  "50901..phaseOrderInverseDisable.1": "enable",
  "50901..relayU16NlineRlyTestDis.0": "Disabilita",
  "50901..relayU16NlineRlyTestDis.1": "enable",
  "50901.ctrl_Config.ClockSetting.clockSet": "Impostazione oraria dell'orologio",
  "50901.ctrl_Config.Device.arcfaultClear.0": "No",
  "50901.ctrl_Config.Device.arcfaultClear.1": "Sì",
  "50901.ctrl_Config.Device.clearfault.0": "No",
  "50901.ctrl_Config.Device.clearfault.1": "Sì",
  "50901.ctrl_Dry_Contact.Generator.dryContactGeCharge": "Ricarica del generatore del nodo secco",
  "50901.ctrl_Dry_Contact.Generator.dryContactGeWait1": "Generatore a nodo secco1",
  "50901.ctrl_Dry_Contact.Generator.dryContactGeWait2": "Standby Generatore A Contatto Secco 2",
  "50901.ctrl_Dry_Contact.Generator.dryContactPracticeTime": "Tempo di avvio della modalità di esercizio del generatore",
  "50901.ctrl_Dry_Contact.HeatPump.dryContactDump1": "Tempo della pompa di calore1",
  "50901.ctrl_Dry_Contact.HeatPump.dryContactDump2": "Periodo Tempo Pompa Di Calore 2",
  "50901.ctrl_Dry_Contact.HeatPump.dryContactDump3": "Tempo della pompa di calore3",
  "50901.ctrl_Dry_Contact.HeatPump.dryContactDump4": "Tempo della pompa di calore4",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContact1Timer1": "Timer A Contatto Secco 1 Periodo 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContact1Timer2": "Nodo secco cronometro 1 ora 2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContact2Timer1": "Nodo secco cronometro 2 ore 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContact2Timer2": "Timer A Contatto Secco 2 Periodo 2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContactTimer1": "Tempo del nodo secco1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContactTimer2": "Tempo del nodo secco2",
  "50901.ctrl_Safety.RPC.rpcMode.0": "Disabilita",
  "50901.ctrl_Safety.RPC.rpcMode.1": "Fixed Power Factor, PF Mode",
  "50901.ctrl_Safety.RPC.rpcMode.2": "Fixed Reactive Power, Q Mode",
  "50901.ctrl_Safety.RPC.rpcMode.3": "Curva Pf(P), Modalità Pf(P)",
  "50901.ctrl_Safety.RPC.rpcMode.4": "W",
  "50901.ctrl_Safety.RPC.rpcMode.5": "PQ",
  "50901.ctrl_WorkMode.economic.dryContactWoTi1Down1": "Nodo Modalità Periodo 1 Valle 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi1Down2": "Modalità Nodo Tempo 1 Basso 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi1Peak1": "Modalità Nodo Tempo1 Picco1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi1Peak2": "Nodo Modalità Periodo 1 Picco 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi2Down1": "Modalità Nodo Tempo 2 Basso 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi2Down2": "Modalità Nodo Tempo 2 Basso 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi2Peak1": "Nodo Modalità Periodo 2 Picco 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi2Peak2": "Modalità Nodo Tempo 2 Picco 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi3Down1": "Nodo Modalità Periodo 3 Valle 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi3Down2": "Modalità Nodo Tempo 3 Basso 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi3Peak1": "Modalità Nodo Tempo 3 Picco 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi3Peak2": "Nodo Modalità Periodo 3 Picco 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi4Down1": "Modalità Nodo Tempo 4 Basso 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi4Down2": "Nodo Modalità Periodo 4 Valle 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi4Peak1": "Modalità Nodo Tempo 4 Picco 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi4Peak2": "Modalità Nodo Tempo 4 Picco 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTimer1": "Nodo Modalità Periodo 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTimer2": "Tempo del nodo del modello2",
  "50901.ctrl_WorkMode.economic.dryContactWoTimer3": "Nodo Modalità Periodo 3",
  "50901.ctrl_WorkMode.economic.dryContactWoTimer4": "Tempo del nodo del modello4",
  "50901.ctrl_WorkMode.TOU.dryContactTOU1Chag": "Tempo di ricarica del nodo di divisione 1",
  "50901.ctrl_WorkMode.TOU.dryContactTOU1Out": "Nodo Time-Of-Use Periodo 1 Scarica",
  "50901.ctrl_WorkMode.TOU.dryContactTOU2Chag": "Tempo di ricarica del nodo di divisione 2",
  "50901.ctrl_WorkMode.TOU.dryContactTOU2Out": "Scarica del nodo di divisione del tempo 2",
  "50901.ctrl_WorkMode.TOU.dryContactTOU3Chag": "Nodo Time-Of-Use Periodo 3 Carica",
  "50901.ctrl_WorkMode.TOU.dryContactTOU3Out": "Scarica del nodo di divisione del tempo 3",
  "50901.ctrl_WorkMode.TOU.dryContactTOU4Chag": "Tempo di ricarica del nodo di divisione 4",
  "50901.ctrl_WorkMode.TOU.dryContactTOU4Out": "Nodo Time-Of-Use Periodo 4 Scarica",
  "50901.ctrl_WorkMode.TOU.dryContactTOU5Chag": "Tempo di ricarica del nodo di divisione del tempo 5",
  "50901.ctrl_WorkMode.TOU.dryContactTOU5Out": "Nodo Time-Of-Use Periodo 5 Scarica",
  "50901.ctrl_WorkMode.TOU.dryContactTOU6Chag": "Tempo di ricarica del nodo di divisione del tempo 6",
  "50901.ctrl_WorkMode.TOU.dryContactTOU6Out": "Scarica del nodo di divisione del tempo 6",
  "50901.ctrl_WorkMode.TOU.dryContactTOU7Chag": "Nodo Time-Of-Use Periodo 7 Carica",
  "50901.ctrl_WorkMode.TOU.dryContactTOU7Out": "Scarica del nodo di divisione del tempo 7",
  "50901.ctrl_WorkMode.TOU.dryContactTOU8Chag": "Tempo di ricarica del nodo di divisione del tempo 8",
  "50901.ctrl_WorkMode.TOU.dryContactTOU8Out": "Nodo Time-Of-Use Periodo 8 Scarica",
  "50901.Fault.arcFault": "Guasto Arco",
  "50901.Fault.arcSelfTestFault": "Errore Autotest Arco",
  "50901.Fault.busbarAbnormality": "Bus Cc Anomalo",
  "50901.Fault.cmpssBiasCalculationError": "Errore Calcolo Offset Cmpss",
  "50901.Fault.driveAbnormality": "Pilotaggio Anomalo",
  "50901.Fault.e2rpomFault": "Guasto Eeprom",
  "50901.Fault.epsOverload": "Sovraccarico Eps",
  "50901.Fault.epsRelayProtection": "Protezione Relè Eps",
  "50901.Fault.epsVoltageAbnormality": "Tensione Eps Anomala",
  "50901.Fault.flashCommunicationFault": "Guasto Comunicazione Memoria Flash",
  "50901.Fault.frequencyVariationRateOutOfRange": "Superamento Limite Velocità Variazione Frequenza",
  "50901.Fault.genAbnormality": "Generatore Anomalo",
  "50901.Fault.genOverload": "Sovraccarico Generatore",
  "50901.Fault.gridCurrentDcOffsetOutOfRange": "Superamento Limite Offset Cc Corrente Rete",
  "50901.Fault.gridOffVoltageDcOffsetOutOfRange": "Superamento Limite Offset Cc Tensione Off-Grid",
  "50901.Fault.gridOverfrequency": "Sovrafrequenza Rete",
  "50901.Fault.gridOvervoltage": "Sovratensione Rete",
  "50901.Fault.gridPowerOutage": "Mancanza Rete",
  "50901.Fault.gridUnderfrequency": "Sottofrequenza Rete",
  "50901.Fault.gridUndervoltage": "Sottotensione Rete",
  "50901.Fault.gridVoltageAbnormality": "Tensione Rete Anomala",
  "50901.Fault.insulationFault": "Guasto Isolamento",
  "50901.Fault.interruptOverflow": "Overflow Interrupt",
  "50901.Fault.lineToEarthFault": "Guasto Verso Terra (Fase-Terra)",
  "50901.Fault.lowAmbientTemperature": "Temperatura Ambiente Troppo Bassa",
  "50901.Fault.meterWiringAbnormality": "Cablaggio Contatore Anomalo",
  "50901.Fault.microelectronicFault": "Guasto Microelettronico",
  "50901.Fault.neutralWireNotConnected": "Neutro Non Collegato",
  "50901.Fault.neutralWireToEarthFault": "Guasto Neutro-Terra",
  "50901.Fault.overTemperature": "Sovratemperatura",
  "50901.Fault.pllLockFailed": "Errore Aggancio Pll",
  "50901.Fault.preSynchronizationFailed": "Errore Presincronizzazione",
  "50901.Fault.pvFault": "Guasto Fv",
  "50901.Fault.pvVoltageExceedingBusVoltage": "Tensione Fv Supera Tensione Bus",
  "50901.Fault.rcdFault": "Guasto Interruttore Differenziale",
  "50901.Fault.rcdSelfTestFault": "Errore Autotest Interruttore Differenziale",
  "50901.Fault.reconnectionFailed": "Errore Riconnessione",
  "50901.Fault.shutDown": "Spegnimento Sistema",
  "50901.Fault.temperatureAbnormality": "Temperatura Anomala",
  "50901.Fault.tenMinuteOvervoltage": "Sovratensione 10 Minuti",
  "50901.Fault.wiringAbnormality": "Cablaggio Anomalo",
  "50901.real_time.copy_communicationStickSoftwareVersion": "Versione del software",
  "50901.ctrl_Dry_Contact.HeatPump.hpBattSocDetectMode": "Modalità di rilevamento della pompa di calore BattSoc",
  "50901.ctrl_Dry_Contact.HeatPump.hpCloseSoc": "Pompa di calore chiuso Soc",
  "50901.ctrl_Dry_Contact.HeatPump.hpDelayDetectTimeLmt": "Limite Tempo Rilevamento Ritardo Pompa Di Calore",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxFeedbackPower": "Potenza massima di feedback della pompa di calore",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxRunTimeOfOneDay": "Tempo massimo di funzionamento della pompa di calore al giorno",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxTimeDetectEnable": "Abilitazione Rilevamento Tempo Massimo Pompa Di Calore",
  "50901.ctrl_Dry_Contact.HeatPump.hpMinRunTimeLmtOfOnce": "Tempo minimo di funzionamento della pompa di calore",
  "50901.ctrl_Dry_Contact.HeatPump.hpStartPower": "Potenza Di Avvio Pompa Di Calore",
  "50901.ctrl_Dry_Contact.HeatPump.hpStartSoc": "Pompa di calore avvio Soc",
  "50901.ctrl_Dry_Contact.HeatPump.hpSupplyPower": "Alimentazione pompa di calore",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1EndDay": "Fine Pompa Di Calore Tempo 1 - Giorno",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1EndMonth": "Tempo pompa di calore 1 fine -",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1StartDay": "Inizio Pompa Di Calore Tempo 1 - Giorno",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1StartMonth": "Tempo pompa di calore 1 inizio-mese",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange1": "Tempo della pompa di calore1 settimana1",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange2": "Pompa Di Calore Tempo 1 Settimana 2",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange3": "Tempo della pompa di calore1 settimana3",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange4": "Tempo della pompa di calore1 settimana4",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange5": "Pompa Di Calore Tempo 1 Settimana 5",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange6": "Tempo pompa di calore 1 settimana6",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange7": "Tempo pompa di calore 1 settimana7",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkMode": "Modalità di funzionamento della pompa di calore",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkTimeParts": "Tempo Di Funzionamento Pompa Di Calore",
  "50901.ctrl_WorkMode.economic.section4WeekRange11": "Gruppo 4 Lunedì 1",
  "50901.ctrl_WorkMode.economic.section4WeekRange12": "Tempo 4 Gruppo 1 Martedì",
  "50901.ctrl_WorkMode.economic.section4WeekRange13": "Periodo 4 Gruppo 1 Mercoledì",
  "50901.ctrl_WorkMode.economic.section4WeekRange14": "Giovedì 4 Gruppo 1",
  "50901.ctrl_WorkMode.economic.section4WeekRange15": "Periodo 4 Gruppo 1 Venerdì",
  "50901.ctrl_WorkMode.economic.section4WeekRange16": "Periodo 4 Gruppo 1 Sabato",
  "50901.ctrl_WorkMode.economic.section4WeekRange17": "Tempo 4 Gruppo 1 Sabato",
  "50901.real_time.copy_bmsSoftwareVersion": "Versione BMS - Software",
  "50901.real_time.copy_controllerarmFirmwareVersion": "Versione Arm Dell'inverter",
  "50901.real_time.previous_gridPower": "Potenza Lato Rete",
  "50901.ctrl_Config.Device.arcfaultClear": "Cancellazione Guasto D’Arco",
  "50901.ctrl_Config.Device.clearfault": "Cancella Guasto",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange27": "Domenica",
  "50901.ctrl_Safety.RPC.gcfExportHardLimitRatio": "Rapporto Limite Rigido Esportazione Gcf",
  "50901.ctrl_Safety.RPC.gcfExportSoftLimitRatio": "Rapporto Limite Morbido Esportazione Gcf",
  "50901.ctrl_WorkMode.economic.section1WeekRange11": "Periodo 1 Gruppo 1 Lunedì",
  "50901.ctrl_WorkMode.economic.section1WeekRange12": "Periodo 1 Gruppo 1 Martedì",
  "50901.ctrl_WorkMode.economic.section1WeekRange13": "Periodo 1 Gruppo 1 Mercoledì",
  "50901.ctrl_WorkMode.economic.section1WeekRange14": "Periodo 1 Gruppo 1 Giovedì",
  "50901.ctrl_WorkMode.economic.section1WeekRange15": "Periodo 1 Gruppo 1 Venerdì",
  "50901.ctrl_WorkMode.economic.section1WeekRange16": "Periodo 1 Gruppo 1 Sabato",
  "50901.ctrl_WorkMode.economic.section1WeekRange17": "Periodo 1 Gruppo 1 Domenica",
  "50901.ctrl_WorkMode.economic.section1WeekRange21": "Periodo 1 Gruppo 2 Lunedì",
  "50901.ctrl_WorkMode.economic.section1WeekRange22": "Periodo 1 Gruppo 2 Martedì",
  "50901.ctrl_WorkMode.economic.section1WeekRange23": "Periodo 1 Gruppo 2 Mercoledì",
  "50901.ctrl_WorkMode.economic.section1WeekRange24": "Periodo 1 Gruppo 2 Giovedì",
  "50901.ctrl_WorkMode.economic.section1WeekRange25": "Periodo 1 Gruppo 2 Venerdì",
  "50901.ctrl_WorkMode.economic.section1WeekRange26": "Periodo 1 Gruppo 2 Sabato",
  "50901.ctrl_WorkMode.economic.section1WeekRange27": "Periodo 1 Gruppo 2 Domenica",
  "50901.ctrl_WorkMode.economic.section2WeekRange11": "Periodo 2 Gruppo 1 Lunedì",
  "50901.ctrl_WorkMode.economic.section2WeekRange12": "Periodo 2 Gruppo 1 Martedì",
  "50901.ctrl_WorkMode.economic.section2WeekRange13": "Periodo 2 Gruppo 1 Mercoledì",
  "50901.ctrl_WorkMode.economic.section2WeekRange14": "Periodo 2 Gruppo 1 Giovedì",
  "50901.ctrl_WorkMode.economic.section2WeekRange15": "Periodo 2 Gruppo 1 Venerdì",
  "50901.ctrl_WorkMode.economic.section2WeekRange16": "Periodo 2 Gruppo 1 Sabato",
  "50901.ctrl_WorkMode.economic.section2WeekRange17": "Periodo 2 Gruppo 1 Domenica",
  "50901.ctrl_WorkMode.economic.section2WeekRange21": "Periodo 2 Gruppo 2 Lunedì",
  "50901.ctrl_WorkMode.economic.section2WeekRange22": "Periodo 2 Gruppo 2 Martedì",
  "50901.ctrl_WorkMode.economic.section2WeekRange23": "Periodo 2 Gruppo 2 Mercoledì",
  "50901.ctrl_WorkMode.economic.section2WeekRange24": "Periodo 2 Gruppo 2 Giovedì",
  "50901.ctrl_WorkMode.economic.section2WeekRange25": "Periodo 2 Gruppo 2 Venerdì",
  "50901.ctrl_WorkMode.economic.section2WeekRange26": "Periodo 2 Gruppo 2 Sabato",
  "50901.ctrl_WorkMode.economic.section2WeekRange27": "Periodo 2 Gruppo 2 Domenica",
  "50901.ctrl_WorkMode.economic.section3WeekRange11": "Periodo 3 Gruppo 1 Lunedì",
  "50901.ctrl_WorkMode.economic.section3WeekRange12": "Periodo 3 Gruppo 1 Martedì",
  "50901.ctrl_WorkMode.economic.section3WeekRange13": "Periodo 3 Gruppo 1 Mercoledì",
  "50901.ctrl_WorkMode.economic.section3WeekRange14": "Periodo 3 Gruppo 1 Giovedì",
  "50901.ctrl_WorkMode.economic.section3WeekRange15": "Periodo 3 Gruppo 1 Venerdì",
  "50901.ctrl_WorkMode.economic.section3WeekRange16": "Periodo 3 Gruppo 1 Sabato",
  "50901.ctrl_WorkMode.economic.section3WeekRange17": "Periodo 3 Gruppo 1 Domenica",
  "50901.real_time.batteryCapacity": "Capacità Installata Della Batteria",
  "50901.real_time.batteryWorkingStatus.1": "Standby",
  "org.aiMessage.charge.fail": "",
  "org.aiMessage.charge.success": "",
  "org.aiMessage.discharge.fail": "",
  "org.aiMessage.discharge.success": "",
  "ai.message.charge.title.success": "Comando di carica eseguito con successo",
  "ai.message.charge.title.fail": "Comando di carica non riuscito",
  "ai.message.charge.content.success": "Comando di carica eseguito con successo. La strategia IA funziona regolarmente.",
  "ai.message.charge.content.fail": "Comando di carica fallito (3 tentativi automatici). L'IA riproverà nei periodi successivi. Controllo manuale possibile disattivando la modalità IA.",
  "ai.message.discharge.title.success": "Comando di scarica eseguito con successo",
  "ai.message.discharge.title.fail": "Comando di scarica non riuscito",
  "ai.message.discharge.content.success": "Comando di scarica eseguito con successo. La strategia IA funziona regolarmente.",
  "ai.message.discharge.content.fail": "Comando di scarica fallito (3 tentativi automatici). L'IA riproverà nei periodi successivi. Controllo manuale possibile disattivando la modalità IA.",
  "50901.fault.evCharger1CommunicationAbnormality": "Comunicazione Colonnina Ricarica Ev 1 Anomala",
  "50901.fault.bmsCanCommunicationAbnormality": "Comunicazione Can Bms Anomala",
  "50901.fault.dtu3Rs485CommunicationAbnormality": "Comunicazione Dtu3 Rs485 Anomala",
  "50901.fault.gridMeterTypeError": "Errore Tipo Contatore Di Rete",
  "50901.fault.lowDtuVersion": "Versione Dtu Troppo Bassa",
  "50901.fault.gridMeterCommunicationAbnormality": "Comunicazione Contatore Di Rete Anomala",
  "50901.fault.pvMeterTypeError": "Errore Tipo Contatore Fv",
  "50901.fault.dspPwrCommunicationAbnormality": "Comunicazione Alimentazione Dsp Anomala",
  "50901.fault.evCharger2CommunicationAbnormality": "Comunicazione Colonnina Ricarica Ev 2 Anomala",
  "50901.fault.dtu5Rs485CommunicationAbnormality": "Comunicazione Dtu5 Rs485 Anomala",
  "50901.fault.dtsCommunicationAbnormality": "Comunicazione Dts Anomala",
  "50901.fault.dtu4Rs485CommunicationAbnormality": "Comunicazione Dtu4 Rs485 Anomala",
  "50901.fault.dtu1Rs485CommunicationAbnormality": "Comunicazione Dtu1 Rs485 Anomala",
  "50901.fault.pvMeterCommunicationAbnormality": "Comunicazione Contatore Fv Anomala",
  "50901.fault.slaveWrongBatteryConnection": "Errore Connessione Batteria Slave",
  "50901.fault.dtu2Rs485CommunicationAbnormality": "Comunicazione Dtu2 Rs485 Anomala",
  "50901.fault.dspSafCommunicationAbnormality": "Comunicazione Sicura Dsp Anomala",
  "50901.fault.sustainedNegativeLoad": "Carico Negativo Persistente",
  "50901.fault.hmidMachineFault": "Guasto Dispositivo Interfaccia Utente",
  "50901.fault.evCharger1Fault": "Guasto Colonnina Ricarica 1",
  "50901.fault.evCharger2Fault": "Guasto Colonnina Ricarica 2",
  "50901.fault.fanSpeedAbnormality": "Velocità Ventola Anomala",
  "50901.fault.masterSlaveCommunicationAbnormality": "Comunicazione Master-Slave Anomala",
  "50901.fault.batteryCapacityAbnormality": "Capacità Batteria Anomala",
  "50901.fault.batteryForceChargeRequest": "Richiesta Carica Forzata Batteria",
  "50901.fault.hmidCommunicationAbnormality": "Comunicazione Interfaccia Utente Anomala",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek7.desc": "Il generatore si avvia periodicamente a quest'ora",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek6.desc": "Il generatore si avvia periodicamente a quest'ora",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek1.desc": "Il generatore si avvia periodicamente a quest'ora",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek2.desc": "Il generatore si avvia periodicamente a quest'ora",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek5.desc": "Il generatore si avvia periodicamente a quest'ora",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek3.desc": "Il generatore si avvia periodicamente a quest'ora",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek4.desc": "Il generatore si avvia periodicamente a quest'ora",
  "50901.fault.loadRelayAfault.0": "Disabilita",
  "50901.fault.fiveVoltPowerSupplyfault.0": "Disabilita",
  "50901.fault.fiveVoltPowerSupplyfault.1": "Abilita",
  "50901.fault.genRelayAfault.0": "Disabilita",
  "50901.fault.genRelayAfault.1": "Abilita",
  "50901.fault.genRelayBfault.0": "Disabilita",
  "50901.fault.genRelayBfault.1": "Abilita",
  "50901.fault.kmRelayfault.0": "Disabilita",
  "50901.fault.kmRelayfault.1": "Abilita",
  "50901.fault.twelveVoltPowerSupplyfault.1": "Abilita",
  "50901.fault.loadRelayAfault.1": "Abilita",
  "50901.fault.loadRelayBfault.0": "Disabilita",
  "50901.fault.loadRelayBfault.1": "Abilita",
  "50901.fault.pvRelayAbfault.0": "Disabilita",
  "50901.fault.pvRelayAbfault.1": "Abilita",
  "50901.fault.threePointThreeVoltPowerSupplyfault.0": "Disabilita",
  "50901.fault.threePointThreeVoltPowerSupplyfault.1": "Abilita",
  "50901.fault.twelveVoltPowerSupplyfault.0": "Disabilita",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek2.0": "Disabilita",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek3.1": "Abilita",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek3.0": "Disabilita",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek7.0": "Disabilita",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek4.0": "Abilita",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek4.1": "Abilita",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek2.1": "Abilita",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek5.0": "Disabilita",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek5.1": "Abilita",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek1.1": "Abilita",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek6.0": "Disabilita",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek6.1": "Abilita",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek1.0": "Disabilita",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek7.1": "Abilita",
  "50901.fault.loadRelayAfault": "Guasto relè carico A",
  "50901.fault.threePointThreeVoltPowerSupplyfault": "Guasto alimentazione 3,3V",
  "50901.fault.pvRelayAbfault": "Guasto relè PV AB",
  "50901.fault.twelveVoltPowerSupplyfault": "Guasto alimentazione 12V",
  "50901.fault.loadRelayBfault": "Guasto relè carico B",
  "50901.fault.kmRelayfault": "Guasto relè KM",
  "50901.fault.genRelayBfault": "Guasto relè generatore B",
  "50901.fault.genRelayAfault": "Guasto relè generatore A",
  "50901.fault.fiveVoltPowerSupplyfault": "Guasto alimentazione 5V",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek4": "Ora di avvio modalità esercizio generatore giovedì",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek3": "Ora di avvio modalità esercizio generatore mercoledì",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek5": "Ora di avvio modalità esercizio generatore venerdì",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek6": "Ora di avvio modalità esercizio generatore sabato",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek2": "Ora di avvio modalità esercizio generatore martedì",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek7": "Ora di avvio modalità esercizio generatore domenica",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek1": "Ora di avvio modalità esercizio generatore lunedì",
  "50901.fault.evCharger1CommunicationAbnormality.0": "Disabilita",
  "50901.fault.evCharger1CommunicationAbnormality.1": "Abilita",
  "50901.fault.bmsCanCommunicationAbnormality.0": "Disabilita",
  "50901.fault.bmsCanCommunicationAbnormality.1": "Abilita",
  "50901.fault.dtu3Rs485CommunicationAbnormality.0": "Disabilita",
  "50901.fault.dtu3Rs485CommunicationAbnormality.1": "Abilita",
  "50901.fault.gridMeterTypeError.0": "Disabilita",
  "50901.fault.gridMeterTypeError.1": "Abilita",
  "50901.fault.lowDtuVersion.0": "Disabilita",
  "50901.fault.lowDtuVersion.1": "Abilita",
  "50901.fault.gridMeterCommunicationAbnormality.0": "Disabilita",
  "50901.fault.gridMeterCommunicationAbnormality.1": "Abilita",
  "50901.fault.pvMeterTypeError.0": "Disabilita",
  "50901.fault.pvMeterTypeError.1": "Abilita",
  "50901.fault.dspPwrCommunicationAbnormality.0": "Disabilita",
  "50901.fault.dspPwrCommunicationAbnormality.1": "Abilita",
  "50901.fault.evCharger2CommunicationAbnormality.0": "Disabilita",
  "50901.fault.evCharger2CommunicationAbnormality.1": "Abilita",
  "50901.fault.dtu5Rs485CommunicationAbnormality.0": "Disabilita",
  "50901.fault.dtu5Rs485CommunicationAbnormality.1": "Abilita",
  "50901.fault.dtsCommunicationAbnormality.0": "Disabilita",
  "50901.fault.dtsCommunicationAbnormality.1": "Abilita",
  "50901.fault.dtu4Rs485CommunicationAbnormality.0": "Disabilita",
  "50901.fault.dtu4Rs485CommunicationAbnormality.1": "Abilita",
  "50901.fault.dtu1Rs485CommunicationAbnormality.0": "Disabilita",
  "50901.fault.dtu1Rs485CommunicationAbnormality.1": "Abilita",
  "50901.fault.pvMeterCommunicationAbnormality.0": "Disabilita",
  "50901.fault.pvMeterCommunicationAbnormality.1": "Abilita",
  "50901.fault.slaveWrongBatteryConnection.0": "Disabilita",
  "50901.fault.slaveWrongBatteryConnection.1": "Abilita",
  "50901.fault.dtu2Rs485CommunicationAbnormality.0": "Disabilita",
  "50901.fault.dtu2Rs485CommunicationAbnormality.1": "Abilita",
  "50901.fault.dspSafCommunicationAbnormality.0": "Disabilita",
  "50901.fault.dspSafCommunicationAbnormality.1": "Abilita",
  "50901.fault.sustainedNegativeLoad.0": "Disabilita",
  "50901.fault.sustainedNegativeLoad.1": "Abilita",
  "50901.fault.hmidMachineFault.0": "Disabilita",
  "50901.fault.hmidMachineFault.1": "Abilita",
  "50901.fault.evCharger1Fault.0": "Disabilita",
  "50901.fault.evCharger1Fault.1": "Abilita",
  "50901.fault.evCharger2Fault.0": "Disabilita",
  "50901.fault.evCharger2Fault.1": "Abilita",
  "50901.fault.fanSpeedAbnormality.0": "Disabilita",
  "50901.fault.fanSpeedAbnormality.1": "Abilita",
  "50901.fault.masterSlaveCommunicationAbnormality.0": "Disabilita",
  "50901.fault.masterSlaveCommunicationAbnormality.1": "Abilita",
  "50901.fault.batteryCapacityAbnormality.0": "Disabilita",
  "50901.fault.batteryCapacityAbnormality.1": "Abilita",
  "50901.fault.batteryForceChargeRequest.0": "Disabilita",
  "50901.fault.batteryForceChargeRequest.1": "Abilita",
  "50901.fault.hmidCommunicationAbnormality.0": "Disabilita",
  "50901.fault.hmidCommunicationAbnormality.1": "Abilita",
  "50901.fault.batteryFault": "Guasto Batteria",
  "50901.fault.fanFault.0": "Disabilita",
  "50901.fault.armCommunicationFault.1": "Abilita",
  "50901.fault.batteryFault.0": "Disabilita",
  "50901.fault.batteryFault.1": "Abilita",
  "50901.fault.evCharger1CommunicationAbnormality.desc": "Descrizione Anomalia Comunicazione Colonnina Ricarica Ev 1",
  "50901.fault.bmsCanCommunicationAbnormality.desc": "Descrizione Anomalia Comunicazione Can Bms",
  "50901.fault.dtu3Rs485CommunicationAbnormality.desc": "Descrizione Anomalia Comunicazione Dtu3 Rs485",
  "50901.fault.gridMeterTypeError.desc": "Descrizione Errore Tipo Contatore Di Rete",
  "50901.fault.lowDtuVersion.desc": "Descrizione Versione Dtu Troppo Bassa",
  "50901.fault.gridMeterCommunicationAbnormality.desc": "Descrizione Anomalia Comunicazione Contatore Di Rete",
  "50901.fault.pvMeterTypeError.desc": "Descrizione Errore Tipo Contatore Fv",
  "50901.fault.dspPwrCommunicationAbnormality.desc": "Descrizione Anomalia Comunicazione Alimentazione Dsp",
  "50901.fault.evCharger2CommunicationAbnormality.desc": "Descrizione Anomalia Comunicazione Colonnina Ricarica Ev 2",
  "50901.fault.dtu5Rs485CommunicationAbnormality.desc": "Descrizione Anomalia Comunicazione Dtu5 Rs485",
  "50901.fault.dtsCommunicationAbnormality.desc": "Descrizione Anomalia Comunicazione Dts",
  "50901.fault.dtu4Rs485CommunicationAbnormality.desc": "Descrizione Anomalia Comunicazione Dtu4 Rs485",
  "50901.fault.dtu1Rs485CommunicationAbnormality.desc": "Descrizione Anomalia Comunicazione Dtu1 Rs485",
  "50901.fault.pvMeterCommunicationAbnormality.desc": "Descrizione Anomalia Comunicazione Contatore Fv",
  "50901.fault.slaveWrongBatteryConnection.desc": "Descrizione Errore Connessione Batteria Slave",
  "50901.fault.dtu2Rs485CommunicationAbnormality.desc": "Descrizione Anomalia Comunicazione Dtu2 Rs485",
  "50901.fault.dspSafCommunicationAbnormality.desc": "Descrizione Anomalia Comunicazione Sicura Dsp",
  "50901.fault.sustainedNegativeLoad.desc": "Descrizione Carico Negativo Persistente",
  "50901.fault.hmidMachineFault.desc": "Descrizione Guasto Dispositivo Interfaccia Utente",
  "50901.fault.evCharger1Fault.desc": "Descrizione Guasto Colonnina Ricarica 1",
  "50901.fault.evCharger2Fault.desc": "Descrizione Guasto Colonnina Ricarica 2",
  "50901.fault.fanSpeedAbnormality.desc": "Descrizione Anomalia Velocità Ventola",
  "50901.fault.batteryFault.desc": "Descrizione Guasto Batteria",
  "50901.fault.masterSlaveCommunicationAbnormality.desc": "Descrizione Anomalia Comunicazione Master-Slave",
  "50901.fault.batteryCapacityAbnormality.desc": "Descrizione Anomalia Capacità Batteria",
  "50901.fault.batteryForceChargeRequest.desc": "Descrizione Richiesta Carica Forzata Batteria",
  "50901.fault.hmidCommunicationAbnormality.desc": "Descrizione Anomalia Comunicazione Interfaccia Utente",
  "50901.fault.evCharger1CommunicationAbnormality.00": "Disabilita",
  "50901.fault.evCharger1CommunicationAbnormality.01": "Abilita",
  "50901.fault.bmsCanCommunicationAbnormality.00": "Disabilita",
  "50901.fault.bmsCanCommunicationAbnormality.01": "Abilita",
  "50901.fault.dtu3Rs485CommunicationAbnormality.00": "Disabilita",
  "50901.fault.dtu3Rs485CommunicationAbnormality.01": "Abilita",
  "50901.fault.gridMeterTypeError.00": "Disabilita",
  "50901.fault.gridMeterTypeError.01": "Abilita",
  "50901.fault.lowDtuVersion.00": "Disabilita",
  "50901.fault.lowDtuVersion.01": "Abilita",
  "50901.fault.gridMeterCommunicationAbnormality.00": "Disabilita",
  "50901.fault.gridMeterCommunicationAbnormality.01": "Abilita",
  "50901.fault.pvMeterTypeError.00": "Disabilita",
  "50901.fault.pvMeterTypeError.01": "Abilita",
  "50901.fault.dspPwrCommunicationAbnormality.00": "Disabilita",
  "50901.fault.dspPwrCommunicationAbnormality.01": "Abilita",
  "50901.fault.evCharger2CommunicationAbnormality.00": "Disabilita",
  "50901.fault.evCharger2CommunicationAbnormality.01": "Abilita",
  "50901.fault.dtu5Rs485CommunicationAbnormality.00": "Disabilita",
  "50901.fault.dtu5Rs485CommunicationAbnormality.01": "Abilita",
  "50901.fault.dtsCommunicationAbnormality.00": "Disabilita",
  "50901.fault.dtsCommunicationAbnormality.01": "Abilita",
  "50901.fault.dtu4Rs485CommunicationAbnormality.00": "Disabilita",
  "50901.fault.dtu4Rs485CommunicationAbnormality.01": "Abilita",
  "50901.fault.dtu1Rs485CommunicationAbnormality.00": "Disabilita",
  "50901.fault.dtu1Rs485CommunicationAbnormality.01": "Abilita",
  "50901.fault.pvMeterCommunicationAbnormality.00": "Disabilita",
  "50901.fault.pvMeterCommunicationAbnormality.01": "Abilita",
  "50901.fault.slaveWrongBatteryConnection.00": "Disabilita",
  "50901.fault.slaveWrongBatteryConnection.01": "Abilita",
  "50901.fault.dtu2Rs485CommunicationAbnormality.00": "Disabilita",
  "50901.fault.dtu2Rs485CommunicationAbnormality.01": "Abilita",
  "50901.fault.dspSafCommunicationAbnormality.00": "Disabilita",
  "50901.fault.dspSafCommunicationAbnormality.01": "Abilita",
  "50901.fault.sustainedNegativeLoad.00": "Disabilita",
  "50901.fault.sustainedNegativeLoad.01": "Abilita",
  "50901.fault.hmidMachineFault.00": "Disabilita",
  "50901.fault.hmidMachineFault.01": "Abilita",
  "50901.fault.evCharger1Fault.00": "Disabilita",
  "50901.fault.evCharger1Fault.01": "Abilita",
  "50901.fault.evCharger2Fault.00": "Disabilita",
  "50901.fault.evCharger2Fault.01": "Abilita",
  "50901.fault.fanSpeedAbnormality.00": "Disabilita",
  "50901.fault.fanSpeedAbnormality.01": "Abilita",
  "50901.fault.batteryFault.00": "Disabilita",
  "50901.fault.batteryFault.01": "Abilita",
  "50901.fault.masterSlaveCommunicationAbnormality.00": "Disabilita",
  "50901.fault.masterSlaveCommunicationAbnormality.01": "Abilita",
  "50901.fault.batteryCapacityAbnormality.00": "Disabilita",
  "50901.fault.batteryCapacityAbnormality.01": "Abilita",
  "50901.fault.batteryForceChargeRequest.00": "Disabilita",
  "50901.fault.batteryForceChargeRequest.01": "Abilita",
  "50901.fault.hmidCommunicationAbnormality.00": "Disabilita",
  "50901.fault.hmidCommunicationAbnormality.01": "Abilita",
  "alarm.excDesc.2047494139783155712": "Guasto comunicazione ARM",
  "alarm.name.2047494139783155712": "Guasto comunicazione ARM",
  "plant.create.type.0": "Installatore",
  "plant.create.type.1": "Utente finale",
  "not.configured": "Non configurato",
  "10001.quickset.note1": "1. Modalità di autoconsumo: L'impostazione consigliata è la modalità di autoconsumo. Questa modalità massimizza l'uso dell'energia fotovoltaica per l'elettricità domestica o la immagazzina nelle batterie per uso domestico. 2. Modalità priorità di immissione: Questa modalità può inviare prioritariamente l'energia alla rete quando il carico è soddisfatto, utilizzata in aree con incentivi per l'immissione in rete. 3. Modalità di riduzione dei picchi: Dopo aver impostato la modalità di autoconsumo o priorità di immissione, è possibile selezionare la riduzione dei picchi di rete quando il gestore locale applica tariffe basate sulla potenza di picco del sistema. I clienti possono attivare questa opzione per evitare il picco di potenza al punto di connessione alla rete. 4. Modalità off-grid: Questa modalità è utilizzata solo per off-grid puro e non è consigliata per sistemi di accumulo standard. Notare che se attivata in stato connesso alla rete, la logica operativa della macchina verrà confusa e verrà visualizzato \"Off-grid\". 5. Fascia oraria: Se è necessario controllare manualmente la carica e la scarica della batteria in base al tempo nelle modalità di autoconsumo, priorità di immissione o riduzione dei picchi, utilizzare l'interruttore della fascia oraria e i seguenti set point. L'opzione \"Consenti carica da rete\" in queste tre modalità è consigliata attivata (se disattivata, l'inverter non forzerà la carica della batteria e la batteria potrebbe entrare in stand-by).",
  "10001.quickset.note2": "1. Modalità di auto-utilizzo: l'impostazione consigliata è la modalità di auto-utilizzo. Questa modalità può massimizzare l'uso della generazione di energia fotovoltaica per l'elettricità domestica o conservarla in batterie e utilizzarla per l'elettricità domestica;\n2. Alimentazione in modalità prioritaria: questa modalità può inviare preferenzialmente energia alla rete quando il carico è soddisfatto, utilizzata in aree con un sussidio per l'alimentazione alla rete;\n3. Modalità di rasatura dei picchi: dopo aver impostato l'autoutilizzo o l'alimentazione in modalità prioritaria, la rasatura dei picchi di rete può essere selezionata anche quando la società di rete locale addebita il prezzo dell'elettricità in base al consumo di potenza di picco del sistema. I clienti possono selezionare questa rasatura di picco per evitare la potenza di consumo di picco nel punto di connessione della griglia;\n4. Modalità Off-Grid: questa modalità viene utilizzata solo per il puro off-grid e non è consigliata per i sistemi di archiviazione standard. Si noti che se questa modalità è abilitata nello stato di connessione alla rete, la logica di funzionamento della macchina verrà confusa e verrà visualizzato \"Off-Grid\";\n5. Tempo di utilizzo: se è necessario controllare manualmente la carica e la scarica della batteria rispetto al tempo in modalità Self-Use o Feed in Priority o Peak-shaving, utilizzare l'interruttore Time of Use e i seguenti set point. E il \"Consenti ricarica griglia\" in queste 3 modalità è o si consiglia di essere acceso (se spento, l'inverter non forzerà la carica della batteria e la batteria potrebbe potenzialmente andare in sospensione).",
  "10001.quickset.note3": "1. Modalità di auto-utilizzo: l'impostazione consigliata è la modalità di auto-utilizzo. Questa modalità può massimizzare l'uso della generazione di energia fotovoltaica per l'elettricità domestica o conservarla in batterie e utilizzarla per l'elettricità domestica;\n2. Alimentazione in modalità prioritaria: questa modalità può inviare preferenzialmente energia alla rete quando il carico è soddisfatto, utilizzata in aree con un sussidio per l'alimentazione alla rete;\n3. Modalità Off-Grid: questa modalità viene utilizzata solo per il puro off-grid e non è consigliata per i sistemi di archiviazione standard. Si noti che se questa modalità è abilitata nello stato di connessione alla rete, la logica di funzionamento della macchina verrà confusa e verrà visualizzato \"Off-Grid\";\n4. Tempo di utilizzo: se è necessario controllare manualmente la carica e la scarica della batteria rispetto al tempo in modalità Self-Use o Feed in Priority o Peak-shaving, utilizzare l'interruttore Time of Use e i seguenti set point. E il \"Consenti ricarica griglia\" in queste 3 modalità è o si consiglia di essere acceso (se spento, l'inverter non forzerà la carica della batteria e la batteria potrebbe potenzialmente andare in sospensione).",
  "chinaAreas.Shandong": "Shandong",
  "country.China": "Cina",
  "json.50901.workmode.timeSection": "Sezione temporale",
  "json.device.dryWorking": "Lavoro a secco",
  "device.dryWorking": "Lavoro a secco",
  "51002.ctrl_antireverse": "Controllo anti-ritorno",
  "51002.ctrl_inverter": "Controllo",
  "51002.null.数据分析_实时监控_PV.tag": "Monitoraggio in tempo reale_PV",
  "51002.real_time": "Monitoraggio in tempo reale",
  "51002.real_time.Energy_PV1.desc": "Energia accumulata PV1",
  "51002.real_time.Energy_PV2.desc": "Energia accumulata PV2",
  "51002.real_time.Energy_PV3.desc": "Energia accumulata PV3",
  "51002.real_time.Energy_PV4.desc": "Energia accumulata PV4",
  "51002.real_time.gridTotalFrequency.desc": "Frequenza totale di rete",
  "51002.real_time.inverterTemp.desc": "Temperatura dell’inverter",
  "51002.real_time.pvPower.desc": "Potenza in uscita PV",
  "51002.real_time.stRelayoN.desc": "Stato connessione relè",
  "51002.real_time.workStatus.desc": "Stato operativo",
  "51002.real_time.数据分析_实时监控_GRID.tag": "Dati di rete",
  "51002.real_time.数据分析_实时监控_P.tag": "Potenza in uscita PV",
  "51002.real_time.数据分析_实时监控_PV.tag": "PV",
  "51002.real_time.数据分析_实时监控_TP.tag": "Temperatura dell’inverter",
  "51002.warning": "Allarme",
  "51002.warning.stAbnorm_Ris.desc": "Anomalia impedenza di isolamento",
  "51002.warning.stErrAccess_EEPROM.desc": "Anomalia accesso EEPROM",
  "51002.warning.stErrOP_Relay.desc": "Anomalia relè lato rete",
  "51002.warning.stHW_Fault.desc": "Protezione hardware inverter",
  "51002.warning.stOV_Fgrid.desc": "Protezione sovrafrequenza lato rete",
  "51002.warning.stOV_Temp.desc": "Protezione sovratemperatura inverter",
  "51002.warning.stOV_Vgrid.desc": "Protezione sovratensione lato rete",
  "51002.warning.stPV1_OV.desc": "Sovratensione ingresso PV 1",
  "51002.warning.stPV1_UV.desc": "Sottotensione ingresso PV 1",
  "51002.warning.stPV2_OV.desc": "Sovratensione ingresso PV 2",
  "51002.warning.stPV2_UV.desc": "Sottotensione ingresso PV 2",
  "51002.warning.stPV3_OV.desc": "Sovratensione ingresso PV 3",
  "51002.warning.stPV3_UV.desc": "Sottotensione ingresso PV 3",
  "51002.warning.stPV4_OV.desc": "Sovratensione ingresso PV 4",
  "51002.warning.stPV4_UV.desc": "Sottotensione ingresso PV 4",
  "51002.warning.stUV_Fgrid.desc": "Protezione sottofrequenza lato rete",
  "51002.warning.stUV_Vgrid.desc": "Protezione sottotensione lato rete",
  "51002..gridtype.desc": "Standard di rete",
  "51002.ctrl_antireverse.enaPAVE_FEEDINLIMIT.0": "Disabilita",
  "51002.ctrl_antireverse.enaPAVE_FEEDINLIMIT.1": "Abilita",
  "51002.ctrl_inverter.ena10mVs1Prot.0": "Disabilita",
  "51002.ctrl_inverter.ena10mVs1Prot.1": "Abilita",
  "51002.ctrl_inverter.enaAPP_PWSET.0": "Disabilita",
  "51002.ctrl_inverter.enaAPP_PWSET.1": "Abilita",
  "51002.ctrl_inverter.enaFgridShiftPowerAdj.0": "Disabilita",
  "51002.ctrl_inverter.enaFgridShiftPowerAdj.1": "Abilita",
  "51002.ctrl_inverter.enaISORES_ABNORMPROT.0": "Disabilita",
  "51002.ctrl_inverter.enaISORES_ABNORMPROT.1": "Abilita",
  "51002.ctrl_inverter.enaOVs1_powerdownadj.0": "Disabilita",
  "51002.ctrl_inverter.enaOVs1_powerdownadj.1": "Abilita",
  "51002.ctrl_inverter.enaRestoretodefault.0": "Disabilita",
  "51002.ctrl_inverter.enaRestoretodefault.1": "Abilita",
  "51002.ctrl_inverter.enaSysProtIF_selfCheck.0": "Disabilita",
  "51002.ctrl_inverter.enaSysProtIF_selfCheck.1": "Abilita",
  "51002.real_time.stRelayoN.0": "Disconnetti",
  "51002.real_time.stRelayoN.1": "Chiudi",
  "51002.real_time.workStatus.0": "Spegnimento",
  "51002.real_time.workStatus.1": "Accensione",
  "51002.warning.stAbnorm_Ris.0": "Funzionamento normale",
  "51002.warning.stAbnorm_Ris.1": "Attiva allarme",
  "51002.warning.stErrAccess_EEPROM.0": "Funzionamento normale",
  "51002.warning.stErrAccess_EEPROM.1": "Attiva allarme",
  "51002.warning.stErrOP_Relay.0": "Funzionamento normale",
  "51002.warning.stErrOP_Relay.1": "Attiva allarme",
  "51002.warning.stHW_Fault.0": "Funzionamento normale",
  "51002.warning.stHW_Fault.1": "Attiva allarme",
  "51002.warning.stOV_Fgrid.0": "Funzionamento normale",
  "51002.warning.stOV_Fgrid.1": "Attiva allarme",
  "51002.warning.stOV_Temp.0": "Funzionamento normale",
  "51002.warning.stOV_Temp.1": "Attiva allarme",
  "51002.warning.stOV_Vgrid.0": "Funzionamento normale",
  "51002.warning.stOV_Vgrid.1": "Attiva allarme",
  "51002.warning.stPV1_OV.0": "Funzionamento normale",
  "51002.warning.stPV1_OV.1": "Attiva allarme",
  "51002.warning.stPV1_UV.0": "Funzionamento normale",
  "51002.warning.stPV1_UV.1": "Attiva allarme",
  "51002.warning.stPV2_OV.0": "Funzionamento normale",
  "51002.warning.stPV2_OV.1": "Attiva allarme",
  "51002.warning.stPV2_UV.0": "Funzionamento normale",
  "51002.warning.stPV2_UV.1": "Attiva allarme",
  "51002.warning.stPV3_OV.0": "Funzionamento normale",
  "51002.warning.stPV3_OV.1": "Attiva allarme",
  "51002.warning.stPV3_UV.0": "Funzionamento normale",
  "51002.warning.stPV3_UV.1": "Attiva allarme",
  "51002.warning.stPV4_OV.0": "Funzionamento normale",
  "51002.warning.stPV4_OV.1": "Attiva allarme",
  "51002.warning.stPV4_UV.0": "Funzionamento normale",
  "51002.warning.stPV4_UV.1": "Attiva allarme",
  "51002.warning.stUV_Fgrid.0": "Funzionamento normale",
  "51002.warning.stUV_Fgrid.1": "Attiva allarme",
  "51002.warning.stUV_Vgrid.0": "Funzionamento normale",
  "51002.warning.stUV_Vgrid.1": "Attiva allarme",
  "51002.ctrl_inverter.ena10mVs1Prot": "Abilitazione protezione sovratensione media tensione lato rete livello 1 su 10 minuti",
  "51002.ctrl_inverter.enaINVTR.0": "Spegnimento",
  "51002.ctrl_inverter.enaINVTR.1": "Accensione",
  "51002.ctrl_inverter.enaOVTPWDN.0": "Disabilita",
  "51002.ctrl_inverter.enaOVTPWDN.1": "Abilita",
  "51002.ctrl_inverter.enaSysProtIF_selfCheck": "Interruttore funzione autotest interfaccia protezione sistema",
  "51002.real_time.Energy_PV1": "Generazione di energia cumulativa PV1",
  "51002.real_time.Energy_PV2": "Generazione di energia cumulativa PV2",
  "51002.real_time.Energy_PV3": "Generazione di energia cumulativa PV3",
  "51002.real_time.Energy_PV4": "Generazione di energia cumulativa PV4",
  "51002.real_time.Firmware_ver": "Numero versione firmware",
  "51002.real_time.Fn": "Frequenza nominale rete connessa",
  "51002.real_time.gridTotalFrequency": "Frequenza totale",
  "51002.real_time.Iacrms": "Valore efficace corrente lato rete",
  "51002.real_time.inverterTemp": "Temperatura dell’inverter",
  "51002.real_time.Ipv1": "Corrente ingresso PV1",
  "51002.real_time.Ipv2": "Corrente ingresso PV2",
  "51002.real_time.Ipv3": "Corrente ingresso PV3",
  "51002.real_time.Ipv4": "Corrente ingresso PV4",
  "51002.real_time.Ipvmax": "Corrente ingresso PV massima",
  "51002.real_time.Irmsmax": "Valore efficace massimo corrente di connessione alla rete",
  "51002.real_time.Pn": "Potenza attiva massima connessa alla rete",
  "51002.real_time.powerGeneration": "Generazione di energia totale",
  "51002.real_time.Powpvmax": "Potenza PV ingresso massima",
  "51002.real_time.pvPower": "Potenza in uscita PV",
  "51002.real_time.stRelayoN": "Stato connessione relè",
  "51002.real_time.Tempmax": "Temperatura operativa massima",
  "51002.real_time.Un": "Valore efficace tensione nominale di connessione alla rete",
  "51002.real_time.Vacrms": "Valore efficace tensione lato rete",
  "51002.real_time.Vmpptmax": "Tensione MPPT massima",
  "51002.real_time.Vmpptmin": "Tensione MPPT minima",
  "51002.real_time.Vpv1": "Tensione ingresso PV1",
  "51002.real_time.Vpv2": "Tensione ingresso PV2",
  "51002.real_time.Vpv3": "Tensione ingresso PV3",
  "51002.real_time.Vpv4": "Tensione ingresso PV4",
  "51002.real_time.workStatus": "Stato operativo",
  "51002.warning.stAbnorm_Ris": "Anomalia impedenza di isolamento",
  "51002.warning.stErrAccess_EEPROM": "Anomalia accesso EEPROM",
  "51002.warning.stErrOP_Relay": "Protezione anomalia relè lato rete",
  "51002.warning.stHW_Fault": "Protezione hardware inverter",
  "51002.warning.stOV_Fgrid": "Protezione sovrafrequenza lato rete",
  "51002.warning.stOV_Temp": "Protezione sovratemperatura inverter",
  "51002.warning.stOV_Vgrid": "Protezione sovratensione lato rete",
  "51002.warning.stPV1_OV": "Sovratensione ingresso PV 1",
  "51002.warning.stPV1_UV": "Sottotensione ingresso PV 1",
  "51002.warning.stPV2_OV": "Sovratensione ingresso PV 2",
  "51002.warning.stPV2_UV": "Sottotensione ingresso PV 2",
  "51002.warning.stPV3_OV": "Sovratensione ingresso PV 3",
  "51002.warning.stPV3_UV": "Sottotensione ingresso PV 3",
  "51002.warning.stPV4_OV": "Sovratensione ingresso PV 4",
  "51002.warning.stPV4_UV": "Sottotensione ingresso PV 4",
  "51002.warning.stUV_Fgrid": "Protezione sottofrequenza lato rete",
  "51002.warning.stUV_Vgrid": "Protezione sottotensione lato rete",
  "51002.ctrl_antireverse.dynamicPowerLimit": "Valore percentuale limite potenza anti-ritorno",
  "51002.ctrl_antireverse.enaPAVE_FEEDINLIMIT": "Abilitazione anti-ritorno",
  "51002.ctrl_inverter.enaAPP_PWSET": "Abilitazione impostazione potenza utente",
  "51002.ctrl_inverter.enaFgridShiftPowerAdj": "Abilitazione regolazione potenza offset frequenza",
  "51002.ctrl_inverter.enaINVTR": "Accensione/spegnimento remoto inverter",
  "51002.ctrl_inverter.enaISORES_ABNORMPROT": "Abilitazione protezione anomalia impedenza di isolamento",
  "51002.ctrl_inverter.enaOVs1_powerdownadj": "Abilitazione derating sovratensione primo livello",
  "51002.ctrl_inverter.enaOVTPWDN": "Abilitazione derating sovratemperatura",
  "51002.ctrl_inverter.enaRestoretodefault": "Ripristina valori protezione predefiniti e interruttori funzione",
  "51002.ctrl_inverter.powersetUserApp": "Percentuale limite potenza utente",
  "bw_param_ctrl_option_BackupMode": "Modalità alimentazione di riserva",
  "bw_param_ctrl_option_ Feed-inPriorityMode": "Priorità immissione rete",
  "50657.fault.comStatus": "Stato di comunicazione",
  "50657.fault.comStatus.00": "Disconnesso",
  "50657.fault.comStatus.01": " Connesso",
  "50657.realtime.FADE": "Energia attiva valle profonda diretta",
  "50657.realtime.FAFE": "Energia attiva normale diretta",
  "50657.realtime.FAFE_PSD": "Energia attiva normale diretta (giorno di fatturazione precedente)",
  "50657.realtime.FAPE": "Energia attiva di picco diretta",
  "50657.realtime.FAPE_PSD": "Energia attiva di picco diretta (giorno di fatturazione precedente)",
  "50657.realtime.FAPVE": "Energia attiva picco-valle diretta",
  "50657.realtime.FAPVE_PSD": "Energia attiva picco-valle diretta (giorno di fatturazione precedente)",
  "50657.realtime.FASE": "Energia attiva picco massimo diretta",
  "50657.realtime.FASE_PSD": "Energia attiva picco massimo diretta (giorno di fatturazione precedente)",
  "50657.realtime.FAVE": "Energia attiva valle diretta",
  "50657.realtime.FAVE_PSD": "Energia attiva valle diretta (giorno di fatturazione precedente)",
  "50657.realtime.FTAE": "Energia attiva totale diretta",
  "50657.realtime.FTAE_PSD": "Energia attiva totale diretta (giorno di fatturazione precedente)",
  "50657.realtime.Fr": "Frequenza",
  "50657.realtime.Ia": "Corrente fase A",
  "50657.realtime.Ib": "Corrente fase B",
  "50657.realtime.Ic": "Corrente fase C",
  "50657.realtime.P": "Potenza attiva totale",
  "50657.realtime.Pa": "Potenza attiva totale fase A",
  "50657.realtime.Pb": "Potenza attiva totale fase B",
  "50657.realtime.Pc": "Potenza attiva totale fase C",
  "50657.realtime.Pf": "Fattore di potenza totale",
  "50657.realtime.Pfa": "Fattore di potenza fase A",
  "50657.realtime.Pfb": "Fattore di potenza fase B",
  "50657.realtime.Pfc": "Fattore di potenza fase C",
  "50657.realtime.Q": "Potenza reattiva totale",
  "50657.realtime.Qa": "Potenza reattiva totale fase A",
  "50657.realtime.Qb": "Potenza reattiva totale fase B",
  "50657.realtime.Qc": "Potenza reattiva totale fase C",
  "50657.realtime.RADE": "Energia attiva valle profonda inversa",
  "50657.realtime.RAFE": "Energia attiva normale inversa",
  "50657.realtime.RAPE": "Energia attiva di picco inversa",
  "50657.realtime.RASE": "Energia attiva picco massimo inversa",
  "50657.realtime.RAVE": "Energia attiva valle inversa",
  "50657.realtime.RTAE": "Energia attiva totale inversa",
  "50657.realtime.S": "Potenza apparente totale",
  "50657.realtime.Sa": "Potenza apparente fase A",
  "50657.realtime.Sb": "Potenza apparente fase B",
  "50657.realtime.Sc": "Potenza apparente fase C",
  "50657.realtime.T": " Temperatura",
  "50657.realtime.Ua": "Tensione fase A",
  "50657.realtime.Uab": "Tensione di linea AB",
  "50657.realtime.Ub": "Tensione fase B",
  "50657.realtime.Ubc": "Tensione di linea BC",
  "50657.realtime.Uc": "Tensione fase C",
  "50657.realtime.Uca": "Tensione di linea CA",
  "50657.realtime.Z0": "Impedenza sequenza zero",
  "50657.realtime.Zf": "Impedenza diretta",
  "bw_param_ctrl_note_DispatchActivepower": "Impostare questi dati su un numero positivo indica la necessità di scaricare, mentre impostarli su un numero negativo indica la necessità di caricare.",
  "bw_param_ctrl_option_Forcedcharginganddischarging": "Carica/Scarica forzata",
  "bw_param_ctrl_option_GridUseCT&PVUseMeter": "TA per rete, contatore per fotovoltaico",
  "bw_param_ctrl_option_GridUseMeter&PVUseCT": "Contatore per rete, TA per fotovoltaico",
  "bw_param_ctrl_option_DisableTimePeriodControl": "Disabilita controllo periodo temporale",
  "bw_param_ctrl_option_OnlyEnableChargeTimeperiodcontrol": "Abilita solo controllo periodo temporale di carica",
  "bw_RTparam_name_TotalApparentPower_Grid": "Potenza apparente del contatore (Totale)",
  "bw_param_ctrl_name_FactoryReset ": "Ripristino impostazioni di fabbrica",
  "bw_param_ctrl_option_FactoryReset ": "Riavvia",
  "bw_param_ctrl_note_DSPReset": "Quando le informazioni sul guasto non sono coerenti con la situazione reale, è possibile ripristinarle riavviando il DSP. Ad esempio, se l'app rileva un guasto di perdita del filo di terra, ma il filo di terra collegato all'inverter non è disconnesso, può essere ripristinato riavviando il DSP.",
  "bw_param_ctrl_note_EMSReset": "Quando si verifica una raccolta dati anomala, reimposta il sistema EMS per ripristinare il sistema.",
  "bw_param_ctrl_note_FactoryReset": "Se si desidera impostare tutti i parametri dell'inverter sui valori predefiniti, è possibile utilizzare questa funzione.",
  "bw_param_ctrl_option_Grid&PVuseCT": "Rete & PV utilizzano CT",
  "bw_param_outage_soc_setting": "Impostazione SOC in caso di interruzione alimentazione",
  "netherland.areas": "The Netherlands",
  "paramSet.grouping.safetySetting": "Impostazioni normative di sicurezza",
  "ice.robot.strategy.type.int.str.sta.rev.pri": "Priorità ai ricavi della stazione",
  "networkEnum.code.1": "LAN",
  "networkEnum.code.2": "WiFi",
  "networkEnum.code.3": "2G",
  "networkEnum.code.63": "4G",
  "networkEnum.code.12": "WiFi + BLE",
  "networkEnum.code.23": "WiFi + 4G + BLE",
  "networkEnum.code.62": "LAN",
  "networkEnum.code.64": "WiFi + AP",
  "networkEnum.code.65": "4G + BLE",
  "networkEnum.code.12,62": "WiFi + BLE + LAN",
  "networkEnum.code.62,63": "LAN + 4G",
  "networkEnum.code.23,62": "WiFi + BLE + LAN + 4G",
  "isShowService.show": "show",
  "transfer.operation.success": "",
  "transfer.operation.fail": "",
  "transfer.operation.unbind": "",
  "transfer.operation.withdraw": "",
  "login.correctEmail": "Per abbonarsi, digitare l’indirizzo postale corretto",
  "login.passLength": "La lunghezza della password deve essere compresa tra 8 e 20 bit",
  "login.passType": "La parola d’ordine deve contenere almeno tre numeri, una lettera maiuscola, una minuscola e un simbolo inglese",
  "placeholder.input": "Inserisci",
  "placeholder.startTime": "ora di inizio",
  "placeholder.endTime": "Tempo di fine",
  "placeholder.startDate": "Data di inizio",
  "placeholder.endDate": "Data di fine",
  "upload.imageDetail": "Dettagli dell'immagine",
  "upload.seeOrigin": "Fare clic per visualizzare il file sorgente",
  "upload.needOpen": "Questo file potrebbe aver bisogno di essere scaricato e visualizzato",
  "upload.knowandSure": "Conoscere e confermare",
  "upload.fail": "Caricamento fallito",
  "upload.uploadError": "Caricamento del file non riuscito, contatta l'amministratore",
  "upload.fielExceed": "Il numero di file supera il limite",
  "upload.fileSizeExceed": "La dimensione dell'immagine caricata non può superare",
  "upload.fileTypeError": "Scegli il formato di file corretto",
  "upload.image": "picture",
  "validator.bank": "Inserisci il numero corretto della carta di credito",
  "validator.phone": "Inserisci il numero corretto di cellulare o di rete fissa",
  "validator.email": "Inserisci l'indirizzo email corretto",
  "validator.password": "La password deve essere lunga 8-20 caratteri e contenere almeno tre tipi di caratteri: numeri, lettere maiuscole, lettere minuscole e simboli inglesi",
  "validator.greater": "Inserisci un numero maggiore di zero",
  "org.user": "utente",
  "org.role": "ruolo",
  "org.email": "cassetta postale",
  "org.editorginfo": "Modifica informazioni organizzative",
  "org.passwordResetTo": "La password verrà ripristinata a",
  "org.pleaseChooseOrg": "Seleziona prima un'organizzazione",
  "org.addDept": "Aggiungi reparto",
  "org.editDept": "Redazione",
  "org.passwordResetSuccess": "Ripristino password riuscito",
  "org.passwordResetFail": "Ripristino della password non riuscito",
  "org.deleteTip": "Questa operazione cancellerà il dipartimento.",
  "org.deleteSuccess": "Elimina correttamente",
  "org.parent": "Organizzazione Superiore",
  "org.orgName": "Nome dell'organizzazione",
  "org.area": "Paese/Regione",
  "org.leader": "responsabile",
  "org.leaderPhone": "Informazioni di contatto del responsabile",
  "org.logo": "Logo organizzativo",
  "org.namenick": "Nome/Soprannome",
  "org.createTime": "Tempo di creazione",
  "org.status": "stato",
  "org.action": "operazione",
  "login.password.not.blank": "La password di accesso non può essere vuota",
  "token.invalid": "Token non valido, per favore accedi di nuovo",
  "token.empty": "Il token non può essere vuoto",
  "user.not.exist": "utente non esiste",
  "user.mail.password.not.correct": "L'email o la password dell'utente non sono corretti",
  "user.email.exist": "E-mail è stata registrata!",
  "dept.suspend": "Dipartimento sospeso, nessuna nuova aggiunta consentita",
  "dept.not.exist": "Le informazioni del dipartimento non esistono",
  "email.code.valid": "Il codice di verifica non è corretto",
  "service.not.found": "Servizio non trovato",
  "service.internal.error": "Errore server interno",
  "login.email.length.error": "La lunghezza dell'email non può superare i 50 caratteri.",
  "login.password.length.error": "La lunghezza della password deve essere compresa tra 8 e 20 caratteri",
  "menu.edit.exist": "Impossibile modificare il menu \"% s\", il nome del menu esiste già",
  "menu.add.exist": "Aggiunta del menu \"% s\" non riuscita, il nome del menu esiste già",
  "menu.edit.parent": "Modifica del menu \"% s\" non riuscita, il menu di livello superiore non può selezionarsi da solo",
  "menu.add.parent": "Aggiunta del menu \"% s\" non riuscita, il menu di livello superiore non può selezionarsi da solo",
  "menu.child.exist": "C'è un sottomenu che non può essere eliminato",
  "menu.assign.error": "Menu assegnato, cancellazione non consentita",
  "password.reset.success": "Ripristino password riuscito",
  "user.register.success": "registrato con successo",
  "dept.add.exist": "Aggiunta \"% s\" del dipartimento non riuscita, il nome del dipartimento esiste già",
  "dept.edit.exist": "Impossibile modificare il dipartimento \"%s\", il nome del dipartimento esiste già",
  "menu.show.status": "display",
  "menu.hide.status": "nascondi",
  "menu.category.name": "catalogo",
  "menu.menu.name": "menu",
  "menu.button.name": "Pulsante",
  "menu.is.external": "sì",
  "menu.not.external": "no",
  "dev.type.oem": "OEM",
  "dev.type.odm": "ODM",
  "dev.type.self": "Sviluppo autonomo",
  "supplier.type.hr": "Haier",
  "supplier.type.jl": "Jinlang",
  "supplier.type.nt": "Natong",
  "device.category.inverter": "inverter",
  "device.category.pv": "fotovoltaico",
  "device.category.battery": "Batteria",
  "device.category.switch": "switch",
  "device.category.charging.pile": "Stazione di ricarica",
  "product.not.exist": "Il prodotto non esiste",
  "product.binding.error": "Il prodotto è già legato e non può essere cancellato",
  "ship.import.empty": "I dati di importazione non possono essere vuoti",
  "mdn.exist": "Il numero del materiale mdn esiste già, non aggiungerlo di nuovo",
  "ship.mdn.not.empty": "Mdn non può essere vuoto",
  "ship.category.not.empty": "La categoria non può essere vuota",
  "ship.hrSn.not.empty": "Il numero di serie Haier non può essere vuoto",
  "ship.devType.not.empty": "Il tipo di R&S non può essere vuoto",
  "ship.supplierSn.not.empty": "Il numero di serie del fornitore non può essere vuoto",
  "ship.mdn.not.exist": "Il prodotto mdn non esiste",
  "ship.add.data.error": "Aggiunta anomala dei dati di gestione della spedizione, contattare l'amministratore",
  "sotrage.sotrage": "Impostazioni di stoccaggio dell'energia",
  "device.input_ent_address": "Termina l'indirizzo del registro",
  "device.selet_data": "Seleziona data",
  "plant.InstallationPlan": "Piano di installazione",
  "plant.owner": "Proprietario",
  "plant.photovoltaicCapacity": "Capacità fotovoltaica (kWh)",
  "plant.batteryCapacity": "Capacità della batteria (kWh)",
  "plant.electricityConsumptionToday": "Energia elettrica odierna",
  "plant.electricityConsumptionMonth": "Energia elettrica mensile",
  "plant.electricityConsumptionTotal": "Energia elettrica cumulativa",
  "plant.runningState": "Stato di Funzionamento",
  "plant.buildState": "Stato di costruzione",
  "plant.plantNum": "Numero di centrali elettriche",
  "plant.totalPlantNum": "Totale",
  "plant.building": "In costruzione",
  "plant.delivered": "Consegnate",
  "plant.electricEnergy": "Produzione di energia elettrica",
  "plant.deleteSuccess": "Centrale elettrica eliminata con successo",
  "plant.life": "Durata di vita",
  "plant.operatingData": "Dati di funzionamento",
  "plant.dataReportingTime": "Ora di invio dei dati",
  "plant.energyBalance": "Bilancio energetico (kWh)",
  "plant.onGridEnergy": "Energia elettrica immessa in rete",
  "plant.purchaseElectricity": "Energia elettrica acquistata",
  "plant.statisticalAnalysis": "Analisi statistica",
  "plant.energyAnalysis": "Analisi energetica",
  "plant.powerAnalysis": "Analisi di potenza",
  "plant.updateTime": "Ora di aggiornamento dei dati meteorologici",
  "plant.stationInfo": "Informazioni sulla centrale elettrica",
  "plant.userInfo": "Informazioni sull'utente",
  "plant.socialContribution": "Contributo sociale",
  "plant.equivalentIncome": "Rendimento equivalente",
  "plant.priceSet": "Impostazioni del prezzo dell'energia elettrica",
  "plant.photovoltaicPowerGenerations": "Produzione di energia elettrica fotovoltaica",
  "plant.weather": "Meteo",
  "plant.sunriseSunset": "Alba/Tramonto",
  "plant.temperature": "Temperatura(℃)",
  "plant.humidity": "Umidità",
  "plant.windSpeed": "Velocità del vento",
  "plant.windDirection": "Direzione del vento",
  "plant.primaryUser": "Utente principale",
  "plant.receiveMode": "Modalità di ricezione",
  "plant.dateOfReceipt": "Data di ricezione",
  "plant.familyName": "Nome della famiglia",
  "plant.familyMembers": "Numero di membri della famiglia",
  "plant.currency": "Valuta",
  "plant.purchasePrice": "Prezzo di acquisto",
  "plant.sellingPrice": "Prezzo di vendita dell'energia elettrica",
  "plant.noUserInfo": "Utenti non ancora consegnati",
  "plant.noIncomeTip": "Per calcolare meglio il vostro rendimento equivalente, si prega di inserire il prezzo di acquisto e vendita dell'energia elettrica",
  "subttile.week": "Settimana",
  "shipment.spread": "Espandi",
  "shipment.packUp": "Comprimi",
  "device.empty": "Dispositivo non esistente",
  "deviceType.empty": "Tipo di dispositivo non supportato",
  "collector.params.error": "Lettura anomala di parametri non acquisiti",
  "can.not.empty": "Non può essere vuoto",
  "shipment.supplierSN": "Codice fornitore (SN)",
  "solis.10001.eToday": "Generazione di energia giornaliera",
  "solis.10001.eMonth": "Generazione di energia mensile",
  "solis.10001.eYear": "Produzione annuale di energia",
  "solis.10001.eTotal": "Generazione di energia totale",
  "solis.10001.fAc": "Frequenza di rete",
  "solis.10001.pac": "Potenza in tempo reale",
  "solis.10001.pacPec": "Percentuale di potenza",
  "solis.10001.fullHour": "Ore di piena potenza",
  "solis.10001.power": "Capacità installata",
  "solis.10001.iAc1": "Corrente lato AC - R",
  "solis.10001.iAc2": "Corrente lato AC - S",
  "solis.10001.iAc3": "Corrente lato AC - T",
  "solis.10001.uAc1": "Tensione lato AC - R",
  "solis.10001.uAc2": "Tensione lato AC - S",
  "solis.10001.uAc3": "Tensione lato AC - T",
  "solis.10001.iPv1": "PV Corrente-1",
  "solis.10001.iPv2": "PV Corrente-2",
  "solis.10001.iPv3": "PV Corrente-3",
  "solis.10001.iPv4": "PV Corrente-4",
  "solis.10001.iPv5": "PV Corrente-5",
  "solis.10001.iPv6": "PV Corrente-6",
  "solis.10001.iPv7": "PV Corrente-7",
  "solis.10001.iPv8": "PV Corrente-8",
  "solis.10001.iPv9": "PV Corrente-9",
  "solis.10001.iPv10": "PV Corrente-10",
  "solis.10001.iPv11": "PV Corrente-11",
  "solis.10001.iPv12": "PV Corrente-12",
  "solis.10001.iPv13": "PV Corrente-13",
  "solis.10001.iPv14": "PV Corrente-14",
  "solis.10001.iPv15": "PV Corrente-15",
  "solis.10001.iPv16": "PV Corrente-16",
  "solis.10001.iPv17": "PV Corrente-17",
  "solis.10001.iPv18": "PV Corrente-18",
  "solis.10001.iPv19": "PV Corrente-19",
  "solis.10001.iPv20": "PV Corrente-20",
  "solis.10001.iPv21": "PV Corrente-21",
  "solis.10001.iPv22": "PV Corrente-22",
  "solis.10001.iPv23": "PV Corrente-23",
  "solis.10001.iPv24": "PV Corrente-24",
  "solis.10001.iPv25": "PV Corrente-25",
  "solis.10001.iPv26": "PV Corrente-26",
  "solis.10001.iPv27": "PV Corrente-27",
  "solis.10001.iPv28": "PV Corrente-28",
  "solis.10001.iPv29": "PV Corrente-29",
  "solis.10001.iPv30": "PV Corrente-30",
  "solis.10001.iPv31": "PV Corrente-31",
  "solis.10001.iPv32": "PV Corrente-32",
  "solis.10001.uPv1": "Tensione PV-1",
  "solis.10001.uPv2": "Tensione PV-2",
  "solis.10001.uPv3": "Tensione PV-3",
  "solis.10001.uPv4": "Tensione PV-4",
  "solis.10001.uPv5": "Tensione PV-5",
  "solis.10001.uPv6": "Tensione PV-6",
  "solis.10001.uPv7": "Tensione PV-7",
  "solis.10001.uPv8": "Tensione PV-8",
  "solis.10001.uPv9": "Tensione PV-9",
  "solis.10001.uPv10": "Tensione PV-10",
  "solis.10001.uPv11": "Tensione PV-11",
  "solis.10001.uPv12": "Tensione PV-12",
  "solis.10001.uPv13": "Tensione PV-13",
  "solis.10001.uPv14": "Tensione PV-14",
  "solis.10001.uPv15": "Tensione PV-15",
  "solis.10001.uPv16": "Tensione PV-16",
  "solis.10001.uPv17": "Tensione PV-17",
  "solis.10001.uPv18": "Tensione PV-18",
  "solis.10001.uPv19": "Tensione PV-19",
  "solis.10001.uPv20": "Tensione PV-20",
  "solis.10001.uPv21": "Tensione PV-21",
  "solis.10001.uPv22": "Tensione PV-22",
  "solis.10001.uPv23": "Tensione PV-23",
  "solis.10001.uPv24": "Tensione PV-24",
  "solis.10001.uPv25": "Tensione PV-25",
  "solis.10001.uPv26": "Tensione PV-26",
  "solis.10001.uPv27": "Tensione PV-27",
  "solis.10001.uPv28": "Tensione PV-28",
  "solis.10001.uPv29": "Tensione PV-29",
  "solis.10001.uPv30": "Tensione PV-30",
  "solis.10001.uPv31": "Tensione PV-31",
  "solis.10001.uPv32": "Tensione PV-32",
  "solis.10001.pow1": "Potenza PV-1",
  "solis.10001.pow2": "Potenza PV-2",
  "solis.10001.pow3": "Potenza PV-3",
  "solis.10001.pow4": "Potenza PV-4",
  "solis.10001.pow5": "Potenza PV-5",
  "solis.10001.pow6": "Potenza PV-6",
  "solis.10001.pow7": "Potenza PV-7",
  "solis.10001.pow8": "Potenza PV-8",
  "solis.10001.pow9": "Potenza PV-9",
  "solis.10001.pow10": "Potenza PV-10",
  "solis.10001.pow11": "Potenza PV-11",
  "solis.10001.pow12": "Potenza PV-12",
  "solis.10001.pow13": "Potenza PV-13",
  "solis.10001.pow14": "Potenza PV-14",
  "solis.10001.pow15": "Potenza PV-15",
  "solis.10001.pow16": "Potenza PV-16",
  "solis.10001.pow17": "Potenza PV-17",
  "solis.10001.pow18": "Potenza PV-18",
  "solis.10001.pow19": "Potenza PV-19",
  "solis.10001.pow20": "Potenza PV-20",
  "solis.10001.pow21": "Potenza PV-21",
  "solis.10001.pow22": "Potenza PV-22",
  "solis.10001.pow23": "Potenza PV-23",
  "solis.10001.pow24": "Potenza PV-24",
  "solis.10001.pow25": "Potenza PV-25",
  "solis.10001.pow26": "Potenza PV-26",
  "solis.10001.pow27": "Potenza PV-27",
  "solis.10001.pow28": "Potenza PV-28",
  "solis.10001.pow29": "Potenza PV-29",
  "solis.10001.pow30": "Potenza PV-30",
  "solis.10001.pow31": "Potenza PV-31",
  "solis.10001.pow32": "Potenza PV-32",
  "solis.10001.inverterTemperature": "Temperatura dell'inverter(℃)",
  "solis.10001.acOutputType": "Livello di uscita AC",
  "solis.10001.dcInputType": "Numero di canali di ingresso DC",
  "solis.10001.powerFactor": "Fattore di potenza ",
  "solis.10001.batteryPower": "Potenza della batteria",
  "solis.10001.batteryPowerPec": "Percentuale di potenza della batteria",
  "solis.10001.batteryCapacitySoc": "SOC della batteria",
  "solis.10001.batteryHealthSoh": "SOH della batteria",
  "solis.10001.socDischargeSet": "SOC Sovrascarica",
  "solis.10001.socChargingSet": "Carica potente SOC",
  "solis.10001.batteryType": "Modello di batteria",
  "solis.10001.batteryVoltage": "Tensione della batteria",
  "solis.10001.batteryCurrent": "Corrente della batteria",
  "solis.10001.batteryTodayChargeEnergy": "Capacità di carica giornaliera della batteria",
  "solis.10001.batteryMonthChargeEnergy": "Capacità di carica mensile della batteria",
  "solis.10001.batteryYearChargeEnergy": "Capacità di carica annuale della batteria",
  "solis.10001.batteryTotalChargeEnergy": "Capacità di carica totale della batteria",
  "solis.10001.batteryTodayDischargeEnergy": "Capacità di scarica giornaliera della batteria",
  "solis.10001.batteryMonthDischargeEnergy": "Capacità di scarica mensile della batteria",
  "solis.10001.batteryYearDischargeEnergy": "Capacità di scaricamento annuale della batteria",
  "solis.10001.batteryTotalDischargeEnergy": "Scarico totale della batteria",
  "solis.10001.gridPurchasedTodayEnergy": "Consumo giornaliero di elettricità dalla rete elettrica",
  "solis.10001.gridPurchasedMonthEnergy": "Acquisto mensile di elettricità dalla rete elettrica",
  "solis.10001.gridPurchasedYearEnergy": "Acquisto annuale di elettricità dalla rete elettrica",
  "solis.10001.gridPurchasedTotalEnergy": "Totale elettricità acquistata dalla rete elettrica",
  "solis.10001.gridSellTodayEnergy": "Vendite giornaliere di elettricità della rete elettrica",
  "solis.10001.gridSellMonthEnergy": "Vendite mensili di elettricità della rete elettrica",
  "solis.10001.gridSellYearEnergy": "Vendite annuali di elettricità della rete elettrica",
  "solis.10001.gridSellTotalEnergy": "Vendite totali di elettricità della rete elettrica",
  "solis.10001.familyLoadPower": "Potenza del carico domestico",
  "solis.10001.bypassLoadPower": "Potenza del carico di bypass",
  "solis.10001.pSum": "Potenza attiva totale della rete elettrica",
  "solis.10001.psumPec": "La percentuale della potenza attiva totale della rete elettrica",
  "solis.10001.homeLoadTodayEnergy": "Consumo giornaliero del carico",
  "solis.10001.homeLoadTotalEnergy": "Consumo totale del carico",
  "solis.10001.model": "Modello di inverter",
  "solis.10001.type": "Tipo di inverter",
  "solis.10001.stateExceptionFlag": "Stato offline dell'inverter",
  "solis.10001.productModel": "Modello di prodotto",
  "solis.10001.nationalStandards": "Standard di rete statale",
  "solis.10001.version": "Versione software dell'inverter",
  "solis.10001.reactivePower": "Potenza reattiva dell'inverter",
  "solis.10001.apparentPower": "Potenza apparente dell'inverter",
  "solis.10001.dcPac": "Potenza totale di ingresso DC",
  "solis.10001.updateShelfEndTime": "Tempo di fine garanzia",
  "solis.10001.iA": "Corrente del contatore A",
  "solis.10001.uA": "Tensione del contatore A",
  "solis.10001.pA": "Potenza del contatore A",
  "solis.10001.aLookedPower": "Potenza apparente del contatore A",
  "solis.10001.aReactivePower": "Potenza reattiva del contatore A",
  "solis.10001.aphasePowerFactor": "Potenza attiva del contatore A",
  "solis.10001.averagePowerFactor": "Fattore di potenza del contatore A",
  "solis.10001.iB": "Corrente del contatore B",
  "solis.10001.uB": "Tensione del contatore B",
  "solis.10001.pB": "Potenza del contatore B",
  "solis.10001.bLookedPower": "Misuratore B Potenza apparente",
  "solis.10001.bReactivePower": "Potenza reattiva del contatore B",
  "solis.10001.bphasePowerFactor": "Potenza attiva del contatore B",
  "solis.10001.bveragePowerFactor": "Misuratore B Fattore di potenza",
  "solis.10001.iC": "Misuratore C Corrente",
  "solis.10001.uC": "Misuratore C Tensione",
  "solis.10001.pC": "Contatore C Potenza",
  "solis.10001.cLookedPower": "Misuratore C Potenza apparente",
  "solis.10001.cReactivePower": "Potenza reattiva del contatore C",
  "solis.10001.cphasePowerFactor": "Potenza attiva del contatore C",
  "solis.10001.cveragePowerFactor": "Misuratore C fattore di potenza",
  "jl_param_ctrl_name_ChargeTimeSlot1Switch": "Slot di tempo di carica 1 interruttore",
  "jl_param_ctrl_name_ChargeTimeSlot1": "Slot temporale di carica 1",
  "jl_param_ctrl_name_SOC1": "SOC 1",
  "jl_param_ctrl_name_ChargeCurrent1": "Corrente di carica 1",
  "jl_param_ctrl_name_ChargeTimeSlot2Switch": "Interruttore slot di tempo di carica 2",
  "jl_param_ctrl_name_ChargeTimeSlot2": "Slot di tempo di carica 2",
  "jl_param_ctrl_name_SOC2": "SOC 2",
  "jl_param_ctrl_name_ChargeCurrent2": "Corrente di carica 2",
  "jl_param_ctrl_name_ChargeTimeSlot3Switch": "Interruttore slot di tempo di carica 3",
  "jl_param_ctrl_name_ChargeTimeSlot3": "Slot di tempo di carica 3",
  "jl_param_ctrl_name_SOC3": "SOC 3",
  "jl_param_ctrl_name_ChargeCurrent3": "Corrente di carica 3",
  "jl_param_ctrl_name_ChargeTimeSlot4Switch": "Interruttore slot di tempo di carica 4",
  "jl_param_ctrl_name_ChargeTimeSlot4": "Slot di tempo di carica 4",
  "jl_param_ctrl_name_SOC4": "SOC 4",
  "jl_param_ctrl_name_ChargeCurrent4": "Corrente di carica 4",
  "jl_param_ctrl_name_ChargeTimeSlot5Switch": "Interruttore slot di tempo di carica 5",
  "jl_param_ctrl_name_ChargeTimeSlot5": "Slot di tempo di carica 5",
  "jl_param_ctrl_name_SOC5": "SOC 5",
  "jl_param_ctrl_name_ChargeCurrent5": "Corrente di carica 5",
  "jl_param_ctrl_name_ChargeTimeSlot6Switch": "Interruttore slot di tempo di carica 6",
  "jl_param_ctrl_name_ChargeTimeSlot6": "Slot di tempo di carica 6",
  "jl_param_ctrl_name_SOC6": "SOC 6",
  "jl_param_ctrl_name_ChargeCurrent6": "Corrente di carica 6",
  "jl_param_ctrl_name_DischargeTimeSlot1Switch": "Slot temporale di scarico 1 Interruttore",
  "jl_param_ctrl_name_DischargeTimeSlot1": "Slot temporale di scarico 1",
  "jl_param_ctrl_name_DischargeCurrent1": "Corrente di scarico 1",
  "jl_param_ctrl_name_DischargeTimeSlot2Switch": "Interruttore della slot temporale di scarico 2",
  "jl_param_ctrl_name_DischargeTimeSlot2": "Slot temporale di scarico 2",
  "jl_param_ctrl_name_DischargeCurrent2": "Corrente di scarico 2",
  "jl_param_ctrl_name_DischargeTimeSlot3Switch": "Interruttore a slot temporale di scarico 3",
  "jl_param_ctrl_name_DischargeTimeSlot3": "Slot temporale di scarico 3",
  "jl_param_ctrl_name_DischargeCurrent3": "Corrente di scarico 3",
  "jl_param_ctrl_name_DischargeTimeSlot4Switch": "Interruttore a slot temporale di scarico 4",
  "jl_param_ctrl_name_DischargeTimeSlot4": "Slot temporale di scarico 4",
  "jl_param_ctrl_name_DischargeCurrent4": "Corrente di scarico 4",
  "jl_param_ctrl_name_DischargeTimeSlot5Switch": "Interruttore a slot temporale di scarico 5",
  "jl_param_ctrl_name_DischargeTimeSlot5": "Slot temporale di scarico 5",
  "jl_param_ctrl_name_DischargeCurrent5": "Corrente di scarico 5",
  "jl_param_ctrl_name_DischargeTimeSlot6Switch": "Interruttore a slot temporale di scarico 6",
  "jl_param_ctrl_name_DischargeTimeSlot6": "Slot temporale di scarico 6",
  "jl_param_ctrl_name_DischargeCurrent6": "Corrente di scarico 6",
  "jl_param_ctrl_note_ChargeTimeSlot1": "Non ci dovrebbe essere sovrapposizione con altri periodi di ricarica e scarica forti",
  "jl_param_ctrl_note_SOC1": "Gamma: SOC~100% di scarico superiore",
  "jl_param_ctrl_note_ChargeTimeSlot2": "Non ci dovrebbe essere sovrapposizione con altri periodi di ricarica e scarica forti",
  "jl_param_ctrl_note_SOC2": "Gamma: SOC~100% di scarico superiore",
  "jl_param_ctrl_note_ChargeTimeSlot3": "Non ci dovrebbe essere sovrapposizione con altri periodi di ricarica e scarica forti",
  "jl_param_ctrl_note_SOC3": "Gamma: SOC~100% di scarico superiore",
  "jl_param_ctrl_note_ChargeTimeSlot4": "Non ci dovrebbe essere sovrapposizione con altri periodi di ricarica e scarica forti",
  "jl_param_ctrl_note_SOC4": "Gamma: SOC~100% di scarico superiore",
  "jl_param_ctrl_note_ChargeTimeSlot5": "Non ci dovrebbe essere sovrapposizione con altri periodi di ricarica e scarica forti",
  "jl_param_ctrl_note_SOC5": "Gamma: SOC~100% di scarico superiore",
  "jl_param_ctrl_note_ChargeTimeSlot6": "Non ci dovrebbe essere sovrapposizione con altri periodi di ricarica e scarica forti",
  "jl_param_ctrl_note_SOC6": "Gamma: SOC~100% di scarico superiore",
  "jl_param_ctrl_note_DischargeTimeSlot1": "Non ci dovrebbe essere sovrapposizione con altri periodi di ricarica e scarica forti",
  "jl_param_ctrl_note_DischargeTimeSlot2": "Non ci dovrebbe essere sovrapposizione con altri periodi di ricarica e scarica forti",
  "jl_param_ctrl_note_DischargeTimeSlot3": "Non ci dovrebbe essere sovrapposizione con altri periodi di ricarica e scarica forti",
  "jl_param_ctrl_note_DischargeTimeSlot4": "Non ci dovrebbe essere sovrapposizione con altri periodi di ricarica e scarica forti",
  "jl_param_ctrl_note_DischargeTimeSlot5": "Non ci dovrebbe essere sovrapposizione con altri periodi di ricarica e scarica forti",
  "jl_param_ctrl_note_DischargeTimeSlot6": "Non ci dovrebbe essere sovrapposizione con altri periodi di ricarica e scarica forti",
  "device.category.collecting.box": "Modulo di concentrazione",
  "device.category.energy.storage": "Sistema di controllo integrato",
  "ywt.65323.runStatus": "Stato di Funzionamento",
  "ywt.65323.faultStatus1": "État de défaillance 1",
  "ywt.65323.faultStatus2": "État de défaillance 2",
  "ywt.65323.warningStatus": "Statut d'alerte",
  "ywt.65323.relayStatus": "État du relais",
  "ywt.65323.inverterTemperature": "Température inverse(℃)",
  "ywt.65323.dcTemperature": "Température DC(℃)",
  "ywt.65323.drmStatus": "Statut DRM",
  "ywt.65323.mpptTemperature": "MPPT température(℃)",
  "ywt.65323.gridVoltageAB": "Tension du réseau électrique AB",
  "ywt.65323.gridVoltageBC": "Tension du réseau électrique BC",
  "ywt.65323.gridVoltageCA": "Tension du réseau électrique CA",
  "ywt.65323.gridCurrentA": "Courant du réseau électrique A",
  "ywt.65323.gridCurrentB": "Courant du réseau électrique B",
  "ywt.65323.gridCurrentC": "Courant du réseau électrique C",
  "ywt.65323.gridFrequencyA": "Fréquence du réseau électrique A",
  "ywt.65323.gridFrequencyB": "Fréquence du réseau électrique B",
  "ywt.65323.gridFrequencyC": "Fréquence du réseau électrique C",
  "ywt.65323.gridActivePower": "Puissance active du réseau électrique",
  "ywt.65323.gridAPhaseActivePower": "Puissance active phase a du réseau électrique",
  "ywt.65323.gridBPhaseActivePower": "Puissance active phase B du réseau électrique",
  "ywt.65323.gridCPhaseActivePower": "Puissance active phase C du réseau électrique",
  "ywt.65323.gridReactivePower": "Puissance réactive du réseau électrique",
  "ywt.65323.gridApparentPower": "Puissance apparente du réseau",
  "ywt.65323.powerFactor": "Facteur de puissance",
  "ywt.65323.dcComponentA": "Composante continue A",
  "ywt.65323.dcComponentB": "Composante continue B",
  "ywt.65323.dcComponentC": "Composante continue C",
  "ywt.65323.phaseOrder": "Ordre des phases",
  "ywt.65323.leakageCurrent": "Courant de fuite",
  "ywt.65323.clsStatus": "Statut CLS",
  "ywt.65323.clsLockNum": "Nombre de verrouillages CLS",
  "ywt.65323.clsLockTime": "Temps de verrouillage CLS",
  "ywt.65323.returnFlowPortVoltageA": "Tension de port de retour A",
  "ywt.65323.returnFlowPortVoltageB": "Tension de port de retour B",
  "ywt.65323.returnFlowPortVoltageC": "Tension de port de retour C",
  "ywt.65323.returnFlowPortCurrentA": "Courant de port de retour A",
  "ywt.65323.returnFlowPortCurrentB": "Courant de port de retour B",
  "ywt.65323.returnFlowPortCurrentC": "Courant de port de retour C",
  "ywt.65323.returnFlowPortTotalActivePower": "Port de retour puissance active totale",
  "ywt.65323.returnFlowPortAPhaseActivePower": "Port de retour phase A puissance active",
  "ywt.65323.returnFlowPortBPhaseActivePower": "Port de retour phase B puissance active",
  "ywt.65323.returnFlowPortCPhaseActivePower": "Port de retour phase C puissance active",
  "ywt.65323.returnFlowPortReactivePower": "Port de retour puissance réactive",
  "ywt.65323.returnFlowPortApparentPower": "Port de retour puissance apparente",
  "ywt.65323.returnFlowPortFrequency": "Fréquence du port de retour",
  "ywt.65323.returnFlowPortPowerFactor": "Facteur de puissance du port de retour",
  "ywt.65323.todayFeedInGridEnergy": "Alimentation du réseau le jour même",
  "ywt.65323.todayConsumeEnergy": "Consommation électrique de la journée",
  "ywt.65323.totalFeedInGridEnergy": "Quantité cumulée d'alimentation réseau",
  "ywt.65323.totalConsumeEnergy": "Consommation électrique cumulée",
  "ywt.65323.ctStatus": "État du compteur électrique",
  "ywt.65323.ctVoltageA": "Voltage du compteur A",
  "ywt.65323.ctVoltageB": "Voltage du compteur B",
  "ywt.65323.ctVoltageC": "Voltage du compteur C",
  "ywt.65323.ctCurrentA": "Courant du compteur A",
  "ywt.65323.ctCurrentB": "Courant du compteur B",
  "ywt.65323.ctCurrentC": "Courant du compteur C",
  "ywt.65323.ctTotalActivePower": "Puissance active totale du compteur",
  "ywt.65323.ctAPhaseActivePower": "Puissance active phase A du compteur",
  "ywt.65323.ctBPhaseActivePower": "Puissance active phase B du compteur",
  "ywt.65323.ctCPhaseActivePower": "Puissance active phase C du compteur",
  "ywt.65323.ctReactivePower": "Puissance réactive du compteur",
  "ywt.65323.ctApparentPower": "Puissance apparente du compteur",
  "ywt.65323.ctFrequency": "Fréquence du compteur électrique",
  "ywt.65323.ctPowerFactor": "Facteur de puissance du compteur électrique",
  "ywt.65323.loadVoltageA": "Tension de charge A",
  "ywt.65323.loadVoltageB": "Tension de charge B",
  "ywt.65323.loadVoltageC": "Tension de charge C",
  "ywt.65323.loadCurrentA": "Courant de charge A",
  "ywt.65323.loadCurrentB": "Courant de charge B",
  "ywt.65323.loadCurrentC": "Courant de charge C",
  "ywt.65323.loadFrequency": "Fréquence de charge",
  "ywt.65323.loadActivePower": "Puissance active de charge",
  "ywt.65323.loadAPhaseActivePower": "Charge phase A puissance active",
  "ywt.65323.loadBPhaseActivePower": "Charge phase B puissance active",
  "ywt.65323.loadCPhaseActivePower": "Charge phase C puissance active",
  "ywt.65323.loadReactivePower": "Puissance réactive de charge",
  "ywt.65323.loadTodayConsumeEnergy": "Consommation d'électricité le jour de la charge",
  "ywt.65323.loadTotalConsumeEnergy": "Consommation électrique cumulée de la charge",
  "ywt.65323.pv1Voltage": "Photovoltaïque 1 Voltage",
  "ywt.65323.pv2Voltage": "Photovoltaïque 2 Voltage",
  "ywt.65323.pv3Voltage": "Photovoltaïque 3 Voltage",
  "ywt.65323.pv4Voltage": "Photovoltaïque 4 Voltage",
  "ywt.65323.pv5Voltage": "Photovoltaïque 5 Voltage",
  "ywt.65323.pv6Voltage": "Photovoltaïque 6 Voltage",
  "ywt.65323.pv1Current": "Photovoltaïque 1 courant",
  "ywt.65323.pv2Current": "Photovoltaïque 2 courant",
  "ywt.65323.pv3Current": "Photovoltaïque 3 courant",
  "ywt.65323.pv4Current": "Photovoltaïque 4 courant",
  "ywt.65323.pv5Current": "Photovoltaïque 5 courant",
  "ywt.65323.pv6Current": "Photovoltaïque 6 courant",
  "ywt.65323.pv1Power": "Photovoltaïque 1 puissance",
  "ywt.65323.pv2Power": "Photovoltaïque 2 puissance",
  "ywt.65323.pv3Power": "Photovoltaïque 3 puissance",
  "ywt.65323.pv4Power": "Photovoltaïque 4 puissance",
  "ywt.65323.pv5Power": "Photovoltaïque 5 puissance",
  "ywt.65323.pv6Power": "Photovoltaïque 6 puissance",
  "ywt.65323.pvTotalPower": "Puissance totale photovoltaïque",
  "ywt.65323.busVoltage": "Tension du bus",
  "ywt.65323.pvTodayEnergy": "Production d'électricité photovoltaïque le jour même",
  "ywt.65323.pvMonthlyEnergy": "Production d'électricité photovoltaïque du mois",
  "ywt.65323.pvAnnualEnergy": "Production d'électricité photovoltaïque cette année - là",
  "ywt.65323.pvTotalEnergy": "Production totale d'électricité photovoltaïque",
  "ywt.65323.negativeElectrodeInsulationImpedance": "Impédance d'isolation négative",
  "ywt.65323.positiveElectrodeInsulationImpedance1": "Impédance d'isolation positive 1",
  "ywt.65323.positiveElectrodeInsulationImpedance2": "Impédance d'isolation positive 2",
  "ywt.65323.positiveElectrodeInsulationImpedance3": "Impédance d'isolation positive 3",
  "ywt.65323.positiveElectrodeInsulationImpedance4": "Impédance d'isolation positive 4",
  "ywt.65323.positiveElectrodeInsulationImpedance5": "Impédance d'isolation positive 5",
  "ywt.65323.positiveElectrodeInsulationImpedance6": "Impédance d'isolation positive 6",
  "ywt.65323.batteryVoltage": "Tension de la batterie",
  "ywt.65323.batteryCurrent": "Courant de batterie",
  "ywt.65323.batteryPower": "Puissance de la batterie",
  "ywt.65323.batterySOC": "Batterie SOC",
  "ywt.65323.batterySOH": "Batterie SOH",
  "ywt.65323.batteryStatus": "État de la batterie",
  "ywt.65323.batChargeVoltage": "Tension de charge",
  "ywt.65323.bmsBatteryVoltage": "Tension de la batterie BMS",
  "ywt.65323.bmsBatteryCurrent": "Courant de batterie BMS",
  "ywt.65323.bmsTemperature": "BMS température(℃)",
  "ywt.65323.bmsChargeCurrentLimit": "BMS charge limite de courant",
  "ywt.65323.bmsDischargeCurrentLimit": "BMS décharge limite de courant",
  "ywt.65323.batTodayChargeEnergy": "Charge de la batterie le jour même",
  "ywt.65323.batTodayDischargeEnergy": "Décharge de la batterie le jour même",
  "ywt.65323.batTotalChargeEnergy": "Charge cumulée de la batterie",
  "ywt.65323.batTotalDischargeEnergy": "Décharge cumulée de la batterie",
  "ywt.65323.bmsMaxVoltage": "BMS tension maximale",
  "ywt.65323.bmsMinVoltage": "BMS tension minimale",
  "ywt.65323.batFaultFlag": "Signe de panne de batterie",
  "ywt.65323.batAlarmFlag": "Signe d'alerte batterie",
  "ywt.65323.bmsRequestFlag": "Indicateur de demande BMS",
  "ywt.65323.generatorRelayStatus": "État du relais générateur",
  "ywt.65323.load2GeneratorVoltageA": "Charge 2 / tension du générateur A",
  "ywt.65323.load2GeneratorVoltageB": "Charge 2 / tension du générateur B",
  "ywt.65323.load2GeneratorVoltageC": "Charge 2 / tension du générateur C",
  "ywt.65323.load2GeneratorCurrentA": "Charge 2 / courant générateur A",
  "ywt.65323.load2GeneratorCurrentB": "Charge 2 / courant générateur B",
  "ywt.65323.load2GeneratorCurrentC": "Charge 2 / courant générateur C",
  "ywt.65323.load2GeneratorFrequency": "Charge 2 / fréquence du générateur",
  "ywt.65323.load2GeneratorActivePower": "Charge 2 / puissance active du générateur",
  "ywt.65323.load2GeneratorAPhaseActivePower": "Charge 2 / générateur phase A puissance active",
  "ywt.65323.load2GeneratorBPhaseActivePower": "Charge 2 / générateur phase B puissance active",
  "ywt.65323.load2GeneratorCPhaseActivePower": "Charge 2 / générateur phase C puissance active",
  "ywt.65323.load2GeneratorReactivePower": "Charge 2 / puissance réactive du générateur",
  "ywt.65323.load2GeneratorTodayConsumeEnergy": "Charge 2 / consommation électrique du générateur le jour même",
  "ywt.65323.load2GeneratorTotalConsumeEnergy": "Charge 2 / consommation électrique cumulée du générateur",
  "ywt.65323.load2GeneratorTodayGenerateEnergy": "Charge 2 / puissance du générateur le jour même",
  "ywt.65323.load2GeneratorTotalGenerateEnergy": "Charge 2 / puissance cumulée du générateur",
  "ywt.65323.spiAutoTestResult": "Résultats des tests automatisés SPI",
  "ywt.65323.spiAutoTestEndFlag": "Indicateur de fin de test automatique SPI",
  "ywt.65323.spiAutoTestThresholdAPhaseU1": "Seuil de test automatique SPI phase A U>>",
  "ywt.65323.spiAutoTestThresholdAPhaseU2": "Seuil de test automatique SPI phase A U>10min",
  "ywt.65323.spiAutoTestThresholdAPhaseU3": "Seuil de test automatique SPI phase A U<",
  "ywt.65323.spiAutoTestThresholdAPhaseU4": "Seuil de test automatique SPI phase A U<<",
  "ywt.65323.spiAutoTestThresholdBPhaseU1": "Seuil de test automatique SPI phase B U>>",
  "ywt.65323.spiAutoTestThresholdBPhaseU2": "Seuil de test automatique SPI phase B U>10min",
  "ywt.65323.spiAutoTestThresholdBPhaseU3": "Seuil de test automatique SPI phase B U<",
  "ywt.65323.spiAutoTestThresholdBPhaseU4": "Seuil de test automatique SPI phase B U<<",
  "ywt.65323.spiAutoTestThresholdCPhaseU1": "Seuil de test automatique SPI phase C U>>",
  "ywt.65323.spiAutoTestThresholdCPhaseU2": "Seuil de test automatique SPI phase C U>10min",
  "ywt.65323.spiAutoTestThresholdCPhaseU3": "Seuil de test automatique SPI phase C U<",
  "ywt.65323.spiAutoTestThresholdCPhaseU4": "Seuil de test automatique SPI phase C U<<",
  "ywt.65323.spiAutoTestThresholdF1": "Seuil de test automatique SPI F>>",
  "ywt.65323.spiAutoTestThresholdF2": "Seuil de test automatique SPI F>>",
  "ywt.65323.spiAutoTestThresholdF3": "Seuil de test automatique SPI F<",
  "ywt.65323.spiAutoTestThresholdF4": "Seuil de test automatique SPI F<<",
  "ywt.65323.spiAutoTestTimeAPhaseU1": "Temps de test automatique SPI phase A U>>",
  "ywt.65323.spiAutoTestTimeAPhaseU2": "Temps de test automatique SPI phase A U>10min",
  "ywt.65323.spiAutoTestTimeAPhaseU3": "Temps de test automatique SPI phase A U<",
  "ywt.65323.spiAutoTestTimeAPhaseU4": "Temps de test automatique SPI phase A U<<",
  "ywt.65323.spiAutoTestTimeBPhaseU1": "Temps de test automatique SPI Phase B U>>",
  "ywt.65323.spiAutoTestTimeBPhaseU2": "Temps de test automatique SPI Phase B U>10min",
  "ywt.65323.spiAutoTestTimeBPhaseU3": "Temps de test automatique SPI Phase B U<",
  "ywt.65323.spiAutoTestTimeBPhaseU4": "Temps de test automatique SPI Phase B U<<",
  "ywt.65323.spiAutoTestTimeCPhaseU1": "Temps de test automatique SPI Phase C U>>",
  "ywt.65323.spiAutoTestTimeCPhaseU2": "Temps de test automatique SPI Phase C U>10min",
  "ywt.65323.spiAutoTestTimeCPhaseU3": "Temps de test automatique SPI Phase C U<",
  "ywt.65323.spiAutoTestTimeCPhaseU4": "Temps de test automatique SPI Phase C U<<",
  "ywt.65323.spiAutoTestTimeF1": "Temps de test automatique SPI F>>",
  "ywt.65323.spiAutoTestTimeF2": "Temps de test automatique SPI F>",
  "ywt.65323.spiAutoTestTimeF3": "Temps de test automatique SPI F<",
  "ywt.65323.spiAutoTestTimeF4": "Temps de test automatique SPI F<<",
  "mini.65290.stOV_Vgrid": "Protezione da sovratensione lato rete",
  "mini.65290.stUV_Vgrid": "Protezione da sottotensione lato rete",
  "mini.65290.stOV_Fgrid": "Protezione da sovrafrequenza della tensione lato rete",
  "mini.65290.stUV_Fgrid": "Protezione da sottofrequenza della tensione lato rete",
  "mini.65290.stOV_Temp": "Protezione da sovratemperatura dell'inverter",
  "mini.65290.stHW_Fault": "Protezione hardware dell'inverter",
  "mini.65290.stErrOP_Relay": "Protezione anomala del relè lato rete",
  "mini.65290.stErrAccess_EEPROM": "Eccezione di accesso EEPROM",
  "mini.65290.stAbnorm_Ris": "Impedenza di isolamento anomala",
  "mini.65290.Vacrms": "Valore effettivo della tensione lato rete",
  "mini.65290.Iacrms": "Valore effettivo della corrente lato rete",
  "mini.65290.Fgrid": "Frequenza lato rete",
  "mini.65290.Temperature": "Temperatura di funzionamento dell'inverter(℃)",
  "mini.65290.stPV1_UV": "Sottotensione ingresso PV 1",
  "mini.65290.stPV1_OV": "Sovratensione dell'ingresso PV 1",
  "mini.65290.stRes1": "Stato riservato 1",
  "mini.65290.Vpv1": "Tensione d'ingresso PV1",
  "mini.65290.Ipv1": "Corrente d'ingresso PV1",
  "mini.65290.Energy_PV1": "Generazione di potenza cumulativa PV1",
  "mini.65290.stPV2_UV": "Ingresso PV 2 sottotensione",
  "mini.65290.stPV2_OV": "Sovratensione ingresso PV 2",
  "mini.65290.stRes2": "Stato di riserva 2",
  "mini.65290.Vpv2": "Tensione di ingresso PV2",
  "mini.65290.Ipv2": "Corrente di ingresso PV2",
  "mini.65290.Energy_PV2": "Produzione di energia cumulativa PV2",
  "mini.65290.stPV3_UV": "Ingresso PV 3 sottotensione",
  "mini.65290.stPV3_OV": "Ingresso PV 3 sovratensione",
  "mini.65290.stRes3": "Stato riservato 3",
  "mini.65290.Vpv3": "Tensione di ingresso PV3",
  "mini.65290.Ipv3": "PV3 corrente d'ingresso",
  "mini.65290.Energy_PV3": "Generazione di potenza cumulativa PV3",
  "mini.65290.stPV4_UV": "Ingresso PV 4 sottotensione",
  "mini.65290.stPV4_OV": "Ingresso PV 4 sovratensione",
  "mini.65290.stRes4": "Stato riservato 4",
  "mini.65290.Vpv4": "Tensione di ingresso PV4",
  "mini.65290.Ipv4": "PV4 corrente di ingresso",
  "mini.65290.Energy_PV4": "Generazione di potenza cumulativa PV4",
  "mini.65290.stPV5_UV": "Ingresso PV 5 sottotensione",
  "mini.65290.stPV5_OV": "Ingresso PV 5 sovratensione",
  "mini.65290.stRes5": "Stato riservato 5",
  "mini.65290.Vpv5": "Tensione di ingresso PV5",
  "mini.65290.Ipv5": "PV5 corrente di ingresso",
  "mini.65290.Energy_PV5": "PV5 generazione di energia cumulativa",
  "mini.65290.stPV6_UV": "Ingresso PV 6 sottotensione",
  "mini.65290.stPV6_OV": "Ingresso PV 6 sovratensione",
  "mini.65290.stRes6": "Stato riservato 6",
  "mini.65290.Vpv6": "Tensione d'ingresso PV6",
  "mini.65290.Ipv6": "PV6 corrente di ingresso",
  "mini.65290.Energy_PV6": "Generazione di potenza cumulativa PV6",
  "mini.65290.StINVTPOWERON": "Stato di funzionamento dell'inverter",
  "mini.65290.stRelayoN": "Stato del relè acceso",
  "mini.65290.activePower": "Potenza attiva",
  "mini.65290.Res10": "Conservare 10",
  "mini.65290.Res11": "Prenotazione 11",
  "mini.65290.Res12": "Conservazione 12",
  "mini.65290.Res13": "Conservazione 13",
  "mini.65290.Res14": "Conservazione 14",
  "mini.65290.Res15": "Conservazione 15",
  "mini.65290.Res16": "Prenotazione 16",
  "mini.65290.Res17": "Prenotazione 17",
  "mini.65290.Res18": "Prenotazione 18",
  "mini.65290.Res19": "Prenotazione 19",
  "mini.65290.Res20": "Mantenimento del 20",
  "mini.65290.Un": "Valore effettivo della tensione nominale per la rete elettrica connessa alla rete",
  "mini.65290.Fn": "Frequenza nominale della rete elettrica connessa alla rete",
  "mini.65290.Pn": "Potenza attiva massima connessa alla rete",
  "mini.65290.Irmsmax": "Valore effettivo della corrente massima connessa alla rete",
  "mini.65290.Vmpptmin": "Tensione minima mppt",
  "mini.65290.Vmpptmax": "Tensione massima mppt",
  "mini.65290.Powpvmax": "Massima potenza PV in ingresso",
  "mini.65290.Ipvmax": "Massima corrente PV in ingresso",
  "mini.65290.Tempmax": "Temperatura massima di funzionamento(℃)",
  "mini.65290.Firmware_ver1": "Versione firmware 1",
  "mini.65290.Firmware_ver2": "Versione firmware 2",
  "mini.65290.Firmware_ver3": "Versione firmware 3",
  "mini.65290.UpdateProgress": "Stato di avanzamento dell'aggiornamento",
  "mini.65290.DeviceID": "Numero di serie dell'apparecchiatura",
  "storage.v2.65284.pvInputVoltage": "Tensione di ingresso del fotovoltaico",
  "storage.v2.65284.pvGenerartion": "Produzione attuale di energia fotovoltaica",
  "storage.v2.65284.pvEnergyDay": "Produzione di energia fotovoltaica giornaliera accumulata",
  "storage.v2.65284.pvEnergyTotal": "Produzione di energia fotovoltaica accumulata",
  "storage.v2.65284.batteryVoltage": "Tensione della batteria",
  "storage.v2.65284.batteryCurrent": "Corrente di carica e scarica della batteria",
  "storage.v2.65284.dcOutputCurrent": "Corrente di uscita DC",
  "storage.v2.65284.dcOutputPower": "Potenza di uscita DC",
  "storage.v2.65284.ratedCapacity": "Capacità nominale della batteria",
  "storage.v2.65284.batterySOC": "Capacità residua della batteria SOC",
  "storage.v2.65284.cycleNumber": "Numero di cicli di carica e scarica",
  "storage.v2.65284.internalTemp": "Temperatura interna del sistema(℃)",
  "storage.v2.65284.heatsinkTemp": "Temperatura del radiatore(℃)",
  "storage.v2.65284.batteryTemp1": "Temperatura del pacco batteria 1(℃)",
  "storage.v2.65284.batteryTemp2": "Temperatura del pacco batteria 2(℃)",
  "storage.v2.65284.BMSTemp": "Temperatura del BMS(℃)",
  "storage.v2.65284.cellVoltage1": "Tensione della cella 1",
  "storage.v2.65284.cellVoltage2": "Tensione della cella 2",
  "storage.v2.65284.cellVoltage3": "Tensione della cella 3",
  "storage.v2.65284.cellVoltage4": "Tensione della cella 4",
  "storage.v2.65284.cellVoltage5": "Tensione della cella 5",
  "storage.v2.65284.cellVoltage6": "Tensione della cella 6",
  "storage.v2.65284.cellVoltage7": "Tensione della cella 7",
  "storage.v2.65284.cellVoltage8": "Tensione della cella 8",
  "storage.v2.65284.cellVoltage9": "Tensione della cella 9",
  "storage.v2.65284.cellVoltage10": "Tensione della cella 10",
  "storage.v2.65284.cellVoltage11": "Tensione della cella 11",
  "storage.v2.65284.cellVoltage12": "Tensione della cella 12",
  "storage.v2.65284.cellVoltage13": "Tensione della cella 13",
  "storage.v2.65284.cellVoltage14": "Tensione della cella 14",
  "storage.v2.65284.cellVoltage15": "Tensione della cella 15",
  "storage.v2.65284.cellVoltage16": "Tensione della cella 16",
  "storage.v2.65284.BMSWorkingStatus": "Stato di funzionamento del BMS",
  "storage.v2.65284.runningStatus": "Stato di funzionamento del dispositivo",
  "storage.v2.65284.time": "Tempo di funzionamento dell'apparecchiatura",
  "storage.v2.65284.invPower": "Micro inversione di potenza",
  "storage.s3.65292.batVoltage": "Tensione della batteria",
  "storage.s3.65292.batCurrent": "Corrente della batteria",
  "storage.s3.65292.batChargePower": "Potenza di carica della batteria",
  "storage.s3.65292.mainsChargeCurrent": "Corrente di carica comunale",
  "storage.s3.65292.pvChargeCurrent": "Corrente di carica PV",
  "storage.s3.65292.pv1Voltage": "Tensione del primo pannello fotovoltaico",
  "storage.s3.65292.pv1Current": "Corrente del primo pannello fotovoltaico",
  "storage.s3.65292.pv1Power": "Potenza di uscita del primo pannello fotovoltaico",
  "storage.s3.65292.pv2Voltage": "Tensione del secondo pannello fotovoltaico",
  "storage.s3.65292.pv2Current": "Corrente del secondo pannello fotovoltaico",
  "storage.s3.65292.pv2Power": "Potenza di uscita del secondo pannello fotovoltaico",
  "storage.s3.65292.aPhaseVoltage": "Tensione di uscita fase A",
  "storage.s3.65292.aPhaseCurrent": "Corrente di uscita fase A",
  "storage.s3.65292.aPhaseActivePower": "Potenza attiva di uscita A-fase",
  "storage.s3.65292.aPhaseApparentPower": "Potenza apparente di uscita A-fase",
  "storage.s3.65292.bPhaseVoltage": "Tensione di uscita della fase B",
  "storage.s3.65292.bPhaseCurrent": "Corrente di uscita B-fase",
  "storage.s3.65292.bPhaseActivePower": "Potenza attiva di uscita B-fase",
  "storage.s3.65292.bPhaseApparentPower": "Potenza apparente di uscita B-fase",
  "storage.s3.65292.cPhaseVoltage": "Tensione di uscita C-fase",
  "storage.s3.65292.cPhaseCurrent": "Corrente di uscita C-fase",
  "storage.s3.65292.cPhaseActivePower": "Potenza attiva di uscita C-fase",
  "storage.s3.65292.cPhaseApparentPower": "Potenza apparente di uscita C-fase",
  "storage.s3.65292.allActivePower": "Potenza attiva di uscita dell'intera macchina",
  "storage.s3.65292.allApparentPower": "Potenza apparente di uscita complessiva",
  "storage.s3.65292.aChargeActivePower": "Potenza attiva della generazione di potenza in fase A",
  "storage.s3.65292.bChargeActivePower": "Potenza attiva di generazione della fase B",
  "storage.s3.65292.cChargeActivePower": "Potenza attiva di generazione della fase C",
  "storage.s3.65292.mainsApVoltage": "Tensione di fase A della rete elettrica",
  "storage.s3.65292.mainsApCurrent": "Corrente della fase A della rete",
  "storage.s3.65292.mainsBpVoltage": "Tensione della fase B della rete",
  "storage.s3.65292.mainsBpCurrent": "Corrente di rete fase B",
  "storage.s3.65292.mainsCpVoltage": "Potenza di città Fase C tensione",
  "storage.s3.65292.mainsCpCurrent": "Corrente di rete fase C",
  "storage.s3.65292.mainsApPower": "Potenza di rete fase A",
  "storage.s3.65292.mainsBpPower": "Potenza di rete fase B",
  "storage.s3.65292.mainsCpPower": "Potenza di rete fase C",
  "storage.s3.65292.onGridActivePower": "Potenza attiva collegata alla rete",
  "storage.s3.65292.homeLoadPower": "Potenza del carico domestico",
  "storage.s3.65292.afterLoadPower": "Potenza di carico del backend",
  "storage.s3.65292.totalLoadPower": "Carico totale",
  "storage.s3.65292.batPower": "Potenza della batteria",
  "storage.s3.65292.girdDisplayPower": "Potenza del display lato rete",
  "storage.s3.65292.invPower": "Potenza dell'inverter",
  "storage.s3.65292.beforeLoadMarker": "Indicatore del flusso di carico del front-end",
  "storage.s3.65292.gridMarker": "Indicatore del flusso di energia della rete elettrica",
  "storage.s3.65292.mainsMarker": "Segnale di flusso di energia del mercato",
  "storage.s3.65292.machineOnStatus": "Stato di avvio della macchina",
  "storage.s3.65292.chargeStatus": "Stato di carica",
  "storage.s3.65292.outputStatus": "Stato dell'uscita",
  "storage.s3.65292.acTodayEnergy": "Generazione giornaliera di energia AC",
  "storage.s3.65292.batTodayChargeEnergy": "Livello di carica della batteria nello stesso giorno",
  "storage.s3.65292.batTodayDischargeEnergy": "Il livello di scarica della batteria nello stesso giorno",
  "storage.s3.65292.pvTodayEnergy": "Generazione di energia fotovoltaica nello stesso giorno",
  "storage.s3.65292.loadTodayEnergy": "Consumo di elettricità nel giorno di carico",
  "storage.s3.65292.mainsTodayChargeEnergy": "Capacità di carica della rete elettrica nello stesso giorno",
  "storage.s3.65292.loadTodayUseMainsEnergy": "Consumo di elettricità dalla rete nel giorno di carico",
  "storage.s3.65292.batTotalChargeEnergy": "Capacità di carica accumulata della batteria",
  "storage.s3.65292.batTotalDischargeEnergy": "Capacità di scarica accumulata della batteria",
  "storage.s3.65292.pvTotalEnergy": "Produzione di energia fotovoltaica cumulativa",
  "storage.s3.65292.loadTotalEnergy": "Consumo di elettricità cumulativo del carico",
  "storage.s3.65292.mainsTotalChargeEnergy": "Capacità di carica accumulata della rete elettrica",
  "storage.s3.65292.loadTotalUseMainsEnergy": "Consumo cumulativo di carico da rete elettrica",
  "storage.s3.65292.acTotalEnergy": "Generazione cumulativa di energia elettrica da rete",
  "storage.s3.65292.mainsChargeTimerSet": "Abilitazione temporizzata alla carica della rete elettrica",
  "storage.s3.65292.batChargeTimerSet": "Abilitazione temporizzata della batteria",
  "storage.s3.65292.softWareVersion3": "Versione software numero 3",
  "storage.s3.65292.aPhaseOnGridPower": "Potenza sul lato rete della fase A",
  "storage.s3.65292.bPhaseOnGridPower": "Potenza sul lato rete della fase B",
  "storage.s3.65292.cPhaseOnGridPower": "Potenza sul lato rete della fase C",
  "storage.s3.65292.aPhaseOnGridCurrent": "Corrente lato rete fase A",
  "storage.s3.65292.bPhaseOnGridCurrent": "Corrente lato rete fase B",
  "storage.s3.65292.cPhaseOnGridCurrent": "Corrente lato rete fase C",
  "storage.s3.65292.batTemp": "Temperatura della batteria(℃)",
  "storage.s3.65292.softWareVersion1": "Versione invertitore",
  "storage.s3.65292.softWareVersion2": "Versione BMS",
  "storage.s3.65292.softWareVersion4": "Versione controller",
  "storage.s3.65292.batChargeCur": "Corrente di carica richiesta dalla batteria",
  "storage.s3.65292.batSurplusCapacity": "Capacità residua della batteria",
  "storage.s3.65292.batRatedCapacity": "Capacità nominale della batteria",
  "storage.s3.65292.batMaxPressure": "Differenza di pressione massima della singola batteria",
  "storage.s3.65292.batSoh": "SOH",
  "storage.s3.65292.batChargeLimitVol": "Valore limite della tensione di carica della batteria",
  "storage.s3.65292.bat1CellVol": "Tensione delle celle 1",
  "storage.s3.65292.bat2CellVol": "Tensione delle celle 2",
  "storage.s3.65292.bat3CellVol": "Tensione delle celle 3",
  "storage.s3.65292.bat4CellVol": "Tensione delle celle 4",
  "storage.s3.65292.bat5CellVol": "Tensione delle celle 5",
  "storage.s3.65292.bat6CellVol": "Tensione delle celle 6",
  "storage.s3.65292.bat7CellVol": "Tensione delle celle 7",
  "storage.s3.65292.bat8CellVol": "Tensione delle celle 8",
  "storage.s3.65292.bat9CellVol": "Tensione delle celle 9",
  "storage.s3.65292.bat10CellVol": "Tensione delle celle 10",
  "storage.s3.65292.bat11CellVol": "Tensione delle celle 11",
  "storage.s3.65292.bat12CellVol": "Tensione delle celle 12",
  "storage.s3.65292.bat13CellVol": "Tensione delle celle 13",
  "storage.s3.65292.bat14CellVol": "Tensione delle celle 14",
  "storage.s3.65292.bat15CellVol": "Tensione delle celle 15",
  "storage.s3.65292.bat16CellVol": "Tensione delle celle 16",
  "storage.s3.65292.batStatus": "Stato della batteria",
  "storage.s3.65292.pvVoltageLevel": "Allarme disattivato",
  "storage.s3.65292.pvRadiatorTemp": "Temperatura del radiatore FV(℃)",
  "storage.s3.65292.invTemp": "Temperatura dell'inversione(℃)",
  "storage.s3.65292.transformerTemp": "Temperatura del trasformatore(℃)",
  "storage.s3.65292.cellTemp1": "Temperatura della cella 1(℃)",
  "storage.s3.65292.cellTemp2": "Temperatura della cella 2(℃)",
  "storage.s3.65292.cellTemp3": "Temperatura della cella 3(℃)",
  "storage.s3.65292.cellTemp4": "Temperatura della cella 4(℃)",
  "storage.s3.65292.mosTemp": "Temperatura del MOS(℃)",
  "storage.s3.65292.mcuTemp": "Temperatura MCU(℃)",
  "storage.s3.65292.msAvgTemp": "Temperatura media delle macchine master e slave(℃)",
  "storage.s3.65292.batSOC": "Capacità residua della batteria SOC",
  "storage.s3.65292.invSubBoardVersion": "Numero di versione della scheda inverter bidirezionale",
  "storage.s3.65292.batDischargeCur": "Corrente di scarica della batteria",
  "storage.s3.65292.batWorkStatus": "Stato dell'interruttore della batteria",
  "storage.s3.65292.ctWorkStatus": "Stato dell'interruttore CT wireless",
  "storage.s3.65292.socketPower1": "Potenza della presa 1",
  "storage.s3.65292.socketPower2": "Potenza della presa 2",
  "storage.s3.65292.socketPower3": "Potenza della presa 3",
  "storage.s3.65292.socketPower4": "Potenza della presa 4",
  "storage.s3.65292.socketPower5": "Potenza della presa 5",
  "storage.s3.65292.socketPower6": "Potenza della presa 6",
  "storage.s3.65292.socketPower7": "Potenza della presa 7",
  "storage.s3.65292.socketPower8": "Potenza della presa 8",
  "storage.s3.65292.socketPower9": "Potenza della presa 9",
  "storage.s3.65292.socketPower10": "Potenza della presa 10",
  "storage.s3.65292.socketPower11": "Potenza della presa 11",
  "storage.s3.65292.socketPower12": "Potenza della presa 12",
  "storage.s3.65292.socketPower13": "Potenza della presa 13",
  "storage.s3.65292.socketPower14": "Potenza della presa 14",
  "storage.s3.65292.socketPower15": "Potenza della presa 15",
  "storage.s3.65292.socketPower16": "Potenza della presa 16",
  "storage.s3.65292.outPutFreq": "frequenza di uscita",
  "storage.s3.65292.mainsFreq": "Frequenza di rete",
  "storage.s3.65292.socketWorkStatus": "Numero di prese",
  "storage.s3.65292.time": "Tempo di funzionamento dell'apparecchiatura",
  "storage.s3.65292.offlineAlarm": "Allarme disattivato",
  "storage.s3.65292.pvPower": "Potenza fotovoltaica",
  "storage.s3.65292.deviceSn": "Numero di serie dell'apparecchiatura",
  "hipment.devType": "Tipo di sviluppo",
  "device.voltageV": "Tensione dell'apparecchiatura V",
  "device.electric.currentA": "Corrente dell'apparecchiatura A",
  "device.return.port": "retroazione",
  "device.a.phase": "A con",
  "device.b.phase": "B con",
  "device.c.phase": "C con",
  "device.electic.meter.data": "Dati dei contatori",
  "device.voltage": "tensione",
  "device.electric.current": "La corrente",
  "unc.65323.runStatus": "Stato di Funzionamento",
  "bw_RTparam_name_TotalPower": "Potenza totale",
  "bw_RTparam_name_TotalYield": "Produzione totale",
  "bw_RTparam_name_TotalRuntime": "Durata totale del fotovoltaico",
  "bw_RTparam_name_PV1Voltage": "Tensione in tempo reale PV1",
  "bw_RTparam_name_PV1Current": "Corrente in tempo reale PV1",
  "bw_RTparam_name_PV1Power": "Potenza in tempo reale PV1",
  "bw_RTparam_name_PV2Voltage": "Tensione in tempo reale PV2",
  "bw_RTparam_name_PV2Current": "Corrente in tempo reale PV2",
  "bw_RTparam_name_PV2Power": "Potenza in tempo reale PV2",
  "bw_RTparam_name_PV3Voltage": "Tensione in tempo reale PV3",
  "bw_RTparam_name_PV3Current": "Corrente in tempo reale PV3",
  "bw_RTparam_name_PV3Power": "Potenza in tempo reale PV3",
  "bw_RTparam_name_GridVoltageL1": "Tensione di rete L1",
  "bw_RTparam_name_GridVoltageL2": "Tensione di rete L2",
  "bw_RTparam_name_GridVoltageL3": "Tensione di rete L3",
  "bw_RTparam_name_GridCurrentL1": "Corrente di rete L1",
  "bw_RTparam_name_GridCurrentL2": "Corrente di rete L2",
  "bw_RTparam_name_GridCurrentL3": "Corrente di rete L3",
  "bw_RTparam_name_GridPowerL1": "Potenza attiva di rete L1",
  "bw_RTparam_name_GridPowerL2": "Potenza attiva di rete L2",
  "bw_RTparam_name_GridPowerL3": "Potenza attiva di rete L3",
  "bw_RTparam_name_GridTotalActivePower": "Potenza attiva totale della rete",
  "bw_RTparam_name_GridFrequency": "Frequenza di rete",
  "bw_RTparam_name_ApparentPOAP_Grid": "Potenza apparente della fase A (rete)",
  "bw_RTparam_name_ApparentPOBP_Grid": "Potenza apparente della fase B (rete)",
  "bw_RTparam_name_ApparentPOCP_Grid": "Potenza apparente della fase C (rete)",
  "bw_RTparam_name_ReactivePOAP_Grid": "Potenza reattiva della fase A (rete)",
  "bw_RTparam_name_ReactivePOBP_Grid": "Potenza reattiva della fase B (rete)",
  "bw_RTparam_name_ReactivePOCP_Grid": "Potenza reattiva della fase C (rete)",
  "bw_RTparam_name_PFOA_Grid": "Fattore di potenza della fase A (rete)",
  "bw_RTparam_name_PFOB_Grid": "Fattore di potenza della fase B (rete)",
  "bw_RTparam_name_PFOC_Grid": "Fattore di potenza della fase C (rete)",
  "bw_RTparam_name_DailyEnergytoGrid": "Energia venduta giornaliera",
  "bw_RTparam_name_TotalEnergytoGrid": "Energia venduta totale",
  "bw_RTparam_name_DailyEnergyfromGrid": "Energia acquistata giornaliera",
  "bw_RTparam_name_TotalEnergyfromGrid": "Energia acquistata totale",
  "bw_RTparam_name_BatteryVoltage": "Tensione della batteria",
  "bw_RTparam_name_BatteryCurrent": "Corrente della batteria",
  "bw_RTparam_name_BatteryPower": "Potenza della batteria",
  "bw_RTparam_name_TotalConsumption": "Consumo totale",
  "bw_RTparam_name_TotalEnergyfromBattery": "Energia totale scaricata dalla batteria",
  "bw_RTparam_name_BatteryChargeFromGrid_Every": "Energia della batteria caricata dalla rete",
  "bw_RTparam_name_BatterySOC": "Stato di carica della batteria (SOC)",
  "bw_RTparam_name_BatterySOH": "Stato di salute della batteria (SOH)",
  "bw_RTparam_name_Maximumtemperatureofbattery": "Temperatura massima della batteria",
  "bw_RTparam_name_Minimumtemperatureofbattery": "Temperatura minima della batteria",
  "bw_RTparam_name_Maximumcellvoltage": "Tensione massima della cella",
  "bw_RTparam_name_Minimumcellvoltage": "Tensione minima della cella",
  "bw_RTparam_name_TotalConsumptionPower": "Potenza totale di consumo",
  "bw_RTparam_name_TodayConsumption": "Consumo giornaliero",
  "bw_RTparam_name_TotalConsumptionEnergy": "Consumo energetico totale",
  "bw_RTparam_name_TotalEnergyFeedToGrid_PV": "Energia totale immessa in rete (fotovoltaico)",
  "bw_RTparam_name_TotalEnergyConsumeFormGrid_PV": "Energia totale prelevata dalla rete (fotovoltaico)",
  "bw_RTparam_name_VoltageOfAPhase_PV": "Tensione della fase A (fotovoltaico)",
  "bw_RTparam_name_VoltageOfBPhase_PV": "Tensione della fase B (PV)",
  "bw_RTparam_name_VoltageOfCPhase_PV": "Tensione della fase C (PV)",
  "bw_RTparam_name_CurrentOfAPhase_PV": "Corrente di fase A (PV)",
  "bw_RTparam_name_CurrentOfBPhase_PV": "Corrente della fase B (PV)",
  "bw_RTparam_name_CurrentOfCPhase_PV": "Corrente della fase C (fotovoltaico)",
  "bw_RTparam_name_Frequent_PV": "Frequenza (fotovoltaico)",
  "bw_RTparam_name_TotalApparentPower_PV": "Potenza apparente totale (fotovoltaico)",
  "bw_RTparam_name_TotalActivePower_PV": "Potenza attiva totale (fotovoltaico)",
  "bw_RTparam_name_TotalReactivePower_PV": "Potenza reattiva totale (fotovoltaico)",
  "bw_RTparam_name_TotalPowerFactor_PV": "Fattore di potenza totale (fotovoltaico)",
  "bw_RTparam_group_Inverter": "Inverter",
  "bw_RTparam_group_Grid": "Rete",
  "bw_RTparam_group_Battery": "Batteria",
  "bw_RTparam_group_Load": "Carico",
  "bw_RTparam_group_PVMeter": "Contatore lato FV",
  "common.50100.pv1Voltage": "Tensione PV1",
  "common.50100.pv1Current": "Corrente PV1",
  "common.50100.pv1Power": "PV1 Potere",
  "common.50100.pv2Voltage": "Tensione PV2",
  "common.50100.pv2Current": "Corrente PV2",
  "common.50100.pv2Power": "PV2 Potenza",
  "common.50100.pv3Voltage": "Tensione PV3",
  "common.50100.pv3Current": "Corrente PV3",
  "common.50100.pv3Power": "Potenza PV3",
  "common.50100.pv4Voltage": "Tensione PV4",
  "common.50100.pv4Current": "Corrente PV4",
  "common.50100.pv4Power": "Potenza PV4",
  "common.50100.temperature": "Temperatura(℃)",
  "common.50100.outputGridVoltage": "Tensione di rete in uscita",
  "common.50100.outputGridCurrent": "Corrente della griglia di uscita",
  "common.50100.outputGridPower": "Potenza di rete in uscita",
  "common.50100.pv1CumulativePowerGeneration": "PV1 Produzione cumulativa di energia",
  "common.50100.pv2CumulativePowerGeneration": "PV2 Produzione cumulativa di energia",
  "common.50100.pv3CumulativePowerGeneration": "PV3 Produzione cumulativa di energia",
  "common.50100.pv4CumulativePowerGeneration": "PV4 Produzione cumulativa di energia",
  "common.50100.totalPowerGeneration": "Produzione totale di energia",
  "common.50100.wnSn": "Datalogger Sn",
  "common.50100.wnWifiVersion": "Datalogger Versione Wifi",
  "common.50100.wnHardwareVersion": "Versione hardware del datalogger",
  "common.50100.wnSoftwareVersion": "Versione software del datalogger",
  "ltwn_RTparam_group_Inverter": "Inverter",
  "\nbw_param_ctrl_option_OnlyEnableDischargeTimePeriodControl": "Abilita Solo Controllo Scarica Temporale",
  "plant.already.deliver": "La centrale è stata consegnata",
  "common.50100.totalPvEnergy": "Produzione totale di energia",
  "ltcg_RTparam_name_name": "Nome del dispositivo",
  "ltcg_RTparam_name_out_pac": "Produzione di energia (kW)",
  "ltcg_RTparam_name_eday": "Produzione di energia oggi (kWh)",
  "ltcg_RTparam_name_etotal": "Produzione cumulativa di energia (kWh)",
  "ltcg_RTparam_name_status": "stato",
  "ltcg_RTparam_name_turnon_time": "tempo di accesso",
  "ltcg_RTparam_name_type": "Tipo di attrezzatura",
  "ltcg_RTparam_name_capacity": "Capacità kw",
  "ltcg_RTparam_name_tempperature": "temperatura",
  "ltcg_RTparam_name_creationDate": "Data ultima ora",
  "ltcg_RTparam_name_pac": "produzione di energia",
  "ltcg_RTparam_name_hTotal": "ore cumulative di produzione di energia",
  "ltcg_RTparam_name_vpv1": "Tensione CC 1",
  "ltcg_RTparam_name_vpv2": "Tensione CC 2",
  "ltcg_RTparam_name_vpv3": "Tensione CC 3",
  "ltcg_RTparam_name_vpv4": "Tensione CC 4",
  "ltcg_RTparam_name_vpv5": "Tensione CC 5",
  "ltcg_RTparam_name_vpv6": "Tensione CC 6",
  "ltcg_RTparam_name_vpv7": "Tensione CC 7",
  "ltcg_RTparam_name_vpv8": "Tensione CC 8",
  "ltcg_RTparam_name_vpv9": "Tensione CC 9",
  "ltcg_RTparam_name_vpv10": "Tensione CC 10",
  "ltcg_RTparam_name_vpv11": "Tensione CC 11",
  "ltcg_RTparam_name_vpv12": "Tensione CC 12",
  "ltcg_RTparam_name_ipv1": "Corrente CC 1",
  "ltcg_RTparam_name_ipv2": "Corrente CC 2",
  "ltcg_RTparam_name_ipv3": "Corrente CC 3",
  "ltcg_RTparam_name_ipv4": "Corrente di CC 4",
  "ltcg_RTparam_name_ipv5": "Corrente CC 5",
  "ltcg_RTparam_name_ipv6": "Corrente CC 6",
  "ltcg_RTparam_name_ipv7": "Corrente di CC 7",
  "ltcg_RTparam_name_ipv8": "Corrente CC 8",
  "ltcg_RTparam_name_ipv9": "Corrente CC 9",
  "ltcg_RTparam_name_ipv10": "Corrente CC 10",
  "ltcg_RTparam_name_ipv11": "Corrente CC 11",
  "ltcg_RTparam_name_ipv12": "Corrente CC 12",
  "ltcg_RTparam_name_vac1": "Tensione CA 1",
  "ltcg_RTparam_name_vac2": "Tensione CA 2",
  "ltcg_RTparam_name_vac3": "Tensione CA 3",
  "ltcg_RTparam_name_iac1": "Corrente CA 1",
  "ltcg_RTparam_name_iac2": "Corrente CA 2",
  "ltcg_RTparam_name_iac3": "Corrente CA 3",
  "ltcg_RTparam_name_fac1": "Frequenza CA 1",
  "ltcg_RTparam_name_fac2": "Frequenza CA 2",
  "ltcg_RTparam_name_fac3": "Frequenza CA 3",
  "ltcg_RTparam_name_istr1": "Corrente della stringa 1",
  "ltcg_RTparam_name_istr2": "Corrente di stringa 2",
  "ltcg_RTparam_name_istr3": "Corrente della stringa 3",
  "ltcg_RTparam_name_istr4": "Corrente della stringa 4",
  "ltcg_RTparam_name_istr5": "Corrente della stringa 5",
  "ltcg_RTparam_name_istr6": "Corrente della stringa 6",
  "ltcg_RTparam_name_istr7": "Corrente della stringa 7",
  "ltcg_RTparam_name_istr8": "Corrente della stringa 8",
  "ltcg_RTparam_name_istr9": "Corrente della stringa 9",
  "ltcg_RTparam_name_istr10": "Corrente della stringa 10",
  "ltcg_RTparam_name_istr11": "Corrente di stringa 11",
  "ltcg_RTparam_name_istr12": "Corrente di stringa 12",
  "ltcg_RTparam_name_istr13": "Corrente di stringa 13",
  "ltcg_RTparam_name_istr14": "Corrente di stringa 14",
  "ltcg_RTparam_name_istr15": "Corrente di stringa 15",
  "ltcg_RTparam_name_istr16": "Corrente di stringa 16",
  "ltcg_RTparam_name_istr17": "Corrente di stringa 17",
  "ltcg_RTparam_name_istr18": "Corrente di stringa 18",
  "ltcg_RTparam_name_istr19": "Corrente di stringa 19",
  "ltcg_RTparam_name_istr20": "Corrente di stringa 20",
  "ltcg_RTparam_name_istr21": "Corrente di stringa 21",
  "ltcg_RTparam_name_istr22": "Corrente di stringa 22",
  "ltcg_RTparam_name_istr23": "Corrente di stringa 23",
  "ltcg_RTparam_name_istr24": "Corrente di stringa 24",
  "ltcg_RTparam_group_Inverter": "Inverter",
  "city.not.exist": "La città non esiste.",
  "bw_RTparam_name_BatterySN1": "Batteria1 SN",
  "bw_RTparam_name_BatterySN2": "Batteria2 SN",
  "bw_RTparam_name_BatterySN3": "Batteria3 SN",
  "bw_RTparam_name_BatterySN4": "Batteria4 SN",
  "bw_RTparam_name_BatterySN5": "Batteria5 SN",
  "bw_RTparam_name_BatterySN6": "Batteria6 SN",
  "supplier.type.tb": "Varietà speciale",
  "common.50300.sn": "Numero di serie del dispositivo",
  "common.50300.name": "Nome del dispositivo",
  "common.50300.out_pac": "Produzione di energia (kW)",
  "common.50300.eday": "Produzione di energia oggi (kWh)",
  "common.50300.etotal": "Produzione cumulativa di energia (kWh)",
  "common.50300.status": "stato",
  "common.50300.turnon_time": "tempo di accesso",
  "common.50300.type": "Tipo di attrezzatura",
  "common.50300.capacity": "Capacità kw",
  "common.50300.tempperature": "temperatura(℃)",
  "common.50300.creationDate": "Data ultima ora",
  "common.50300.pac": "produzione di energia",
  "common.50300.hTotal": "ore cumulative di produzione di energia",
  "common.50300.vpv1": "Tensione CC 1",
  "common.50300.vpv2": "Tensione CC 2",
  "common.50300.vpv3": "Tensione CC 3",
  "common.50300.vpv4": "Tensione CC 4",
  "common.50300.vpv5": "Tensione CC 5",
  "common.50300.vpv6": "Tensione CC 6",
  "common.50300.vpv7": "Tensione CC 7",
  "common.50300.vpv8": "Tensione CC 8",
  "common.50300.vpv9": "Tensione CC 9",
  "common.50300.vpv10": "Tensione CC 10",
  "common.50300.vpv11": "Tensione CC 11",
  "common.50300.vpv12": "Tensione CC 12",
  "common.50300.ipv1": "Corrente CC 1",
  "common.50300.ipv2": "Corrente CC 2",
  "common.50300.ipv3": "Corrente CC 3",
  "common.50300.ipv4": "Corrente di CC 4",
  "common.50300.ipv5": "Corrente CC 5",
  "common.50300.ipv6": "Corrente CC 6",
  "common.50300.ipv7": "Corrente di CC 7",
  "common.50300.ipv8": "Corrente CC 8",
  "common.50300.ipv9": "Corrente CC 9",
  "common.50300.ipv10": "Corrente CC 10",
  "common.50300.ipv11": "Corrente CC 11",
  "common.50300.ipv12": "Corrente CC 12",
  "common.50300.vac1": "Tensione CA 1",
  "common.50300.vac2": "Tensione CA 2",
  "common.50300.vac3": "Tensione CA 3",
  "common.50300.iac1": "Corrente CA 1",
  "common.50300.iac2": "Corrente CA 2",
  "common.50300.iac3": "Corrente CA 3",
  "common.50300.fac1": "Frequenza CA 1",
  "common.50300.fac2": "Frequenza CA 2",
  "common.50300.fac3": "Frequenza CA 3",
  "common.50300.istr1": "Corrente della stringa 1",
  "common.50300.istr2": "Corrente di stringa 2",
  "common.50300.istr3": "Corrente della stringa 3",
  "common.50300.istr4": "Corrente della stringa 4",
  "common.50300.istr5": "Corrente della stringa 5",
  "common.50300.istr6": "Corrente della stringa 6",
  "common.50300.istr7": "Corrente della stringa 7",
  "common.50300.istr8": "Corrente della stringa 8",
  "common.50300.istr9": "Corrente della stringa 9",
  "common.50300.istr10": "Corrente della stringa 10",
  "common.50300.istr11": "Corrente di stringa 11",
  "common.50300.istr12": "Corrente di stringa 12",
  "common.50300.istr13": "Corrente di stringa 13",
  "common.50300.istr14": "Corrente di stringa 14",
  "common.50300.istr15": "Corrente di stringa 15",
  "common.50300.istr16": "Corrente di stringa 16",
  "common.50300.istr17": "Corrente di stringa 17",
  "common.50300.istr18": "Corrente di stringa 18",
  "common.50300.istr19": "Corrente di stringa 19",
  "common.50300.istr20": "Corrente di stringa 20",
  "common.50300.istr21": "Corrente di stringa 21",
  "common.50300.istr22": "Corrente di stringa 22",
  "common.50300.istr23": "Corrente di stringa 23",
  "common.50300.istr24": "Corrente di stringa 24",
  "common.50402.sn": "Invertitore SN",
  "common.50402.ID": "ID inverter",
  "common.50402.STATION_ID": "ID della centrale elettrica",
  "common.50402.INV_EG_DAY": "produzione giornaliera di energia",
  "common.50402.INV_EG_TOTAL": "Produzione cumulativa di potenza dell'inverter",
  "common.50402.INV_I_AC": "Corrente dell'invertitore",
  "common.50402.INV_U_AC": "Tensione dell'invertitore",
  "common.50402.PV1_I": "Corrente PV1",
  "common.50402.PV2_I": "Corrente PV2",
  "common.50402.PV3_I": "Corrente PV3",
  "common.50402.PV4_I": "Corrente PV4",
  "common.50402.PV5_I": "Corrente PV5",
  "common.50402.PV6_I": "Corrente PV6",
  "common.50402.PV7_I": "Corrente PV7",
  "common.50402.PV8_I": "Corrente PV8",
  "common.50402.PV9_I": "Corrente PV9",
  "common.50402.PV10_I": "Corrente PV10",
  "common.50402.PV11_I": "Corrente PV11",
  "common.50402.PV12_I": "Corrente PV12",
  "common.50402.PV13_I": "Corrente PV13",
  "common.50402.PV14_I": "Corrente PV14",
  "common.50402.PV15_I": "Corrente PV15",
  "common.50402.PV16_I": "Corrente PV16",
  "common.50402.PV17_I": "Corrente PV17",
  "common.50402.PV18_I": "Corrente PV18",
  "common.50402.PV19_I": "Corrente PV19",
  "common.50402.PV20_I": "Corrente PV20",
  "common.50402.PV21_I": "Corrente PV21",
  "common.50402.PV22_I": "Corrente PV22",
  "common.50402.PV23_I": "Corrente PV23",
  "common.50402.PV24_I": "Corrente PV24",
  "common.50402.PV25_I": "Corrente PV25",
  "common.50402.PV26_I": "Corrente PV26",
  "common.50402.PV27_I": "Corrente PV27",
  "common.50402.PV28_I": "Corrente PV28",
  "common.50402.PV29_I": "Corrente PV29",
  "common.50402.PV30_I": "Corrente PV30",
  "common.50402.PV1_V": "Tensione PV1",
  "common.50402.PV2_V": "Tensione PV2",
  "common.50402.PV3_V": "Tensione PV3",
  "common.50402.PV4_V": "Tensione PV4",
  "common.50402.PV5_V": "Tensione PV5",
  "common.50402.PV6_V": "Tensione PV6",
  "common.50402.PV7_V": "Tensione PV7",
  "common.50402.PV8_V": "Tensione PV8",
  "common.50402.PV9_V": "Tensione PV9",
  "common.50402.PV10_V": "Tensione PV10",
  "common.50402.PV11_V": "Tensione PV11",
  "common.50402.PV12_V": "Tensione PV12",
  "common.50402.PV13_V": "Tensione PV13",
  "common.50402.PV14_V": "Tensione PV14",
  "common.50402.PV15_V": "Tensione PV15",
  "common.50402.PV16_V": "Tensione PV16",
  "common.50402.PV17_V": "Tensione PV17",
  "common.50402.PV18_V": "Tensione PV18",
  "common.50402.PV19_V": "Tensione PV19",
  "common.50402.PV20_V": "Tensione PV20",
  "common.50402.PV21_V": "Tensione PV21",
  "common.50402.PV22_V": "Tensione PV22",
  "common.50402.PV23_V": "Tensione PV23",
  "common.50402.PV24_V": "Tensione PV24",
  "common.50402.PV25_V": "Tensione PV25",
  "common.50402.PV26_V": "Tensione PV26",
  "common.50402.PV27_V": "Tensione PV27",
  "common.50402.PV28_V": "Tensione PV28",
  "common.50402.PV29_V": "Tensione PV29",
  "common.50402.PV30_V": "Tensione PV30",
  "common.50402.INV_P_AC": "Potenza attiva dell'inverter",
  "common.50402.CAPACITY": "Capacità kw",
  "common.50402.INV_RUN_STATE": "Stato di funzionamento dell'inverter",
  "common.50402.DATA_TIME": "tempo di dati",
  "common.50402.name": "Il nome del dispositivo",
  "common.50402.out_pac": "Produzione di energia (kW)",
  "common.50402.eday": "Produzione di energia elettrica (kWh) di oggi",
  "common.50402.etotal": "Produzione cumulativa di energia (kWh)",
  "common.50402.status": "stato",
  "common.50402.turnon_time": "Tempo di accesso",
  "common.50402.type": "Tipo di dispositivo",
  "common.50402.tempperature": "temperatura(℃)",
  "common.50402.creationDate": "L'ora in cui i dati erano aggiornati",
  "common.50402.pac": "Produzione di energia",
  "common.50402.hTotal": "Ore cumulative di produzione di energia",
  "common.50402.vpv1": "Tensione CC 1",
  "common.50402.vpv2": "Tensione CC 2",
  "common.50402.vpv3": "Tensione CC 3",
  "common.50402.vpv4": "Tensione CC 4",
  "common.50402.vpv5": "Tensione CC 5",
  "common.50402.vpv6": "Tensione CC 6",
  "common.50402.vpv7": "Tensione CC 7",
  "common.50402.vpv8": "Tensione CC 8",
  "common.50402.vpv9": "Tensione CC 9",
  "common.50402.vpv10": "Tensione CC 10",
  "common.50402.vpv11": "Tensione CC 11",
  "common.50402.vpv12": "Tensione CC 12",
  "common.50402.ipv1": "Corrente continua 1",
  "common.50402.ipv2": "Corrente continua 2",
  "common.50402.ipv3": "Corrente continua 3",
  "common.50402.ipv4": "Corrente continua 4",
  "common.50402.ipv5": "Corrente continua 5",
  "common.50402.ipv6": "Corrente continua 6",
  "common.50402.ipv7": "Corrente continua 7",
  "common.50402.ipv8": "Corrente continua 8",
  "common.50402.ipv9": "Corrente continua 9",
  "common.50402.ipv10": "Corrente continua 10",
  "common.50402.ipv11": "Corrente continua 11",
  "common.50402.ipv12": "Corrente continua 12",
  "common.50402.vac1": "Tensione CA 1",
  "common.50402.vac2": "Tensione CA 2",
  "common.50402.vac3": "Tensione CA 3",
  "common.50402.iac1": "Corrente alternata 1",
  "common.50402.iac2": "Corrente alternata 2",
  "common.50402.iac3": "Corrente alternata 3",
  "common.50402.fac1": "Frequenza CA 1",
  "common.50402.fac2": "Frequenza CA 2",
  "common.50402.fac3": "Frequenza CA 3",
  "common.50402.istr1": "Corrente di stringa 1",
  "common.50402.istr2": "Corrente di stringa 2",
  "common.50402.istr3": "Corrente di stringa 3",
  "common.50402.istr4": "Corrente di stringa 4",
  "common.50402.istr5": "Corrente di stringa 5",
  "common.50402.istr6": "Corrente di stringa 6",
  "common.50402.istr7": "Corrente di stringa 7",
  "common.50402.istr8": "Corrente di stringa 8",
  "common.50402.istr9": "Corrente di stringa 9",
  "common.50402.istr10": "Corrente di stringa 10",
  "common.50402.istr11": "Corrente di stringa 11",
  "common.50402.istr12": "Corrente di stringa 12",
  "common.50402.istr13": "Corrente di stringa 13",
  "common.50402.istr14": "Corrente di stringa 14",
  "common.50402.istr15": "Corrente di stringa 15",
  "common.50402.istr16": "Corrente di stringa 16",
  "common.50402.istr17": "Corrente di stringa 17",
  "common.50402.istr18": "Corrente di stringa 18",
  "common.50402.istr19": "Corrente di stringa 19",
  "common.50402.istr20": "Corrente di stringa 20",
  "common.50402.istr21": "Corrente di stringa 21",
  "common.50402.istr22": "Corrente di stringa 22",
  "common.50402.istr23": "Corrente di stringa 23",
  "common.50402.istr24": "Corrente di stringa 24",
  "bw_RTparam_group_ Dongle": "Dongle",
  "bw_RTparam_name_DongleRssi": "RSSI",
  "bw_RTparam_group_Dongle": "Dongle",
  "common.50500.xnl_RTparam_name_FV_P": "Valore del fattore di potenza",
  "common.50500.xnl_RTparam_name_GVL": "Livello di tensione collegato alla rete",
  "common.50500.xnl_RTparam_name_RS_D": "Stato di esecuzione (predefinito)",
  "common.50500.xnl_RTparam_name_Etdy_ge1": "Produzione giornaliera di energia (attiva)",
  "common.50500.xnl_RTparam_name_A_R_P_D": "Energia reattiva AC nel giorno",
  "common.50500.xnl_RTparam_name_GEN_P_D": "Produzione giornaliera del generatore",
  "common.50500.xnl_RTparam_name_Et_ge0": "Elettricità cumulativa generata (attiva)",
  "common.50500.xnl_RTparam_name_Emon1": "Produzione mensile di energia (attiva)",
  "common.50500.xnl_RTparam_name_Etdy_use2": "Consumo elettrico mensile",
  "common.50500.xnl_RTparam_name_t_gc_tdy2": "Capacità mensile connessa alla rete",
  "common.50500.xnl_RTparam_name_Eyr1": "Produzione annua di energia (attiva)",
  "common.50500.xnl_RTparam_name_Etdy_cg1": "Il volume di ricarica di oggi",
  "common.50500.xnl_RTparam_name_Etdy_dcg1": "Importo di scarico di oggi",
  "common.50500.xnl_RTparam_name_t_cg_n1": "Capacità di carica cumulativa",
  "common.50500.xnl_RTparam_name_t_dcg_n1": "Scarico cumulativo",
  "common.50500.xnl_RTparam_name_E_B_D": "Volume di acquisto giornaliero di elettricità",
  "common.50500.xnl_RTparam_name_GRID_C_D": "Capacità della rete elettrica connessa alla rete il giorno",
  "common.50500.xnl_RTparam_name_E_B_TO": "Elettricità totale acquistata",
  "common.50500.xnl_RTparam_name_PG_F1": "Frequenza di rete",
  "common.50500.xnl_RTparam_name_t_gc1": "Capacità cumulativa connessa alla rete",
  "common.50500.xnl_RTparam_name_GDOH": "Orario di lavoro giornaliero del generatore",
  "common.50500.xnl_RTparam_name_Etdy_use1": "Il consumo di elettricità di oggi",
  "common.50500.xnl_RTparam_name_Et_use1": "Consumo elettrico cumulativo",
  "common.50500.xnl_RTparam_name_Etdy_use3": "Consumo annuo di elettricità",
  "common.50500.xnl_RTparam_name_T_TFM1": "Temperatura del trasformatore",
  "common.50500.xnl_RTparam_name_T_RDT1": "Temperatura del radiatore",
  "common.50500.xnl_RTparam_name_EG_t_ge1": "Produzione totale di energia del generatore",
  "common.50500.xnl_RTparam_name_E_PVhis_ge1": "Produzione storica di energia fotovoltaica",
  "common.50500.xnl_RTparam_name_t_gc_tdy3": "Capacità annuale connessa alla rete",
  "common.50500.xnl_RTparam_name_LCD": "Punta della bandiera di prova LCD",
  "common.50500.xnl_RTparam_name_CBAC": "Capacità dopo la calibrazione della batteria",
  "common.50500.xnl_RTparam_name_PVDE": "Produzione giornaliera di energia fotovoltaica",
  "common.50500.xnl_RTparam_name_DV1": "Tensione CC PV1",
  "common.50500.xnl_RTparam_name_DC1": "Corrente di CC PV1",
  "common.50500.xnl_RTparam_name_DV2": "Tensione CC PV2",
  "common.50500.xnl_RTparam_name_DC2": "Corrente di CC PV2",
  "common.50500.xnl_RTparam_name_DV3": "Tensione CC PV3",
  "common.50500.xnl_RTparam_name_DC3": "Corrente di CC PV3",
  "common.50500.xnl_RTparam_name_DV4": "Tensione CC PV4",
  "common.50500.xnl_RTparam_name_DC4": "Corrente di CC PV4",
  "common.50500.xnl_RTparam_name_INV_DSP_D_1": "INV DSP Debug Informazioni 1",
  "common.50500.xnl_RTparam_name_INV_DSP_D_2": "INV DSP Debug Informazioni 2",
  "common.50500.xnl_RTparam_name_INV_DSP_D_3": "INV DSP Debug Informazioni 3",
  "common.50500.xnl_RTparam_name_INV_DSP_D_4": "INV DSP Debug Informazioni 4",
  "common.50500.xnl_RTparam_name_INV_DSP_D_5": "INV DSP Debug Informazioni 5",
  "common.50500.xnl_RTparam_name_INV_DSP_D_6": "INV DSP informazioni di debug 6",
  "common.50500.xnl_RTparam_name_INV_DSP_D_7": "INV DSP informazioni di debug 7",
  "common.50500.xnl_RTparam_name_INV_DSP_D_8": "INV DSP Debug Informazioni 8",
  "common.50500.xnl_RTparam_name_INV_DSP_D_9": "INV DSP Debug Informazioni 9",
  "common.50500.xnl_RTparam_name_INV_DSP_D_10": "INV DSP Debug Informazioni 10",
  "common.50500.xnl_RTparam_name_INV_DSP_D_11": "INV DSP Debug Informazioni 11",
  "common.50500.xnl_RTparam_name_INV_DSP_D_12": "INV DSP Debug Informazioni 12",
  "common.50500.xnl_RTparam_name_INV_DSP_D_13": "INV DSP Debug Informazioni 13",
  "common.50500.xnl_RTparam_name_INV_DSP_D_14": "INV DSP Debug Informazioni 14",
  "common.50500.xnl_RTparam_name_INV_DSP_D_15": "INV DSP Debug Informazioni 15",
  "common.50500.xnl_RTparam_name_INV_DSP_D_16": "INV DSP Debug Informazioni 16",
  "common.50500.xnl_RTparam_name_INV_DSP_D_17": "INV DSP Debug Informazioni 17",
  "common.50500.xnl_RTparam_name_INV_DSP_D_18": "INV DSP Debug Informazioni 18",
  "common.50500.xnl_RTparam_name_INV_DSP_D_19": "INV DSP Debug Informazioni 19",
  "common.50500.xnl_RTparam_name_INV_DSP_D_20": "INV DSP Debug Informazioni 20",
  "common.50500.xnl_RTparam_name_INV_DSP_D_21": "INV DSP Debug Informazioni 21",
  "common.50500.xnl_RTparam_name_INV_DSP_D_22": "INV DSP Debug Informazioni 22",
  "common.50500.xnl_RTparam_name_INV_DSP_D_23": "INV DSP Debug Informazioni 23",
  "common.50500.xnl_RTparam_name_INV_DSP_D_24": "INV DSP Debug Informazioni 24",
  "common.50500.xnl_RTparam_name_INV_DSP_D_25": "INV DSP Debug Informazioni 25",
  "common.50500.xnl_RTparam_name_INV_DSP_D_26": "INV DSP Debug Informazioni 26",
  "common.50500.xnl_RTparam_name_INV_DSP_D_27": "INV DSP Debug Informazioni 27",
  "common.50500.xnl_RTparam_name_INV_DSP_D_28": "INV DSP Debug Informazioni 28",
  "common.50500.xnl_RTparam_name_G_V_L1_N": "Tensione lato rete L1-N",
  "common.50500.xnl_RTparam_name_G_V_L2_N": "Tensione lato rete L2-N",
  "common.50500.xnl_RTparam_name_G_V_L1_L2": "Tensione lato rete L1-L2",
  "common.50500.xnl_RTparam_name_R_I_V_L1_L2": "Tensione laterale intermedia del relè L1-L2",
  "common.50500.xnl_RTparam_name_AV1": "Tensione di CA R / U / A",
  "common.50500.xnl_RTparam_name_AV2": "Tensione di CA S / V / B",
  "common.50500.xnl_RTparam_name_INV_O_P_L1_L2": "Tensione di uscita dell'invertitore L1-L2",
  "common.50500.xnl_RTparam_name_C_V_L1": "Tensione di carico L1",
  "common.50500.xnl_RTparam_name_C_V_L2": "Tensione di carico L2",
  "common.50500.xnl_RTparam_name_I_O_F2": "Frequenza di uscita dell'invertitore L2",
  "common.50500.xnl_RTparam_name_G_C_L1": "Corrente di rete L1",
  "common.50500.xnl_RTparam_name_G_C_L2": "Corrente di rete L2",
  "common.50500.xnl_RTparam_name_G_C_A": "Corrente di griglia A",
  "common.50500.xnl_RTparam_name_G_C_B": "Corrente di griglia B",
  "common.50500.xnl_RTparam_name_AC1": "Corrente alternata R / U / A",
  "common.50500.xnl_RTparam_name_AC2": "Corrente di CA S / V / B",
  "common.50500.xnl_RTparam_name_GEN_P_T": "Potenza totale del generatore",
  "common.50500.xnl_RTparam_name_G_P_L1": "Potenza di rete L1",
  "common.50500.xnl_RTparam_name_G_P_L2": "Potenza di rete L2",
  "common.50500.xnl_RTparam_name_PG_Pt1": "Potenza totale della rete",
  "common.50500.xnl_RTparam_name_E_CT_P1": "Potenza esterna CT1",
  "common.50500.xnl_RTparam_name_E_CT_P2": "Potenza esterna CT2",
  "common.50500.xnl_RTparam_name_CT_P_T": "Potenza totale della rete CT",
  "common.50500.xnl_RTparam_name_INV_O_P_L1": "Potenza di uscita dell'inverter L1",
  "common.50500.xnl_RTparam_name_INV_O_P_L2": "Potenza di uscita dell'inverter L2",
  "common.50500.xnl_RTparam_name_I_O_P_LN": "Potenza di uscita dell'invertitore L / N",
  "common.50500.xnl_RTparam_name_C_P_L1": "Potere del carico L1",
  "common.50500.xnl_RTparam_name_C_P_L2": "Potere del carico L2",
  "common.50500.xnl_RTparam_name_E_Puse_t1": "Consumo totale di energia elettrica",
  "common.50500.xnl_RTparam_name_E_Cuse1": "Corrente elettrica R / U / A",
  "common.50500.xnl_RTparam_name_E_Cuse2": "Corrente elettrica S / V / B",
  "common.50500.xnl_RTparam_name_PVGP_A": "Tensione di fase A della porta Gen",
  "common.50500.xnl_RTparam_name_B_T1": "Temperatura della batteria",
  "common.50500.xnl_RTparam_name_B_V1": "Tensione della batteria",
  "common.50500.xnl_RTparam_name_B_R_C": "Capacità residua della batteria",
  "common.50500.xnl_RTparam_name_LF2": "Frequenza del carico L2",
  "common.50500.xnl_RTparam_name_DP1": "Potere di CC PV1",
  "common.50500.xnl_RTparam_name_DP2": "Potere di CC PV2",
  "common.50500.xnl_RTparam_name_DP3": "Potere di CC PV3",
  "common.50500.xnl_RTparam_name_DP4": "Potere di CC PV4",
  "common.50500.xnl_RTparam_name_B_Pdcg1": "Potere di scarico della batteria",
  "common.50500.xnl_RTparam_name_B_C1": "Corrente della batteria",
  "common.50500.xnl_RTparam_name_LF1": "Frequenza del carico L1",
  "common.50500.xnl_RTparam_name_I_O_F1": "Frequenza di uscita dell'invertitore L1",
  "common.50500.xnl_RTparam_name_GRID_RELAY_ST1": "Stato del relè di rete",
  "common.50500.xnl_RTparam_name_ST_EG_RELAY1": "Stato relè lato generatore",
  "common.50500.xnl_RTparam_name_EG_F1": "Frequenza del generatore",
  "common.50500.xnl_RTparam_name_BUS_VOL": "Tensione del bus",
  "common.50500.xnl_RTparam_name_H_B_V": "Mezza tensione della sbarra collettrice",
  "common.50500.xnl_RTparam_name_B_B_C": "Corrente a ponte bilanciata",
  "common.50500.xnl_RTparam_name_I_EARipa1": "Impedenza di terra parallela",
  "common.50500.xnl_RTparam_name_LBVN": "Numero di versione della batteria al litio",
  "common.50500.xnl_RTparam_name_M_P": "Potenza totale del contatore elettrico",
  "common.50500.xnl_RTparam_name_M_P_A": "Misuratore elettrico Potenza A",
  "common.50500.xnl_RTparam_name_M_P_B": "Misuratore elettrico Potenza B",
  "common.50500.xnl_RTparam_name_M_P_C": "Misuratore elettrico Potere C",
  "common.50500.xnl_RTparam_name_t_gc_tdy1": "La capacità di connessione alla rete di oggi",
  "common.50500.xnl_RTparam_name_Etdy_pu1": "Il volume di acquisto di elettricità di oggi",
  "common.50500.xnl_RTparam_name_Et_pu1": "Elettricità cumulativa acquistata",
  "common.50500.xnl_RTparam_name_Vtr1_BAP1": "Tensione totale del pacco batteria 1",
  "common.50500.xnl_RTparam_name_Cr1_BAP1": "Pacchetto batteria 1 corrente",
  "common.50500.xnl_RTparam_name_T_BAP1": "Batteria Pack 1 Temperatura",
  "common.50500.xnl_RTparam_name_SOC_BAP1": "Pacchetto batteria 1 SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP1": "Capacità residua del pacco batteria 1",
  "common.50500.xnl_RTparam_name_T_cap_BAP1": "Capacità totale del pacco batteria 1",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg1": "Batteria Pack 1 Richiesta di ricarica Tensione",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg1": "Richiesta di carica Corrente del pacco batteria 1",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg1": "Batteria Pack 1 Richiesta di scarica Corrente",
  "common.50500.xnl_RTparam_name_Max_V_BAP1": "Tensione massima del pacco batteria 1",
  "common.50500.xnl_RTparam_name_MIN_V_BAP1": "Tensione minima della batteria nel pacco batteria 1",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP1": "Numero di cicli del pacco batteria 1",
  "common.50500.xnl_RTparam_name_Warn_BAP1": "Batteria Pack 1 Allarme",
  "common.50500.xnl_RTparam_name_Fault_BAP1": "Pacchetto batteria 1 errore",
  "common.50500.xnl_RTparam_name_Vtr_BAP2": "Tensione totale del pacco batteria 2",
  "common.50500.xnl_RTparam_name_Cr_BAP2": "Pacchetto batteria 2 corrente",
  "common.50500.xnl_RTparam_name_T_BAP2": "Batteria Pack 2 Temperatura",
  "common.50500.xnl_RTparam_name_SOC_BAP2": "Batteria Pack 2 SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP2": "Capacità residua del pacco batteria 2",
  "common.50500.xnl_RTparam_name_T_cap_BAP2": "Capacità totale del pacco batteria 2",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg2": "Batteria Pack 2 Richiesta di ricarica Tensione",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg2": "Batteria Pack 2 Richiesta di carica Corrente",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg2": "Batteria 2 richiesta di scarica corrente",
  "common.50500.xnl_RTparam_name_Max_V_BAP2": "Tensione massima della batteria 2 nel pacco batteria",
  "common.50500.xnl_RTparam_name_MIN_V_BAP2": "Tensione minima della batteria 2 nel pacco batteria",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP2": "Batteria Pack 2 conteggio dei cicli",
  "common.50500.xnl_RTparam_name_Warn_BAP2": "Batteria Pack 2 Allarme",
  "common.50500.xnl_RTparam_name_Fault_BAP2": "Batteria 2 guasto",
  "common.50500.xnl_RTparam_name_Vtr_BAP3": "Tensione totale del pacco batteria 3",
  "common.50500.xnl_RTparam_name_Cr_BAP3": "Pacchetto batteria 3 corrente",
  "common.50500.xnl_RTparam_name_T_BAP3": "Batteria Pack 3 Temperatura",
  "common.50500.xnl_RTparam_name_SOC_BAP3": "Batteria Pack 3 SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP3": "Capacità residua del pacco batteria 3",
  "common.50500.xnl_RTparam_name_T_cap_BAP3": "Capacità totale del pacco batteria 3",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg3": "Batteria Pack 3 Richiesta di ricarica Tensione",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg3": "Batteria Pack 3 Richiesta di carica Corrente",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg3": "Batteria 3 richiesta di scarica corrente",
  "common.50500.xnl_RTparam_name_Max_V_BAP3": "Tensione massima della batteria 3 nel pacco batteria",
  "common.50500.xnl_RTparam_name_MIN_V_BAP3": "Tensione minima della batteria 3 nel pacco batteria",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP3": "Numero di cicli del pacco batteria 3",
  "common.50500.xnl_RTparam_name_Warn_BAP3": "Batteria Pack 3 Allarme",
  "common.50500.xnl_RTparam_name_Fault_BAP3": "Batteria 3 malfunzionamento",
  "common.50500.xnl_RTparam_name_Vtr_BAP4": "Tensione totale del pacco batteria 4",
  "common.50500.xnl_RTparam_name_Cr_BAP4": "Pacco batteria 4 corrente",
  "common.50500.xnl_RTparam_name_T_BAP4": "Batteria Pack 4 Temperatura",
  "common.50500.xnl_RTparam_name_SOC_BAP4": "Batteria Pack 4 SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP4": "Capacità residua del pacco batteria 4",
  "common.50500.xnl_RTparam_name_T_cap_BAP4": "Capacità totale del pacco batteria 4",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg4": "Batteria Pack 4 Richiesta di ricarica Tensione",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg4": "Batteria Pack 4 Richiesta di carica Corrente",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg4": "Batteria Pack 4 Richiesta di scarica Corrente",
  "common.50500.xnl_RTparam_name_Max_V_BAP4": "Tensione massima della batteria 4 nel pacco batteria",
  "common.50500.xnl_RTparam_name_MIN_V_BAP4": "Tensione minima della batteria 4 nel pacco batteria",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP4": "Batteria Pack 4 conteggio del ciclo",
  "common.50500.xnl_RTparam_name_Warn_BAP4": "Batteria Pack 4 Allarme",
  "common.50500.xnl_RTparam_name_Fault_BAP4": "Batteria 4 guasto",
  "common.50500.xnl_RTparam_name_Vtr5_BAP5": "Tensione totale del pacco batteria 5",
  "common.50500.xnl_RTparam_name_Cr5_BAP5": "Pacco batteria 5 Corrente",
  "common.50500.xnl_RTparam_name_T_BAP5": "Batteria Pack 5 Temperatura",
  "common.50500.xnl_RTparam_name_SOC_BAP5": "Batteria Pack 5 SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP5": "Capacità residua del pacco batteria 5",
  "common.50500.xnl_RTparam_name_T_cap_BAP5": "Capacità totale del pacco batteria 5",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg5": "Batteria Pack 5 Richiesta di ricarica Tensione",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg5": "Batteria Pack 5 Richiesta di carica Corrente",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg5": "Pacchetto batteria 5 richiesta di scarica corrente",
  "common.50500.xnl_RTparam_name_Max_V_BAP5": "Tensione massima della batteria 5 nel pacco batteria",
  "common.50500.xnl_RTparam_name_MIN_V_BAP5": "Tensione minima della batteria 5 nel pacco batteria",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP5": "Batteria Pack 5 conteggio del ciclo",
  "common.50500.xnl_RTparam_name_Warn_BAP5": "Batteria Pack 5 Allarme",
  "common.50500.xnl_RTparam_name_Fault_BAP5": "Batteria 5 guasto",
  "common.50500.xnl_RTparam_name_Vtr6_BAP6": "Tensione totale del pacco batteria 6",
  "common.50500.xnl_RTparam_name_Cr6_BAP6": "Pacchetto batteria 6 Corrente",
  "common.50500.xnl_RTparam_name_T_BAP6": "Batteria Pack 6 Temperatura",
  "common.50500.xnl_RTparam_name_SOC_BAP6": "Batteria 6 SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP6": "Capacità residua del pacco batteria 6",
  "common.50500.xnl_RTparam_name_T_cap_BAP6": "Capacità totale del pacco batteria 6",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg6": "Batteria Pack 6 Richiesta di ricarica Tensione",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg6": "Batteria 6 richiesta di carica corrente",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg6": "Batteria 6 richiesta di scarica corrente",
  "common.50500.xnl_RTparam_name_Max_V_BAP6": "Batteria Pack 6 Batteria Tensione massima",
  "common.50500.xnl_RTparam_name_MIN_V_BAP6": "Tensione minima della batteria 6 nel pacco batteria",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP6": "Confezione batteria 6 cicli",
  "common.50500.xnl_RTparam_name_Warn_BAP6": "Batteria Pack 6 Allarme",
  "common.50500.xnl_RTparam_name_Fault_BAP6": "Batteria 6 guasto",
  "common.50500.xnl_RTparam_name_Vtr7_BAP7": "Tensione totale del pacco batteria 7",
  "common.50500.xnl_RTparam_name_Cr7_BAP7": "Pacco batteria 7 Corrente",
  "common.50500.xnl_RTparam_name_T_BAP7": "Batteria Pack 7 Temperatura",
  "common.50500.xnl_RTparam_name_SOC_BAP7": "Batteria Pack 7 SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP7": "Capacità residua del pacco batteria 7",
  "common.50500.xnl_RTparam_name_T_cap_BAP7": "Capacità totale del pacco batteria 7",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg7": "Batteria Pack 7 Richiesta di ricarica Tensione",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg7": "Batteria Pack 7 Richiesta di carica Corrente",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg7": "Batteria 7 richiesta scarica corrente",
  "common.50500.xnl_RTparam_name_Max_V_BAP7": "Batteria Pack 7 Batteria Tensione massima",
  "common.50500.xnl_RTparam_name_MIN_V_BAP7": "Tensione minima della batteria 7 nel pacco batteria",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP7": "Batteria Pack 7 conteggio del ciclo",
  "common.50500.xnl_RTparam_name_Warn_BAP7": "Allarme pacco batteria 7",
  "common.50500.xnl_RTparam_name_Fault_BAP7": "Batteria 7 guasto",
  "common.50500.xnl_RTparam_name_Vtr8_BAP8": "Tensione totale del pacco batteria 8",
  "common.50500.xnl_RTparam_name_Cr8_BAP8": "Pacco batteria 8 Corrente",
  "common.50500.xnl_RTparam_name_T_BAP8": "Batteria Pack 8 Temperatura",
  "common.50500.xnl_RTparam_name_SOC_BAP8": "Batteria Pack 8 SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP8": "Capacità residua del pacco batteria 8",
  "common.50500.xnl_RTparam_name_T_cap_BAP8": "Capacità totale del pacco batteria 8",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg8": "Batteria Pack 8 Richiesta di ricarica Tensione",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg8": "Batteria Pack 8 Richiesta di carica Corrente",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg8": "Batteria 8 richiesta di scarica corrente",
  "common.50500.xnl_RTparam_name_Max_V_BAP8": "Tensione massima della batteria 8 nel pacco batteria",
  "common.50500.xnl_RTparam_name_MIN_V_BAP8": "Tensione minima della batteria 8 nel pacco batteria",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP8": "Confezione batteria 8 cicli",
  "common.50500.xnl_RTparam_name_Warn_BAP8": "Batteria Pack 8 Allarme",
  "common.50500.xnl_RTparam_name_Fault_BAP8": "Batteria 8 guasto",
  "common.50500.xnl_RTparam_name_Vtr9_BAP9": "Tensione totale del pacco batteria 9",
  "common.50500.xnl_RTparam_name_Cr9_BAP9": "Pacco batteria 9 Corrente",
  "common.50500.xnl_RTparam_name_T_BAP9": "Batteria Pack 9 Temperatura",
  "common.50500.xnl_RTparam_name_SOC_BAP9": "Batteria Pack 9 SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP9": "Capacità residua del pacco batteria 9",
  "common.50500.xnl_RTparam_name_T_cap_BAP9": "Capacità totale del pacco batteria 9",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg9": "Batteria Pack 9 Richiesta di ricarica Tensione",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg9": "Batteria 9 richiesta di carica corrente",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg9": "Batteria 9 richiesta di scarica corrente",
  "common.50500.xnl_RTparam_name_Max_V_BAP9": "Batteria Pack 9 Batteria Tensione massima",
  "common.50500.xnl_RTparam_name_MIN_V_BAP9": "Tensione minima della batteria 9 nel pacco batteria",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP9": "Batteria Conta 9 cicli",
  "common.50500.xnl_RTparam_name_Warn_BAP9": "Allarme pacco batteria 9",
  "common.50500.xnl_RTparam_name_Fault_BAP9": "Batteria 9 guasto",
  "common.50500.xnl_RTparam_name_Vtr10_BAP10": "Tensione totale del pacco batteria 10",
  "common.50500.xnl_RTparam_name_Cr10_BAP10": "Pacchetto batteria 10 corrente",
  "common.50500.xnl_RTparam_name_T_BAP10": "Batteria Pack 10 Temperatura",
  "common.50500.xnl_RTparam_name_SOC_BAP10": "Batteria Pack 10 SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP10": "Capacità residua del pacco batteria 10",
  "common.50500.xnl_RTparam_name_T_cap_BAP10": "Capacità totale del pacco batteria 10",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg10": "Batteria Pack 10 Richiesta di ricarica Tensione",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg10": "Richiesta di carica Corrente del pacco batteria 10",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg10": "Richiesta di scarica Corrente del pacco batteria 10",
  "common.50500.xnl_RTparam_name_Max_V_BAP10": "Tensione massima della batteria 10 nel pacco batteria",
  "common.50500.xnl_RTparam_name_MIN_V_BAP10": "Tensione minima della batteria 10 nel pacco batteria",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP10": "Numero di cicli del pacco batteria 10",
  "common.50500.xnl_RTparam_name_Warn_BAP10": "Batteria Pack 10 Allarme",
  "common.50500.xnl_RTparam_name_Fault_BAP10": "Batteria 10 guasto",
  "common.50500.xnl_RTparam_name_Vtr11_BAP11": "Tensione totale del pacco batteria 11",
  "common.50500.xnl_RTparam_name_Cr11_BAP11": "Pacchetto batteria 11 Corrente",
  "common.50500.xnl_RTparam_name_T_BAP11": "Batteria Pack 11 Temperatura",
  "common.50500.xnl_RTparam_name_SOC_BAP11": "Pacchetto batteria 11 SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP11": "Capacità residua del pacco batteria 11",
  "common.50500.xnl_RTparam_name_T_cap_BAP11": "Capacità totale del pacco batteria 11",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg11": "Batteria Pack 11 Richiesta di ricarica Tensione",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg11": "Batteria Pack 11 Richiesta di carica Corrente",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg11": "Richiesta di scarica corrente del pacco batteria 11",
  "common.50500.xnl_RTparam_name_Max_V_BAP11": "Tensione massima del pacco batteria 11 batterie",
  "common.50500.xnl_RTparam_name_MIN_V_BAP11": "Tensione minima della batteria 11 nel pacco batteria",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP11": "Numero di cicli del pacco batteria 11",
  "common.50500.xnl_RTparam_name_Warn_BAP11": "Allarme pacco batteria 11",
  "common.50500.xnl_RTparam_name_Fault_BAP11": "Batteria 11 malfunzionamento",
  "common.50500.xnl_RTparam_name_Vtr12_BAP12": "Tensione totale del pacco batteria 12",
  "common.50500.xnl_RTparam_name_Cr12_BAP12": "Pacco batteria 12 corrente",
  "common.50500.xnl_RTparam_name_T_BAP12": "Batteria Pack 12 Temperatura",
  "common.50500.xnl_RTparam_name_SOC_BAP12": "Batteria Pack 12 SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP12": "Capacità residua del pacco batteria 12",
  "common.50500.xnl_RTparam_name_T_cap_BAP12": "Capacità totale del pacco batteria 12",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg12": "Batteria Pack 12 Richiesta di ricarica Tensione",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg12": "Batteria Pack 12 Richiesta di carica Corrente",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg12": "Pacchetto batteria 12 corrente di richiesta di scarica",
  "common.50500.xnl_RTparam_name_Max_V_BAP12": "Tensione massima della batteria 12 nel pacco batteria",
  "common.50500.xnl_RTparam_name_MIN_V_BAP12": "Tensione minima della batteria 12 nel pacco batteria",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP12": "Numero di cicli del pacco batteria 12",
  "common.50500.xnl_RTparam_name_Warn_BAP12": "Allarme pacco batteria 12",
  "common.50500.xnl_RTparam_name_Fault_BAP12": "Batteria 12 guasto",
  "common.50500.xnl_RTparam_name_Vtr13_BAP13": "Tensione totale del pacco batteria 13",
  "common.50500.xnl_RTparam_name_Cr13_BAP13": "Pacchetto batteria 13 Corrente",
  "common.50500.xnl_RTparam_name_T_BAP13": "Batteria Pack 13 Temperatura",
  "common.50500.xnl_RTparam_name_SOC_BAP13": "Batteria 13 SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP13": "Capacità residua del pacco batteria 13",
  "common.50500.xnl_RTparam_name_T_cap_BAP13": "Capacità totale del pacco batteria 13",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg13": "Batteria 13 tensione di richiesta di carica",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg13": "Batteria 13 richiesta di carica corrente",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg13": "Richiesta di scarica Corrente del pacco batteria 13",
  "common.50500.xnl_RTparam_name_Max_V_BAP13": "Tensione massima della batteria 13 nel pacco batteria",
  "common.50500.xnl_RTparam_name_MIN_V_BAP13": "Tensione minima della batteria 13 nel pacco batteria",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP13": "Numero di cicli del pacco batteria 13",
  "common.50500.xnl_RTparam_name_Warn_BAP13": "Allarme pacco batteria 13",
  "common.50500.xnl_RTparam_name_Fault_BAP13": "Batteria 13 malfunzionamento",
  "common.50500.xnl_RTparam_name_Vtr14_BAP14": "Tensione totale del pacco batteria 14",
  "common.50500.xnl_RTparam_name_Cr14_BAP14": "Pacchetto batteria 14 Corrente",
  "common.50500.xnl_RTparam_name_T_BAP14": "Batteria Pack 14 Temperatura",
  "common.50500.xnl_RTparam_name_SOC_BAP14": "Pacchetto batteria 14 SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP14": "Capacità residua del pacco batteria 14",
  "common.50500.xnl_RTparam_name_T_cap_BAP14": "Capacità totale del pacco batteria 14",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg14": "Batteria Pack 14 Richiesta di ricarica Tensione",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg14": "Batteria 14 richiesta di carica corrente",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg14": "Richiesta di scarica Corrente del pacco batteria 14",
  "common.50500.xnl_RTparam_name_Max_V_BAP14": "Tensione massima della batteria 14 nel pacco batteria",
  "common.50500.xnl_RTparam_name_MIN_V_BAP14": "Tensione minima della batteria 14 nel pacco batterie",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP14": "Numero di cicli del pacco batteria 14",
  "common.50500.xnl_RTparam_name_Warn_BAP14": "Allarme pacco batteria 14",
  "common.50500.xnl_RTparam_name_Fault_BAP14": "Batteria 14 malfunzionamento",
  "common.50500.xnl_RTparam_name_Vtr15_BAP15": "Tensione totale del pacco batteria 15",
  "common.50500.xnl_RTparam_name_Cr15_BAP15": "Pacchetto batteria 15 Corrente",
  "common.50500.xnl_RTparam_name_T_BAP15": "Batteria Pack 15 Temperatura",
  "common.50500.xnl_RTparam_name_SOC_BAP15": "Pacchetto batteria 15 SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP15": "Capacità residua del pacco batteria 15",
  "common.50500.xnl_RTparam_name_T_cap_BAP15": "Capacità totale del pacco batteria 15",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg15": "Batteria Pack 15 Richiesta di ricarica Tensione",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg15": "Batteria 15 richiesta di carica corrente",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg15": "Batteria 15 richiesta di scarica corrente",
  "common.50500.xnl_RTparam_name_Max_V_BAP15": "Tensione massima della batteria 15 nel pacco batteria",
  "common.50500.xnl_RTparam_name_MIN_V_BAP15": "Tensione minima della batteria 15 nel pacco batteria",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP15": "Numero di cicli del pacco batteria 15",
  "common.50500.xnl_RTparam_name_Warn_BAP15": "Allarme pacco batteria 15",
  "common.50500.xnl_RTparam_name_Fault_BAP15": "Batteria 15 malfunzionamento",
  "common.50500.xnl_RTparam_name_yr1": "Anno",
  "common.50500.xnl_RTparam_name_mon1": "Mese",
  "common.50500.xnl_RTparam_name_tdy1": "Giorno",
  "common.50500.xnl_RTparam_name_hou1": "quando",
  "common.50500.xnl_RTparam_name_min1": "punti",
  "common.50500.xnl_RTparam_name_sec1": "secondi",
  "common.50500.xnl_RTparam_name_BMS_D_V": "Tensione di scarica BMS",
  "common.50500.xnl_RTparam_name_BMS_B_Ccg_thd1": "Limite di visualizzazione della ricarica della batteria BMS di",
  "common.50500.xnl_RTparam_name_BMS_B_Cdcg_thd1": "Limite di scarica della batteria BMS",
  "common.50500.xnl_RTparam_name_B_R_P": "Potenza residua BMS",
  "common.50500.xnl_RTparam_name_BMS_B_V1": "Tensione della batteria BMS",
  "common.50500.xnl_RTparam_name_BMS_B_C1": "Corrente della batteria BMS",
  "common.50500.xnl_RTparam_name_BMST": "Temperatura BMS",
  "common.50500.xnl_RTparam_name_BCT": "Tipo di batteria",
  "common.50500.xnl_RTparam_name_HF_1": "Errore storico 1",
  "common.50500.xnl_RTparam_name_HF_2": "Errore storico 2",
  "common.50500.xnl_RTparam_name_HF_3": "Errore storico 3",
  "common.50500.xnl_RTparam_name_HF_4": "Errore storico 4",
  "common.50500.xnl_RTparam_name_HF_5": "Errore storico 5",
  "common.50500.xnl_RTparam_name_HF_6": "Errore storico 6",
  "common.50500.xnl_RTparam_name_HF_7": "Errore storico 7",
  "common.50500.xnl_RTparam_name_HF_8": "Errore storico 8",
  "common.50500.xnl_RTparam_name_HF_9": "Errore storico 9",
  "common.50500.xnl_RTparam_name_HF_10": "Errore storico 10",
  "common.50500.xnl_RTparam_name_HF_11": "Errore storico 11",
  "common.50500.xnl_RTparam_name_HF_12": "Errore storico 12",
  "common.50500.xnl_RTparam_name_HF_13": "Faglia storica 13",
  "common.50500.xnl_RTparam_name_G_V_L3": "Tensione di rete L3",
  "common.50500.xnl_RTparam_name_G_V_L1_L3": "Tensione lato rete L1-L3",
  "common.50500.xnl_RTparam_name_G_V_L2_L3": "Tensione lato rete L2-L3",
  "common.50500.xnl_RTparam_name_AV3": "Tensione di CA T / W / C",
  "common.50500.xnl_RTparam_name_INV_O_P_L1_L3": "Tensione di uscita dell'invertitore L1-L3",
  "common.50500.xnl_RTparam_name_INV_O_P_L2_L3": "Tensione di uscita dell'invertitore L2-L3",
  "common.50500.xnl_RTparam_name_C_V_L3": "Tensione di carico L3",
  "common.50500.xnl_RTparam_name_NA": "NA",
  "common.50500.xnl_RTparam_name_I_O_F3": "Frequenza di uscita dell'invertitore L3",
  "common.50500.xnl_RTparam_name_G_C_L3": "Corrente di rete L3",
  "common.50500.xnl_RTparam_name_G_C_C": "Corrente di rete C",
  "common.50500.xnl_RTparam_name_AC3": "Corrente alternata T / W / C",
  "common.50500.xnl_RTparam_name_G_P_L3": "Potenza di rete L3",
  "common.50500.xnl_RTparam_name_CT3_P_E": "Potenza esterna CT3",
  "common.50500.xnl_RTparam_name_INV_O_P_L3": "Potenza di uscita dell'inverter L3",
  "common.50500.xnl_RTparam_name_C_P_L3": "Potere del carico L3",
  "common.50500.xnl_RTparam_name_C_C_L3": "Corrente di carico L3",
  "common.50500.xnl_RTparam_name_BMS_C_V": "Tensione di carica BMS",
  "common.50500.xnl_RTparam_name_INV_ADDR": "Indirizzo dell'inversore",
  "bw_RTparam_name_online": "in linea",
  "bw_RTparam_name_offline": "off-line",
  "bw_RTparam_name_buy": "Compra elettricità",
  "bw_RTparam_name_sell": "Vendere energia elettrica",
  "bw_RTparam_name_dontBuy": "Non comprare, non vendere",
  "bw_RTparam_name_noCharging": "Nessuna carica e nessuna scarica",
  "bw_RTparam_name_forbidden": "È vietato caricare e scaricare",
  "bw_RTparam_name_charging": "L'autorizzazione è vietata",
  "bw_RTparam_name_allowCharged": "Consentire la ricarica e il rilascio",
  "bw_RTparam_name_forcedCharging": "Ricarica forzata e divieto",
  "bw_RTparam_name_forcedCharge": "Carica e scarica forzata",
  "bw_RTparam_name_photovoltaics": "Il CT viene utilizzato per le reti elettriche e il fotovoltaico",
  "bw_RTparam_name_gridCT": "La rete utilizza il TA e il fotovoltaico utilizza i contatori",
  "bw_RTparam_name_electricity": "I contatori elettrici sono utilizzati per le reti elettriche e il TA è utilizzato per il fotovoltaico",
  "bw_RTparam_name_grid": "Contatori di rete e fotovoltaici",
  "bw_RTparam_name_forced": "Carica e scarica forzata",
  "bw_RTparam_name_charge": "La funzione di carica/scarica non è abilitata",
  "common.50100.Inverter": "Inverter",
  "supplier.type.tuobang": "Tuobao",
  "supplier.type.gd": "GOODWE",
  "Ajouterbar.plant": "Aggiungi Pianta",
  "ASNZ4777-N": "Australia_ASNZ4777-N",
  "CEI 0-21": "Italy_CEI 0-21",
  "custom50": "User defined_Custom50",
  "custom60": "User defined_Custom60",
  "EN50438L": "Cyprus,Finland,Czech,Slovenia,Jamaica_EN50438 L",
  "G83/1-A": "UK_G83/1-A",
  "G83/3": "UK_G83/3",
  "General50": "User defined_General 50",
  "General60": "User defined_General 60",
  "GN300V": "China_GN300V",
  "GNB": "China_GNB",
  "GNC": "China_GNC",
  "ISONE208": "USA_ISONE208",
  "ISONE208A": "USA_ISONE208A",
  "ISONE240": "USA_ISONE240",
  "ISONE240A": "USA_ISONE240A",
  "JAM-230": "Jamaica_JAM-230",
  "MEX": "China_MEX",
  "MEX-A": "Mexico_MEX-A",
  "MEX-N": "MEX-N_MEX-N",
  "NA-EEA-A": "Switzerland_NA-EEA-A",
  "R14-208": "USA_R14-208",
  "R14-208A": "USA_R14-208A",
  "R14-240": "USA_R14-240",
  "R14-240A": "USA_R14-240A",
  "R14H-208": "USA_R14H-208",
  "R14H-240": "USA_R14H-240",
  "R21-208": "USA_R21-208",
  "R21-240": "USA_R21-240",
  "R21P3-208": "USA_R21P3-208",
  "R21P3-20A": "USA_R21P3-20A",
  "R21P3-240": "USA_R21P3-240",
  "R21P3-24A": "USA_R21P3-24A",
  "UL-208V-13": "USA_UL-208V-13",
  "UL-208V-18": "USA_UL-208V-18",
  "UL-208V-A": "USA_UL-208V-A",
  "UL240-13": "USA_UL240-13",
  "UL-240V-18": "USA_UL-240V-18",
  "common.50402.Derating": "Declassamento",
  "common.50402.dispatch": "spedizione",
  "common.50402.fault": "colpa",
  "common.50402.outages": "Razionamento dell'energia e interruzioni",
  "common.50402.generation": "Produzione di energia elettrica connessa alla rete",
  "common.50402.Standby": "Standby",
  "common.50402.Planned": "Interruzioni pianificate",
  "common.50300.offline": "off-line",
  "common.50300.Standby": "Standby",
  "common.50300.online": "in linea",
  "common.50300.fault": "colpa",
  "device.category.fox": "Fox",
  "bw_RTparam_name_TotalPowerFactor_PV1": "Fattore di potenza totale (fotovoltaico)1",
  "CEI0-21": "Italy_CEI 0-21",
  "common.50700.xnl_RTparam_group_Load": "Carico",
  "common.50700.xnl_RTparam_group_Inverter": "Inverter",
  "common.50700.xnl_RTparam_group_Grid": "Rete elettrica",
  "common.50700.170": "Illegale",
  "common.50700.169": "Test di fabbrica",
  "common.50700.168": "Aggiornamento in corso",
  "common.50700.167": "Modalità standby",
  "common.50700.166": "Errore permanente",
  "common.50700.165": "Guasto",
  "common.50700.164": "Disconnessione dalla rete",
  "common.50700.163": "Connessione alla rete",
  "common.50700.162": "In verifica",
  "common.50700.161": "In attesa",
  "common.50700.160": "Auto - controllo",
  "common.50700.TFreq": "Frequenza fase T",
  "common.50700.TCurrent": "Corrente fase T",
  "common.50700.SVolt": "Tensione fase S",
  "common.50700.SPower": "Potenza fase S",
  "common.50700.SOH": "SOH",
  "common.50700.SoC": "SOC",
  "common.50700.SFreq": "Frequenza fase S",
  "common.50700.SCurrent": "Corrente fase S",
  "common.50700.RVolt": "Tensione fase R",
  "common.50700.runningState": "Stato di funzionamento",
  "common.50700.RPower": "Potenza fase R",
  "common.50700.RFreq": "Frequenza fase R",
  "common.50700.ResidualEnergy": "Quantità residua di carica della batteria",
  "common.50700.ReactivePower": "Potenza reattiva",
  "common.50700.RCurrent": "Corrente fase R",
  "common.50700.pvPower": "Potenza PV",
  "common.50700.pv9Volt": "Tensione PV9",
  "common.50700.pv9Power": "Potenza PV9",
  "common.50700.pv9Current": "Corrente PV9",
  "common.50700.pv8Volt": "Tensione PV8",
  "common.50700.pv8Power": "Potenza PV8",
  "common.50700.pv8Current": "Corrente PV8",
  "common.50700.pv7Volt": "Tensione PV7",
  "common.50700.pv7Power": "Potenza PV7",
  "common.50700.pv7Current": "Corrente PV7",
  "common.50700.pv6Volt": "Tensione PV6",
  "common.50700.pv6Power": "Potenza PV6",
  "common.50700.pv6Current": "Corrente PV6",
  "common.50700.pv5Volt": "Tensione PV5",
  "common.50700.pv5Power": "Potenza PV5",
  "common.50700.pv5Current": "Corrente PV5",
  "common.50700.pv4Volt": "Tensione PV4",
  "common.50700.pv4Power": "Potenza PV4",
  "common.50700.pv4Current": "Corrente PV4",
  "common.50700.pv3Volt": "Tensione PV3",
  "common.50700.pv3Power": "Potenza PV3",
  "common.50700.pv3Current": "Corrente PV3",
  "common.50700.pv2Volt": "Tensione PV2",
  "common.50700.pv2Power": "Potenza PV2",
  "common.50700.pv2Current": "Corrente PV2",
  "common.50700.pv1Volt": "Tensione PV1",
  "common.50700.pv1Power": "Potenza PV1",
  "common.50700.pv1Current": "Corrente PV1",
  "common.50700.pv18Volt": "Tensione PV18",
  "common.50700.pv18Power": "Potenza PV18",
  "common.50700.pv18Current": "Corrente PV18",
  "common.50700.pv17Volt": "Tensione PV17",
  "common.50700.pv17Power": "Potenza PV17",
  "common.50700.pv17Current": "Corrente PV17",
  "common.50700.pv16Volt": "Tensione PV16",
  "common.50700.pv16Power": "Potenza PV16",
  "common.50700.pv16Current": "Corrente PV16",
  "common.50700.pv15Volt": "Tensione PV15",
  "common.50700.pv15Power": "Potenza PV15",
  "common.50700.pv15Current": "Corrente PV15",
  "common.50700.pv14Volt": "Tensione PV14",
  "common.50700.pv14Power": "Potenza PV14",
  "common.50700.pv14Current": "Corrente PV14",
  "common.50700.pv13Volt": "Tensione PV13",
  "common.50700.pv13Power": "Potenza PV13",
  "common.50700.pv13Current": "Corrente PV13",
  "common.50700.pv12Volt": "Tensione PV12",
  "common.50700.pv12Power": "Potenza PV12",
  "common.50700.pv12Current": "Corrente PV12",
  "common.50700.pv11Volt": "Tensione PV11",
  "common.50700.pv11Power": "Potenza PV11",
  "common.50700.pv11Current": "Corrente PV11",
  "common.50700.pv10Volt": "Tensione PV10",
  "common.50700.pv10Power": "Potenza PV10",
  "common.50700.pv10Current": "Corrente PV10",
  "common.50700.PowerFactor": "Fattore di potenza",
  "common.50700.meterPowerT": "Potenza T del contatore elettrico",
  "common.50700.meterPowerS": "Potenza S del contatore elettrico",
  "common.50700.meterPowerR": "Potenza R del contatore elettrico",
  "common.50700.meterPower2": "Potenza del contatore elettrico 2",
  "common.50700.meterPower": "Potenza del contatore elettrico",
  "common.50700.loadsPowerT": "Potenza fase T del carico",
  "common.50700.loadsPowerS": "Potenza fase S del carico",
  "common.50700.loadsPowerR": "Potenza fase R del carico",
  "common.50700.loadsPower": "Potenza del carico",
  "common.50700.loads": "Consumo di energia del carico",
  "common.50700.invTemperation": "Temperatura dell'inverter",
  "common.50700.invBatVolt": "Tensione della batteria lato inverter",
  "common.50700.invBatPower": "Potenza della batteria lato inverter",
  "common.50700.invBatCurrent": "Corrente della batteria lato inverter",
  "common.50700.gridConsumptionPower": "Potenza di perdita nella rete",
  "common.50700.gridConsumption": "Consumo totale di energia dalla rete",
  "common.50700.generationPower": "Potenza di generazione",
  "common.50700.generation": "Energia elettrica generata cumulativa",
  "common.50700.feedinPower": "Potenza di iniezione nella rete",
  "common.50700.feedin": "Quantità totale di energia iniettata nella rete",
  "common.50700.epsVoltT": "Tensione fase T EPS",
  "common.50700.epsVoltS": "Tensione fase S EPS",
  "common.50700.epsVoltR": "Tensione fase R EPS",
  "common.50700.epsPowerT": "Potenza fase T EPS",
  "common.50700.epsPowerS": "Potenza fase S EPS",
  "common.50700.epsPowerR": "Potenza fase R EPS",
  "common.50700.epsPower": "Potenza EPS",
  "common.50700.epsCurrentT": "Corrente fase T EPS",
  "common.50700.epsCurrentS": "Corrente fase S EPS",
  "common.50700.epsCurrentR": "Corrente fase R EPS",
  "common.50700.energyThroughput": "Throughput della batteria",
  "common.50700.dspTemperature": "Temperatura del DSP",
  "common.50700.dischargeEnergyToTal": "Quantità totale di scarica",
  "common.50700.chargeTemperature": "Temperatura di ricarica",
  "common.50700.chargeEnergyToTal": "Quantità totale di ricarica",
  "common.50700.boostTemperation": "Temperatura del caricabatterie",
  "common.50700.batVolt": "Tensione della batteria",
  "common.50700.batTemperature": "Temperatura della batteria",
  "common.50700.batStatusV2": "Stato della batteria",
  "common.50700.batStatus": "Stato della batteria",
  "common.50700.batDischargePower": "Potenza di scarica della batteria",
  "common.50700.batCurrent": "Corrente della batteria",
  "common.50700.batChargePower": "Potenza di ricarica della batteria",
  "common.50700.ambientTemperation": "Temperatura ambiente",
  "common.50700.xnl_RTparam_group_Battery": "Batteria",
  "common.50702.xnl_RTparam_group_Battery": "Batteria",
  "common.50698.TVolt": "Tensione di Fase T",
  "common.50700.TPower": "Potenza di Fase T",
  "common.50700.TVolt": "Tensione di Fase T",
  "supplier.type.ankerui": "ankerui",
  "subtype.collector.4g.meters": "contatore 4G",
  "param_set.xnl_inverter_Factoryresetenable": "Ripristino di fabbrica",
  "param_set.xnl_inverter_GridMode": "standard collegato alla rete",
  "param_set.xnl_inverter_GridType": "impostazione del tipo di griglia",
  "param_set.xnl_inverter_GridFrequency": "Impostazione della frequenza di rete",
  "param_set.xnl_inverter_Restoreconnectiontime": "Ripristina il tempo di connessione alla rete",
  "param_set.xnl_inverter_PF": "Impostazione del valore PF di uscita",
  "param_set.xnl_inverter_GridFrequencyOver": "Punto di protezione ad alta frequenza",
  "param_set.xnl_inverter_GridFrequencyUnder": "Frequenza di rete basso punto di protezione",
  "param_set.xnl_inverter_GridVoltageOver": "Punto di protezione da sovratensione della rete elettrica",
  "param_set.xnl_inverter_GridVoltageUnder": "Rete elettrica punto di protezione di bassa tensione",
  "param_set.xnl_inverter_Q(V)": "California CA _ QV Abilita",
  "param_set.xnl_inverter_V1": "CA _ QV _ V1",
  "param_set.xnl_inverter_V2": "CA _ QV _ V2",
  "param_set.xnl_inverter_V3": "CA _ QV _ V3",
  "param_set.xnl_inverter_V4": "CA _ QV _ V4",
  "param_set.xnl_inverter_Q1": "CA _ QV _ Q1",
  "param_set.xnl_inverter_Q2": "CA _ QV _ Q2",
  "param_set.xnl_inverter_Q3": "CA _ QV _ Q3",
  "param_set.xnl_inverter_Q4": "CA _ QV _ Q4",
  "param_set.xnl_inverter_FW": "California CA _ FW Abilita",
  "param_set.xnl_inverter_Fstart": "CA _ Fstart",
  "param_set.xnl_inverter_Fstop": "CA _ Fstop",
  "param_set.xnl_inverter_VW": "California CA _ VW Abilita",
  "param_set.xnl_inverter_Vstart": "CA _ Vstart",
  "param_set.xnl_inverter_Vstop": "CA _ Vstop",
  "param_set.xnl_inverter_Normalupwardslope": "normale pendenza ascendente",
  "param_set.xnl_inverter_Softstartriserate": "Tasso di aumento di inizio morbido",
  "param_set.xnl_inverter_LHVRT": "L'attraversamento ad alta pressione a bassa pressione della California consente",
  "param_set.xnl_inverter_HV2": "CA _ HV2",
  "param_set.xnl_inverter_HV1": "CA _ HV1",
  "param_set.xnl_inverter_LV1": "CA _ LV1",
  "param_set.xnl_inverter_LV2": "CA _ LV2",
  "param_set.xnl_inverter_LV3": "CA _ LV3",
  "param_set.xnl_inverter_CA_HV2_Time": "CA _ HV2 _ Tempo",
  "param_set.xnl_inverter_CA_HV1_Time": "CA _ HV1 _ Tempo",
  "param_set.xnl_inverter_CA_LV1_Time": "CA _ LV1 _ Tempo",
  "param_set.xnl_inverter_CA_LV2_Time": "CA _ LV2 _ Tempo",
  "param_set.xnl_inverter_CA_LV3_Time": "CA _ LV3 _ Tempo",
  "param_set.xnl_inverter_CA_LHFRT": "California Low Frequency High Frequency Crossing CA _ LHFRT Abilita",
  "param_set.xnl_inverter_CA_HF2": "CA _ HF2",
  "param_set.xnl_inverter_CA_HF1": "CA _ HF1",
  "param_set.xnl_inverter_CA_LF1": "CA _ LF1",
  "param_set.xnl_inverter_CA_LF2": "CA _ LF2",
  "param_set.xnl_inverter_CA_HF2_Time": "CA _ HF2 _ Tempo",
  "param_set.xnl_inverter_CA_HF1_Time": "CA _ HF1 _ Tempo",
  "param_set.xnl_inverter_CA_LF1_Time": "CA _ LF1 _ Tempo",
  "param_set.xnl_inverter_CA_LF2_Time": "CA _ LF2 _ Tempo",
  "param_set.xnl_inverter_GeneratorInputRatedPower": "Potenza nominale in ingresso del generatore",
  "param_set.xnl_inverter_GENConnectToGridInput": "Il generatore è collegato alla rete elettrica",
  "param_set.xnl_inverter_SmartLoadOutput": "Potenza sotto carico",
  "param_set.xnl_inverter_OnGridAlwayson00": "Attivare le condizioni della griglia",
  "param_set.xnl_inverter_OFF1": "SmartLoad OFF Tensione batteria",
  "param_set.xnl_inverter_ON1": "Tensione batteria SmartLoad ON",
  "param_set.xnl_inverter_OFF2": "SmartLoad OFF Carica batteria",
  "param_set.xnl_inverter_ON2": "SmartLoad sulla batteria",
  "param_set.xnl_inverter_Battery_Type": "Tipo di batteria",
  "param_set.xnl_inverter_Battery_Mode": "Modalità batteria",
  "param_set.xnl_inverter_Activate Battery": "Bandiera di risveglio della batteria al litio",
  "param_set.xnl_inverter_Batt Capacity": "Capacità della batteria",
  "param_set.xnl_inverter_MaxACharge": "Corrente di carica massima della batteria",
  "param_set.xnl_inverter_MaxAdischarge": "Corrente di scarica massima della batteria",
  "param_set.xnl_inverter_GenCharge1": "Ricarica del generatore abilitata",
  "param_set.xnl_inverter_GenSignal1": "Segnale Gen",
  "param_set.xnl_inverter_GenStartingCapacityPoint2": "Punto di capacità di avvio della ricarica del generatore",
  "param_set.xnl_inverter_GenMainsPowerBattery2": "Corrente di carica del generatore alla batteria",
  "param_set.xnl_inverter_MaxRunTime": "Tempo di funzionamento massimo del generatore",
  "param_set.xnl_inverter_CoolingTime": "Raffreddamento del generatore",
  "param_set.xnl_inverter_GridCharge": "Ricarica di rete abilitata",
  "param_set.xnl_inverter_GridSignal": "Segnale di rete",
  "param_set.xnl_inverter_StartVoltageMainsPowerCharge1": "Punto di capacità di avvio della ricarica di rete",
  "param_set.xnl_inverter_ChargeCurrentBatteryMains1": "Corrente di carica della batteria",
  "param_set.xnl_inverter_Lithium Protocol": "Opzioni di comunicazione con batteria al litio",
  "param_set.xnl_inverter_ShutDown": "Batteria spenta",
  "param_set.xnl_inverter_Restart": "Riavvio della batteria",
  "param_set.xnl_inverter_LowBatt": "Batteria a bassa tensione",
  "param_set.xnl_inverter_GenSignal ": "segnale di rete",
  "param_set.xnl_inverter_GenStartVoltageMainsPowerCharge": "Punto di tensione di inizio della carica del generatore",
  "param_set.xnl_inverter_StartVoltageMainsPowerCharge": "Punto di tensione iniziale di carica di rete",
  "param_set.xnl_inverter_FloatVoltage": "tensione di galleggiamento",
  "param_set.xnl_inverter_AbsorptionVoltage": "tensione di assorbimento",
  "param_set.xnl_inverter_EqualizationVoltage": "uguale tensione di carica",
  "param_set.xnl_inverter_EqualizationdayS": "La carica bilanciata viene eseguita ogni pochi giorni",
  "param_set.xnl_inverter_TEMPCO": "valore di compensazione della temperatura",
  "param_set.xnl_inverter_Equalizationhours": "tempo di esecuzione della carica di equilibrio",
  "param_set.xnl_inverter_batteryresistancevalue": "Valore di resistenza interna della batteria",
  "param_set.xnl_inverter_GenStartingCapacityPoint": "Punto di capacità di avvio della ricarica del generatore",
  "param_set.xnl_inverter_SellingFirst": "Priorità alla vendita di energia elettrica",
  "param_set.xnl_inverter_Solarsell": "Energia fotovoltaica",
  "param_set.xnl_inverter_MaxSolarPower": "Potenza fotovoltaica massima",
  "param_set.xnl_inverter_MaxSellPower": "Potenza massima connessa alla rete",
  "param_set.xnl_inverter_Zero-Exportpower": "potenza operativa minima",
  "param_set.xnl_inverter_EnergyPattern": "Modello di gestione energetica",
  "param_set.xnl_inverter_GridPeakShavingPower": "Rasatura di picco della rete elettrica",
  "param_set.xnl_inverter_GridGen10": "Ricarica griglia abilitata 1",
  "param_set.xnl_inverter_GridGen20": "Ricarica griglia abilitata 2",
  "param_set.xnl_inverter_GridGen30": "Ricarica griglia abilitata 3",
  "param_set.xnl_inverter_GridGen40": "Ricarica griglia abilitata 4",
  "param_set.xnl_inverter_GridGen50": "Ricarica griglia abilitata 5",
  "param_set.xnl_inverter_GridGen60": "Ricarica griglia abilitata 6",
  "param_set.xnl_inverter_Time1": "Periodo di tempo 1",
  "param_set.xnl_inverter_Time2": "Periodo di tempo 2",
  "param_set.xnl_inverter_Time3": "Periodo di tempo 3",
  "param_set.xnl_inverter_Time4": "Periodo di tempo 4",
  "param_set.xnl_inverter_Time5": "Periodo di tempo 5",
  "param_set.xnl_inverter_Time6": "Periodo di tempo 6",
  "param_set.xnl_inverter_Power1": "potere",
  "param_set.xnl_inverter_Power2": "Potenza 2",
  "param_set.xnl_inverter_Power3": "Potenza 3",
  "param_set.xnl_inverter_Power4": "Potenza 4",
  "param_set.xnl_inverter_Power5": "Potenza 5",
  "param_set.xnl_inverter_Power6": "Potenza 6",
  "param_set.xnl_inverter_BattV1": "Tensione della batteria 1 ",
  "param_set.xnl_inverter_BattV2": "Tensione della batteria 2 ",
  "param_set.xnl_inverter_BattV3": "Tensione della batteria 3 ",
  "param_set.xnl_inverter_BattV4": "Tensione della batteria 4 ",
  "param_set.xnl_inverter_BattV5": "Tensione della batteria 5 ",
  "param_set.xnl_inverter_BattV6": "Tensione della batteria 6 ",
  "param_set.xnl_inverter_Batt1": "Batteria 1",
  "param_set.xnl_inverter_Batt2": "Batteria 2",
  "param_set.xnl_inverter_Batt3": "Batteria 3",
  "param_set.xnl_inverter_Batt4": "Batteria 4",
  "param_set.xnl_inverter_Batt5": "Batteria 5",
  "param_set.xnl_inverter_Batt6": "Batteria 6",
  "param_set.xnl_inverter_SolarArcFaultON": "Modalità errore arco",
  "param_set.xnl_inverter_CTRatio": "Rapporto di trasformazione CT",
  "param_set.xnl_inverter_BackupDelay": "Ups _ tempo",
  "param_set.xnl_inverter_Parallel1": "Parallelo",
  "param_set.xnl_inverter_3P1": "Parallelo trifase - Abilita metro CT",
  "param_set.xnl_inverter_GenCharge": "Ricarica del generatore abilitata",
  "param_set.xnl_inverter_GenChargeCurrentBatterMains": "Corrente di carica del generatore alla batteria",
  "param_set.xnl_inverter_Down Time": "Raffreddamento del generatore",
  "param_set.xnl_inverter_Grid Charge": "Ricarica di rete abilitata",
  "param_set.xnl_inverter_ChargeCurrentBatterMains": "Corrente di carica della batteria",
  "param_set.xnl_inverter_GenMainsPowerBattery": "Corrente di carica del generatore alla batteria",
  "param_set.xnl_inverter_DownTime": "Raffreddamento del generatore",
  "param_set.xnl_inverter_StartingCapacityPoint": "Punto di capacità di avvio della ricarica di rete",
  "param_set.xnl_inverter_MainsPowerBattery": "Corrente di carica della batteria",
  "param_set.xnl_inverter_Equalizationtime": "tempo di esecuzione della carica di equilibrio",
  "param_set.xnl_inverter_Parallel2": "Maestro",
  "param_set.xnl_inverter_Parallel3": "Fase",
  "param_set.xnl_inverter_Parallel4": "Modbus SN",
  "param_set.xnl_inverter_3P2": "Abilitazione trifase parallelo-A",
  "param_set.xnl_inverter_3P3": "Abilitazione trifase parallelo-B- fase",
  "param_set.xnl_inverter_3P4": "Abilitazione trifase parallelo-C",
  "param_set.xnl_inverter_GridGen11": "Carburante / Ricarica Abilita 1",
  "param_set.xnl_inverter_GridGen21": "Chaifa ricarica abilitare 2",
  "param_set.xnl_inverter_GridGen31": "Chaifa ricarica abilitare 3",
  "param_set.xnl_inverter_GridGen41": "Chaifa ricarica abilitare 4",
  "param_set.xnl_inverter_GridGen51": "Chaifa ricarica abilitare 5",
  "param_set.xnl_inverter_GridGen61": "Chaifa ricarica abilitare 6",
  "param_set.xnl_inverter_OnGridAlwayson04": "Attivare le condizioni della griglia - picco del generatore",
  "param_set.xnl_inverter_OnGridAlwayson08": "Attivare le condizioni della griglia: la rasatura dei picchi della griglia",
  "param_set.xnl_inverter_OnGridAlwayson12": "In condizioni di griglia - In griglia sempre attiva",
  "param_set.xnl_inverter_OnGridAlwayson13": "Attivare la condizione della griglia - relè esterno",
  "param_set.xnl_inverter_OnGridAlwayson14": "Accendere la condizione della griglia: la batteria al litio viene persa e viene segnalato il guasto. Abilita bit",
  "param_set.xnl_inverter_OnGridAlwayson15": "Attivare la condizione della griglia - bit di abilitazione DRM",
  "param_set.xnl_inverterGroup_BasicSettings": "Impostazioni Base",
  "param_set.xnl_inverterGroup_GridSettings": "Configurazione Rete",
  "param_set.xnl_inverterGroup_GeneratorSettings": "Impostazioni Generatore",
  "param_set.xnl_inverterGroup_BatterySettings": "Impostazioni Batteria",
  "param_set.xnl_inverterGroup_SystemOperatingMode": "Modalità Operativa Sistema",
  "param_set.xnl_inverterGroup_AdvancedSettings": "Impostazioni Avanzate",
  "param_set.xnl_inverter_GenSignal_fdj": "segnale del generatore",
  "param_set.xnl_inverter_GenSignal_charge": "segnale di rete",
  "param_set.xnl_inverter_GenSignal_fdj_1": "segnale del generatore1",
  "param_set.xnl_inverter_GenSignal_charge_1": "segnale di rete1",
  "param_set.xnl_inverter_GenSignal_fdj_2": "segnale del generatore2",
  "param_set.xnl_inverter_GenSignal_charge_2": "segnale di rete2",
  "param_set.xnl_inverter_TimeOfUse": "Time of Use",
  "param_set.xnl_inverter_GenPortUsedFor": "Porta del generatore utilizzata per",
  "bw_RTparam_name_InverterMasterSoftwareVersion": "Versione del software master dell'inverter",
  "bw_RTparam_name_TotalReactivePower_Grid": "Potenza reattiva totale (rete)",
  "bw_RTparam_name_TotalApparent Power_Grid": "Potenza apparente totale (griglia)",
  "bw_RTparam_name_TotalPowerFactor_Grid": "Fattore di potenza totale (griglia)",
  "bw_RTparam_name_BatteryRelayStatus": "Stato del relè della batteria",
  "bw_RTparam_name_BatWarnningPack": "Pacchetto di avvertimento pipistrello",
  "bw_RTparam_name_PvBoostTemperature": "Pv Boost Temperatura",
  "bw_RTparam_name_InvModuleTemperature": "Temperatura del modulo INV",
  "bw_RTparam_name_PowerBoardTemperature": "Temperatura della scheda di alimentazione",
  "bw_RTparam_name_InvApparentPower": "Inv Potenza apparente",
  "bw_RTparam_name_InvActivePower": "INV Potenza attiva",
  "bw_RTparam_name_InvReactivePower": "Potenza reattiva inv",
  "bw_RTparam_name_InvPowerFactor": "Inv Fattore di potenza",
  "bw_RTparam_name_BackupFrequency": "Frequenza di backup",
  "bw_RTparam_name_InvCurrentR": "Corrente inv R",
  "bw_RTparam_name_InvCurrentS": "Inv Corrente S",
  "bw_RTparam_name_InvCurrentT": "Inv Corrente T",
  "bw_RTparam_name_BatteryMaxChargePower": "Batteria Potere massimo della tassa",
  "bw_RTparam_name_BatteryMaxDischargePower": "Batteria Potere massimo di scarico",
  "bw_RTparam_name_TotalEnergyInvInput": "Input totale di energia inv",
  "bw_RTparam_name_BackupVoltageR": "Tensione di backup R",
  "bw_RTparam_name_BackupVoltageS": "Tensione di backup S",
  "bw_RTparam_name_BackupVoltageT": "Tensione di backup T",
  "bw_RTparam_name_BackupCurrentR": "Corrente di backup R",
  "bw_RTparam_name_BackupCurrentS": "Corrente di backup S",
  "bw_RTparam_name_BackupCurrentT": "Corrente di backup T",
  "bw_RTparam_name_BackupPower": "Alimentazione di backup",
  "common.50300.Ia": "Corrente di fase A",
  "common.50300.Pa": "Potenza attiva di fase A",
  "common.50300.Ib": "Corrente di fase B",
  "common.50300.Pb": "Potenza attiva di fase B",
  "common.50300.Ic": "Corrente di fase C",
  "common.50300.Pc": "Potenza attiva di fase C",
  "common.50300.ctTotalActivePower": "Gesamte Wirkleistung",
  "bw_value_ChargeDischargeRelaysAreDisconnected": "I relè di scarico della tassa sono scollegati",
  "bw_value_OnlyDischargeRelayIsClosed": "Solo il relè di scarica è chiuso",
  "bw_value_OnlyChargeRelayIsClosed": "Solo il relè di carica è chiuso",
  "bw_value_ChargeAndDischargeRelaysAreClosed": "I relè di carica e scarica sono chiusi",
  "bw_value_Single-Phase5KwModel": "Modello monofase 5Kw",
  "bw_value_SinglePhaseEnergyStorage5KwModel": "Stoccaggio di energia monofase modello 5Kw",
  "bw_value_Single-PhaseEnergyStorage3KwModel": "Stoccaggio di energia monofase modello 3Kw",
  "bw_value_Single-PhaseEnergyStorage6KwModel": "Stoccaggio di energia monofase modello 6Kw",
  "bw_value_SinglePhaseEnergyStorage8KwModel": "Stoccaggio di energia monofase modello 8Kw",
  "bw_value_Three-Phase4KwModel": "Modello trifase 4Kw",
  "bw_value_Three-Phase5KwModel": "Modello trifase 5Kw",
  "bw_value_Three-Phase6KwModel": "Modello trifase 6Kw",
  "bw_value_Three-Phase8KwModel": "Modello trifase 8Kw",
  "bw_value_ThreePhase10KwModel": "Modello trifase 10Kw",
  "bw_RTparam_name_TheSystemTotalPVEnergy": "Energia fotovoltaica totale del sistema (compresa l'energia del contatore fotovoltaico)",
  "bw_RTparam_name_GridFrequencyINV": "Frequenza della griglia (Form INV)",
  "device.category.heatpump": "pompa di calore",
  "jl_RTparam_name_powerAmmeter2": "Potenza del contatore 2",
  "jl_RTparam_name_dayEnergyAmmeter2": "Consumo elettrico giornaliero del contatore 2",
  "jl_RTparam_name_monthEnergyAmmeter2": "Consumo elettrico mensile del contatore 2",
  "jl_RTparam_name_yearEnergyAmmeter2": "Consumo elettrico annuale del contatore 2",
  "jl_RTparam_name_totalEnergyAmmeter2": "Consumo elettrico accumulato del contatore 2",
  "jl_RTparam_group_Ammeter": "Contatore elettrico",
  "ai.robot.manage.family": "Ciao, il robot AI sta gestendo il consumo di elettricità della tua casa.",
  "ai.robot.predicted.price": "Il prezzo dell'elettricità di oggi è stato ottenuto, si prevede una generazione di {###}kWh oggi.",
  "ai.robot.regulating.heat.pump": "Il funzionamento della pompa di calore sarà regolato in modo opportuno.",
  "bw_RTparam_name_PV_ActivePowerOfAPhase": "Potenza attiva di una fase (PV)",
  "bw_RTparam_name_PV_ActivePowerOfBPhase": "Potenza attiva della fase B (PV)",
  "bw_RTparam_name_PV_ActivePowerOfCPhase": "Potenza attiva della fase C (PV)",
  "bw_RTparam_name_PV_ApparentPowerOfAPhase": "Potenza apparente di una fase (PV)",
  "bw_RTparam_name_PV_ApparentPowerOfBPhase": "Potenza apparente della fase B (PV)",
  "bw_RTparam_name_PV_ApparentPowerOfCPhase": "Potenza apparente della fase C (PV)",
  "bw_RTparam_name_PV_ReactivePowerOfAPhase": "Potenza reattiva di una fase (PV)",
  "bw_RTparam_name_PV_ReactivePowerOfBPhase": "Potenza reattiva della fase B (PV)",
  "bw_RTparam_name_PV_ReactivePowerOfCPhase": "Potenza reattiva della fase C (PV)",
  "bw_RTparam_name_PV_PowerFactorOfAPhase": "Fattore di potenza di una fase (PV)",
  "bw_RTparam_name_PV_PowerFactorOfBPhase": "Fattore di potenza della fase B (PV)",
  "bw_RTparam_name_PV_PowerFactorOfCPhase": "Fattore di potenza della fase C (PV)",
  "bw_RTparam_name_PvConnectState": "Stato di connessione PV",
  "bw_RTparam_name_PVMeterNegate": "Direzione di accesso del misuratore fotovoltaico",
  "bw_RTparam_Option_NoPV": "Nessun PV",
  "bw_RTparam_Option_HasPV": "Ha PV",
  "bw_RTparam_Option_PVMeterNormal": "Misuratore di PV normale",
  "bw_RTparam_Option_PVMeterReversed": "Misuratore di PV invertito",
  "bw_RTparam_name_TotalPVEnergy_includePVMeter": "Totale generazione fotovoltaica (all'interno + all'esterno INV)",
  "bw_RTparam_name_TodayYield": "All'interno INV Generazione fotovoltaica giornaliera",
  "bw_RTparam_name_TotalDevicePower": "Potenza fotovoltaica totale",
  "bw_RTparam_name_DailyDeviceEnergy": "Totale generazione giornaliera fotovoltaica",
  "device.category.module": "Componente",
  "bw_RTparam_name_TotalEnergyInvOutput": "Energia totale di uscita INV=",
  "50000_0X561-M-12": "La fase di griglia è incoerente",
  "50000_0X561-M-13": "DCV campione anormale",
  "50000_0X561-M-14": "Scatola nera Flash Fault",
  "50000_0X561-M-15": "Errore RTC",
  "bw.content.alarm.0X55E-M-60": "La fase di griglia è incoerente",
  "bw.content.alarm.0X55E-M-61": "DCV campione anormale",
  "bw.content.alarm.0X55E-M-62": "Scatola nera Flash Fault",
  "bw.content.alarm.0X55E-M-63": "Errore RTC",
  "plant.deliver.type.zj": "Haier Smart Home",
  "deliver.type.energy": "Haier Energy",
  "deliver.type.smart": "Haier Smart Home",
  "VDE0126-50Hz": "France--VDE0126-50Hz",
  "VDE4105/11.18": "Germany--VDE4105/11.18",
  "AS4777.2": "Australia--AS4777.2",
  "G83_2": "G83_2",
  "C10/C11": "Belgium--C10/C11",
  "TOR Erzeuger": "Austria--TOR Erzeuger",
  "EN50549-NL": "Netherlands--EN50549-NL",
  "EN50549-DK": "EN50549-DK",
  "CEB": "CEB",
  "CEI-021": "Italy--CEI-021",
  "NRS097-2-1": "South Africa--NRS097-2-1",
  "EN50549-GR": "EN50549-GR",
  "UTE_C15_712": "UTE_C15_712",
  "IEC61727": "IEC61727",
  "G59_3": "G59_3",
  "RD1699": "Spain--RD1699",
  "G99": "UK--G99",
  "NA": "NA",
  "VDE0126-60Hz": "VDE0126-60Hz",
  "AS4777.2-SA": "Australia--AS4777.2-SA",
  "G98": "UK--G98",
  "EN50549-CZ": "EN50549-CZ",
  "PEA": "Thailand--PEA",
  "MEA": "Thailand--MEA",
  "BISI": "BISI",
  "JET-GR Series": "JET-GR Series",
  "50Hz Default": "50Hz Default",
  "60Hz Default": "60Hz Default",
  "WAREHOUSE": "WAREHOUSE",
  "AS4777.2-NZ": "Australia--AS4777.2-NZ",
  "Korea": "Korea",
  "G98/G99-IE": "UK--G98/G99-IE",
  "NCRfg": "NCRfg",
  "UL1741": "UL1741",
  "UL1741-Rule21": "UL1741-Rule21",
  "UL1741-Hawaiian": "UL1741-Hawaiian",
  "EN50549": "EU--EN50549",
  "common.50800.defrosting": "sbrinamento",
  "common.50800.antiFreezing": "anticongelamento",
  "common.50800.sterilization": "sterilizzazione",
  "common.50800.antiRust": "antiruggine",
  "common.50800.auto": "automatico",
  "common.50800.cool": "raffreddamento",
  "common.50800.heat": "riscaldamento",
  "common.50800.dhw": "acqua calda sanitaria",
  "common.50800.pool": "piscina",
  "common.50800.heat+pool": "riscaldamento + piscina",
  "common.50800.auto+dhw": "automatico + acqua calda",
  "common.50800.cool+dhw": "raffreddamento + acqua calda",
  "common.50800.heat+dhw": "riscaldamento + acqua calda",
  "person.confirmPassword": "Conferma password",
  "supplier.type.lg": "LIGOO",
  "plant.not.delivered": "La centrale elettrica non è stata consegnata",
  "plant.not.exist": "La centrale elettrica non esiste",
  "device.agent.admin.can.operate": "Non hai il permesso di ritirare la consegna",
  "plant.pure.light": "Casa a zero emissioni - Solo fotovoltaico",
  "ywt.60419.meterTPower\n": "Leistung des Stromzählers Phase T",
  "ywt.60419.loadPower\n": "Lastleistung",
  "param_set.lg_inverterGroup_LithiumBattery": "Batteriaallitio",
  "param_set.lg_inverterGroup_AdvancedSettings": "Impostazioniavanzate",
  "param_set.lg_inverterGroup_SystemOperationMode": "Modalitàdifunzionamentodelsistema",
  "param_set.lg_inverterGroup_GeneratorSettings": "Impostazionigeneratore",
  "param_set.lg_inverterGroup_ParallelOperationSettings": "Impostazioniunitàparallele",
  "param_set.lg_inverterGroup_PeakShavingandValleyFillingSettings": "Impostazionilivellamentocarico",
  "param_set.lg_inverterGroup_GeneratorInputEnable": "Abilitazioneingressogeneratore",
  "param_set.lg_inverterGroup_SmartLoadEnable": "Abilitazionecaricointelligente",
  "param_set.lg_inverterGroup_MicroinverterEnable": "Abilitazionemicroinverter",
  "param_set.lg_inverterGroup_Battery(Shared)": "Batteria(condivisa)",
  "param_set.lg_inverterGroup_Lead-AcidBattery": "Batteriaalpiombo",
  "param_set.lg_inverter_SystemOn": "Accensione/spegnimentosistema",
  "param_set.lg_inverter_ClearFault": "Cancellaguasti",
  "param_set.lg_inverter_ManualActivation": "Attivazionemanuale",
  "param_set.lg_inverter_InverterRated（%）": "Impostazionepercentualepotenzainverter",
  "param_set.lg_inverter_PVActivePowerSetting": "ImpostazionepotenzaattivaPV(%)",
  "param_set.lg_inverter_PVConnectorMode": "ImpostazioniconnessionePV",
  "param_set.lg_inverter_PVStarupEnable": "AbilitazioneavvioPVsingolo",
  "param_set.lg_inverter_ZeroGroundVoltFaultDetectionEnable": "Abilitazionerilevamentoguastotensioneneutro-terra",
  "param_set.lg_inverter_GFCIEnable": "Abilitazionerilevamentocorrentedidispersione",
  "param_set.lg_inverter_AllowGridCharging": "Consenticaricadallarete",
  "param_set.lg_inverter_PVISOEnable": "AbilitazionerilevamentoisolamentoPV",
  "param_set.lg_inverter_CT/MeterOptional": "BitabilitazionecontatoreCT",
  "param_set.lg_inverter_PhaseType": "Tiposequenzafasi",
  "param_set.lg_inverter_CTRatio": "RapportoCT",
  "param_set.lg_inverter_PVOperationMode": "ModalitàfunzionamentoPV",
  "param_set.lg_inverter_CVT1CurrentLimit": "LimitecorrenteCVT1",
  "param_set.lg_inverter_CVT2CurrentLimit": "LimitecorrenteCVT2",
  "param_set.lg_inverter_ChargingCurrent": "Correntedicarica",
  "param_set.lg_inverter_DischargingCurrent": "Correntediscarica",
  "param_set.lg_inverter_FloatChargingVoltage": "Tensionedimantenimento",
  "param_set.lg_inverter_EqualChargingVoltage": "Tensionediequalizzazione",
  "param_set.lg_inverter_CT/MeterAccessDirection": "DirezioneconnessioneCT/contatore",
  "param_set.lg_inverter_HomeloadUnbalancedCurrentEnable": "Abilitazionesquilibriocaricodomestico",
  "param_set.lg_inverter_BMSClearFault": "CancellazioneguastiBMS",
  "param_set.lg_inverter_AFCIReset": "ResetAFCI",
  "param_set.lg_inverter_HMIBrightness": "LuminositàHMI",
  "param_set.lg_inverter_HMIRestTime": "TempospegnimentoschermoHMI",
  "param_set.lg_inverter_StatisticClear": "Cancellastatistiche",
  "param_set.lg_inverter_EnergyPattern": "Modalitàgestioneenergia",
  "param_set.lg_inverter_SyncTimeEnable": "Abilitazionesincronizzazionetemporale",
  "param_set.lg_inverter_RSDEnable": "AbilitazioneRSD",
  "param_set.lg_inverter_Startuptimesetbytheinstaller": "Oradiavvioimpostatadainstallatore",
  "param_set.lg_inverter_DynamicPassword": "Passworddinamica",
  "param_set.lg_inverter_ACType": "TipoAC",
  "param_set.lg_inverter_ChargingPriorityMode": "Modalitàprioritàdicarica",
  "param_set.lg_inverter_SellPowerLimit": "Limitapotenzamassimaimmissioneinrete",
  "param_set.lg_inverter_BuzzerEnable": "Cicalino",
  "param_set.lg_inverter_MeterType": "Tipocontatore",
  "param_set.lg_inverter_Specialfeatures": "Funzionispeciali",
  "param_set.lg_inverter_NLineNotGrounded": "Neutrononmessoaterra",
  "param_set.lg_inverter_AFCIEnable": "Abilitazionerilevamentoarco",
  "param_set.lg_inverter_FactoryReset": "Ripristinaimpostazionidifabbrica",
  "param_set.lg_inverter_AsymmetricPhaseFeeding": "Alimentazionefaseasimmetrica",
  "param_set.lg_inverter_ParamsChangeLock": "Bloccomodificaparametri",
  "param_set.lg_inverter_SystemWorkMode": "Modalitàdifunzionamentodelsistema",
  "param_set.lg_inverter_SolarSell": "Venditaenergiafotovoltaica",
  "param_set.lg_inverter_SignalIslandMode": "Ingressosegnaleoff-grid",
  "param_set.lg_inverter_GridTOUEnable": "Abilitazionefasciaorariapiccorete",
  "param_set.lg_inverter_AutoRunEnable": "Abilitazionefunzionamentoautomatico",
  "param_set.lg_inverter_DRMEnable": "AbilitazioneDRM",
  "param_set.lg_inverter_Password": "Passwordpredefinita",
  "param_set.lg_inverter_PasswordValidityTime": "Tempovaliditàpassword",
  "param_set.lg_inverter_GeneratorStartMode": "Modalitàavviogeneratore",
  "param_set.lg_inverter_GeneratorManualStartMode": "Avviomanualegeneratore",
  "param_set.lg_inverter_Generatorpriority": "Prioritàgeneratore",
  "param_set.lg_inverter_GeneratorInputPort": "Portaingressogeneratore",
  "param_set.lg_inverter_GeneratorPower": "Potenzageneratore",
  "param_set.lg_inverter_GeneratorStartupVoltage": "Tensioneaccensionegeneratore",
  "param_set.lg_inverter_GeneratorShutdownVoltage": "Tensionespegnimentogeneratore",
  "param_set.lg_inverter_GeneratorStartupSOC": "SOCavviogeneratore",
  "param_set.lg_inverter_GeneratorShutdownSOC": "SOCfinegeneratore(modalitàavvioautomatico)",
  "param_set.lg_inverter_GeneratorStartSignal": "Segnaleavviogeneratore",
  "param_set.lg_inverter_GeneratorChargeCurrent": "Correntecaricageneratore",
  "param_set.lg_inverter_GeneratorOperatingTimeLimit": "Tempomassimofunzionamentogeneratore",
  "param_set.lg_inverter_GeneratorCutOffTime": "Oradisattivazionegeneratore",
  "param_set.lg_inverter_GeneratorTOUEnable": "Abilitazionepiccodicaricageneratore",
  "param_set.lg_inverter_ParallelEnable": "Abilitazionefunzionamentoparallelo",
  "param_set.lg_inverter_ParallelAddress": "Indirizzounitàparallele",
  "param_set.lg_inverter_ParallelNumber": "Numerodiunitàparallele",
  "param_set.lg_inverter_ParallelBatterySharingEnable": "Abilitazionecondivisionebatteriaparallela",
  "param_set.lg_inverter_ParallelPhase": "Sequenzafasiunitàparallele",
  "param_set.lg_inverter_ParallelMode": "Modalitàparallelo",
  "param_set.lg_inverter_Year/Month": "Anno/Mese",
  "param_set.lg_inverter_Day/Reserve": "Giorno/Riservato",
  "param_set.lg_inverter_Hour/Minute": "Ora/Minuto",
  "param_set.lg_inverter_Second/Week": "Secondo/Settimana",
  "param_set.lg_inverter_TOUStartTime1": "Orainiziocarica/scarica1(livellamento)",
  "param_set.lg_inverter_TOUEndTime1": "Orafinecarica/scarica1(livellamento)",
  "param_set.lg_inverter_Time1TOUPower": "Potenzacarica/scaricareteTempo1",
  "param_set.lg_inverter_TOUStartTime2": "Orainiziocarica/scarica2(livellamento)",
  "param_set.lg_inverter_TOUEndTime2": "Orafinecarica/scarica2(livellamento)",
  "param_set.lg_inverter_Time2TOUPower": "Potenzacarica/scaricareteTempo2",
  "param_set.lg_inverter_TOUStartTime3": "Orainiziocarica/scarica3(livellamento)",
  "param_set.lg_inverter_TOUEndTime3": "Orafinecarica/scarica3(livellamento)",
  "param_set.lg_inverter_Time3TOUPower": "Potenzacarica/scaricareteTempo3",
  "param_set.lg_inverter_TOUStartTime4": "Orainiziocarica/scarica4(livellamento)",
  "param_set.lg_inverter_TOUEndTime4": "Orafinecarica/scarica4(livellamento)",
  "param_set.lg_inverter_Time4TOUPower": "Potenzacarica/scaricareteTempo4",
  "param_set.lg_inverter_TOUStartTime5": "Orainiziocarica/scarica5(livellamento)",
  "param_set.lg_inverter_TOUEndTime5": "Orafinecarica/scarica5(livellamento)",
  "param_set.lg_inverter_Time5TOUPower": "Potenzacarica/scaricareteTempo5",
  "param_set.lg_inverter_TOUStartTime6": "Orainiziocarica/scarica6(livellamento)",
  "param_set.lg_inverter_TOUEndTime6": "Orafinecarica/scarica6(livellamento)",
  "param_set.lg_inverter_Time6TOUPower": "Potenzacarica/scaricareteTempo5",
  "param_set.lg_inverter_Time1TOUSOC": "SOCbatteriapiccoTempo1",
  "param_set.lg_inverter_Time2TOUSOC": "SOCbatteriapiccoTempo2",
  "param_set.lg_inverter_Time3TOUSOC": "SOCbatteriapiccoTempo3",
  "param_set.lg_inverter_Time4TOUSOC": "SOCbatteriapiccoTempo4",
  "param_set.lg_inverter_Time5TOUSOC": "SOCbatteriapiccoTempo5",
  "param_set.lg_inverter_Time6TOUSOC": "SOCbatteriapiccoTempo6",
  "param_set.lg_inverter_Time1TOUVoltage": "TensionepiccoTempo1",
  "param_set.lg_inverter_Time2TOUVoltage": "TensionepiccoTempo2",
  "param_set.lg_inverter_Time3TOUVoltage": "TensionepiccoTempo3",
  "param_set.lg_inverter_Time4TOUVoltage": "TensionepiccoTempo4",
  "param_set.lg_inverter_Time5TOUVoltage": "TensionepiccoTempo5",
  "param_set.lg_inverter_Time6TOUVoltage": "TensionepiccoTempo6",
  "param_set.lg_inverter_TOUWeek": "Parametrisettimanalipiccodicarica",
  "param_set.lg_inverter_GENTOUEnable": "Abilitazionefasciaorariapiccogeneratore",
  "param_set.lg_inverter_SmartLoadSetting": "ImpostazioniSmartLoad",
  "param_set.lg_inverter_SmartLoadStopVoltage": "Tensionespegnimentocaricointelligente",
  "param_set.lg_inverter_GeneratorLinktoInput": "Generatorecollegatoall'ingressorete",
  "param_set.lg_inverter_MicroINVLinkLoad": "Microinvertercollegatolatocarico",
  "param_set.lg_inverter_MicroINVLinkGrid": "Microinvertercollegatolatorete",
  "param_set.lg_inverter_SolarPower": "Potenzasolare",
  "param_set.lg_inverter_GridAlwaysOn": "Retesempreaccesa",
  "param_set.lg_inverter_OffGridDisconnection": "Disconnessioneimmediataoff-grid",
  "param_set.lg_inverter_SmartLoadONSOC": "SOCavviocaricointelligente",
  "param_set.lg_inverter_SmartLoadOFFSOC": "SOCspegnimentocaricointelligente",
  "param_set.lg_inverter_ACCoupleFreqUpperLimit": "ImpostazionelimitefrequenzaACCouple",
  "param_set.lg_inverter_MicroINVOutputtoGrid": "Interruzioneuscitamicroinverterversorete",
  "param_set.lg_inverter_MicroINVOFFSOC": "SOCspegnimentomicroinverter",
  "param_set.lg_inverter_MicroINVONSOC": "SOCavviomicroinverter",
  "param_set.lg_inverter_SmartLoadStartVoltage": "Tensioneaccensionecaricointelligente",
  "param_set.lg_inverter_SmartLoadDuration": "Duratacaricointelligente",
  "param_set.lg_inverter_SmartLoadStartTime": "Orainiziocaricointelligente",
  "param_set.lg_inverter_SmartLoadEndTime": "Orafinecaricointelligente",
  "param_set.lg_inverter_BatteryType": "Tipobatteria",
  "param_set.lg_inverter_BatteryInputMode": "Modalitàconnessionebatteria",
  "param_set.lg_inverter_BatteryFailureShutdown": "Arrestoperguastocomunicazionebatteria",
  "param_set.lg_inverter_GridChargeEnable": "Abilitazionecaricadarete",
  "param_set.lg_inverter_GridSignal": "Segnaledirete",
  "param_set.lg_inverter_GridChargeCurrent": "Correntecaricadarete",
  "param_set.lg_inverter_GridStartupSOC": "SOCavviorete",
  "param_set.lg_inverter_BatteryLowCostMode": "Modalitàbassoconsumobatteria",
  "param_set.lg_inverter_LowNoiseMode": "Modalitàsilenziosabatteria",
  "param_set.lg_inverter_StrongchargeSOC": "PuntoSOCcaricaforzata",
  "param_set.lg_inverter_StrongchargeStopSOC": "PuntoSOCfinecaricaforzata",
  "param_set.lg_inverter_StrongchargeSOCEN": "AbilitazioneSOCcaricaforzata",
  "param_set.lg_inverter_LithiumBatteryManufacturers": "Produttorebatteriaallitio",
  "param_set.lg_inverter_ChargingVoltage": "Tensionedicarica",
  "param_set.lg_inverter_ChargingCurrentLimit": "Correntedicaricamassima",
  "param_set.lg_inverter_DischargingCurrentLimit": "Correntediscaricamassima",
  "param_set.lg_inverter_DischargingShutdownVoltage": "Puntodifinescaricatensionebatteria",
  "param_set.lg_inverter_BatteryLowVoltage": "Puntotensionescaricabassabatteria",
  "param_set.lg_inverter_DischargingShutdownSOC": "SOCfinescaricabatteria",
  "param_set.lg_inverter_ChargingEndSOC": "SOCfinecaricabatteria",
  "param_set.lg_inverter_BatteryLowSOC": "SOCbatteriascarica",
  "param_set.lg_inverter_BatteryRestartSOC": "SOCriavviobatteria",
  "param_set.lg_inverter_AutoForced-chargeEnable": "Abilitazionecaricaforzataautomatica",
  "param_set.lg_inverter_AutoActivationEnable": "Abilitazioneattivazioneautomaticabatteria",
  "param_set.lg_inverter_BatteryTriggerVoltage": "Tensioneattivazionebatteria",
  "param_set.lg_inverter_BatteryTriggerTime": "Durataattivazionebatteria",
  "param_set.lg_inverter_DisableFloatCharge": "Disabilitacaricadimantenimento",
  "param_set.lg_inverter_CV-CCChargingTime": "TempotransizioneCVaCC",
  "param_set.lg_inverter_CC-CVChargingTime": "TempotransizioneCCaCV",
  "param_set.lg_inverter_CC-FCChargingTime": "Tempotransizioneequalizzazioneamantenimento",
  "param_set.lg_inverter_LeadAcidOvervolt": "Puntosovratensionepiombo-acido",
  "param_set.lg_inverter_LeadAcidBatteryType": "Tipobatteriaalpiombo",
  "param_set.lg_inverter_BatteryRatedCapacity": "Capacitànominalebatteria",
  "param_set.lg_inverter_BatteryOverTempVoltage": "Puntoprotezionesovratemperaturabatteria",
  "param_set.lg_inverter_TempCompensationFactor": "Coefficientecompensazionetemperaturabatteria",
  "param_set.lg_inverter_BatteryRestartVoltage": "Puntotensionerecuperobatteria",
  "param_set.lg_inverter_EC-FCChargeCurrent": "Correntecaricatransizioneequalizzazioneamantenimento",
  "param_set.lg_inverter_FC-ECChargeCurrent": "Correntecaricatransizionemantenimentoaequalizzazione",
  "param_set.lg_inverter_CCChargingTimeLimit": "Tempomassimoequalizzazioneacorrentecostante",
  "param_set.lg_inverter_CVChargingTimeLimit": "Tempomassimoequalizzazioneatensionecostante",
  "status.enable": "abilitare",
  "status.disable": "disabilitare",
  "end.app": "app",
  "end.backend": "backend",
  "module.product_management": "Gestione Prodotto",
  "module.plant_management": "Gestione Impianto",
  "module.shipment_management": "Gestione Spedizioni",
  "module.device_management": "Gestione Dispositivi",
  "module.device_detail": "Dettaglio Dispositivo",
  "module.org_management": "Gestione Organizzazione",
  "module.login_register": "Accesso Registrazione",
  "module.user_management": "Gestione Utenti",
  "module.family_management": "Gestione Famiglia",
  "module.physical_model": "Modello Fisico",
  "module.dictionary_value": "Valore Dizionario",
  "param.name.dongle.reset.returnTip": "Dongle ripristinato con successo. Per favore, riconnettilo.",
  "bw_RTparam_name_AFCI_Version": "Numero di versione AFCI",
  "bw_RTparam_name_BB_Version": "Backup Box Version Number",
  "test.code": "",
  "test.code1": "",
  "test.code3": "",
  "test.code.222": "",
  "dict.sttaus.not.normal": "yi",
  "dict.status.normal": "yi",
  "rr": "2",
  "dict..status.not.normal": "yi",
  "org.keyFilter": "Inserisci una parola chiave per filtrare",
  "dict.status.not.normal": "yi-normal",
  "test": "",
  "role.status.abnormal": "Anomalia",
  "filter.all.blank.null": "Tutte le versioni di traduzione sono vuote.",
  "shipment.confirmDownload": "Scarica elenco",
  "shipment.updateCustomer": "Aggiorna cliente di spedizione",
  "shipment.invalidEquipmentList": "Vuoi scaricare l'elenco dei dispositivi non validati? (Valido per 10 minuti) Numero di dispositivi non validi:",
  "plant.smart.investment": "Investimento intelligente zero carbonio",
  "module.oversea": "Gestione dei ticket",
  "published": "pubblicato",
  "income.unit.cny.pkr": "PKR",
  "alarmInfo.time": "Orario di allarme",
  "alarmInfo.duration": "Durata dell'allarme",
  "alarmInfo.level": "Livello di allarme",
  "alarmInfo.triggerCondition": "Condizioni di scateno",
  "alarmInfo.reason": "Cause di allarme",
  "alarmInfo.handleTime": "Tempo di elaborazione",
  "alarmInfo.handleType": "Tipo di elaborazione",
  "common.maintain": "Per favore mantieni prima",
  "device.robotChannel": "robot",
  "device.communicationChannel": "bastone di comunicazione",
  "device.channelType": "canale di comunicazione",
  "device.switchChannelFailed": "Impossibile cambiare canale di comunicazione",
  "test.chuneng": "chuneng",
  "Manual": "Manuale",
  "System": "Sistema",
  "Processed": "Elaborato",
  "Critical": "Critico",
  "Urgent": "Urgente",
  "Severe": "Grave",
  "General": "Generale",
  "Reminder": "Promemoria",
  "common.cropper": "Ritaglio dell'immagine",
  "common.confirmCropper": "Conferma il ritaglio",
  "welcome": "",
  "device.operatingDataInfoTip": "Nota: se questo campo è vuoto, contatta l’amministratore della piattaforma IoT per la configurazione.",
  "dynamic.price.not.exist": "Impossibile ottenere il prezzo elettrico dinamico",
  "product.pleaseUploadAtLeastOneImage": "Si prega di caricare almeno un'immagine.",
  "device.importTemplateDownload": "Scarica modello di importazione",
  "device.snNumber": "Numero SN",
  "device.enterSnCode": "Inserisci il codice SN",
  "device.enterSupplierSN": "Inserisci la SN del fornitore",
  "device.deviceModelLabel": "Modello del dispositivo",
  "device.importTip": "Importa il codice impianto, nome dispositivo, numero SN e codice MDM corrispondenti",
  "device.importTip2": "Importa il nome dispositivo, numero SN e codice MDM corrispondenti",
  "device.keepAtLeastOneRow": "Mantieni almeno una riga",
  "device.importSuccessWithCount": "Importati con successo {count} record di dispositivi",
  "device.fillAllRequiredFields": "Completa tutti i campi obbligatori",
  "device.enterPlantCode": "Inserisci il codice impianto",
  "device.plantCodeLabel": "Codice impianto",
  "device.supplierSNLabel": "SN del fornitore",
  "device.importTemplateEmpty": "Il modello di importazione è vuoto",
  "plant.plantCategory": "Tipo di centrale elettrica",
  "plant.plantCode": "Codice centrale elettrica",
  "plant.energyStorageCapacity": "Capacità di stoccaggio",
  "plant.energyStoragePower": "Potenza di accumulo energetico",
  "plant.gridConnectionMode": "Modalità di accesso a Internet",
  "plant.img": "Immagini della centrale elettrica",
  "device.realTimeMonitoring": "Monitoraggio in tempo reale",
  "device.propertyName": "Nome della proprietà",
  "device.issueCommand": "Invia",
  "device.history": "Storia",
  "device.properName": "Nome",
  "device.daterange": "personalizzato",
  "device.near24h": "Quasi 24 ore",
  "device.date": "Oggi",
  "device.near3d": "Quasi 3 giorni",
  "device.chartModule": "Modulo grafico",
  "device.lineChart": "Diagramma di curve",
  "device.barChart": "Diagramma a colonne",
  "device.dateRangeDayError": "L'intervallo di data deve essere entro {scope} giorni",
  "device.SOCHistoryData": "Dati storici",
  "device.paramSave": "Parametri",
  "common.deleteTip": "Confirmare la rimozione di {scope}?",
  "product.deleteConfirm": "Sei sicuro di voler eliminare il prodotto {productName}?",
  "upgrade.upgradeSN": "Aggiornamento SN",
  "upgrade.datalogSN": "Registro dati SN",
  "upgrade.upgradeType": "Tipo di aggiornamento",
  "upgrade.fileAddress": "Indirizzo del file",
  "upgrade.plantTime": "Orario della centrale elettrica",
  "upgrade.timeUTC8": "Ora (UTC+8)",
  "upgrade.timeServer": "Orario (server)",
  "upgrade.content": "Contenuto",
  "upgrade.account": "Numero di account",
  "upgrade.devicesSN": "attrezzature SN",
  "firmware.secretType": "Tipo segreto",
  "product.ratedPowerOnTheACSide": "Potenza nominale lato CA (kW)",
  "product.ratedPowerOnTheDCSide": "Potenza nominale lato CC (kW)",
  "product.energyStoragePower": "Potenza di accumulo di energia (kW)",
  "product.energyStorageCapacity": "Capacità di accumulo di energia (kWh)",
  "iot.device.register.failed": "Registrazione del dispositivo IoT non riuscita",
  "common.title": "Impostazioni visualizzazione colonne",
  "common.fixedLeft": "Fissato a sinistra",
  "common.fixedRight": "Fissato a destra",
  "common.notFixed": "Non fissato",
  "common.unfix": "Sblocca",
  "common.resetSuccess": "Impostazioni colonne reimpostate",
  "alarmInfo.exceptionDesc": "Descrizione eccezione",
  "alarmInfo.suggestion": "Suggerimento di gestione",
  "language.syncIot": "Sincronizza allarme IoT",
  "language.syncSuccess": "Sincronizzazione configurazione allarme IoT Qingluo riuscita",
  "plant.saveTimezoneTip": "La modifica del fuso orario può causare:\nInterruzioni o sovrapposizioni nei grafici dei dati del dispositivo (della durata di diverse ore)\nLe attività locali del dispositivo potrebbero andare in disordine e potrebbero verificarsi brevi periodi di offline",
  "plant.deviceCount": "Numero di dispositivi installati",
  "common.rangeErrorTip": "Errore di intervallo {scope}, si prega di confermare",
  "expired": "scaduto",
  "due.today": "due oggi",
  "sidebar.bulletinBoard": "Installazione",
  "sidebar.dataQuery": "Query dati",
  "plant.electrovalence": "Configurazione Tariffa",
  "plant.energy_management": "Gestione dell'Energia",
  "plant.energy_todayStrategy": "Strategia di Oggi",
  "plant.energy_PeakShavingAndValleyFilling": "Riduzione dei Picchi & Riempimento delle Valli",
  "plant.energy_ValidTime": "Orario Valido",
  "plant.energy_Charging": "Ricarica",
  "plant.energy_Discharging": "Scarica",
  "plant.energy_SelectStartTime": "Seleziona Ora di Inizio",
  "plant.energy_StrategyName": "Nome Strategia",
  "plant.energy_StrategyType": "Tipo di Strategia",
  "plant.energy_Status": "Stato",
  "plant.energy_No": "N.",
  "plant.energy_StartDate": "Data di Inizio",
  "plant.energy_EndDate": "Data di Fine",
  "plant.energy_AddStrategy": "Aggiungi Strategia",
  "plant.energy_EffectiveTime": "Ora di Efficacia",
  "plant.energy_SelectStrategy": "Seleziona Strategia",
  "plant.energy_SelectCorrespondingStrategy": "Seleziona la Strategia Corrispondente",
  "plant.energy_ConfirmAndDeploy": "Conferma e Distribuisci",
  "plant.energy_PleaseConfirmSaveAndDeployTheStrategy": "Conferma, salva e distribuisci la strategia.",
  "plant.energy_Cancel": "Annulla",
  "plant.energy_PleaseConfirmStrategyDeletion": "Conferma eliminazione strategia.",
  "plant.energy_IfNoOtherStrategyExistsExecuteManualStrategy": "Se non esiste alcun'altra strategia, esegui la strategia manuale.",
  "plant.energy_PriorityChargingTime": "Orario di Ricarica Prioritaria",
  "plant.energy_PriorityDischargingTime": "Orario di Scarica Prioritaria",
  "plant.energy_PVConsumptionPeriod": "Periodo di Consumo FV",
  "plant.energy_StartTime": "Ora di Inizio",
  "plant.energy_EndTime": "Ora di Fine",
  "plant.energy_ChargingPower": "Potenza di Ricarica",
  "plant.energy_DischargingPower": "Potenza di Scarica",
  "plant.energy_SOCUpperLimit": "Limite Superiore SOC",
  "plant.energy_SOCLowerLimit": "Limite Inferiore SOC",
  "plant.energy_Action": "Azione",
  "plant.energy_AddTimePeriod": "Aggiungi Intervallo",
  "plant.energy_ChargingStatus": "Stato di Ricarica",
  "plant.energy_DischargingPower_kW": "Potenza di Scarica (kW)",
  "plant.energy_copyStrategy": "Copia Strategia",
  "plant.energy_examine": "Visualizza",
  "plant.energy_delete": "Elimina",
  "plant.energy_edit": "Modifica",
  "plant.energy_basicInfo": "Informazioni Base",
  "plant.energy_PriorityChargingDischargingTime": "Orario di Ricarica e Scarica Prioritaria",
  "plant.energy_PeakShavingAtLeastOne": "Mantieni almeno una voce.",
  "plant.energy_overlapTime": "Non sovrapporre gli intervalli temporali.",
  "plant.energy_cover24hour": "Gli intervalli devono coprire 24 ore.",
  "plant.energy_PleaseConfirmStrategyModification": "Conferma la modifica della strategia.",
  "plant.energy_Strategy": "Strategia",
  "plant.energy_cutOff_SOC": "SOC di arresto",
  "plant.energy_EditStrategy": "Modifica strategia",
  "plant.energy_ExamineStrategy": "Visualizza strategia",
  "plant.energy_photovoltaic_storage_peak_valley_explain1": "1) Periodo di Ricarica Prioritaria: Ricarica la batteria utilizzando l‘eccedenza di energia FV e l’elettricità della rete (ore non di punta) per raggiungere il valore SOC impostato; la batteria non si scarica.",
  "plant.energy_photovoltaic_storage_peak_valley_explain2": "2) Periodo di Scarica Prioritaria: L‘eccedenza FV ricarica la batteria. Quando l’energia FV è insufficiente, la batteria si scarica per prima, fino al limite SOC impostato; l‘alimentazione di rete è secondaria.",
  "plant.energy_photovoltaic_storage_peak_valley_explain3": "3) Periodo di Consumo FV: L‘energia FV è usata prioritariamente per il carico, poi per ricaricare la batteria (fino al limite superiore SOC), infine, l’eccedenza è limitata o immessa in rete. Se l‘energia FV è insufficiente, la batteria si scarica per prima (fino al limite inferiore SOC), seguita dall’alimentazione di rete.",
  "plant.energy_photovoltaic_storage_peak_valley_explain4": "4) Altri periodi: L‘energia FV è usata prioritariamente per il carico, poi per ricaricare la batteria (fino al limite superiore SOC), infine, l’eccedenza è limitata o immessa in rete. La batteria non si scarica.",
  "plant.energy_peak_shaving_valley_filling_explain": "Una strategia che programma la carica/scarica della batteria per ridurre il carico di punta e soddisfare la domanda delle ore non di punta, al fine di ottenere un utilizzo bilanciato delle risorse.",
  "plant.energy_photovoltaic_consumption_self_consumption_explain": "L‘energia FV è usata prioritariamente per il carico, poi consumata dalla batteria, e infine, la produzione FV è limitata per garantire nessun reimmissione. Se l’energia FV è insufficiente, la batteria si scarica per prima, seguita dall‘alimentazione di rete.",
  "plant.energy_photovoltaic_consumptionsurplus_power_grid_feed_in_explain": "L‘energia FV è usata prioritariamente per il carico, poi consumata dalla batteria, e infine, l’eccedenza è immessa in rete. Se l‘energia FV è insufficiente, la batteria si scarica per prima, seguita dall’alimentazione di rete.",
  "plant.energy_smart_strategy_station_profit_priority_explain": "Integra obiettivi multidimensionali come tariffe orarie, consumo FV, arbitraggio picco-valle, previsione FV e carico e gestione della domanda. Nella premessa di garantire un funzionamento stabile della microrete, un robot AI calcola e risolve in modo intelligente la pianificazione ottimale per l’accumulo di energia e i carichi regolabili, massimizzando così i ricavi complessivi del sito.",
  "plant.energy_manual_mode_explain": "Attualmente non c‘è una strategia di dispatch per il FV e l’accumulo. Si prega di andare alla pagina del dispositivo per l‘operazione manuale.",
  "plant.energy_SOCUpperLowerLimits": "Limiti Superiore e Inferiore del SOC",
  "plant.energy_ChargeDischargePower": "Potenza di Ricarica e Scarica",
  "plant.energy_ChargeDischargeStatus": "Stato di Ricarica e Scarica",
  "system.physicalModels": "Gestione modelli oggetti",
  "subtitle.physicalModelsDetail": "Dettagli modello oggetto",
  "physicalModels.functionSet": "Set di funzioni",
  "physicalModels.minItemsTip": "È necessario conservare almeno {scope} elemento/i",
  "physicalModels.conflictTip": "Periodo di conflitto: {scope}",
  "physicalModels.name": "Nome configurazione",
  "physicalModels.jsonCorrect": "Il formato JSON è corretto",
  "physicalModels.jsonCorrectTip": "Il formato JSON è corretto (servizio di validazione non connesso)",
  "physicalModels.jsonInCorrect": "Il formato JSON non è corretto",
  "physicalModels.deleteFailed": "Eliminazione fallita",
  "physicalModels.loadPreviewFailed": "Impossibile caricare la configurazione di anteprima",
  "physicalModels.configEditor": "Editor di configurazione",
  "physicalModels.selectTemplate": "Seleziona modello preimpostato",
  "physicalModels.jsonConfig": "Configurazione JSON",
  "physicalModels.realTimePreview": "Anteprima in tempo reale",
  "physicalModels.checkJsonFormat": "Si prega di verificare se il formato JSON è corretto",
  "physicalModels.readDataStructure": "Leggi struttura dati",
  "physicalModels.userBehaviorData": "Dati grezzi del comportamento utente",
  "physicalModels.actualDataData": "Dati effettivamente inviati",
  "physicalModels.ready": "Pronto",
  "physicalModels.previewConfigLoaded": "Configurazione anteprima caricata",
  "physicalModels.pasteFromClipboard": "Incollato dagli appunti",
  "physicalModels.pasteFromClipboardTip": "Si prega di aggiungere il SN del dispositivo dopo il percorso del browser, ad esempio:",
  "physicalModels.error": "Errore",
  "plant.createType": "Creato da",
  "physicalModels.jsonComplete": "Completamento JSON",
  "physicalModels.jsonCompleteTip": "Se il JSON è stato salvato, il completamento potrebbe causare problemi di produzione. Procedere con cautela.",
  "physicalModels.maxItemsTip": "È consentito un massimo di {scope} elemento/i",
  "physicalModels.Empty": "{scope} non può essere vuoto",
  "Setting.timeSet": "",
  "plantScreen.singleSiteScree.PVPower": "Potenza FV",
  "plantScreen.singleSiteScree.GridImportPower": "Potenza di import dalla rete",
  "plantScreen.singleSiteScree.GridExportPower": "Potenza di export verso la rete",
  "plantScreen.singleSiteScree.ChargingPower": "Potenza di carica",
  "plantScreen.singleSiteScree.DischargingPower": "Potenza di scarica",
  "plantScreen.singleSiteScree.LoadPower": "Potenza carico",
  "plantScreen.singleSiteScree.SelfConsumptionRate": "Tasso di Autoconsumo",
  "plantScreen.ChartSet.GenerationPower": "Potenza di generazione",
  "plantScreen.ChartSet.DayAheadForecast": "Previsione giornaliera anticipata",
  "plantScreen.ChartSet.RealTimeForecast": "Previsione in tempo reale",
  "plantScreen.ChartSet.RealTimeScheduling": "Programmazione in tempo reale",
  "plantScreen.ChartSet.DayAheadScheduling": "Programmazione giornaliera anticipata",
  "plantScreen.PlantInfo": "Informazioni impianto",
  "plantScreen.PhotovoltaicCapacity": "Capacità installata FV",
  "plantScreen.StorageCapacity": "Capacità batteria",
  "plantScreen.EnergyDispatch": "Programmazione energetica",
  "plantScreen.SelfGenerationRate": "Tasso di autoproduzione",
  "plantScreen.DailyStorageCharging": "Energia caricata giornalmente",
  "plantScreen.DailyStorageDischarging": "Energia scaricata giornalmente",
  "plantScreen.DailyElectricitySold2": "Elettricità venduta giornalmente",
  "plantScreen.ChartSet.Storage": "Accumulo energetico",
  "plantScreen.ChartSet.Solar": "FV",
  "plantScreen.ChartSet.Load": "Carico",
  "plantScreen.ChartSet.ChargeDischargePower": "Potenza carica/scarica",
  "plantScreen.coal": "Carbone",
  "physicalModels.missingIoTIdTip": "IoTId o virtualId mancante, si prega di controllare",
  "org.authCompanyName": "Nome dell'azienda certificata",
  "org.serviceAddress": "Indirizzo del servizio",
  "org.servicePhone": "Telefono del servizio",
  "org.serviceEmail": "Email del servizio",
  "org.companyLogo": "Logo aziendale",
  "org.websiteUrl": "URL del sito web",
  "org.partnerId": "ID partner",
  "org.serviceAgreement": "Accordo di servizio",
  "org.serviceCertificate": "Certificato",
  "physicalModels.slotId": "Identificatore pubblicitario",
  "report.dataQuery.maxDevicesWarning": "È possibile selezionare al massimo 10 dispositivi",
  "report.dataQuery.maxParamsWarning": "È possibile selezionare al massimo 10 parametri",
  "report.dataQuery.selectDeviceAndParamsFirst": "Seleziona prima dispositivi e parametri",
  "report.dataQuery.chartTitle": "Confronto trend operativi multi-serie",
  "report.dataQuery.selectDevice": "Seleziona dispositivo",
  "report.dataQuery.placeholderSelectDevice": "Seleziona un dispositivo",
  "report.dataQuery.tabByModel": "Per modello",
  "report.dataQuery.tabByStation": "Per impianto",
  "report.dataQuery.modelGroupName": "Nome modello",
  "report.dataQuery.noMore": "Non ce ne sono altri",
  "report.dataQuery.selectedDevicesFooter": "Selezionati {current} / 10 dispositivi",
  "report.dataQuery.selectedDevicesShort": "Dispositivi selezionati",
  "report.dataQuery.clear": "Svuota",
  "report.dataQuery.noDeviceSelectedYet": "Nessun dispositivo selezionato",
  "report.dataQuery.selectParamsTitle": "Seleziona parametri (max 10)",
  "report.dataQuery.maxParamsHint": "Fino a 10 parametri contemporaneamente",
  "report.dataQuery.searchParamsPlaceholder": "Cerca parametri",
  "report.dataQuery.noMatchingParams": "Nessun parametro corrispondente",
  "report.dataQuery.selectDeviceFirst": "Seleziona prima un dispositivo",
  "report.dataQuery.placeholderDeviceSn": "Inserisci il numero di serie del dispositivo",
  "report.dataQuery.placeholderModelName": "Inserisci il nome del modello",
  "report.dataQuery.placeholderStationName": "Inserisci il nome dell'impianto",
  "report.dataQuery.selectedDevicesSummary": "{count} dispositivi selezionati",
  "report.dataQuery.startAnalysis": "Avvia analisi",
  "report.dataQuery.emptyGuide": "Fai clic su «Seleziona dispositivo» in alto a sinistra, scegli fino a 10 dispositivi da analizzare, poi parametri e intervallo temporale per iniziare",
  "report.dataQuery.noDataHint": "Nessun dato da mostrare per la query corrente. Modifica dispositivi, parametri o intervallo temporale e riprova",
  "report.dataQuery.tableTitle": "Confronto dati operativi multi-dispositivo",
  "report.dataQuery.peakLabel": "Picco:",
  "report.dataQuery.peakColor": "Rosso",
  "report.dataQuery.valleyLabel": "Valle:",
  "report.dataQuery.valleyColor": "Blu",
  "report.dataQuery.timeByDay": "Per giorno",
  "report.dataQuery.timeByWeek": "Per settimana",
  "report.dataQuery.timeByMonth": "Per mese",
  "report.dataQuery.timeByCustom": "Personalizzato",
  "report.dataQuery.highlightNone": "Nessuna evidenziazione",
  "report.dataQuery.highlightCol": "Evidenzia differenze per colonna",
  "report.dataQuery.highlightRow": "Evidenzia differenze per riga",
  "report.dataQuery.weekdayMon": "lun",
  "report.dataQuery.weekdayTue": "mar",
  "report.dataQuery.weekdayWed": "mer",
  "report.dataQuery.weekdayThu": "gio",
  "report.dataQuery.weekdayFri": "ven",
  "report.dataQuery.weekdaySat": "sab",
  "report.dataQuery.weekdaySun": "dom",
  "report.dataQuery.axisMonthDay": "G.{n}",
  "plant.statisticalCycle": "Ciclo statistico",
  "plant.stationTopology": "Topologia della stazione",
  "plant.topologyConfig": "Configurazione della topologia",
  "plant.projectName": "Nome del progetto",
  "plant.topologyUrl": "URL della topologia",
  "plant.topologyMap": "Mappa della topologia",
  "plant.topologyPlaceholder": "Si prega di inserire l'URL della topologia",
  "plant.addScopeSuccess": "{scope} aggiunto con successo",
  "plant.updateScopeSuccess": "{scope} modificato con successo",
  "plant.topologyUrlFormatError": "Errore nel formato dell'URL della topologia",
  "report.dataQuery.maxCurvesWarning": "La selezione supera 10 curve",
  "report.dataQuery.maxCurvesLimitHint": "È possibile selezionare al massimo 10 curve",
  "report.dataQuery.selectParamsHeading": "Seleziona parametri",
  "ota.don.upgrade": "Aggiornamento del dongle",
  "device.ota.tip.newversion": "La versione attuale è la più recente e non richiede alcun aggiornamento.",
  "device.button.cancel": "OK",
  "org.accountNumber": "Numero account utente",
  "org.accountName": "Nome account utente",
  "org.description": "Descrizione utente elettricità",
  "org.creditCode": "Codice di credito sociale",
  "plant.deptName": "Nome dell'organizzazione",
  "plant.businessScope": "Industriale e commerciale",
  "plant.withdrawBusinessDeliveryTip": "Dopo aver ritirato la consegna, gli utenti {scope} non potranno più gestire questa centrale. Procedere con cautela.",
  "mapScreen.RevenueInfo": "Informazioni sui ricavi",
  "mapScreen.MonthlyRevenue": "Ricavi mensili",
  "mapScreen.YearlyRevenue": "Ricavi annuali",
  "mapScreen.CumulativeRevenue": "Ricavi cumulativi",
  "mapScreen.CarbonIndicator": "Indicatori di carbonio",
  "mapScreen.StorageInfo": "Informazioni sullo stoccaggio",
  "mapScreen.MonthlyChargeDischarge": "Carica/Scarica mensile",
  "mapScreen.YearlyChargeDischarge": "Carica/Scarica annuale",
  "mapScreen.TotalPlants": "Numero di centrali",
  "mapScreen.PvInstalledCapacity": "Capacità FV installata",
  "mapScreen.StorageInstalledCapacity": "Capacità di stoccaggio installata",
  "mapScreen.ChargingPileCapacity": "Capacità colonnine di ricarica",
  "mapScreen.Residential": "Residenziale",
  "mapScreen.Commercial": "Commerciale",
  "mapScreen.PlantCount": "Totale {count} centrali",
  "mapScreen.NewEnergyPower": "Potenza energie rinnovabili",
  "mapScreen.GenerationInfo": "Informazioni sulla produzione",
  "mapScreen.MonthlyGeneration": "Produzione mensile",
  "mapScreen.YearlyGeneration": "Produzione annuale",
  "mapScreen.ChargingPileInfo": "Informazioni colonnine di ricarica",
  "mapScreen.MonthlyConsumption": "Consumo mensile",
  "mapScreen.YearlyConsumption": "Consumo annuale",
  "mapScreen.GridConnectionInfo": "Informazioni connessione alla rete",
  "mapScreen.MonthlyPurchaseFeedin": "Acquisto/Immissione mensile",
  "mapScreen.YearlyPurchaseFeedin": "Acquisto/Immissione annuale",
  "mapScreen.CO2Reduction": "Riduzione di CO2",
  "mapScreen.SaveCoal": "Carbone risparmiato",
  "mapScreen.TreePlanting": "Alberi piantati",
  "mapScreen.SelectCountry": "Seleziona paese",
  "mapScreen.BackToPrev": "Torna al livello precedente",
  "mapScreen.Revenue": "Ricavi",
  "mapScreen.ChargeAmount": "Quantità di carica",
  "mapScreen.DischargeAmount": "Quantità di scarica",
  "mapScreen.GenerationAmount": "Quantità di produzione",
  "mapScreen.ConsumptionAmount": "Quantità di consumo",
  "mapScreen.PowerGeneration": "Potenza di produzione",
  "mapScreen.PurchaseAmount": "Quantità acquistata",
  "mapScreen.GridSellAmount": "Quantità immessa in rete",
  "mapScreen.title": "Piattaforma di Gestione dell'Energia",
  "mapScreen.PlantMonthlyRevenue": "Ricavi mensili",
  "mapScreen.PlantYearlyRevenue": "Ricavi annuali",
  "mapScreen.PlantCumulativeRevenue": "Ricavi cumulativi",
  "physicalModels.tagGroup": "Gruppo di tag",
  "device.expandAll": "Espandi tutto",
  "device.collapseAll": "Comprimi tutto",
  "common.deleteSuccess": "Eliminato con successo",
  "device.systemTime": "Ora di sistema",
  "device.traceId": "ID di tracciamento",
  "device.collectorSn": "SN del collettore",
  "device.functionCode": "Codice funzione",
  "device.encryptedStr": "Messaggio crittografato",
  "device.decryptedStr": "Messaggio decrittografato",
  "device.dateRangeErrorScope": "L'intervallo di date deve essere entro {scope} giorni",
  "common.noMore": "Non più",
  "common.unloginOrExpired": "Non autenticato o sessione scaduta",
  "common.serverError": "Eccezione del server, riprova più tardi",
  "common.requestFailed": "Richiesta fallita",
  "common.backendError": "Errore di connessione dell'interfaccia backend",
  "common.timeout": "Timeout della richiesta dell'interfaccia di sistema",
  "common.systemInterface": "Interfaccia di sistema",
  "common.contains": "Contiene",
  "common.columnSetting": "Impostazioni colonna",
  "product.skipShipmentCheck": "Salta controllo spedizione",
  "system.mapScreen": "Grande schermo panoramico",
  "settingDrawer.title": "Impostazioni layout",
  "settingDrawer.themeMode": "Modalità tema",
  "settingDrawer.darkTheme": "Tema scuro",
  "settingDrawer.lightTheme": "Tema chiaro",
  "settingDrawer.themeColor": "Colore tema",
  "settingDrawer.navMode": "Modalità di navigazione",
  "settingDrawer.sideMenu": "Layout menu laterale",
  "settingDrawer.topMenu": "Layout menu superiore",
  "settingDrawer.mixMenu": "Layout misto",
  "settingDrawer.columnMenu": "Layout a colonne",
  "settingDrawer.drawerMenu": "Layout a cassetto",
  "settingDrawer.layoutSetting": "Impostazioni layout",
  "settingDrawer.contentWidth": "Larghezza contenuto",
  "settingDrawer.contentWidthFixed": "Fisso",
  "settingDrawer.contentWidthFluid": "Fluido",
  "settingDrawer.fixedHeader": "Intestazione fissa",
  "settingDrawer.fixedSidebar": "Barra laterale fissa",
  "settingDrawer.hideFooter": "Nascondi piè di pagina",
  "settingDrawer.multiTab": "Modalità a schede multiple",
  "settingDrawer.sidebarColorfulIcon": "Icone colorate della barra laterale",
  "settingDrawer.searchMode": "Modalità componente di ricerca",
  "settingDrawer.searchModeHeader": "Nuova versione",
  "settingDrawer.searchModeForm": "Vecchia versione",
  "settingDrawer.systemConfig": "Configurazione di sistema",
  "settingDrawer.systemTitle": "Titolo di sistema",
  "settingDrawer.systemCopyright": "Informazioni sul copyright",
  "settingDrawer.systemVersion": "Versione di sistema",
  "settingDrawer.systemVersionPlaceholder": "Numero di versione",
  "settingDrawer.tableStyle": "Stile tabella",
  "settingDrawer.tableSize": "Dimensione tabella",
  "settingDrawer.tableSizeDefault": "Predefinito",
  "settingDrawer.tableSizeMiddle": "Medio",
  "settingDrawer.tableSizeSmall": "Compatto",
  "settingDrawer.tableBordered": "Mostra bordo",
  "settingDrawer.tableFixHeader": "Intestazione fissa",
  "settingDrawer.tableHeaderBold": "Intestazione in grassetto",
  "settingDrawer.tableResizable": "Colonne ridimensionabili",
  "settingDrawer.tableRowSelection": "Selezione righe",
  "settingDrawer.tableHeaderBgColor": "Colore di sfondo dell'intestazione",
  "settingDrawer.tableHeight": "Altezza tabella",
  "settingDrawer.pageSize": "Dimensione della pagina",
  "settingDrawer.pageSizeUnit": "Elementi/pagina",
  "settingDrawer.showTotal": "Mostra totale",
  "settingDrawer.showSizeChanger": "Mostra selettore di dimensione",
  "settingDrawer.showQuickJumper": "Mostra salto rapido",
  "settingDrawer.tableStripe": "Righe alternate a zebra",
  "settingDrawer.tableShowHeader": "Mostra intestazione",
  "settingDrawer.saveTableConfig": "Salva configurazione tabella",
  "settingDrawer.reset": "Reimposta",
  "settingDrawer.configManagement": "Gestione configurazione",
  "settingDrawer.saveAll": "Salva tutte le configurazioni",
  "settingDrawer.exportConfig": "Esporta configurazione",
  "settingDrawer.importConfig": "Importa configurazione",
  "settingDrawer.resetAll": "Reimposta tutte le configurazioni",
  "settingDrawer.msg.initFail": "Inizializzazione del sistema fallita, aggiornare e riprovare",
  "settingDrawer.msg.configInitFail": "Inizializzazione della configurazione fallita",
  "settingDrawer.msg.themeChangeFail": "Cambio tema fallito",
  "settingDrawer.msg.colorChangeFail": "Cambio colore tema fallito",
  "settingDrawer.msg.searchModeSwitched": "Passato alla ricerca {mode}",
  "settingDrawer.msg.searchModeSwitchFail": "Cambio del componente di ricerca fallito",
  "settingDrawer.msg.navModeSwitched": "Passato alla modalità {mode}",
  "settingDrawer.msg.navSide": "Barra laterale",
  "settingDrawer.msg.navTop": "Menu superiore",
  "settingDrawer.msg.navMix": "Misto",
  "settingDrawer.msg.navModeSwitchFail": "Cambio modalità di navigazione fallito",
  "settingDrawer.msg.layoutSwitchFail": "Cambio layout fallito",
  "settingDrawer.msg.settingUpdateFail": "Aggiornamento delle impostazioni fallito",
  "settingDrawer.msg.tableStoreNotInit": "L'archivio di configurazione della tabella non è inizializzato",
  "settingDrawer.msg.tableConfigSaved": "Configurazione della tabella salvata",
  "settingDrawer.msg.tableConfigSaveFail": "Impossibile salvare la configurazione della tabella",
  "settingDrawer.msg.tableConfigReset": "Configurazione della tabella reimpostata",
  "settingDrawer.msg.tableConfigResetFail": "Impossibile reimpostare la configurazione della tabella",
  "settingDrawer.msg.systemConfigUpdated": "Configurazione di sistema aggiornata",
  "settingDrawer.msg.systemConfigUpdateFailStore": "Aggiornamento della configurazione di sistema fallito: Store non inizializzato",
  "settingDrawer.msg.systemConfigUpdateFail": "Aggiornamento della configurazione di sistema fallito",
  "settingDrawer.msg.allConfigSaved": "Tutte le configurazioni salvate",
  "settingDrawer.msg.configSaveFail": "Impossibile salvare la configurazione",
  "settingDrawer.msg.configExported": "Configurazione esportata",
  "settingDrawer.msg.configExportFail": "Impossibile esportare la configurazione",
  "settingDrawer.msg.configImportConfirmTitle": "Confermare l'importazione della configurazione",
  "settingDrawer.msg.configImportConfirmContent": "L'importazione della configurazione sovrascriverà tutte le impostazioni correnti. Continuare?",
  "settingDrawer.msg.confirm": "Conferma",
  "settingDrawer.msg.cancel": "Annulla",
  "settingDrawer.msg.configImported": "Configurazione importata con successo",
  "settingDrawer.msg.configFileInvalid": "Formato del file di configurazione non valido",
  "settingDrawer.msg.resetConfirmTitle": "Conferma reimpostazione",
  "settingDrawer.msg.resetConfirmContent": "La reimpostazione cancellerà tutte le configurazioni personalizzate e ripristinerà lo stato predefinito. Continuare?",
  "settingDrawer.msg.allConfigReset": "Tutte le configurazioni reimpostate"
}
